import { defineComponent as t, mergeDefaults as ql, createElementBlock as o, openBlock as n, renderSlot as f, mergeProps as j, unref as y, nextTick as Rl, computed as Z, ref as z, watchEffect as V, createTextVNode as ll, toDisplayString as F, watch as wl, inject as Xl, onMounted as rl, provide as le, createCommentVNode as L, normalizeClass as ul, normalizeProps as ee, guardReactiveProps as ae, onUnmounted as Dl, createBlock as N, Teleport as se, createElementVNode as E, createVNode as bl, withCtx as K, withModifiers as re } from "vue";
const Fl = {
  primary: void 0,
  link: void 0,
  tertiary: void 0,
  neutral: void 0,
  success: void 0,
  danger: void 0,
  toggle: void 0,
  xSmall: void 0,
  small: void 0,
  large: void 0,
  wide: void 0,
  block: void 0,
  flex: void 0,
  outline: void 0,
  outlinePrimary: void 0,
  outlineSuccess: void 0,
  outlineDanger: void 0,
  icon: void 0
}, ne = ["type", "disabled", "isLoading", "sync", "areaLabel", "primary", "link", "tertiary", "neutral", "success", "danger", "toggle", "x-small", "small", "large", "wide", "block", "flex", "outline", "outline-primary", "outline-success", "outline-danger", "icon"], tl = /* @__PURE__ */ t({
  __name: "VsgButton",
  props: /* @__PURE__ */ ql({
    type: {},
    disabled: { type: Boolean },
    isLoading: { type: Boolean },
    sync: { type: Boolean },
    ariaLabel: {},
    primary: { type: Boolean },
    link: { type: Boolean },
    tertiary: { type: Boolean },
    neutral: { type: Boolean },
    success: { type: Boolean },
    danger: { type: Boolean },
    toggle: { type: Boolean },
    xSmall: { type: Boolean },
    small: { type: Boolean },
    large: { type: Boolean },
    wide: { type: Boolean },
    block: { type: Boolean },
    flex: { type: Boolean },
    outline: { type: Boolean },
    outlinePrimary: { type: Boolean },
    outlineSuccess: { type: Boolean },
    outlineDanger: { type: Boolean },
    icon: { type: Boolean }
  }, {
    type: "button",
    ...Fl
  }),
  emits: ["click", "submit"],
  setup(e, { emit: l }) {
    const a = l, s = (d) => {
      a("click", d);
    }, c = (d) => {
      a("submit", d);
    };
    return (d, v) => (n(), o("jha-button", {
      type: d.type,
      disabled: d.disabled,
      isLoading: d.isLoading,
      sync: d.sync,
      areaLabel: d.ariaLabel,
      onClick: s,
      onSubmit: c,
      primary: d.primary,
      link: d.link,
      tertiary: d.tertiary,
      neutral: d.neutral,
      success: d.success,
      danger: d.danger,
      toggle: d.toggle,
      "x-small": d.xSmall,
      small: d.small,
      large: d.large,
      wide: d.wide,
      block: d.block,
      flex: d.flex,
      outline: d.outline,
      "outline-primary": d.outlinePrimary,
      "outline-success": d.outlineSuccess,
      "outline-danger": d.outlineDanger,
      icon: d.icon
    }, [
      f(d.$slots, "default")
    ], 40, ne));
  }
}), oe = ["primary"], Hc = /* @__PURE__ */ t({
  __name: "VsgButtonGroup",
  props: {
    primary: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-button-group", { primary: l.primary }, [
      f(l.$slots, "default")
    ], 8, oe));
  }
}), te = ["primary", "tertiary", "neutral", "success", "danger", "toggle", "x-small", "small", "large", "wide", "block", "flex", "outline", "outline-primary", "outline-success", "outline-danger", "icon"], kc = /* @__PURE__ */ t({
  __name: "VsgLinkButton",
  props: /* @__PURE__ */ ql({
    href: {},
    rel: {},
    target: {},
    disabled: { type: Boolean },
    primary: { type: Boolean },
    tertiary: { type: Boolean },
    neutral: { type: Boolean },
    success: { type: Boolean },
    danger: { type: Boolean },
    toggle: { type: Boolean },
    xSmall: { type: Boolean },
    small: { type: Boolean },
    large: { type: Boolean },
    wide: { type: Boolean },
    block: { type: Boolean },
    flex: { type: Boolean },
    outline: { type: Boolean },
    outlinePrimary: { type: Boolean },
    outlineSuccess: { type: Boolean },
    outlineDanger: { type: Boolean },
    icon: { type: Boolean }
  }, {
    target: "_self",
    ...Fl
  }),
  emits: ["click"],
  setup(e, { emit: l }) {
    const a = e, s = l, c = (d) => {
      s("click", d);
    };
    return (d, v) => (n(), o("jha-link-button", j(a, {
      onClick: c,
      primary: d.primary,
      tertiary: d.tertiary,
      neutral: d.neutral,
      success: d.success,
      danger: d.danger,
      toggle: d.toggle,
      "x-small": d.xSmall,
      small: d.small,
      large: d.large,
      wide: d.wide,
      block: d.block,
      flex: d.flex,
      outline: d.outline,
      "outline-primary": d.outlinePrimary,
      "outline-success": d.outlineSuccess,
      "outline-danger": d.outlineDanger,
      icon: d.icon
    }), [
      f(d.$slots, "default")
    ], 16, te));
  }
});
function zl(e) {
  return {
    change: (v) => {
      e("update:modelValue", v.detail), e("change", v);
    },
    blur: (v) => {
      e("blur", v);
    },
    keydown: (v) => {
      e("keydown", v);
    },
    keypress: (v) => {
      e("keypress", v);
    },
    inputValueChange: (v) => {
      e("input-value-change", v);
    }
  };
}
const ce = ["data", "searchFields", "chipLimit", "required", "inputValue", "hideRequiredIndicator", "label", "placeholder", "helperText", "warning", "showWarning", "disabled", "focused", "outline", "filled", "small", "allowUnknownValue", "showSearchIcon", "showClearInputButton"], Cc = /* @__PURE__ */ t({
  __name: "VsgAdvancedSearchInput",
  props: {
    searchFields: { default: () => [] },
    data: { default: () => [] },
    outline: { type: Boolean },
    filled: { type: Boolean },
    chipLimit: { default: 1 },
    inputValue: { default: "" },
    helperText: { default: "" },
    label: { default: "" },
    placeholder: { default: "" },
    small: { type: Boolean },
    required: { type: Boolean },
    hideRequiredIndicator: { type: Boolean },
    warning: { default: "" },
    focused: { type: Boolean },
    disabled: { type: Boolean },
    showWarning: { type: Boolean },
    allowUnknownValue: { type: Boolean },
    showSearchIcon: { type: Boolean, default: !0 },
    showClearInputButton: { type: Boolean, default: !0 }
  },
  emits: ["input-value-change", "update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = l, { change: s, blur: c, keydown: d, keypress: v, inputValueChange: _ } = zl(a);
    return (h, x) => (n(), o("jha-form-advanced-search", {
      data: h.data,
      searchFields: h.searchFields,
      chipLimit: h.chipLimit,
      required: h.required,
      inputValue: h.inputValue,
      hideRequiredIndicator: h.hideRequiredIndicator,
      label: h.label,
      placeholder: h.placeholder,
      helperText: h.helperText,
      warning: h.warning,
      showWarning: h.showWarning,
      disabled: h.disabled,
      focused: h.focused,
      outline: h.outline,
      filled: h.filled,
      small: h.small,
      allowUnknownValue: h.allowUnknownValue,
      showSearchIcon: h.showSearchIcon,
      showClearInputButton: h.showClearInputButton,
      onChange: x[0] || (x[0] = //@ts-ignore
      (...r) => y(s) && y(s)(...r)),
      onInputValueChange: x[1] || (x[1] = //@ts-ignore
      (...r) => y(_) && y(_)(...r)),
      onBlur: x[2] || (x[2] = //@ts-ignore
      (...r) => y(c) && y(c)(...r)),
      onKeydown: x[3] || (x[3] = //@ts-ignore
      (...r) => y(d) && y(d)(...r)),
      onKeypress: x[4] || (x[4] = //@ts-ignore
      (...r) => y(v) && y(v)(...r))
    }, null, 40, ce));
  }
});
function k(e) {
  return {
    change: (d) => {
      e("update:modelValue", d.detail), e("change", d);
    },
    blur: (d) => {
      e("blur", d);
    },
    keydown: (d) => {
      e("keydown", d);
    },
    keypress: (d) => {
      e("keypress", d);
    }
  };
}
const il = (e, l = []) => {
  for (const a of e.querySelectorAll("*"))
    a.matches("input,select,textarea") && l.push(a), a.shadowRoot && il(a.shadowRoot, l);
  return l;
}, pl = (e) => {
  var a;
  const l = e.closest("jha-form-floating-group");
  if (e.checkValidity())
    l == null || l.removeAttribute("error");
  else {
    const c = ((a = e.getRootNode().host.attributes.getNamedItem("warning")) == null ? void 0 : a.value) ?? "";
    l == null || l.setAttribute("error", c);
  }
}, Bl = (e) => {
  const l = document.querySelector(`form#${e}`);
  if (!l)
    throw new Error(`Cannot find form with id ${e}`);
  return l;
}, ue = (e, l) => {
  let a;
  return (s) => {
    clearTimeout(a), a = setTimeout(() => e(s), l);
  };
}, Lc = (e) => ({
  resetForm: () => {
    setTimeout(() => {
      const s = Bl(e);
      il(s).forEach((d) => {
        pl(d);
      });
    }, 0);
  },
  validateForm: () => {
    const s = Bl(e), c = il(s), d = ue(pl, 500);
    return c.forEach((v) => {
      pl(v), v.oninput = () => {
        d(v);
      };
    }), c.every((v) => v.checkValidity());
  }
}), B = (e, l) => {
  Rl(() => {
    var s, c;
    if (!((s = e.value) != null && s.shadowRoot)) return;
    const a = (c = il(e.value.shadowRoot)) == null ? void 0 : c[0];
    a && a.setCustomValidity(l ? "Invalid" : "");
  });
}, ie = ["type", "disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], me = /* @__PURE__ */ t({
  __name: "VsgBaseInput",
  props: {
    type: {},
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 / 0 },
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: {},
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "text" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value != null ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      type: r.type,
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), [
      f(r.$slots, "default", {}, void 0, !0)
    ], 16, ie));
  }
}), H = (e, l) => {
  const a = e.__vccOpts || e;
  for (const [s, c] of l)
    a[s] = c;
  return a;
}, Ac = /* @__PURE__ */ H(me, [["__scopeId", "data-v-1b4eacc8"]]), de = ["disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], Ec = /* @__PURE__ */ t({
  __name: "VsgCCInput",
  props: {
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: { default: "Please enter a valid credit card number." },
    filled: { type: Boolean },
    pattern: { default: "[0-9]{19}" },
    required: { type: Boolean },
    label: { default: "Card number" },
    small: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 / 0 },
    minlength: { default: 0 },
    maxlength: { default: 19 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: { default: "[0-9]+" },
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: {}
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keypress: _, keydown: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-cc-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(h) && y(h)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(_) && y(_)(...p))
    }), null, 16, de));
  }
}), ge = ["options", "selectedOptions", "inputValue", "selectedChipIndex", "chipLimit", "required", "hideRequiredIndicator", "label", "placeholder", "helperText", "warning", "showWarning", "disabled", "focused", "outline", "filled", "small", "allowUnknownValue", "showSearchIcon", "showClearInputButton"], Sc = /* @__PURE__ */ t({
  __name: "VsgChipInput",
  props: {
    outline: { type: Boolean },
    filled: { type: Boolean },
    options: { default: () => [] },
    selectedOptions: { default: () => [] },
    chipLimit: { default: null },
    selectedChipIndex: { default: null },
    inputValue: { default: "" },
    helperText: { default: "" },
    label: { default: "" },
    placeholder: { default: "" },
    small: { type: Boolean },
    required: { type: Boolean },
    hideRequiredIndicator: { type: Boolean },
    warning: { default: "" },
    focused: { type: Boolean },
    disabled: { type: Boolean },
    showWarning: { type: Boolean },
    allowUnknownValue: { type: Boolean },
    showSearchIcon: { type: Boolean },
    showClearInputButton: { type: Boolean }
  },
  emits: ["input-value-change", "update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = l, { change: c, blur: d, keydown: v, keypress: _, inputValueChange: h } = zl(s), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-chip-input", {
      ref_key: "el",
      ref: x,
      options: r.options,
      selectedOptions: r.selectedOptions,
      inputValue: r.inputValue,
      selectedChipIndex: r.selectedChipIndex,
      chipLimit: r.chipLimit,
      required: r.required,
      hideRequiredIndicator: r.hideRequiredIndicator,
      label: r.label,
      placeholder: r.placeholder,
      helperText: r.helperText,
      warning: r.warning,
      showWarning: r.showWarning,
      disabled: r.disabled,
      focused: r.focused,
      outline: r.outline,
      filled: r.filled,
      small: r.small,
      allowUnknownValue: r.allowUnknownValue,
      showSearchIcon: r.showSearchIcon,
      showClearInputButton: r.showClearInputButton,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(c) && y(c)(...p)),
      onInputValueChange: g[1] || (g[1] = //@ts-ignore
      (...p) => y(h) && y(h)(...p)),
      onBlur: g[2] || (g[2] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onKeydown: g[3] || (g[3] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeypress: g[4] || (g[4] = //@ts-ignore
      (...p) => y(_) && y(_)(...p))
    }, null, 40, ge));
  }
}), he = ["selectedOptions", "selectedChipIndex", "chipLimit", "required", "inputValue", "hideRequiredIndicator", "label", "placeholder", "helperText", "warning", "showWarning", "disabled", "focused", "outline", "filled", "small", "allowUnknownValue", "showSearchIcon", "showClearInputButton"], Jc = /* @__PURE__ */ t({
  __name: "VsgChipInputCountry",
  props: {
    outline: { type: Boolean },
    filled: { type: Boolean },
    selectedOptions: { default: () => [] },
    chipLimit: { default: null },
    selectedChipIndex: { default: null },
    inputValue: { default: "" },
    helperText: { default: "" },
    label: { default: "" },
    placeholder: { default: "" },
    small: { type: Boolean },
    required: { type: Boolean },
    hideRequiredIndicator: { type: Boolean },
    warning: { default: "" },
    focused: { type: Boolean },
    disabled: { type: Boolean },
    showWarning: { type: Boolean },
    allowUnknownValue: { type: Boolean },
    showSearchIcon: { type: Boolean },
    showClearInputButton: { type: Boolean },
    options: {}
  },
  emits: ["input-value-change", "update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = {
      ...a.options ? { options: a.options } : {}
    }, c = l, { change: d, blur: v, keydown: _, keypress: h, inputValueChange: x } = zl(c), r = z(null);
    return V(() => B(r, a.showWarning)), (g, p) => (n(), o("jha-form-chip-input-country", j({
      ref_key: "el",
      ref: r
    }, s, {
      selectedOptions: g.selectedOptions,
      selectedChipIndex: g.selectedChipIndex,
      chipLimit: g.chipLimit,
      required: g.required,
      inputValue: g.inputValue,
      hideRequiredIndicator: g.hideRequiredIndicator,
      label: g.label,
      placeholder: g.placeholder,
      helperText: g.helperText,
      warning: g.warning,
      showWarning: g.showWarning,
      disabled: g.disabled,
      focused: g.focused,
      outline: g.outline,
      filled: g.filled,
      small: g.small,
      allowUnknownValue: g.allowUnknownValue,
      showSearchIcon: g.showSearchIcon,
      showClearInputButton: g.showClearInputButton,
      onChange: p[0] || (p[0] = //@ts-ignore
      (...w) => y(d) && y(d)(...w)),
      onInputValueChange: p[1] || (p[1] = //@ts-ignore
      (...w) => y(x) && y(x)(...w)),
      onBlur: p[2] || (p[2] = //@ts-ignore
      (...w) => y(v) && y(v)(...w)),
      onKeydown: p[3] || (p[3] = //@ts-ignore
      (...w) => y(_) && y(_)(...w)),
      onKeypress: p[4] || (p[4] = //@ts-ignore
      (...w) => y(h) && y(h)(...w))
    }), null, 16, he));
  }
}), pe = ["disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "noDecimal", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "allowNegative", "useCommas", "showWarning", "mask", "hideRequiredIndicator", "inputMode", "validator"], Tc = /* @__PURE__ */ t({
  __name: "VsgCurrencyInput",
  props: {
    min: { default: 0 },
    max: { default: 1 / 0 },
    noDecimal: { type: Boolean },
    allowNegative: { type: Boolean },
    validator: {},
    useCommas: { type: Boolean },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: { default: "0.00" },
    step: { default: "0.01" },
    alwaysFloat: { type: Boolean },
    allowedCharacters: { default: "[0-9.-]+" },
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "decimal" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null), r = (p) => {
      let w = "";
      if (p && p.length > 0) {
        const { min: b, max: $ } = a, M = parseFloat(p), A = b && M < b, C = $ && M > $, gl = A || C, U = b && b > 0, hl = $ && $ < 1 / 0;
        U && !hl && A ? w = `Must be at least ${b} dollars` : !U && hl && C ? w = `Must be at most ${$} dollars` : hl && U && gl && (w = `Must be between ${b} and ${$} dollars`);
      }
      return w;
    }, g = (p) => {
      const w = r(p.detail);
      if (p.target) {
        const M = p.target.shadowRoot.querySelector("input");
        M && M.setCustomValidity(w);
      }
      d && typeof d == "function" && d(p);
    };
    return V(() => B(x, a.showWarning)), (p, w) => (n(), o("jha-form-currency-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      disabled: p.disabled,
      warning: p.warning,
      filled: p.filled,
      pattern: p.pattern,
      required: p.required,
      label: p.label,
      small: p.small,
      min: p.min,
      max: p.max,
      minlength: p.minlength,
      maxlength: p.maxlength,
      caption: p.caption,
      assistiveText: p.assistiveText,
      autocomplete: p.autocomplete,
      autocapitalize: p.autocapitalize,
      name: p.name,
      noLabel: p.noLabel,
      noDecimal: p.noDecimal,
      outline: p.outline,
      readonly: p.readonly,
      placeholder: p.placeholder,
      step: p.step,
      alwaysFloat: p.alwaysFloat,
      allowedCharacters: p.allowedCharacters,
      allowNegative: p.allowNegative,
      useCommas: p.useCommas,
      showWarning: p.showWarning,
      mask: p.mask,
      hideRequiredIndicator: p.hideRequiredIndicator,
      inputMode: p.inputMode,
      validator: p.validator,
      onChange: g,
      onBlur: w[0] || (w[0] = //@ts-ignore
      (...b) => y(v) && y(v)(...b)),
      onKeydown: w[1] || (w[1] = //@ts-ignore
      (...b) => y(_) && y(_)(...b)),
      onKeypress: w[2] || (w[2] = //@ts-ignore
      (...b) => y(h) && y(h)(...b))
    }), null, 16, pe));
  }
}), ve = ["disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], qc = /* @__PURE__ */ t({
  __name: "VsgCVVInput",
  props: {
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: { default: "Enter the security code found on the back of your card." },
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: { default: "CVV" },
    small: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 / 0 },
    minlength: { default: 3 },
    maxlength: { default: 4 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: { default: "[0-9]+" },
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "numeric" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-cvv-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), null, 16, ve));
  }
}), xe = ["label", "min", "max", "warning", "name"], Rc = /* @__PURE__ */ t({
  __name: "VsgDateInput",
  props: {
    name: {},
    label: {},
    min: {},
    max: {},
    warning: { default: "Invalid date" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = l, { change: s, blur: c, keydown: d, keypress: v } = k(a);
    return (_, h) => (n(), o("jha-form-date-input", {
      label: _.label,
      onChange: h[0] || (h[0] = //@ts-ignore
      (...x) => y(s) && y(s)(...x)),
      onBlur: h[1] || (h[1] = //@ts-ignore
      (...x) => y(c) && y(c)(...x)),
      onKeydown: h[2] || (h[2] = //@ts-ignore
      (...x) => y(d) && y(d)(...x)),
      onKeypress: h[3] || (h[3] = //@ts-ignore
      (...x) => y(v) && y(v)(...x)),
      min: _.min,
      max: _.max,
      warning: _.warning,
      name: _.name
    }, null, 40, xe));
  }
}), ye = ["label", "min", "max", "warning", "name"], Dc = /* @__PURE__ */ t({
  __name: "VsgDateInputIcon",
  props: {
    name: {},
    label: {},
    min: {},
    max: {},
    warning: { default: "Invalid date" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = l, { change: s, blur: c, keydown: d, keypress: v } = k(a);
    return (_, h) => (n(), o("jha-form-date-input-icon", {
      label: _.label,
      onChange: h[0] || (h[0] = //@ts-ignore
      (...x) => y(s) && y(s)(...x)),
      onBlur: h[1] || (h[1] = //@ts-ignore
      (...x) => y(c) && y(c)(...x)),
      onKeydown: h[2] || (h[2] = //@ts-ignore
      (...x) => y(d) && y(d)(...x)),
      onKeypress: h[3] || (h[3] = //@ts-ignore
      (...x) => y(v) && y(v)(...x)),
      min: _.min,
      max: _.max,
      warning: _.warning,
      name: _.name
    }, null, 40, ye));
  }
}), _e = ["minDate", "maxDate", "initialDate", "selectedDate", "secondaryDate", "maxMonths", "showToday", "activeDates", "allowRangeSelection", "showActiveDateBadge", "infiniteScroll", "activeDateFilter"], Fc = /* @__PURE__ */ t({
  __name: "VsgDatePicker",
  props: {
    minDate: {},
    maxDate: {},
    initialDate: {},
    selectedDate: {},
    secondaryDate: {},
    maxMonths: {},
    showToday: { type: Boolean, default: !0 },
    activeDates: {},
    allowRangeSelection: { type: Boolean },
    showActiveDateBadge: { type: Boolean },
    infiniteScroll: { type: Boolean },
    activeDateFilter: {}
  },
  setup(e) {
    return (l, a) => (n(), o("jha-date-picker", {
      minDate: l.minDate,
      maxDate: l.maxDate,
      initialDate: l.initialDate,
      selectedDate: l.selectedDate,
      secondaryDate: l.secondaryDate,
      maxMonths: l.maxMonths,
      showToday: l.showToday,
      activeDates: l.activeDates,
      allowRangeSelection: l.allowRangeSelection,
      showActiveDateBadge: l.showActiveDateBadge,
      infiniteScroll: l.infiniteScroll,
      activeDateFilter: l.activeDateFilter
    }, [
      f(l.$slots, "default")
    ], 8, _e));
  }
}), we = ["minDays", "maxDays", "selectedDays", "calendarOnly"], Pc = /* @__PURE__ */ t({
  __name: "VsgDayPicker",
  props: {
    minDays: { default: 2 },
    maxDays: { default: 2 },
    selectedDays: {},
    calendarOnly: { type: Boolean },
    small: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const l = e, a = Z(() => ({
      ...l.small ? { small: l.small } : {}
    }));
    return (s, c) => (n(), o("jha-day-picker", j({
      minDays: s.minDays,
      maxDays: s.maxDays,
      selectedDays: s.selectedDays,
      calendarOnly: s.calendarOnly
    }, a.value), [
      f(s.$slots, "default")
    ], 16, we));
  }
}), fe = ["disabled", "warning", "filled", "pattern", "required", "label", "small", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], Wc = /* @__PURE__ */ t({
  __name: "VsgEmailInput",
  props: {
    matchValue: { default: null },
    matchValueWarning: { default: "Emails must match" },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: { default: "Please provide a valid email address." },
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: { default: "Email address" },
    small: { type: Boolean },
    min: {},
    max: {},
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: {},
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "email" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { expose: l, emit: a }) {
    const s = e, c = z(null);
    l({ input: c });
    const d = Z(() => ({
      ...s.value !== void 0 ? { value: s.value } : {},
      ...s.modelValue !== void 0 ? { value: s.modelValue } : {}
    })), v = a, { change: _, blur: h, keydown: x, keypress: r } = k(v);
    return V(() => B(c, s.showWarning)), (g, p) => (n(), o("jha-form-email-input", j(d.value, {
      ref_key: "input",
      ref: c,
      disabled: g.disabled,
      warning: g.warning,
      filled: g.filled,
      pattern: g.pattern,
      required: g.required,
      label: g.label,
      small: g.small,
      minlength: g.minlength,
      maxlength: g.maxlength,
      caption: g.caption,
      assistiveText: g.assistiveText,
      autocomplete: g.autocomplete,
      autocapitalize: g.autocapitalize,
      name: g.name,
      noLabel: g.noLabel,
      outline: g.outline,
      readonly: g.readonly,
      placeholder: g.placeholder,
      step: g.step,
      alwaysFloat: g.alwaysFloat,
      allowedCharacters: g.allowedCharacters,
      showWarning: g.showWarning,
      mask: g.mask,
      hideRequiredIndicator: g.hideRequiredIndicator,
      inputMode: g.inputMode,
      onChange: p[0] || (p[0] = //@ts-ignore
      (...w) => y(_) && y(_)(...w)),
      onBlur: p[1] || (p[1] = //@ts-ignore
      (...w) => y(h) && y(h)(...w)),
      onKeydown: p[2] || (p[2] = //@ts-ignore
      (...w) => y(x) && y(x)(...w)),
      onKeypress: p[3] || (p[3] = //@ts-ignore
      (...w) => y(r) && y(r)(...w))
    }), null, 16, fe));
  }
}), be = ["name", "multiple", "accept"], Oc = /* @__PURE__ */ t({
  __name: "VsgFileInput",
  props: {
    name: {},
    multiple: { type: Boolean },
    accept: {}
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-form-file-input", {
      name: c.name,
      multiple: c.multiple,
      accept: c.accept,
      onChange: s
    }, [
      f(c.$slots, "default")
    ], 40, be));
  }
}), ze = ["name", "text", "multiple", "accept"], Uc = /* @__PURE__ */ t({
  __name: "VsgFileUploader",
  props: {
    text: { default: "Upload files" },
    name: {},
    multiple: { type: Boolean },
    accept: {}
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-file-uploader", {
      name: c.name,
      text: c.text,
      multiple: c.multiple,
      accept: c.accept,
      onChange: s
    }, [
      f(c.$slots, "default")
    ], 40, ze));
  }
}), $e = ["error", "assistiveText", "alwaysFloat", "hasValue", "indentError", "filled", "outline", "small"], Nc = /* @__PURE__ */ t({
  __name: "VsgFloatingGroup",
  props: {
    error: {},
    assistiveText: {},
    alwaysFloat: { type: Boolean },
    hasValue: { type: Boolean },
    hasFocus: { type: Boolean },
    indentError: { type: Boolean },
    filled: { type: Boolean },
    outline: { type: Boolean },
    small: { type: Boolean }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-form-floating-group", {
      error: l.error,
      assistiveText: l.assistiveText,
      alwaysFloat: l.alwaysFloat,
      hasValue: l.hasValue,
      indentError: l.indentError,
      filled: l.filled,
      outline: l.outline,
      small: l.small
    }, [
      f(l.$slots, "default")
    ], 8, $e));
  }
}), Ze = ["checked", "disabled", "indeterminate", "label", "name", "value"], Kc = /* @__PURE__ */ t({
  __name: "VsgCheckbox",
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean },
    indeterminate: { type: Boolean },
    label: {},
    name: {},
    value: {}
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-form-checkbox", {
      checked: c.checked,
      disabled: c.disabled,
      indeterminate: c.indeterminate,
      label: c.label,
      name: c.name,
      value: c.value,
      onChange: s
    }, [
      f(c.$slots, "default"),
      ll(" " + F(c.label), 1)
    ], 40, Ze));
  }
});
function O(e) {
  return {
    change: (c) => {
      e("change", c);
    },
    blur: (c) => {
      e("blur", c);
    },
    focus: (c) => {
      e("focus", c);
    }
  };
}
const Ve = ["options", "value", "warning", "label", "required", "filled", "outline", "hideRequiredIndicator", "disabled", "error", "assistiveText", "focused", "emptyOptionLabel", "labelKey", "valueKey", "showWarning"], Gc = /* @__PURE__ */ t({
  __name: "VsgSelect",
  props: {
    options: {},
    required: { type: Boolean },
    label: {},
    filled: { type: Boolean, default: !0 },
    outline: { type: Boolean },
    labelKey: { default: "name" },
    valueKey: { default: "value" },
    value: {},
    focused: { type: Boolean },
    emptyOptionLabel: {},
    hideRequiredIndicator: { type: Boolean },
    disabled: { type: Boolean },
    error: {},
    showWarning: { type: Boolean },
    warning: { default: "Required" },
    assistiveText: {},
    iconLeft: { type: Boolean }
  },
  emits: ["change", "blur", "focus"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.iconLeft ? { "icon-left": a.iconLeft } : {}
    })), c = l, { change: d, blur: v, focus: _ } = O(c), h = z(null), x = (r) => {
      const g = a.valueKey, p = a.options.find(
        (b) => {
          var $;
          return Array.isArray(b.group) ? b : (($ = b[g]) == null ? void 0 : $.toString()) === r.detail;
        }
      ), w = p && Array.isArray(p.group) ? p.group.find((b) => {
        var $;
        return (($ = b[g]) == null ? void 0 : $.toString()) === r.detail;
      }) : p;
      if (w)
        return d(new CustomEvent("change", { detail: w[g] }));
      d(r);
    };
    return V(() => B(h, a.showWarning)), (r, g) => (n(), o("jha-form-select", j({
      ref_key: "el",
      ref: h,
      options: r.options,
      onChange: x,
      onBlur: g[0] || (g[0] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onFocus: g[1] || (g[1] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      value: r.value,
      warning: r.warning,
      label: r.label,
      required: r.required,
      filled: r.filled,
      outline: r.outline,
      hideRequiredIndicator: r.hideRequiredIndicator,
      disabled: r.disabled,
      error: r.error,
      assistiveText: r.assistiveText,
      focused: r.focused,
      emptyOptionLabel: r.emptyOptionLabel,
      labelKey: r.labelKey,
      valueKey: r.valueKey,
      showWarning: r.showWarning
    }, s.value), [
      f(r.$slots, "default")
    ], 16, Ve));
  }
}), Be = ["label", "isLoading", "checked", "disabled", "async"], Yc = /* @__PURE__ */ t({
  __name: "VsgSwitch",
  props: {
    checked: { type: Boolean },
    isLoading: { type: Boolean },
    disabled: { type: Boolean },
    label: {},
    labelText: {},
    async: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-form-switch", {
      label: c.label,
      isLoading: c.isLoading,
      checked: c.checked,
      disabled: c.disabled,
      async: c.async,
      onChange: s
    }, [
      f(c.$slots, "default")
    ], 40, Be));
  }
}), Ie = ["options", "selectedOptions", "inputValue", "label", "allSelectedText", "helperText", "allowSelectAll", "selectAllLabel", "warning", "small", "outline", "chipLimit", "filled", "required", "hideRequiredIndicator", "menuOpen"], Qc = /* @__PURE__ */ t({
  __name: "VsgMultiSelect",
  props: {
    options: {},
    selectedOptions: {},
    inputValue: {},
    label: {},
    allSelectedText: {},
    helperText: {},
    allowSelectAll: { type: Boolean },
    selectAllLabel: { default: "Select All" },
    warning: {},
    chipLimit: {},
    small: { type: Boolean },
    outline: { type: Boolean },
    filled: { type: Boolean },
    required: { type: Boolean },
    hideRequiredIndicator: { type: Boolean },
    menuOpen: { type: Boolean },
    displayWarning: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = e, s = l, c = z(null), d = z(null), v = Z(() => a.options.map((x) => typeof x == "string" ? x : x.name)), _ = Z(() => a.selectedOptions.map((x) => typeof x == "string" ? x : x.name)), h = (x) => {
      const r = x.detail.map(
        (g) => a.options.find((p) => typeof p == "string" ? p === g : p.name === g)
      ).filter((g) => g !== void 0);
      s("change", { ...x, detail: r });
    };
    return wl(
      () => [a.selectedOptions, a.displayWarning, a.required],
      () => {
        setTimeout(() => {
          var x, r, g;
          d.value = (g = (r = (x = c.value) == null ? void 0 : x.shadowRoot) == null ? void 0 : r.children[0]) == null ? void 0 : g.querySelector(".input input"), d.value.checkValidity = function() {
            return a.required ? a.selectedOptions.length > 0 : a.displayWarning !== void 0 ? !a.displayWarning : !0;
          };
        });
      },
      { immediate: !0 }
    ), wl(
      () => [a.displayWarning, a.warning],
      () => {
        setTimeout(() => {
          var p, w;
          const x = (w = (p = c.value) == null ? void 0 : p.shadowRoot) == null ? void 0 : w.querySelector("jha-form-floating-group"), r = x == null ? void 0 : x.querySelector("div.input"), g = x == null ? void 0 : x.querySelector("label");
          x && r && g && (a.displayWarning ? (x == null || x.setAttribute("error", a.warning ?? ""), r.style.border = "1px solid var(--jha-color-danger)", g.style.color = "var(--jha-color-danger)") : (x.removeAttribute("error"), r.style.border = "", g.style.color = ""));
        }, 0);
      }
    ), (x, r) => (n(), o("jha-form-multi-select", {
      ref_key: "el",
      ref: c,
      options: v.value,
      selectedOptions: _.value,
      inputValue: x.inputValue,
      label: x.label,
      allSelectedText: x.allSelectedText,
      helperText: x.helperText,
      allowSelectAll: x.allowSelectAll,
      selectAllLabel: x.selectAllLabel,
      warning: x.warning,
      small: x.small,
      outline: x.outline,
      chipLimit: x.chipLimit,
      filled: x.filled,
      required: x.required,
      hideRequiredIndicator: x.hideRequiredIndicator,
      menuOpen: x.menuOpen,
      onChange: h
    }, null, 40, Ie));
  }
}), je = ["disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "noDecimal", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], Xc = /* @__PURE__ */ t({
  __name: "VsgPercentInput",
  props: {
    min: { default: 0 },
    max: { default: 100 },
    noDecimal: { type: Boolean },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: { default: "" },
    step: { default: "0.01" },
    alwaysFloat: { type: Boolean },
    allowedCharacters: {},
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "decimal" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-percent-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      noDecimal: r.noDecimal,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), null, 16, je));
  }
}), Me = ["disabled", "warning", "filled", "format", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], lu = /* @__PURE__ */ t({
  __name: "VsgPhoneNumber",
  props: {
    format: { type: Boolean },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: { default: "Please provide a valid phone number." },
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: { default: "Phone Number" },
    small: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 / 0 },
    minlength: { default: 10 },
    maxlength: { default: 15 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: { default: "[0-9 ]" },
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "tel" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-phone-number", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      format: r.format,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), null, 16, Me));
  }
}), He = ["checked", "disabled", "for", "name", "id", "value"], eu = /* @__PURE__ */ t({
  __name: "VsgRadioButton",
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean },
    labelFor: {},
    name: {},
    id: {},
    value: {}
  },
  emits: ["checked"],
  setup(e, { emit: l }) {
    const a = e, s = l, c = z(null), d = Xl("onRadioCheck"), v = (_) => {
      s("checked", _), typeof d == "function" && d();
    };
    return rl(() => {
      a.checked && typeof d == "function" && d();
    }), (_, h) => (n(), o("jha-form-radio-button", {
      ref_key: "radioRef",
      ref: c,
      checked: _.checked,
      disabled: _.disabled,
      for: _.labelFor,
      name: _.name,
      id: _.id,
      value: _.value,
      onChecked: v
    }, [
      f(_.$slots, "default")
    ], 40, He));
  }
}), ke = {
  class: "radio-group",
  role: "radiogroup"
}, Ce = ["for"], Le = {
  key: 0,
  class: "asterisk"
}, Ae = ["name"], Ee = {
  key: 2,
  "aria-live": "polite",
  class: "error"
}, Se = /* @__PURE__ */ t({
  __name: "VsgRadioGroup",
  props: {
    name: {},
    label: {},
    labelClass: { default: "" },
    showWarning: { type: Boolean },
    warning: { default: "Required" },
    required: { type: Boolean }
  },
  setup(e) {
    const l = z(!0), a = z(null), s = (v) => {
      const _ = v.target;
      l.value = _.validity.valid;
    };
    le("onRadioCheck", () => {
      a.value && (a.value.checked = !0);
    });
    const c = e, d = Z(() => !l.value || c.showWarning);
    return (v, _) => (n(), o("div", ke, [
      c.label ? (n(), o("label", {
        key: 0,
        for: v.name,
        class: ul("radio-label " + c.labelClass)
      }, [
        ll(F(c.label + " ") + " ", 1),
        c.required ? (n(), o("span", Le, "*")) : L("", !0)
      ], 10, Ce)) : L("", !0),
      v.required ? (n(), o("input", {
        key: 1,
        required: "",
        ref_key: "hiddenRadio",
        ref: a,
        type: "radio",
        name: v.name,
        onBlur: s,
        style: { display: "none" }
      }, null, 40, Ae)) : L("", !0),
      f(v.$slots, "default", {}, void 0, !0),
      d.value ? (n(), o("p", Ee, F(v.warning), 1)) : L("", !0)
    ]));
  }
}), au = /* @__PURE__ */ H(Se, [["__scopeId", "data-v-c392ed62"]]), Je = ["min", "max", "value"], su = /* @__PURE__ */ t({
  __name: "VsgRangeSlider",
  props: {
    min: { default: 0 },
    max: { default: 1 / 0 },
    value: {}
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-form-range-slider", {
      min: c.min,
      max: c.max,
      value: c.value,
      onChange: s
    }, null, 40, Je));
  }
}), Te = ["debounceInterval", "disabled", "warning", "filled", "pattern", "required", "label", "small", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], ru = /* @__PURE__ */ t({
  __name: "VsgSearchInput",
  props: {
    debounceInterval: { default: 0 },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: {},
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "text" }
  },
  emits: ["search", "update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { blur: d, keydown: v, keypress: _ } = k(c), h = (r) => {
      c("change", r);
    }, x = (r) => {
      c("update:modelValue", r.detail), c("search", r);
    };
    return (r, g) => (n(), o("jha-form-search-input", j(s.value, {
      debounceInterval: r.debounceInterval,
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: h,
      onSearch: x,
      onBlur: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onKeydown: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeypress: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p))
    }), null, 16, Te));
  }
}), qe = ["value", "warning", "label", "required", "filled", "outline", "hideRequiredIndicator", "disabled", "error", "assistiveText", "focused", "emptyOptionLabel", "showWarning"], nu = /* @__PURE__ */ t({
  __name: "VsgSelectCardType",
  props: {
    required: { type: Boolean },
    label: { default: "Card Type" },
    filled: { type: Boolean },
    outline: { type: Boolean },
    labelKey: {},
    valueKey: {},
    value: {},
    focused: { type: Boolean },
    emptyOptionLabel: { default: "Choose one *" },
    hideRequiredIndicator: { type: Boolean },
    disabled: { type: Boolean },
    error: {},
    showWarning: { type: Boolean },
    warning: {},
    assistiveText: {},
    iconLeft: { type: Boolean }
  },
  emits: ["change", "blur", "focus"],
  setup(e, { emit: l }) {
    const a = e, s = l, { change: c, blur: d, focus: v } = O(s), _ = z(null);
    return V(() => B(_, a.showWarning)), (h, x) => (n(), o("jha-form-select-card-type", {
      ref_key: "el",
      ref: _,
      onChange: x[0] || (x[0] = //@ts-ignore
      (...r) => y(c) && y(c)(...r)),
      onBlur: x[1] || (x[1] = //@ts-ignore
      (...r) => y(d) && y(d)(...r)),
      onFocus: x[2] || (x[2] = //@ts-ignore
      (...r) => y(v) && y(v)(...r)),
      value: h.value,
      warning: h.warning,
      label: h.label,
      required: h.required,
      filled: h.filled,
      outline: h.outline,
      hideRequiredIndicator: h.hideRequiredIndicator,
      disabled: h.disabled,
      error: h.error,
      assistiveText: h.assistiveText,
      focused: h.focused,
      emptyOptionLabel: h.emptyOptionLabel,
      showWarning: h.showWarning
    }, null, 40, qe));
  }
}), Re = ["value", "warning", "label", "required", "filled", "outline", "hideRequiredIndicator", "disabled", "error", "assistiveText", "focused", "emptyOptionLabel", "showWarning"], ou = /* @__PURE__ */ t({
  __name: "VsgSelectCountry",
  props: {
    required: { type: Boolean },
    label: { default: "Country" },
    filled: { type: Boolean },
    outline: { type: Boolean },
    labelKey: {},
    valueKey: {},
    value: {},
    focused: { type: Boolean },
    emptyOptionLabel: {},
    hideRequiredIndicator: { type: Boolean },
    disabled: { type: Boolean },
    error: {},
    showWarning: { type: Boolean },
    warning: {},
    assistiveText: {},
    iconLeft: { type: Boolean }
  },
  emits: ["change", "blur", "focus"],
  setup(e, { emit: l }) {
    const a = e, s = l, { change: c, blur: d, focus: v } = O(s), _ = z(null);
    return V(() => B(_, a.showWarning)), (h, x) => (n(), o("jha-form-select-country", {
      onChange: x[0] || (x[0] = //@ts-ignore
      (...r) => y(c) && y(c)(...r)),
      onBlur: x[1] || (x[1] = //@ts-ignore
      (...r) => y(d) && y(d)(...r)),
      onFocus: x[2] || (x[2] = //@ts-ignore
      (...r) => y(v) && y(v)(...r)),
      value: h.value,
      warning: h.warning,
      label: h.label,
      required: h.required,
      filled: h.filled,
      outline: h.outline,
      hideRequiredIndicator: h.hideRequiredIndicator,
      disabled: h.disabled,
      error: h.error,
      assistiveText: h.assistiveText,
      focused: h.focused,
      emptyOptionLabel: h.emptyOptionLabel,
      showWarning: h.showWarning
    }, null, 40, Re));
  }
}), De = ["value", "warning", "label", "required", "filled", "outline", "hideRequiredIndicator", "disabled", "error", "assistiveText", "focused", "emptyOptionLabel", "showWarning"], tu = /* @__PURE__ */ t({
  __name: "VsgSelectMonth",
  props: {
    required: { type: Boolean },
    label: { default: "Month" },
    filled: { type: Boolean },
    outline: { type: Boolean },
    labelKey: {},
    valueKey: {},
    value: {},
    focused: { type: Boolean },
    emptyOptionLabel: { default: "Choose one *" },
    hideRequiredIndicator: { type: Boolean },
    disabled: { type: Boolean },
    error: {},
    showWarning: { type: Boolean },
    warning: {},
    assistiveText: {},
    iconLeft: { type: Boolean }
  },
  emits: ["change", "blur", "focus"],
  setup(e, { emit: l }) {
    const a = e, s = l, { change: c, blur: d, focus: v } = O(s), _ = z(null);
    return V(() => B(_, a.showWarning)), (h, x) => (n(), o("jha-form-select-month", {
      onChange: x[0] || (x[0] = //@ts-ignore
      (...r) => y(c) && y(c)(...r)),
      onBlur: x[1] || (x[1] = //@ts-ignore
      (...r) => y(d) && y(d)(...r)),
      onFocus: x[2] || (x[2] = //@ts-ignore
      (...r) => y(v) && y(v)(...r)),
      value: h.value,
      warning: h.warning,
      label: h.label,
      required: h.required,
      filled: h.filled,
      outline: h.outline,
      hideRequiredIndicator: h.hideRequiredIndicator,
      disabled: h.disabled,
      error: h.error,
      assistiveText: h.assistiveText,
      focused: h.focused,
      emptyOptionLabel: h.emptyOptionLabel,
      showWarning: h.showWarning
    }, null, 40, De));
  }
}), Fe = ["value", "warning", "label", "required", "filled", "outline", "hideRequiredIndicator", "disabled", "error", "assistiveText", "focused", "emptyOptionLabel", "showWarning"], cu = /* @__PURE__ */ t({
  __name: "VsgSelectState",
  props: {
    required: { type: Boolean },
    label: { default: "State" },
    filled: { type: Boolean },
    outline: { type: Boolean },
    labelKey: {},
    valueKey: {},
    value: {},
    focused: { type: Boolean },
    emptyOptionLabel: { default: "Choose one *" },
    hideRequiredIndicator: { type: Boolean },
    disabled: { type: Boolean },
    error: {},
    showWarning: { type: Boolean },
    warning: {},
    assistiveText: {},
    iconLeft: { type: Boolean }
  },
  emits: ["change", "blur", "focus"],
  setup(e, { emit: l }) {
    const a = e, s = l, { change: c, blur: d, focus: v } = O(s), _ = z(null);
    return V(() => B(_, a.showWarning)), (h, x) => (n(), o("jha-form-state-select", {
      ref_key: "el",
      ref: _,
      onChange: x[0] || (x[0] = //@ts-ignore
      (...r) => y(c) && y(c)(...r)),
      onBlur: x[1] || (x[1] = //@ts-ignore
      (...r) => y(d) && y(d)(...r)),
      onFocus: x[2] || (x[2] = //@ts-ignore
      (...r) => y(v) && y(v)(...r)),
      value: h.value,
      warning: h.warning,
      label: h.label,
      required: h.required,
      filled: h.filled,
      outline: h.outline,
      hideRequiredIndicator: h.hideRequiredIndicator,
      disabled: h.disabled,
      error: h.error,
      assistiveText: h.assistiveText,
      focused: h.focused,
      emptyOptionLabel: h.emptyOptionLabel,
      showWarning: h.showWarning
    }, null, 40, Fe));
  }
}), Pe = ["value", "warning", "label", "required", "filled", "outline", "hideRequiredIndicator", "disabled", "error", "assistiveText", "focused", "emptyOptionLabel", "showWarning"], uu = /* @__PURE__ */ t({
  __name: "VsgSelectYear",
  props: {
    required: { type: Boolean },
    label: { default: "Year" },
    filled: { type: Boolean },
    outline: { type: Boolean },
    labelKey: {},
    valueKey: {},
    value: {},
    focused: { type: Boolean },
    emptyOptionLabel: { default: "Choose one *" },
    hideRequiredIndicator: { type: Boolean },
    disabled: { type: Boolean },
    error: {},
    showWarning: { type: Boolean },
    warning: {},
    assistiveText: {},
    iconLeft: { type: Boolean }
  },
  emits: ["change", "blur", "focus"],
  setup(e, { emit: l }) {
    const a = e, s = l, { change: c, blur: d, focus: v } = O(s), _ = z(null);
    return V(() => B(_, a.showWarning)), (h, x) => (n(), o("jha-form-select-year", {
      ref_key: "el",
      ref: _,
      onChange: x[0] || (x[0] = //@ts-ignore
      (...r) => y(c) && y(c)(...r)),
      onBlur: x[1] || (x[1] = //@ts-ignore
      (...r) => y(d) && y(d)(...r)),
      onFocus: x[2] || (x[2] = //@ts-ignore
      (...r) => y(v) && y(v)(...r)),
      value: h.value,
      warning: h.warning,
      label: h.label,
      required: h.required,
      filled: h.filled,
      outline: h.outline,
      hideRequiredIndicator: h.hideRequiredIndicator,
      disabled: h.disabled,
      error: h.error,
      assistiveText: h.assistiveText,
      focused: h.focused,
      emptyOptionLabel: h.emptyOptionLabel,
      showWarning: h.showWarning
    }, null, 40, Pe));
  }
}), We = ["text"], iu = /* @__PURE__ */ t({
  __name: "VsgSignatureInput",
  props: {
    text: { default: "Draw your signature" }
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-form-signature-input", {
      text: c.text,
      onChange: s
    }, null, 40, We));
  }
}), Oe = ["lastFour", "disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], mu = /* @__PURE__ */ t({
  __name: "VsgSSNInput",
  props: {
    lastFour: { type: Boolean },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 / 0 },
    minlength: {},
    maxlength: {},
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: { default: "[0-9-]+" },
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "text" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {},
      ...a.minlength !== void 0 ? { minlength: a.minlength } : {},
      ...a.maxlength !== void 0 ? { maxlength: a.maxlength } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-ssn", j(s.value, {
      lastFour: r.lastFour,
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), null, 16, Oe));
  }
}), Ue = ["characterLimit", "disabled", "warning", "filled", "pattern", "required", "label", "small", "min", "max", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], du = /* @__PURE__ */ t({
  __name: "VsgTextareaInput",
  props: {
    characterLimit: { default: null },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    min: {},
    max: {},
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: { default: "" },
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: { default: "" },
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: {},
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "text" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = z(null), c = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), d = l, { change: v, blur: _, keydown: h, keypress: x } = k(d);
    return rl(() => {
      setTimeout(() => {
        var g, p, w, b, $;
        const r = (w = (p = (g = s.value) == null ? void 0 : g.shadowRoot) == null ? void 0 : p.children[0]) == null ? void 0 : w.querySelector("textarea");
        if (r) {
          r.rows = 1;
          const M = r == null ? void 0 : r.scrollHeight;
          ($ = (b = s.value) == null ? void 0 : b.style) == null || $.setProperty("--jha-input-height", `${M}px`);
        }
      }, 0);
    }), V(() => B(s, a.showWarning)), (r, g) => (n(), o("jha-form-textarea-input", j({
      ref_key: "el",
      ref: s
    }, c.value, {
      characterLimit: r.characterLimit,
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      min: r.min,
      max: r.max,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(h) && y(h)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(x) && y(x)(...p))
    }), null, 16, Ue));
  }
}), Ne = ["list", "listOptions", "disabled", "warning", "characterLimit", "filled", "pattern", "required", "label", "small", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], gu = /* @__PURE__ */ t({
  __name: "VsgTextInput",
  props: {
    characterLimit: { default: null },
    list: { default: "" },
    listOptions: { default: () => [] },
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: {},
    filled: { type: Boolean },
    pattern: {},
    required: { type: Boolean },
    label: {},
    small: { type: Boolean },
    minlength: { default: 0 },
    maxlength: { default: 1 / 0 },
    caption: { default: "" },
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: {},
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "text" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-text-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      list: r.list,
      listOptions: r.listOptions,
      disabled: r.disabled,
      warning: r.warning,
      characterLimit: r.characterLimit,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), [
      f(r.$slots, "default")
    ], 16, Ne));
  }
}), Ke = ["disabled", "warning", "filled", "pattern", "required", "label", "small", "minlength", "maxlength", "caption", "assistiveText", "autocomplete", "autocapitalize", "name", "noLabel", "outline", "readonly", "placeholder", "step", "alwaysFloat", "allowedCharacters", "showWarning", "mask", "hideRequiredIndicator", "inputMode"], hu = /* @__PURE__ */ t({
  __name: "VsgZipInput",
  props: {
    value: {},
    modelValue: {},
    disabled: { type: Boolean },
    warning: { default: "Please provide a valid zip." },
    filled: { type: Boolean },
    pattern: { default: "(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)|(^[0-9]{9}$)" },
    required: { type: Boolean },
    label: { default: "Zip code" },
    small: { type: Boolean },
    minlength: { default: 0 },
    maxlength: { default: 10 },
    caption: {},
    assistiveText: {},
    autocomplete: { type: Boolean },
    autocapitalize: {},
    name: {},
    noLabel: { type: Boolean },
    outline: { type: Boolean },
    readonly: { type: Boolean },
    placeholder: {},
    step: {},
    alwaysFloat: { type: Boolean },
    allowedCharacters: { default: "[0-9-]+" },
    showWarning: { type: Boolean },
    mask: {},
    hideRequiredIndicator: { type: Boolean },
    inputMode: { default: "text" }
  },
  emits: ["update:modelValue", "change", "blur", "keydown", "keypress"],
  setup(e, { emit: l }) {
    const a = e, s = Z(() => ({
      ...a.value !== void 0 ? { value: a.value } : {},
      ...a.modelValue !== void 0 ? { value: a.modelValue } : {}
    })), c = l, { change: d, blur: v, keydown: _, keypress: h } = k(c), x = z(null);
    return V(() => B(x, a.showWarning)), (r, g) => (n(), o("jha-form-zip-input", j({
      ref_key: "el",
      ref: x
    }, s.value, {
      disabled: r.disabled,
      warning: r.warning,
      filled: r.filled,
      pattern: r.pattern,
      required: r.required,
      label: r.label,
      small: r.small,
      minlength: r.minlength,
      maxlength: r.maxlength,
      caption: r.caption,
      assistiveText: r.assistiveText,
      autocomplete: r.autocomplete,
      autocapitalize: r.autocapitalize,
      name: r.name,
      noLabel: r.noLabel,
      outline: r.outline,
      readonly: r.readonly,
      placeholder: r.placeholder,
      step: r.step,
      alwaysFloat: r.alwaysFloat,
      allowedCharacters: r.allowedCharacters,
      showWarning: r.showWarning,
      mask: r.mask,
      hideRequiredIndicator: r.hideRequiredIndicator,
      inputMode: r.inputMode,
      onChange: g[0] || (g[0] = //@ts-ignore
      (...p) => y(d) && y(d)(...p)),
      onBlur: g[1] || (g[1] = //@ts-ignore
      (...p) => y(v) && y(v)(...p)),
      onKeydown: g[2] || (g[2] = //@ts-ignore
      (...p) => y(_) && y(_)(...p)),
      onKeypress: g[3] || (g[3] = //@ts-ignore
      (...p) => y(h) && y(h)(...p))
    }), null, 16, Ke));
  }
}), pu = /* @__PURE__ */ t({
  __name: "VsgList",
  props: {
    borderless: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const l = e, a = Z(() => ({
      ...l.borderless ? { borderless: l.borderless } : {},
      ...l.collapse ? { collapse: l.collapse } : {}
    }));
    return (s, c) => (n(), o("jha-list", j({ role: "list" }, a.value), [
      f(s.$slots, "default")
    ], 16));
  }
}), vu = /* @__PURE__ */ t({
  __name: "VsgListItem",
  props: {
    noPadding: { type: Boolean },
    inset: { type: Boolean }
  },
  setup(e) {
    const l = e, a = Z(() => ({
      ...l.noPadding ? { "no-padding": l.noPadding } : {},
      ...l.inset ? { inset: l.inset } : {}
    }));
    return (s, c) => (n(), o("jha-list-item", ee(ae(a.value)), [
      f(s.$slots, "default")
    ], 16));
  }
}), Ge = {};
function Ye(e, l) {
  return n(), o("jha-collapsible-group", null, [
    f(e.$slots, "default")
  ]);
}
const xu = /* @__PURE__ */ H(Ge, [["render", Ye]]), Qe = ["isOpen", "headless", "disabled"], yu = /* @__PURE__ */ t({
  __name: "VsgCollapsibleSection",
  props: {
    isOpen: { type: Boolean },
    headless: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["open"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("open", c);
    };
    return (c, d) => (n(), o("jha-collapsible-section", {
      isOpen: c.isOpen,
      headless: c.headless,
      disabled: c.disabled,
      onCollapsibleSectionOpened: s
    }, [
      f(c.$slots, "default")
    ], 40, Qe));
  }
}), Xe = ["isOpen", "full"], _u = /* @__PURE__ */ t({
  __name: "VsgAccordion",
  props: {
    isOpen: { type: Boolean },
    full: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-accordion", {
      isOpen: l.isOpen,
      full: l.full
    }, [
      f(l.$slots, "default")
    ], 8, Xe));
  }
}), la = ["loading", "hasData", "errorMessage", "noDataMessage", "borderless"], ea = /* @__PURE__ */ t({
  __name: "VsgCard",
  props: {
    loading: { type: Boolean },
    hasData: { type: Boolean, default: !0 },
    errorMessage: {},
    noDataMessage: { default: "No data" },
    borderless: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-card", {
      loading: l.loading,
      hasData: l.hasData,
      errorMessage: l.errorMessage,
      noDataMessage: l.noDataMessage,
      borderless: l.borderless
    }, [
      f(l.$slots, "default")
    ], 8, la));
  }
}), aa = {};
function sa(e, l) {
  return n(), o("jha-container", null, [
    f(e.$slots, "default")
  ]);
}
const wu = /* @__PURE__ */ H(aa, [["render", sa]]), ra = ["space-between", "flex-start"], fu = /* @__PURE__ */ t({
  __name: "VsgFlexWrapper",
  props: {
    spaceBetween: { type: Boolean, default: void 0 },
    flexStart: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-flex-wrapper", {
      "space-between": l.spaceBetween,
      "flex-start": l.flexStart
    }, [
      f(l.$slots, "default")
    ], 8, ra));
  }
}), na = {};
function oa(e, l) {
  return n(), o("jha-grid", null, [
    f(e.$slots, "default")
  ]);
}
const bu = /* @__PURE__ */ H(na, [["render", oa]]), zu = /* @__PURE__ */ t({
  __name: "VsgTable",
  props: {
    columns: {},
    data: {},
    striped: { type: Boolean },
    stickyHeader: { type: Boolean },
    responsive: { type: Boolean },
    rowsSelectable: { type: Boolean },
    checkboxSelection: { type: Boolean },
    hideHeaderButtons: { type: Boolean },
    nowrap: { type: Boolean },
    offsetFixedHeader: { type: Boolean },
    headerBackground: {}
  },
  emits: ["change", "tableCellClick", "select"],
  setup(e, { emit: l }) {
    const a = e, s = z(null), c = l, d = (h) => {
      c("change", h);
    }, v = (h) => {
      c("tableCellClick", h);
    }, _ = (h) => {
      c("select", h);
    };
    return rl(() => {
      Rl(() => {
        var h, x, r;
        if (a.headerBackground) {
          const g = (r = (x = (h = s.value) == null ? void 0 : h.shadowRoot) == null ? void 0 : x.children[0]) == null ? void 0 : r.querySelector("jha-table-row#header");
          g && (g.style.background = a.headerBackground);
        }
      });
    }), wl(
      () => [a.columns, a.data],
      () => {
        setTimeout(() => {
          var x;
          const h = (x = a.columns) == null ? void 0 : x.filter((r) => r.textBold);
          h == null || h.forEach((r) => {
            var p, w;
            const g = (w = (p = s.value) == null ? void 0 : p.shadowRoot) == null ? void 0 : w.querySelectorAll(`jha-table-cell#${r.id}`);
            g == null || g.forEach((b) => {
              b.children[0].style.fontWeight = "bold";
            });
          });
        }, 0);
      },
      { immediate: !0 }
    ), (h, x) => (n(), o("jha-table", j({
      ref_key: "el",
      ref: s
    }, a, {
      onChange: d,
      "on:tableCellClick": v,
      onSelect: _
    }), [
      f(h.$slots, "default")
    ], 16));
  }
}), ta = {};
function ca(e, l) {
  return n(), o("jha-table-cell", null, [
    f(e.$slots, "default")
  ]);
}
const $u = /* @__PURE__ */ H(ta, [["render", ca]]), ua = {};
function ia(e, l) {
  return n(), o("jha-table-header", null, [
    f(e.$slots, "default")
  ]);
}
const Zu = /* @__PURE__ */ H(ua, [["render", ia]]), ma = ["sticky-header"], Vu = /* @__PURE__ */ t({
  __name: "VsgTableRow",
  props: {
    stickyHeader: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-table-row", { "sticky-header": l.stickyHeader }, [
      f(l.$slots, "default")
    ], 8, ma));
  }
}), da = {};
function ga(e, l) {
  return n(), o("jha-content", null, [
    f(e.$slots, "default")
  ]);
}
const Bu = /* @__PURE__ */ H(da, [["render", ga]]), ha = {};
function pa(e, l) {
  return n(), o("jha-content-heading", null, [
    f(e.$slots, "default")
  ]);
}
const Iu = /* @__PURE__ */ H(ha, [["render", pa]]), va = ["x-small", "small", "large", "x-large"], ju = /* @__PURE__ */ t({
  __name: "VsgContentPush",
  props: {
    xSmall: { type: Boolean, default: void 0 },
    small: { type: Boolean, default: void 0 },
    large: { type: Boolean, default: void 0 },
    xLarge: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-content-push", {
      "x-small": l.xSmall,
      small: l.small,
      large: l.large,
      "x-large": l.xLarge
    }, [
      f(l.$slots, "default")
    ], 8, va));
  }
}), Mu = /* @__PURE__ */ t({
  __name: "VsgReorderList",
  emits: ["reorder"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("reorder", c);
    };
    return (c, d) => (n(), o("jha-reorder-list", { onReorder: s }, [
      f(c.$slots, "default")
    ], 32));
  }
}), xa = ["title", "itemId"], Hu = /* @__PURE__ */ t({
  __name: "VsgReorderListItem",
  props: {
    title: {},
    itemId: {}
  },
  setup(e) {
    return (l, a) => (n(), o("jha-reorder-list-item", {
      title: l.title,
      itemId: l.itemId
    }, [
      f(l.$slots, "default")
    ], 8, xa));
  }
}), ku = /* @__PURE__ */ t({
  __name: "VsgInfiniteScroll",
  emits: ["loadMore"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("loadMore", c);
    };
    return (c, d) => (n(), o("jha-infinite-scroll", { onLoadMore: s }, [
      f(c.$slots, "default")
    ], 32));
  }
}), ya = ["title", "collapsible", "open"], Cu = /* @__PURE__ */ t({
  __name: "VsgNav",
  props: {
    title: { default: "Navigation" },
    collapsible: { type: Boolean },
    open: { type: Boolean }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-nav", {
      title: l.title,
      collapsible: l.collapsible,
      open: l.open
    }, [
      f(l.$slots, "default")
    ], 8, ya));
  }
}), _a = ["open", "hovered", "disabled", "disableItemMenuClose", "disableOutsideClickClose", "focusMatchingItem", "adjustToPageBottom"], Lu = /* @__PURE__ */ t({
  __name: "VsgDropdown",
  props: {
    open: { type: Boolean },
    hovered: { type: Boolean },
    disabled: { type: Boolean },
    disableItemMenuClose: { type: Boolean },
    disableOutsideClickClose: { type: Boolean },
    focusMatchingItem: { type: Boolean },
    adjustToPageBottom: { type: Boolean }
  },
  emits: ["open", "close"],
  setup(e, { emit: l }) {
    const a = l, s = (d) => {
      a("open", d);
    }, c = (d) => {
      a("close", d);
    };
    return (d, v) => (n(), o("jha-dropdown", {
      open: d.open,
      hovered: d.hovered,
      disabled: d.disabled,
      disableItemMenuClose: d.disableItemMenuClose,
      disableOutsideClickClose: d.disableOutsideClickClose,
      focusMatchingItem: d.focusMatchingItem,
      adjustToPageBottom: d.adjustToPageBottom,
      "on:openDropdown": s,
      "on:closeDropdown": c
    }, [
      f(d.$slots, "default")
    ], 40, _a));
  }
}), wa = ["openUp"], Au = /* @__PURE__ */ t({
  __name: "VsgDropdownMenu",
  props: {
    openUp: { type: Boolean }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-dropdown-menu", { openUp: l.openUp }, [
      f(l.$slots, "default")
    ], 8, wa));
  }
}), fa = ["danger"], Eu = /* @__PURE__ */ t({
  __name: "VsgDropdownMenuItem",
  props: {
    danger: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-dropdown-menu-item", { danger: l.danger }, [
      f(l.$slots, "default")
    ], 8, fa));
  }
}), ba = {};
function za(e, l) {
  return n(), o("jha-dropdown-toggle", null, [
    f(e.$slots, "default")
  ]);
}
const Su = /* @__PURE__ */ H(ba, [["render", za]]), $a = ["filters", "buttonLabel", "menuId", "requireConfirmation"], Ju = /* @__PURE__ */ t({
  __name: "VsgFilterMenu",
  props: {
    filters: {},
    buttonLabel: {},
    menuId: {},
    requireConfirmation: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-filter-menu", {
      filters: c.filters,
      buttonLabel: c.buttonLabel,
      menuId: c.menuId,
      requireConfirmation: c.requireConfirmation,
      onChange: s
    }, [
      f(c.$slots, "default")
    ], 40, $a));
  }
}), Za = ["items", "itemsPerPage", "pageIndex"], Tu = /* @__PURE__ */ t({
  __name: "VsgPaginationControls",
  props: {
    items: {},
    itemsPerPage: { default: 4 },
    pageIndex: { default: 0 }
  },
  emits: ["change"],
  setup(e, { emit: l }) {
    const a = l, s = (c) => {
      a("change", c);
    };
    return (c, d) => (n(), o("jha-pagination-controls", {
      items: c.items,
      itemsPerPage: c.itemsPerPage,
      pageIndex: c.pageIndex,
      onChange: s
    }, null, 40, Za));
  }
}), Va = ["bordered"], qu = /* @__PURE__ */ t({
  __name: "VsgTab",
  props: {
    bordered: { type: Boolean }
  },
  setup(e) {
    const l = e, a = Z(() => ({
      ...l.bordered === !0 ? { bordered: !0 } : { bordered: void 0 }
    }));
    return (s, c) => (n(), o("jha-tab", {
      bordered: a.value.bordered
    }, [
      f(s.$slots, "default")
    ], 8, Va));
  }
}), Ba = ["active"], Ru = /* @__PURE__ */ t({
  __name: "VsgTabItem",
  props: {
    active: { type: Boolean }
  },
  setup(e) {
    const l = e, a = Z(() => ({
      ...l.active === !0 ? { active: !0 } : { active: void 0 }
    }));
    return (s, c) => (n(), o("jha-tab-item", {
      active: a.value.active
    }, [
      f(s.$slots, "default")
    ], 8, Ba));
  }
}), Ia = ["value", "label", "showValueText"], Du = /* @__PURE__ */ t({
  __name: "VsgCircleProgress",
  props: {
    value: { default: 75 },
    label: {},
    showValueText: { type: Boolean }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-circle-progress", {
      value: l.value,
      label: l.label,
      showValueText: l.showValueText
    }, null, 8, Ia));
  }
}), ja = ["inline", "card"], Ma = /* @__PURE__ */ t({
  __name: "VsgProgress",
  props: {
    inline: { type: Boolean },
    card: { type: Boolean }
  },
  setup(e) {
    const l = e, a = Z(() => ({
      ...l.inline === !0 ? { inline: !0 } : { inline: void 0 },
      ...l.card === !0 ? { card: !0 } : { card: void 0 }
    }));
    return (s, c) => (n(), o("jha-progress", {
      inline: a.value.inline,
      card: a.value.card
    }, null, 8, ja));
  }
}), Ha = ["percentage"], Fu = /* @__PURE__ */ t({
  __name: "VsgProgressLinear",
  props: {
    percentage: {}
  },
  setup(e) {
    return (l, a) => (n(), o("jha-progress-linear", { percentage: l.percentage }, null, 8, Ha));
  }
}), ka = ["type", "data", "options"], Pu = /* @__PURE__ */ t({
  __name: "VsgChart",
  props: {
    data: {},
    options: {},
    type: { default: "pie" }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-chart", {
      type: l.type,
      data: l.data,
      options: l.options
    }, null, 8, ka));
  }
}), Ca = ["primary", "success", "danger", "warning", "light", "small", "medium", "dot", "appearance"], Wu = /* @__PURE__ */ t({
  __name: "VsgBadge",
  props: {
    primary: { type: Boolean, default: void 0 },
    success: { type: Boolean, default: void 0 },
    danger: { type: Boolean, default: void 0 },
    warning: { type: Boolean, default: void 0 },
    light: { type: Boolean, default: void 0 },
    small: { type: Boolean, default: void 0 },
    medium: { type: Boolean, default: void 0 },
    dot: { type: Boolean, default: void 0 },
    appearance: {}
  },
  setup(e) {
    return (l, a) => (n(), o("jha-badge", {
      primary: l.primary,
      success: l.success,
      danger: l.danger,
      warning: l.warning,
      light: l.light,
      small: l.small,
      medium: l.medium,
      dot: l.dot,
      appearance: l.appearance
    }, [
      f(l.$slots, "default")
    ], 8, Ca));
  }
}), La = ["primary", "success", "danger", "warning", "small", "medium"], Ou = /* @__PURE__ */ t({
  __name: "VsgChip",
  props: {
    primary: { type: Boolean, default: void 0 },
    success: { type: Boolean, default: void 0 },
    danger: { type: Boolean, default: void 0 },
    warning: { type: Boolean, default: void 0 },
    small: { type: Boolean, default: void 0 },
    medium: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-chip", {
      primary: l.primary,
      success: l.success,
      danger: l.danger,
      warning: l.warning,
      small: l.small,
      medium: l.medium
    }, [
      f(l.$slots, "default")
    ], 8, La));
  }
}), Aa = {};
function Ea(e, l) {
  return n(), o("jha-error-message", null, [
    f(e.$slots, "default")
  ]);
}
const Sa = /* @__PURE__ */ H(Aa, [["render", Ea]]), Uu = {
  title: "Components/Messages/VsgErrorMessage",
  component: Sa,
  tags: ["autodocs"],
  argTypes: {
    default: {
      description: "Use slotted content to display content for the error message.",
      table: {
        category: "Slots"
      }
    },
    // @ts-expect-error CSS variables
    backgroundColor: {
      name: "--jha-color-warning",
      description: "Background color of the message",
      table: {
        category: "CSS Variables"
      }
    }
  }
}, Ja = ["success", "danger"], Nu = /* @__PURE__ */ t({
  __name: "VsgMessage",
  props: {
    success: { type: Boolean, default: void 0 },
    danger: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-message", {
      success: l.success,
      danger: l.danger
    }, [
      f(l.$slots, "default")
    ], 8, Ja));
  }
}), Ta = ["text", "visible", "bottom", "bottom-left", "bottom-right", "top", "top-left", "top-right", "left", "right"], Ku = /* @__PURE__ */ t({
  __name: "VsgTooltip",
  props: {
    text: {},
    visible: { type: Boolean },
    bottom: { type: Boolean, default: void 0 },
    bottomRight: { type: Boolean, default: void 0 },
    bottomLeft: { type: Boolean, default: void 0 },
    top: { type: Boolean, default: void 0 },
    topRight: { type: Boolean, default: void 0 },
    topLeft: { type: Boolean, default: void 0 },
    left: { type: Boolean, default: void 0 },
    right: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-tooltip", {
      text: l.text,
      visible: l.visible,
      bottom: l.bottom,
      "bottom-left": l.bottomLeft,
      "bottom-right": l.bottomRight,
      top: l.top,
      "top-left": l.topLeft,
      "top-right": l.topRight,
      left: l.left,
      right: l.right
    }, [
      f(l.$slots, "default")
    ], 8, Ta));
  }
}), qa = ["card", "primary", "success", "danger"], Gu = /* @__PURE__ */ t({
  __name: "VsgWell",
  props: {
    card: { type: Boolean, default: void 0 },
    primary: { type: Boolean, default: void 0 },
    success: { type: Boolean, default: void 0 },
    danger: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-well", {
      card: l.card,
      primary: l.primary,
      success: l.success,
      danger: l.danger
    }, [
      f(l.$slots, "default")
    ], 8, qa));
  }
}), Ra = ["avatar", "badgeUrl", "initials", "isOrgUser", "x-small", "small", "large", "x-large", "profile"], Yu = /* @__PURE__ */ t({
  __name: "VsgAvatar",
  props: {
    avatar: {},
    badgeUrl: {},
    initials: {},
    isOrgUser: { type: Boolean },
    xSmall: { type: Boolean, default: void 0 },
    small: { type: Boolean, default: void 0 },
    large: { type: Boolean, default: void 0 },
    xLarge: { type: Boolean, default: void 0 },
    profile: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-avatar", {
      avatar: l.avatar,
      badgeUrl: l.badgeUrl,
      initials: l.initials,
      isOrgUser: l.isOrgUser,
      "x-small": l.xSmall,
      small: l.small,
      large: l.large,
      "x-large": l.xLarge,
      profile: l.profile
    }, [
      f(l.$slots, "default")
    ], 8, Ra));
  }
}), Da = {};
function Fa(e, l) {
  return n(), o("jha-slider", null, [
    f(e.$slots, "default")
  ]);
}
const Qu = /* @__PURE__ */ H(Da, [["render", Fa]]), Pa = ["staticHeight", "fullHeight", "focusedPane"], Xu = /* @__PURE__ */ t({
  __name: "VsgSliderContent",
  props: {
    staticHeight: { type: Boolean, default: void 0 },
    fullHeight: { type: Boolean, default: void 0 },
    focusedPane: {}
  },
  setup(e) {
    return (l, a) => (n(), o("jha-slider-content", {
      staticHeight: l.staticHeight,
      fullHeight: l.fullHeight,
      focusedPane: l.focusedPane
    }, [
      f(l.$slots, "default")
    ], 8, Pa));
  }
}), Wa = ["focus", "pane-id"], li = /* @__PURE__ */ t({
  __name: "VsgSliderPane",
  props: {
    focus: { type: Boolean, default: void 0 },
    paneId: {}
  },
  setup(e) {
    return (l, a) => (n(), o("jha-slider-pane", {
      focus: l.focus,
      "pane-id": l.paneId
    }, [
      f(l.$slots, "default")
    ], 8, Wa));
  }
}), Oa = ["role", "duration", "isVisible"], ei = /* @__PURE__ */ t({
  __name: "VsgToast",
  props: {
    role: {},
    duration: { default: 5e3 },
    isVisible: { type: Boolean, default: void 0 }
  },
  setup(e) {
    return (l, a) => (n(), o("jha-toast", {
      role: l.role,
      duration: l.duration,
      isVisible: l.isVisible
    }, null, 8, Oa));
  }
}), Ua = {};
function Na(e, l) {
  return n(), o("jha-toast-container", null, [
    f(e.$slots, "default")
  ]);
}
const ai = /* @__PURE__ */ H(Ua, [["render", Na]]), Ka = {
  key: 0,
  class: "header"
}, Ga = { key: 1 }, Ya = { key: 1 }, Qa = /* @__PURE__ */ t({
  __name: "VsgModal",
  props: {
    title: {},
    cancelLabel: { default: "Cancel" },
    confirmLabel: { default: "Ok" },
    showCancel: { type: Boolean, default: !0 },
    showConfirm: { type: Boolean, default: !0 },
    cancelDisabled: { type: Boolean },
    confirmDisabled: { type: Boolean },
    showHeader: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showBackButton: { type: Boolean },
    showCloseButton: { type: Boolean, default: !0 },
    clickOutsideToClose: { type: Boolean, default: !0 },
    escapeToClose: { type: Boolean, default: !0 },
    size: { default: "small" },
    isLoading: { type: Boolean },
    isLoadingData: { type: Boolean },
    hasData: { type: Boolean, default: !0 },
    errorMessage: {},
    noDataMessage: {},
    teleportTo: { default: "body" },
    class: {}
  },
  emits: ["confirm", "cancel", "back"],
  setup(e, { emit: l }) {
    const a = e, s = l, c = z(null), d = () => {
      s("confirm");
    }, v = () => {
      s("cancel");
    }, _ = () => {
      s("back");
    }, h = (r) => {
      const g = r.target;
      a.clickOutsideToClose && g === c.value && v();
    }, x = (r) => {
      a.escapeToClose && r.key == "Escape" && v();
    };
    return rl(() => {
      document.body.style.overflow = "hidden", window.document.addEventListener("keydown", x);
    }), Dl(() => {
      document.body.style.overflow = "auto", window.document.removeEventListener("keydown", x);
    }), (r, g) => (n(), N(se, {
      to: a.teleportTo
    }, [
      E("dialog", {
        ref_key: "dialog",
        ref: c,
        onClick: h,
        open: ""
      }, [
        E("div", {
          class: ul({
            small: a.size === "small",
            large: a.size === "large"
          })
        }, [
          bl(ea, {
            loading: a.isLoadingData,
            "has-data": r.hasData,
            "error-message": a.errorMessage,
            "no-data-message": a.noDataMessage
          }, {
            default: K(() => [
              a.showHeader ? (n(), o("header", Ka, [
                f(r.$slots, "header", {}, () => [
                  a.showBackButton ? (n(), N(tl, {
                    key: 0,
                    onClick: re(_, ["stop"]),
                    icon: "",
                    sync: ""
                  }, {
                    default: K(() => g[0] || (g[0] = [
                      E("jha-icon-chevron-back", null, null, -1)
                    ])),
                    _: 1
                  })) : L("", !0),
                  a.title ? (n(), o("h1", Ga, F(a.title), 1)) : L("", !0),
                  a.showCloseButton ? (n(), N(tl, {
                    key: 2,
                    onClick: v,
                    icon: "",
                    sync: ""
                  }, {
                    default: K(() => g[1] || (g[1] = [
                      E("jha-icon-close", null, null, -1)
                    ])),
                    _: 1
                  })) : L("", !0)
                ], !0)
              ])) : L("", !0),
              E("div", null, [
                f(r.$slots, "fixed-content", {}, void 0, !0)
              ]),
              E("article", {
                class: ul(a.class)
              }, [
                f(r.$slots, "default", {}, void 0, !0)
              ], 2),
              a.showFooter ? (n(), o("footer", Ya, [
                f(r.$slots, "footer", {}, () => [
                  a.showCancel ? (n(), N(tl, {
                    key: 0,
                    onClick: v,
                    "aria-label": a.cancelLabel,
                    disabled: a.cancelDisabled,
                    "outline-primary": "",
                    sync: ""
                  }, {
                    default: K(() => [
                      ll(F(r.cancelLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled"])) : L("", !0),
                  a.showConfirm ? (n(), N(tl, {
                    key: 1,
                    onClick: d,
                    "aria-label": a.confirmLabel,
                    disabled: a.confirmDisabled,
                    isLoading: a.isLoading,
                    primary: "",
                    sync: ""
                  }, {
                    default: K(() => [
                      ll(F(r.confirmLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["aria-label", "disabled", "isLoading"])) : L("", !0)
                ], !0)
              ])) : L("", !0)
            ]),
            _: 3
          }, 8, ["loading", "has-data", "error-message", "no-data-message"])
        ], 2)
      ], 512)
    ], 8, ["to"]));
  }
}), si = /* @__PURE__ */ H(Qa, [["__scopeId", "data-v-8aa53dab"]]);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const cl = globalThis, $l = cl.ShadowRoot && (cl.ShadyCSS === void 0 || cl.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Zl = Symbol(), Il = /* @__PURE__ */ new WeakMap();
let Pl = class {
  constructor(l, a, s) {
    if (this._$cssResult$ = !0, s !== Zl) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = l, this.t = a;
  }
  get styleSheet() {
    let l = this.o;
    const a = this.t;
    if ($l && l === void 0) {
      const s = a !== void 0 && a.length === 1;
      s && (l = Il.get(a)), l === void 0 && ((this.o = l = new CSSStyleSheet()).replaceSync(this.cssText), s && Il.set(a, l));
    }
    return l;
  }
  toString() {
    return this.cssText;
  }
};
const Xa = (e) => new Pl(typeof e == "string" ? e : e + "", void 0, Zl), nl = (e, ...l) => {
  const a = e.length === 1 ? e[0] : l.reduce((s, c, d) => s + ((v) => {
    if (v._$cssResult$ === !0) return v.cssText;
    if (typeof v == "number") return v;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + v + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(c) + e[d + 1], e[0]);
  return new Pl(a, e, Zl);
}, ls = (e, l) => {
  if ($l) e.adoptedStyleSheets = l.map((a) => a instanceof CSSStyleSheet ? a : a.styleSheet);
  else for (const a of l) {
    const s = document.createElement("style"), c = cl.litNonce;
    c !== void 0 && s.setAttribute("nonce", c), s.textContent = a.cssText, e.appendChild(s);
  }
}, jl = $l ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((l) => {
  let a = "";
  for (const s of l.cssRules) a += s.cssText;
  return Xa(a);
})(e) : e;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: es, defineProperty: as, getOwnPropertyDescriptor: ss, getOwnPropertyNames: rs, getOwnPropertySymbols: ns, getPrototypeOf: os } = Object, J = globalThis, Ml = J.trustedTypes, ts = Ml ? Ml.emptyScript : "", vl = J.reactiveElementPolyfillSupport, Q = (e, l) => e, fl = { toAttribute(e, l) {
  switch (l) {
    case Boolean:
      e = e ? ts : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, l) {
  let a = e;
  switch (l) {
    case Boolean:
      a = e !== null;
      break;
    case Number:
      a = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        a = JSON.parse(e);
      } catch {
        a = null;
      }
  }
  return a;
} }, Wl = (e, l) => !es(e, l), Hl = { attribute: !0, type: String, converter: fl, reflect: !1, hasChanged: Wl };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), J.litPropertyMetadata ?? (J.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class D extends HTMLElement {
  static addInitializer(l) {
    this._$Ei(), (this.l ?? (this.l = [])).push(l);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(l, a = Hl) {
    if (a.state && (a.attribute = !1), this._$Ei(), this.elementProperties.set(l, a), !a.noAccessor) {
      const s = Symbol(), c = this.getPropertyDescriptor(l, s, a);
      c !== void 0 && as(this.prototype, l, c);
    }
  }
  static getPropertyDescriptor(l, a, s) {
    const { get: c, set: d } = ss(this.prototype, l) ?? { get() {
      return this[a];
    }, set(v) {
      this[a] = v;
    } };
    return { get() {
      return c == null ? void 0 : c.call(this);
    }, set(v) {
      const _ = c == null ? void 0 : c.call(this);
      d.call(this, v), this.requestUpdate(l, _, s);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(l) {
    return this.elementProperties.get(l) ?? Hl;
  }
  static _$Ei() {
    if (this.hasOwnProperty(Q("elementProperties"))) return;
    const l = os(this);
    l.finalize(), l.l !== void 0 && (this.l = [...l.l]), this.elementProperties = new Map(l.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(Q("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Q("properties"))) {
      const a = this.properties, s = [...rs(a), ...ns(a)];
      for (const c of s) this.createProperty(c, a[c]);
    }
    const l = this[Symbol.metadata];
    if (l !== null) {
      const a = litPropertyMetadata.get(l);
      if (a !== void 0) for (const [s, c] of a) this.elementProperties.set(s, c);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [a, s] of this.elementProperties) {
      const c = this._$Eu(a, s);
      c !== void 0 && this._$Eh.set(c, a);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(l) {
    const a = [];
    if (Array.isArray(l)) {
      const s = new Set(l.flat(1 / 0).reverse());
      for (const c of s) a.unshift(jl(c));
    } else l !== void 0 && a.push(jl(l));
    return a;
  }
  static _$Eu(l, a) {
    const s = a.attribute;
    return s === !1 ? void 0 : typeof s == "string" ? s : typeof l == "string" ? l.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var l;
    this._$ES = new Promise((a) => this.enableUpdating = a), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (l = this.constructor.l) == null || l.forEach((a) => a(this));
  }
  addController(l) {
    var a;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(l), this.renderRoot !== void 0 && this.isConnected && ((a = l.hostConnected) == null || a.call(l));
  }
  removeController(l) {
    var a;
    (a = this._$EO) == null || a.delete(l);
  }
  _$E_() {
    const l = /* @__PURE__ */ new Map(), a = this.constructor.elementProperties;
    for (const s of a.keys()) this.hasOwnProperty(s) && (l.set(s, this[s]), delete this[s]);
    l.size > 0 && (this._$Ep = l);
  }
  createRenderRoot() {
    const l = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return ls(l, this.constructor.elementStyles), l;
  }
  connectedCallback() {
    var l;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (l = this._$EO) == null || l.forEach((a) => {
      var s;
      return (s = a.hostConnected) == null ? void 0 : s.call(a);
    });
  }
  enableUpdating(l) {
  }
  disconnectedCallback() {
    var l;
    (l = this._$EO) == null || l.forEach((a) => {
      var s;
      return (s = a.hostDisconnected) == null ? void 0 : s.call(a);
    });
  }
  attributeChangedCallback(l, a, s) {
    this._$AK(l, s);
  }
  _$EC(l, a) {
    var d;
    const s = this.constructor.elementProperties.get(l), c = this.constructor._$Eu(l, s);
    if (c !== void 0 && s.reflect === !0) {
      const v = (((d = s.converter) == null ? void 0 : d.toAttribute) !== void 0 ? s.converter : fl).toAttribute(a, s.type);
      this._$Em = l, v == null ? this.removeAttribute(c) : this.setAttribute(c, v), this._$Em = null;
    }
  }
  _$AK(l, a) {
    var d;
    const s = this.constructor, c = s._$Eh.get(l);
    if (c !== void 0 && this._$Em !== c) {
      const v = s.getPropertyOptions(c), _ = typeof v.converter == "function" ? { fromAttribute: v.converter } : ((d = v.converter) == null ? void 0 : d.fromAttribute) !== void 0 ? v.converter : fl;
      this._$Em = c, this[c] = _.fromAttribute(a, v.type), this._$Em = null;
    }
  }
  requestUpdate(l, a, s) {
    if (l !== void 0) {
      if (s ?? (s = this.constructor.getPropertyOptions(l)), !(s.hasChanged ?? Wl)(this[l], a)) return;
      this.P(l, a, s);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(l, a, s) {
    this._$AL.has(l) || this._$AL.set(l, a), s.reflect === !0 && this._$Em !== l && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(l);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (a) {
      Promise.reject(a);
    }
    const l = this.scheduleUpdate();
    return l != null && await l, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var s;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [d, v] of this._$Ep) this[d] = v;
        this._$Ep = void 0;
      }
      const c = this.constructor.elementProperties;
      if (c.size > 0) for (const [d, v] of c) v.wrapped !== !0 || this._$AL.has(d) || this[d] === void 0 || this.P(d, this[d], v);
    }
    let l = !1;
    const a = this._$AL;
    try {
      l = this.shouldUpdate(a), l ? (this.willUpdate(a), (s = this._$EO) == null || s.forEach((c) => {
        var d;
        return (d = c.hostUpdate) == null ? void 0 : d.call(c);
      }), this.update(a)) : this._$EU();
    } catch (c) {
      throw l = !1, this._$EU(), c;
    }
    l && this._$AE(a);
  }
  willUpdate(l) {
  }
  _$AE(l) {
    var a;
    (a = this._$EO) == null || a.forEach((s) => {
      var c;
      return (c = s.hostUpdated) == null ? void 0 : c.call(s);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(l)), this.updated(l);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(l) {
    return !0;
  }
  update(l) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((a) => this._$EC(a, this[a]))), this._$EU();
  }
  updated(l) {
  }
  firstUpdated(l) {
  }
}
D.elementStyles = [], D.shadowRootOptions = { mode: "open" }, D[Q("elementProperties")] = /* @__PURE__ */ new Map(), D[Q("finalized")] = /* @__PURE__ */ new Map(), vl == null || vl({ ReactiveElement: D }), (J.reactiveElementVersions ?? (J.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const X = globalThis, ml = X.trustedTypes, kl = ml ? ml.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, Ol = "$lit$", S = `lit$${Math.random().toFixed(9).slice(2)}$`, Ul = "?" + S, cs = `<${Ul}>`, R = document, el = () => R.createComment(""), al = (e) => e === null || typeof e != "object" && typeof e != "function", Vl = Array.isArray, us = (e) => Vl(e) || typeof (e == null ? void 0 : e[Symbol.iterator]) == "function", xl = `[ 	
\f\r]`, G = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Cl = /-->/g, Ll = />/g, T = RegExp(`>|${xl}(?:([^\\s"'>=/]+)(${xl}*=${xl}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Al = /'/g, El = /"/g, Nl = /^(?:script|style|textarea|title)$/i, is = (e) => (l, ...a) => ({ _$litType$: e, strings: l, values: a }), i = is(1), P = Symbol.for("lit-noChange"), I = Symbol.for("lit-nothing"), Sl = /* @__PURE__ */ new WeakMap(), q = R.createTreeWalker(R, 129);
function Kl(e, l) {
  if (!Vl(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return kl !== void 0 ? kl.createHTML(l) : l;
}
const ms = (e, l) => {
  const a = e.length - 1, s = [];
  let c, d = l === 2 ? "<svg>" : l === 3 ? "<math>" : "", v = G;
  for (let _ = 0; _ < a; _++) {
    const h = e[_];
    let x, r, g = -1, p = 0;
    for (; p < h.length && (v.lastIndex = p, r = v.exec(h), r !== null); ) p = v.lastIndex, v === G ? r[1] === "!--" ? v = Cl : r[1] !== void 0 ? v = Ll : r[2] !== void 0 ? (Nl.test(r[2]) && (c = RegExp("</" + r[2], "g")), v = T) : r[3] !== void 0 && (v = T) : v === T ? r[0] === ">" ? (v = c ?? G, g = -1) : r[1] === void 0 ? g = -2 : (g = v.lastIndex - r[2].length, x = r[1], v = r[3] === void 0 ? T : r[3] === '"' ? El : Al) : v === El || v === Al ? v = T : v === Cl || v === Ll ? v = G : (v = T, c = void 0);
    const w = v === T && e[_ + 1].startsWith("/>") ? " " : "";
    d += v === G ? h + cs : g >= 0 ? (s.push(x), h.slice(0, g) + Ol + h.slice(g) + S + w) : h + S + (g === -2 ? _ : w);
  }
  return [Kl(e, d + (e[a] || "<?>") + (l === 2 ? "</svg>" : l === 3 ? "</math>" : "")), s];
};
class sl {
  constructor({ strings: l, _$litType$: a }, s) {
    let c;
    this.parts = [];
    let d = 0, v = 0;
    const _ = l.length - 1, h = this.parts, [x, r] = ms(l, a);
    if (this.el = sl.createElement(x, s), q.currentNode = this.el.content, a === 2 || a === 3) {
      const g = this.el.content.firstChild;
      g.replaceWith(...g.childNodes);
    }
    for (; (c = q.nextNode()) !== null && h.length < _; ) {
      if (c.nodeType === 1) {
        if (c.hasAttributes()) for (const g of c.getAttributeNames()) if (g.endsWith(Ol)) {
          const p = r[v++], w = c.getAttribute(g).split(S), b = /([.?@])?(.*)/.exec(p);
          h.push({ type: 1, index: d, name: b[2], strings: w, ctor: b[1] === "." ? gs : b[1] === "?" ? hs : b[1] === "@" ? ps : dl }), c.removeAttribute(g);
        } else g.startsWith(S) && (h.push({ type: 6, index: d }), c.removeAttribute(g));
        if (Nl.test(c.tagName)) {
          const g = c.textContent.split(S), p = g.length - 1;
          if (p > 0) {
            c.textContent = ml ? ml.emptyScript : "";
            for (let w = 0; w < p; w++) c.append(g[w], el()), q.nextNode(), h.push({ type: 2, index: ++d });
            c.append(g[p], el());
          }
        }
      } else if (c.nodeType === 8) if (c.data === Ul) h.push({ type: 2, index: d });
      else {
        let g = -1;
        for (; (g = c.data.indexOf(S, g + 1)) !== -1; ) h.push({ type: 7, index: d }), g += S.length - 1;
      }
      d++;
    }
  }
  static createElement(l, a) {
    const s = R.createElement("template");
    return s.innerHTML = l, s;
  }
}
function W(e, l, a = e, s) {
  var v, _;
  if (l === P) return l;
  let c = s !== void 0 ? (v = a._$Co) == null ? void 0 : v[s] : a._$Cl;
  const d = al(l) ? void 0 : l._$litDirective$;
  return (c == null ? void 0 : c.constructor) !== d && ((_ = c == null ? void 0 : c._$AO) == null || _.call(c, !1), d === void 0 ? c = void 0 : (c = new d(e), c._$AT(e, a, s)), s !== void 0 ? (a._$Co ?? (a._$Co = []))[s] = c : a._$Cl = c), c !== void 0 && (l = W(e, c._$AS(e, l.values), c, s)), l;
}
class ds {
  constructor(l, a) {
    this._$AV = [], this._$AN = void 0, this._$AD = l, this._$AM = a;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(l) {
    const { el: { content: a }, parts: s } = this._$AD, c = ((l == null ? void 0 : l.creationScope) ?? R).importNode(a, !0);
    q.currentNode = c;
    let d = q.nextNode(), v = 0, _ = 0, h = s[0];
    for (; h !== void 0; ) {
      if (v === h.index) {
        let x;
        h.type === 2 ? x = new ol(d, d.nextSibling, this, l) : h.type === 1 ? x = new h.ctor(d, h.name, h.strings, this, l) : h.type === 6 && (x = new vs(d, this, l)), this._$AV.push(x), h = s[++_];
      }
      v !== (h == null ? void 0 : h.index) && (d = q.nextNode(), v++);
    }
    return q.currentNode = R, c;
  }
  p(l) {
    let a = 0;
    for (const s of this._$AV) s !== void 0 && (s.strings !== void 0 ? (s._$AI(l, s, a), a += s.strings.length - 2) : s._$AI(l[a])), a++;
  }
}
class ol {
  get _$AU() {
    var l;
    return ((l = this._$AM) == null ? void 0 : l._$AU) ?? this._$Cv;
  }
  constructor(l, a, s, c) {
    this.type = 2, this._$AH = I, this._$AN = void 0, this._$AA = l, this._$AB = a, this._$AM = s, this.options = c, this._$Cv = (c == null ? void 0 : c.isConnected) ?? !0;
  }
  get parentNode() {
    let l = this._$AA.parentNode;
    const a = this._$AM;
    return a !== void 0 && (l == null ? void 0 : l.nodeType) === 11 && (l = a.parentNode), l;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(l, a = this) {
    l = W(this, l, a), al(l) ? l === I || l == null || l === "" ? (this._$AH !== I && this._$AR(), this._$AH = I) : l !== this._$AH && l !== P && this._(l) : l._$litType$ !== void 0 ? this.$(l) : l.nodeType !== void 0 ? this.T(l) : us(l) ? this.k(l) : this._(l);
  }
  O(l) {
    return this._$AA.parentNode.insertBefore(l, this._$AB);
  }
  T(l) {
    this._$AH !== l && (this._$AR(), this._$AH = this.O(l));
  }
  _(l) {
    this._$AH !== I && al(this._$AH) ? this._$AA.nextSibling.data = l : this.T(R.createTextNode(l)), this._$AH = l;
  }
  $(l) {
    var d;
    const { values: a, _$litType$: s } = l, c = typeof s == "number" ? this._$AC(l) : (s.el === void 0 && (s.el = sl.createElement(Kl(s.h, s.h[0]), this.options)), s);
    if (((d = this._$AH) == null ? void 0 : d._$AD) === c) this._$AH.p(a);
    else {
      const v = new ds(c, this), _ = v.u(this.options);
      v.p(a), this.T(_), this._$AH = v;
    }
  }
  _$AC(l) {
    let a = Sl.get(l.strings);
    return a === void 0 && Sl.set(l.strings, a = new sl(l)), a;
  }
  k(l) {
    Vl(this._$AH) || (this._$AH = [], this._$AR());
    const a = this._$AH;
    let s, c = 0;
    for (const d of l) c === a.length ? a.push(s = new ol(this.O(el()), this.O(el()), this, this.options)) : s = a[c], s._$AI(d), c++;
    c < a.length && (this._$AR(s && s._$AB.nextSibling, c), a.length = c);
  }
  _$AR(l = this._$AA.nextSibling, a) {
    var s;
    for ((s = this._$AP) == null ? void 0 : s.call(this, !1, !0, a); l && l !== this._$AB; ) {
      const c = l.nextSibling;
      l.remove(), l = c;
    }
  }
  setConnected(l) {
    var a;
    this._$AM === void 0 && (this._$Cv = l, (a = this._$AP) == null || a.call(this, l));
  }
}
class dl {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(l, a, s, c, d) {
    this.type = 1, this._$AH = I, this._$AN = void 0, this.element = l, this.name = a, this._$AM = c, this.options = d, s.length > 2 || s[0] !== "" || s[1] !== "" ? (this._$AH = Array(s.length - 1).fill(new String()), this.strings = s) : this._$AH = I;
  }
  _$AI(l, a = this, s, c) {
    const d = this.strings;
    let v = !1;
    if (d === void 0) l = W(this, l, a, 0), v = !al(l) || l !== this._$AH && l !== P, v && (this._$AH = l);
    else {
      const _ = l;
      let h, x;
      for (l = d[0], h = 0; h < d.length - 1; h++) x = W(this, _[s + h], a, h), x === P && (x = this._$AH[h]), v || (v = !al(x) || x !== this._$AH[h]), x === I ? l = I : l !== I && (l += (x ?? "") + d[h + 1]), this._$AH[h] = x;
    }
    v && !c && this.j(l);
  }
  j(l) {
    l === I ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, l ?? "");
  }
}
class gs extends dl {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(l) {
    this.element[this.name] = l === I ? void 0 : l;
  }
}
class hs extends dl {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(l) {
    this.element.toggleAttribute(this.name, !!l && l !== I);
  }
}
class ps extends dl {
  constructor(l, a, s, c, d) {
    super(l, a, s, c, d), this.type = 5;
  }
  _$AI(l, a = this) {
    if ((l = W(this, l, a, 0) ?? I) === P) return;
    const s = this._$AH, c = l === I && s !== I || l.capture !== s.capture || l.once !== s.once || l.passive !== s.passive, d = l !== I && (s === I || c);
    c && this.element.removeEventListener(this.name, this, s), d && this.element.addEventListener(this.name, this, l), this._$AH = l;
  }
  handleEvent(l) {
    var a;
    typeof this._$AH == "function" ? this._$AH.call(((a = this.options) == null ? void 0 : a.host) ?? this.element, l) : this._$AH.handleEvent(l);
  }
}
class vs {
  constructor(l, a, s) {
    this.element = l, this.type = 6, this._$AN = void 0, this._$AM = a, this.options = s;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(l) {
    W(this, l);
  }
}
const yl = X.litHtmlPolyfillSupport;
yl == null || yl(sl, ol), (X.litHtmlVersions ?? (X.litHtmlVersions = [])).push("3.2.1");
const xs = (e, l, a) => {
  const s = (a == null ? void 0 : a.renderBefore) ?? l;
  let c = s._$litPart$;
  if (c === void 0) {
    const d = (a == null ? void 0 : a.renderBefore) ?? null;
    s._$litPart$ = c = new ol(l.insertBefore(el(), d), d, void 0, a ?? {});
  }
  return c._$AI(e), c;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class u extends D {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var a;
    const l = super.createRenderRoot();
    return (a = this.renderOptions).renderBefore ?? (a.renderBefore = l.firstChild), l;
  }
  update(l) {
    const a = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(l), this._$Do = xs(a, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var l;
    super.connectedCallback(), (l = this._$Do) == null || l.setConnected(!0);
  }
  disconnectedCallback() {
    var l;
    super.disconnectedCallback(), (l = this._$Do) == null || l.setConnected(!1);
  }
  render() {
    return P;
  }
}
var Tl;
u._$litElement$ = !0, u.finalized = !0, (Tl = globalThis.litElementHydrateSupport) == null || Tl.call(globalThis, { LitElement: u });
const _l = globalThis.litElementPolyfillSupport;
_l == null || _l({ LitElement: u });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.1");
const m = nl`
  :host {
    display: inline-block;
    width: 24px;
    height: 24px;
    fill: var(
      --jha-icon-fill-color,
      var(--jha-icon-color, var(--jha-text-base))
    );
    box-sizing: content-box !important;
    margin: var(--jha-icon-margin, 0);
    padding: var(--jha-icon-padding, 0);
  }
  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
  :host([x-small]) {
    width: 16px;
    height: 16px;
  }
  :host([small]) {
    width: 18px;
    height: 18px;
  }
  :host([large]) {
    width: 36px;
    height: 36px;
  }
  :host([x-large]) {
    width: 60px;
    height: 60px;
  }
  :host([primary]) {
    fill: var(--jha-color-primary, #3aaeda);
  }
  :host([success]) {
    fill: var(--jha-color-success, #4caf50);
  }
  :host([danger]) {
    fill: var(--jha-color-danger, #f44336);
  }
  :host([base]) {
    fill: var(--jha-text-base, #6b757b);
  }
  :host([light]) {
    fill: var(--jha-color-light, #8c989f);
  }
  :host([muted]) {
    fill: var(--jha-color-muted, #b3bfc9);
  }
  :host([neutral]) {
    fill: var(--jha-color-neutral, #8d99a0);
  }
`;
class ys extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.53 4.47 12 3.94l-.53.53-4 4a.75.75 0 0 0 1.06 1.061l2.72-2.72v9.19a.75.75 0 0 0 1.5 0v-9.19l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4ZM3 14.252a.75.75 0 0 1 .75.75v3.045c0 .403.117.736.268.949.152.215.292.256.367.256h15.23c.075 0 .215-.041.367-.256.151-.213.268-.546.268-.95v-3.044a.75.75 0 0 1 1.5 0v3.045c0 .676-.193 1.32-.544 1.816-.348.493-.9.889-1.59.889H4.384c-.69 0-1.242-.396-1.59-.89-.35-.494-.544-1.139-.544-1.816v-3.044a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-upload", ys);
const _s = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ws = /* @__PURE__ */ t({
  __name: "VsgIconUpload",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-upload", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _s));
  }
}), fs = { class: "flex-center wrapper" }, bs = ["disabled", "multiple", "accept"], zs = 1048576, $s = /* @__PURE__ */ t({
  __name: "VsgCustomFileUploader",
  props: {
    maxFileSizeMB: { default: 50 },
    accept: { default: "image/*,.xlsx,.xls,.pdf,.doc,.docx" },
    multiple: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["dragIn", "dragOut", "drop", "change"],
  setup(e, { emit: l }) {
    const a = {
      sizeExceeded: "File exceeded maximum size",
      invalidFormat: "Invalid file format"
    }, s = e, c = l, d = z(null), v = z(!1), _ = (w) => {
      w.preventDefault(), w.stopPropagation(), v.value = !0, c("dragIn", w);
    }, h = (w) => {
      w.preventDefault(), w.stopPropagation(), v.value = !1, c("dragOut", w);
    }, x = async (w) => {
      var $, M;
      if (w.preventDefault(), w.stopPropagation(), v.value = !1, !(($ = w.dataTransfer) != null && $.files)) return;
      const b = await g((M = w.dataTransfer) == null ? void 0 : M.files);
      c("drop", b);
    }, r = (w) => {
      const b = s.accept.split(","), $ = w.type, M = w.type.replace(/\/.*$/, "");
      return b.some((A) => {
        const C = A.trim();
        if (C.charAt(0) === ".") {
          const gl = w.name.toLowerCase(), U = w.name.length - C.length;
          return gl.indexOf(C.toLowerCase(), U) !== -1;
        } else if (/\/\*$/.test(C))
          return M === C.replace(/\/.*$/, "");
        return $ === C;
      });
    }, g = async (w) => {
      const b = [];
      for (let $ = 0; $ < w.length; $ += 1) {
        const M = w[$], A = { file: M, error: null }, C = s.maxFileSizeMB * zs;
        M.size > C && (A.error = a.sizeExceeded), r(M) || (A.error = a.invalidFormat), b.push(A);
      }
      return b;
    }, p = async (w) => {
      w.preventDefault(), w.stopPropagation();
      const b = w.target;
      if (!b.files) return;
      const $ = await g(b.files);
      c("change", $);
    };
    return (w, b) => (n(), o("div", fs, [
      E("label", {
        for: "dropzone-file",
        class: ul(["flex-center", { "bg-light border-solid": v.value }])
      }, [
        f(w.$slots, "icon", {}, () => [
          bl(ws, {
            primary: "",
            large: ""
          })
        ], !0),
        f(w.$slots, "default", {}, () => [
          b[0] || (b[0] = ll(" Drag and drop your files here or browse files "))
        ], !0),
        E("input", {
          ref_key: "inputRef",
          ref: d,
          type: "file",
          disabled: s.disabled,
          multiple: s.multiple,
          accept: s.accept,
          onDragenter: _,
          onDragleave: h,
          onDrop: x,
          onChange: p
        }, null, 40, bs)
      ], 2)
    ]));
  }
}), ni = /* @__PURE__ */ H($s, [["__scopeId", "data-v-e6988de1"]]), Zs = { class: "loader-wrapper" }, Vs = /* @__PURE__ */ t({
  __name: "VsgLoader",
  setup(e) {
    return rl(() => {
      document.body.classList.add("overflow-hidden");
    }), Dl(() => {
      document.body.classList.remove("overflow-hidden");
    }), (l, a) => (n(), o("div", Zs, [
      bl(Ma, {
        style: { "z-index": "50" },
        large: "",
        card: ""
      })
    ]));
  }
}), oi = /* @__PURE__ */ H(Vs, [["__scopeId", "data-v-a0df1616"]]), Gl = nl`
  * {
    box-sizing: border-box;
  }
  *[hidden] {
    display: none;
  }
  *[button-reset] {
    touch-action: manipulation;
    background: none;
    border: none;
    color: var(--jha-text-dark);
    cursor: pointer;
    display: block;
    font-family: -apple-system, system-ui, 'Segoe UI', Roboto, 'Helvetica Neue',
      sans-serif;
    font-size: 14px;
    margin: 0;
    padding: 0;
    text-align: left;
    width: 100%;
    -webkit-appearance: none;
  }
  header[dialog] {
    padding: 32px;
    border-bottom: 1px solid var(--jha-border-color, #e4e7ea);
    border-top-left-radius: 1px;
    border-top-right-radius: 1px;
    text-align: center;
    position: relative;
    font-size: 18px;
    font-weight: 400;
    color: var(--jha-text-dark, #455564);
  }
  hr {
    box-sizing: content-box;
    height: 1px;
    background-color: var(--jha-border-color);
    border: 0;
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
function Bs() {
  return Math.round(16 * Math.random()).toString(16);
}
function Is() {
  return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/x/g, () => Bs());
}
const js = nl`
  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(105%);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeOutDown {
    0% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    100% {
      opacity: 0;
      transform: translate3d(0, 15%, 0);
    }
  }
  :host {
    display: flex;
    position: relative;
    contain: content;
    color: var(--jha-toast-text-color, #fff);
    background-color: var(
      --jha-toast-background,
      var(--jha-color-dark, #455564)
    );
    border-radius: var(--jha-toast-border-radius, 0px);
    margin-bottom: 8px;
    padding: 12px 24px;
    opacity: 0;
    transform: translateY(105%);
    transition: all cubic-bezier(0.1, 0.5, 0.1, 1) 0.75s;
    will-change: opacity, transform;
  }
  :host([role='danger']),
  :host([danger]) {
    background-color: var(
      --jha-toast-background-danger,
      var(--jha-color-danger, #f44336)
    );
  }
  :host([role='success']),
  :host([success]) {
    background-color: var(
      --jha-toast-background-success,
      var(--jha-color-success, #4caf50)
    );
  }
  :host([is-visible]) {
    animation-name: fadeInUp;
    animation-duration: 0.75s;
    animation-timing-function: cubic-bezier(0.1, 0.5, 0.1, 1);
    animation-delay: initial;
    animation-iteration-count: 1;
    animation-direction: initial;
    animation-fill-mode: backwards;
    animation-play-state: initial;
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    transition:
      opacity,
      transform cubic-bezier(0.1, 0.5, 0.1, 1) 0.75s;
    will-change: opacity, transform;
  }
  :host ::slotted(.icon) {
    fill: #fff;
    margin-right: 10px;
  }
  :host ::slotted(div) {
    --jha-button-background: #fff;
    --jha-button-link-font-weight: 700;
  }
  @media (min-width: 415px) {
    :host {
      border-radius: var(--jha-toast-border-radius, 2px);
    }
  }
`;
class Yl extends u {
  static get styles() {
    return [Gl, js];
  }
  static get properties() {
    return {
      role: {
        type: String,
        reflect: !0,
        attribute: "role"
      },
      duration: {
        type: Number
      },
      isVisible: {
        type: Boolean,
        reflect: !0,
        attribute: "is-visible"
      }
    };
  }
  constructor() {
    super(), this.role = null, this.duration = 5e3, this.isVisible = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.displayToast();
  }
  displayToast() {
    this.isVisible = !0, this.addEventListener("transitionend", () => {
      this.dispatchEvent(new CustomEvent("hide"));
    }, { once: !0 }), setTimeout(() => {
      this.isVisible = !1;
    }, this.duration || 5e3);
  }
  render() {
    return i`
      <slot></slot>
    `;
  }
}
customElements.define("jha-toast", Yl);
const Ms = nl`
  :host {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1060;
    pointer-events: none;
  }
  @media (min-width: 740px) {
    :host {
      bottom: 32px;
      left: 32px;
    }
  }
  @media (min-width: 415px) {
    :host {
      min-width: var(--jha-toast-min-width, 288px);
      max-width: var(--jha-toast-max-width, 568px);
      bottom: 24px;
      left: 16px;
    }
  }
`;
class Ql extends u {
  static get styles() {
    return [Gl, Ms];
  }
  /** @param {ToastObject} toast */
  addToast(l) {
    const a = new Yl();
    if (a.duration = l.duration, a.setAttribute("id", `toast-${Is()}`), l.el && a.appendChild(l.el), l.message) {
      const s = new Text();
      s.textContent = l.message, a.appendChild(s);
    }
    l.role && (a.role = l.role), a.addEventListener("hide", (s) => {
      this.removeToast(s.target.id);
    }), this.shadowRoot.appendChild(a);
  }
  /** @param {string} toastId */
  removeToast(l) {
    const a = this.shadowRoot.querySelector(`#${l}`);
    a && a.remove();
  }
  render() {
    return i`
      <slot></slot>
    `;
  }
}
customElements.define("jha-toast-container", Ql);
const ti = (e) => {
  const l = document.querySelector("body");
  let a = (
    /** @type{?JhaToastContainer} */
    l.querySelector("jha-toast-container")
  );
  a || (a = new Ql(), l.appendChild(a)), a.addToast(e);
};
async function ci() {
  await Promise.all([
    import("./jha-nav-BRvejqyD.js"),
    import("./jha-button-By46Vpc3.js"),
    import("./jha-reorder-list-BKD2-Bbj.js"),
    import("./jha-reorder-list-item-BxHSR1Cw.js"),
    import("./jha-button-group-BS1uEV8E.js"),
    import("./jha-link-button-fy8Yg-Ea.js"),
    import("./jha-form-advanced-search-D0f7fAZl.js"),
    import("./jha-form-input-CwSNFFX2.js"),
    import("./jha-form-cc-input-BHGdcpHL.js"),
    import("./jha-form-checkbox-nnWS3KBp.js"),
    import("./jha-form-chip-input-CfjYsAT-.js"),
    import("./jha-form-chip-input-country-Du9tK6T3.js"),
    import("./jha-form-currency-input-CCTFEkpa.js"),
    import("./jha-form-cvv-input-BqT_zro7.js"),
    import("./jha-form-date-input-D8y9VYPQ.js"),
    import("./jha-form-date-input-icon-vVkJkoqj.js"),
    import("./jha-date-picker-Dsv_-U7f.js"),
    import("./jha-day-picker-Dc0kCn_6.js"),
    import("./jha-form-email-input-hUeKiX2v.js"),
    import("./jha-form-file-input-BEx8FaIy.js"),
    import("./jha-file-uploader-DILcXdJa.js"),
    import("./jha-form-floating-group-z73hgqvD.js"),
    import("./jha-form-multi-select-Cf8iP-xZ.js"),
    import("./jha-form-percent-input-Ci6M_KMN.js"),
    import("./jha-form-phone-number-DiiBffRO.js"),
    import("./jha-form-radio-button-BoRzYXxi.js"),
    import("./jha-form-range-slider-BJ9sh8MK.js"),
    import("./jha-form-search-input-CXrO2LRB.js"),
    import("./jha-form-select-DWw2uqoe.js"),
    import("./jha-form-select-card-type-aZDt2xYo.js"),
    import("./jha-form-select-country-vw0eQkVP.js"),
    import("./jha-form-select-month-Ck_iUgRn.js"),
    import("./jha-form-state-select-BS-pL3ms.js"),
    import("./jha-form-select-year-BpPvMFDF.js"),
    import("./jha-form-signature-input-CEUY2OLS.js"),
    import("./jha-form-ssn-DAjlmmG_.js"),
    import("./jha-form-switch-eRQrpcg4.js"),
    import("./jha-form-text-input-DI23cFh3.js"),
    import("./jha-form-textarea-input-Br9Hy3R2.js"),
    import("./jha-form-zip-input-oVGBibRF.js"),
    import("./jha-collapsible-group-Biei_UCN.js"),
    import("./jha-collapsible-section-C3SGjzAa.js"),
    import("./jha-content-2dMOfTOP.js"),
    import("./jha-content-heading-CAtEp69B.js"),
    import("./jha-content-push-Cuk1PsOs.js"),
    import("./jha-table-Bu00axpb.js"),
    // Table sub-components are imported in the main table component, so they don't need to be imported here.
    // import('@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell'),
    // import('@banno/jha-wc/src/tables/jha-table-header/jha-table-header'),
    // import('@banno/jha-wc/src/tables/jha-table-row/jha-table-row'),
    import("./jha-accordion-CeqarcZ-.js"),
    import("./jha-card-C7WHBl7Q.js"),
    import("./jha-container-DJSSKK2a.js"),
    import("./jha-flex-wrapper-RUZLbEiK.js"),
    import("./jha-grid-ClqS4zFg.js"),
    import("./jha-infinite-scroll-g8Vs4y3j.js"),
    import("./jha-list-Cqp0LBts.js"),
    import("./jha-list-item-Bkn1rR9x.js"),
    import("./jha-pagination-controls-DglZotOc.js"),
    import("./jha-dropdown-BNRsPcCp.js"),
    import("./jha-dropdown-toggle-DyD17NzG.js"),
    import("./jha-dropdown-menu-DSgWaAnU.js"),
    import("./jha-dropdown-menu-item-QUhuViLR.js"),
    import("./jha-filter-menu-2H9qjwCc.js"),
    import("./jha-tab-Df77XEEc.js"),
    import("./jha-tab-item-B6955PGl.js"),
    import("./jha-circle-progress-CLdhGTgj.js"),
    import("./jha-progress-BR0Wo1sa.js"),
    import("./jha-progress-linear-DsuNZPQ6.js"),
    import("./jha-chart-Be3K1oas.js"),
    import("./jha-badge-lK8LvXNX.js"),
    import("./jha-chip-CeYB7RvT.js"),
    import("./jha-error-message-CEbfXJBZ.js"),
    import("./jha-message-C-K3mS2S.js"),
    import("./jha-tooltip-BdUrS8ly.js"),
    import("./jha-well-CVGwFZy7.js"),
    import("./jha-avatar-C9iwSk43.js"),
    import("./jha-slider-UBkoL0s6.js"),
    import("./jha-slider-content-DtiLBMBG.js"),
    import("./jha-slider-pane-C5rAV7vU.js")
    // import('@banno/jha-wc/src/js/utils/toast-util')
    // Toasts are imported in the toast util which is imported in the toast-utils file
    // import('@banno/jha-wc/src/toasts/jha-toast/jha-toast'),
    // import('@banno/jha-wc/src/toasts/jha-toast-container/jha-toast-container')
  ]);
}
const Hs = nl`
  * {
    --jha-platform-font: system-ui, -apple-system, BlinkMacSystemFont,
      sans-serif;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  *::before,
  *::after {
    user-select: none;
    -webkit-user-select: none;
  }
  body {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
    color: var(--jha-text-base);
    font-family: var(--jha-platform-font);
    line-height: 1.4;
    background-color: var(--jha-background-color, #f8f8f8);
  }
`, Y = {
  CONSUMER: "consumer",
  DESIGN_SYSTEM: "design-system",
  DESIGN_SYSTEM_INPUTS: "design-system-inputs",
  JHA_ADMIN: "jha-admin"
}, ks = (e) => {
  Object.values(Y).filter((l) => l !== e).forEach((l) => {
    const a = document.querySelector(`style#jha-wc-${l}`);
    a && a.remove();
  });
}, Cs = async () => {
  const e = await import("./design-system-inputs-BT6jEfkr.js"), l = document.createElement("style");
  l.id = "ds-inputs", l.innerHTML = `${e.default}`, document.head.append(l);
}, Jl = async (e = !1) => {
  let a = (await import("./jh-theme-light-BLzYPCIx.js")).default;
  if (!e) {
    let d = await import("./jh-theme-dark-Bq_G53vg.js");
    d = d.default.replace(".jh-theme-dark", ":root"), a = `
      ${a}
      @media (prefers-color-scheme: dark) {
        ${d}
      }
    `;
  }
  const s = "jh-theme", c = document.querySelector(`style#${s}`);
  if (c)
    c.innerHTML = a;
  else {
    const d = document.createElement("style");
    d.id = s, d.innerHTML = a, document.head.append(d);
  }
}, ui = async (e, l = !1) => {
  let a;
  try {
    switch (e) {
      case Y.CONSUMER:
        a = await import("./consumer-BrpaKuA8.js");
        break;
      case Y.DESIGN_SYSTEM:
        await Jl(l), a = await import("./design-system-DHiYw4Lc.js");
        break;
      case Y.DESIGN_SYSTEM_INPUTS:
        await Jl(l), await Cs(), a = await import("./design-system-DHiYw4Lc.js");
        break;
      case Y.JHA_ADMIN:
        a = await import("./jha-admin-Dml5gxZM.js");
        break;
      default:
        break;
    }
  } catch (v) {
    console.log(v);
    return;
  }
  const s = `
    ${Hs}
    ${a.default}
  `, c = `jha-wc-${e}`, d = document.querySelector(`style#${c}`);
  if (d)
    d.innerHTML = s;
  else {
    const v = document.createElement("style");
    v.id = c, v.innerHTML = s, document.head.append(v);
  }
  ks(e);
};
class Ls extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.004 3h-1.25a1.75 1.75 0 0 0-1.75 1.75v9.517a7.266 7.266 0 0 1 1.5 1.007V4.75a.25.25 0 0 1 .25-.25h1.25V3Zm6.75 18.5h-5.883a2.26 2.26 0 0 0 .129-.753c0-.252-.013-.501-.038-.747h5.792a.25.25 0 0 0 .25-.25V18.5h-6.359a7.208 7.208 0 0 0-.687-1.5h7.046V4.75a.25.25 0 0 0-.25-.25h-1.25V3h1.25c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75ZM4.75 17.997a.75.75 0 0 0 0 1.5c.69 0 1.25.56 1.25 1.25a.75.75 0 0 0 1.5 0 2.75 2.75 0 0 0-2.75-2.75ZM4 15.747a.75.75 0 0 1 .75-.75 5.75 5.75 0 0 1 5.75 5.75.75.75 0 0 1-1.5 0 4.25 4.25 0 0 0-4.25-4.25.75.75 0 0 1-.75-.75ZM14.254 7.25a.5.5 0 0 0-1 0v1.377l-1.187-.697a.5.5 0 0 0-.506.863l1.2.704-1.205.695a.5.5 0 0 0 .5.866l1.198-.692v1.384a.5.5 0 1 0 1 0v-1.377l1.188.697a.5.5 0 1 0 .506-.863l-1.2-.704 1.205-.695a.5.5 0 1 0-.5-.866l-1.199.692V7.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-2fa-device", Ls);
const As = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ii = /* @__PURE__ */ t({
  __name: "VsgIcon2faDevice",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-2fa-device", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, As));
  }
});
class Es extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.368 2.346 12 2.14l-.368.207-8 4.5-.382.215V7.5c0 6.425 2.064 10.016 4.246 11.993a9.608 9.608 0 0 0 2.984 1.855 7.9 7.9 0 0 0 1.004.315 5.345 5.345 0 0 0 .382.075l.026.004.009.001h.003l.002.001L12 21l-.093.744.093.012.093-.012L12 21l.094.744h.005l.009-.002.026-.004a5.345 5.345 0 0 0 .382-.076 7.826 7.826 0 0 0 1.004-.314 9.607 9.607 0 0 0 2.984-1.855c2.182-1.977 4.246-5.568 4.246-11.993v-.439l-.382-.215-8-4.5Zm-.197 17.857L12 20.24a6.332 6.332 0 0 1-.98-.291 8.107 8.107 0 0 1-2.516-1.567c-1.774-1.608-3.66-4.655-3.75-10.445L12 3.86l7.247 4.076c-.09 5.79-1.977 8.837-3.75 10.445a8.108 8.108 0 0 1-2.517 1.567c-.34.13-.62.209-.809.254Zm-.267.053Zm4.1-11.261a.75.75 0 0 1 .001 1.06l-4.95 4.95-.015.015-.01.01a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.97 1.97 4.444-4.445a.75.75 0 0 1 1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-2fa", Es);
const Ss = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], mi = /* @__PURE__ */ t({
  __name: "VsgIcon2fa",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-2fa", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ss));
  }
});
class Js extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8.5 2.25a.75.75 0 0 1 .687.45l3.5 8a.75.75 0 1 1-1.374.6l-.679-1.55H6.366l-.679 1.55a.75.75 0 0 1-1.374-.6l3.5-8a.75.75 0 0 1 .687-.45Zm-1.478 6h2.956L8.5 4.871 7.022 8.25Zm7.508 4.22a.75.75 0 1 0-1.06 1.06l2.72 2.72H9.5c-1.11 0-1.808-.254-2.252-.548a2.193 2.193 0 0 1-.825-.993.75.75 0 1 0-1.383.58 3.693 3.693 0 0 0 1.379 1.663c.735.488 1.737.798 3.081.798h6.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4 .53-.53-.53-.53-4-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-ach", Js);
const Ts = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], di = /* @__PURE__ */ t({
  __name: "VsgIconAch",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-ach", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ts));
  }
});
class qs extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m12 2.107.507.465 3 2.753a.75.75 0 0 1-1.014 1.106l-1.743-1.6v9.044a.75.75 0 0 1-1.5 0V4.831l-1.743 1.6a.75.75 0 0 1-1.014-1.106l3-2.753.507-.465ZM7 9.625a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25h-2.008a.75.75 0 0 1 0-1.5H17c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75H7a1.75 1.75 0 0 1-1.75-1.75v-10c0-.966.784-1.75 1.75-1.75h2.012a.75.75 0 0 1 0 1.5H7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-action", qs);
const Rs = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], gi = /* @__PURE__ */ t({
  __name: "VsgIconAction",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-action", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Rs));
  }
});
class Ds extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.25 4A.75.75 0 0 1 6 3.25h6a.75.75 0 0 1 .53.22l6 6c.141.14.22.332.22.53v10a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V4Zm1.5.75v14.5h10.5v-8.5H12a.75.75 0 0 1-.75-.75V4.75h-4.5Zm6 1.06v3.44h3.439L12.75 5.81Zm0 6.69a.75.75 0 0 0-1.5 0v1.75H9.5a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75h1.75a.75.75 0 0 0 0-1.5h-1.75V12.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-add-document", Ds);
const Fs = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], hi = /* @__PURE__ */ t({
  __name: "VsgIconAddDocument",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-add-document", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Fs));
  }
});
class Ps extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.928 4.796c.614-.427 1.397-.671 2.366-.671.97 0 1.752.244 2.366.671.61.423 1.002.99 1.253 1.556.484 1.089.484 2.267.484 2.697v.017c0 .529-.137 1.264-.432 2-.253.632-.64 1.307-1.204 1.869a.83.83 0 0 0 .065.194c.047.097.127.2.318.296.347.173.804.313 1.363.473l.178.05c.49.139 1.038.294 1.543.494.568.224 1.156.533 1.606 1.01.471.501.754 1.15.754 1.961v1.712a.75.75 0 0 1-1.5 0v-1.712c0-.428-.136-.709-.346-.932-.231-.246-.585-.455-1.066-.645-.43-.17-.9-.303-1.402-.445l-.177-.05c-.541-.155-1.132-.329-1.624-.575a2.13 2.13 0 0 1-.996-.98c-.188-.386-.237-.786-.251-1.118l-.016-.372.287-.237c.487-.403.842-.968 1.076-1.55.235-.588.324-1.133.324-1.443 0-.423-.007-1.323-.354-2.105-.168-.378-.405-.701-.738-.933-.33-.228-.803-.403-1.51-.403-.708 0-1.183.175-1.512.403-.333.232-.57.555-.737.933-.348.782-.355 1.682-.355 2.105 0 .31.088.85.32 1.433.231.578.582 1.141 1.065 1.547l.323.271-.064.417a3.99 3.99 0 0 1-.27.96c-.158.359-.44.818-.95 1.072-.492.246-1.082.42-1.623.574l-.178.05c-.5.143-.972.276-1.402.446-.48.19-.835.4-1.066.645-.21.223-.346.504-.346.932v1.712a.75.75 0 0 1-1.5 0v-1.712c0-.811.283-1.46.754-1.96.45-.478 1.039-.787 1.606-1.011.505-.2 1.053-.355 1.543-.494l.178-.05c.56-.16 1.016-.3 1.363-.473.058-.03.153-.119.246-.332.031-.071.057-.145.08-.218a5.612 5.612 0 0 1-1.151-1.82c-.293-.731-.428-1.46-.428-1.989V9.05c0-.43 0-1.608.484-2.697.251-.566.643-1.133 1.253-1.556ZM15.5 8.625H18v-2.5h1.5v2.5H22v1.5h-2.5v2.5H18v-2.5h-2.5v-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-add-person", Ps);
const Ws = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], pi = /* @__PURE__ */ t({
  __name: "VsgIconAddPerson",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-add-person", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ws));
  }
});
class Os extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M17.242 3.645a2.2 2.2 0 0 1 3.113 0 2.2 2.2 0 0 1 0 3.113l-3.468 3.468 1.958 8.487a.75.75 0 0 1-.2.7l-1.368 1.367a.75.75 0 0 1-1.195-.182l-3.289-6.278-2.775 2.775.288 2.023a.75.75 0 0 1-.212.636L9.068 20.78a.75.75 0 0 1-1.186-.166l-1.606-2.89-2.89-1.607a.75.75 0 0 1-.166-1.185l1.025-1.026a.75.75 0 0 1 .637-.212l2.023.289 2.776-2.776-6.279-3.289a.75.75 0 0 1-.182-1.194l1.368-1.369a.75.75 0 0 1 .699-.2l8.487 1.959 3.468-3.468Zm2.052 1.06a.699.699 0 0 0-.991 0v.001L14.54 8.468a.75.75 0 0 1-.699.2L5.355 6.71l-.353.353 6.278 3.289a.75.75 0 0 1 .183 1.194L7.7 15.308a.75.75 0 0 1-.636.213l-2.023-.29-.058.058 2.209 1.227a.75.75 0 0 1 .291.292l1.228 2.209.058-.058-.29-2.023a.75.75 0 0 1 .213-.636l3.762-3.762a.75.75 0 0 1 1.195.182l3.288 6.278.353-.352-1.958-8.488a.75.75 0 0 1 .2-.699l3.762-3.761a.7.7 0 0 0 0-.992Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-airplane", Os);
const Us = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], vi = /* @__PURE__ */ t({
  __name: "VsgIconAirplane",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-airplane", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Us));
  }
});
class Ns extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.53 3.53a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 1.06 1.06l3-3ZM4.75 12a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM12 20.75a8.715 8.715 0 0 1-3.816-.874L6.53 21.53a.75.75 0 1 1-1.06-1.06l1.389-1.39a8.75 8.75 0 1 1 10.283 0l1.388 1.39a.75.75 0 1 1-1.06 1.06l-1.654-1.654A8.716 8.716 0 0 1 12 20.75Zm5.47-18.28a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06ZM12.25 8a.75.75 0 0 0-1.5 0v4c0 .25.125.485.334.624l3 2a.75.75 0 0 0 .832-1.248l-2.666-1.777v-3.6Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-alarm-clock", Ns);
const Ks = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], xi = /* @__PURE__ */ t({
  __name: "VsgIconAlarmClock",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-alarm-clock", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ks));
  }
});
class Gs extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7 17c0 .458.375.833.833.833h.834v2.917c0 .692.558 1.25 1.25 1.25.691 0 1.25-.558 1.25-1.25v-2.917h1.666v2.917c0 .692.559 1.25 1.25 1.25.692 0 1.25-.558 1.25-1.25v-2.917h.834A.836.836 0 0 0 17 17V8.667H7V17ZM4.917 8.667c-.692 0-1.25.558-1.25 1.25v5.833c0 .692.558 1.25 1.25 1.25.691 0 1.25-.558 1.25-1.25V9.917c0-.692-.559-1.25-1.25-1.25Zm14.166 0c-.691 0-1.25.558-1.25 1.25v5.833c0 .692.559 1.25 1.25 1.25.692 0 1.25-.558 1.25-1.25V9.917c0-.692-.558-1.25-1.25-1.25ZM14.942 3.8l1.083-1.083a.413.413 0 0 0 0-.592.413.413 0 0 0-.592 0L14.2 3.358a4.867 4.867 0 0 0-2.2-.525c-.8 0-1.55.192-2.217.525L8.542 2.125a.413.413 0 0 0-.592 0 .413.413 0 0 0 0 .592l1.092 1.091A4.986 4.986 0 0 0 7 7.833h10A4.971 4.971 0 0 0 14.942 3.8Zm-4.609 2.367H9.5v-.834h.833v.834Zm4.167 0h-.833v-.834h.833v.834Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-android", Gs);
const Ys = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], yi = /* @__PURE__ */ t({
  __name: "VsgIconAndroid",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-android", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ys));
  }
});
class Qs extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19.983 8.727c-1-1.272-2.455-2-3.819-2-1.818 0-2.545.818-3.818.818-1.273 0-2.273-.818-3.818-.818s-3.182.91-4.182 2.546c-1.545 2.181-1.273 6.363 1.091 10 .818 1.273 2 2.727 3.455 2.727 1.272 0 1.636-.818 3.454-.818 1.818 0 2.091.818 3.455.818 1.454 0 2.636-1.636 3.545-2.91.637-.908.818-1.363 1.273-2.454-3.455-1.272-4-6.09-.636-7.909ZM14.8 5.273c.636-.818 1.182-2 1-3.273-1.091.09-2.364.727-3.091 1.636-.637.819-1.182 2-1 3.182 1.182 0 2.363-.636 3.09-1.545Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-apple", Qs);
const Xs = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], _i = /* @__PURE__ */ t({
  __name: "VsgIconApple",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-apple", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Xs));
  }
});
class l0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.53 5.53a.75.75 0 0 0-1.06-1.06l-7 7a.75.75 0 0 0 0 1.06l7 7a.75.75 0 1 0 1.06-1.06l-5.72-5.72H19a.75.75 0 0 0 0-1.5H6.81l5.72-5.72Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-back", l0);
const e0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], wi = /* @__PURE__ */ t({
  __name: "VsgIconArrowBack",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-back", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, e0));
  }
});
class a0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M20.75 12a8.75 8.75 0 0 0-15-6.123V4a.75.75 0 0 0-1.5 0v4.75H9a.75.75 0 0 0 0-1.5H6.522A7.25 7.25 0 0 1 19.25 12a.75.75 0 0 0 1.5 0Zm-1.54 3.549a.75.75 0 0 0-1.031.246 7.273 7.273 0 0 1-.807 1.074.75.75 0 1 0 1.111 1.007c.363-.4.689-.833.973-1.295a.75.75 0 0 0-.245-1.032ZM5.15 16.2A.75.75 0 0 0 5 17.252c.296.394.624.761.98 1.1a.75.75 0 1 0 1.032-1.09 7.291 7.291 0 0 1-.813-.91.75.75 0 0 0-1.05-.15Zm9.063 3.527a.75.75 0 0 0-.875-.6 7.293 7.293 0 0 1-2.556.021.75.75 0 1 0-.25 1.48 8.807 8.807 0 0 0 3.081-.026.75.75 0 0 0 .6-.875Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-dashed-rotate-left", a0);
const s0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], fi = /* @__PURE__ */ t({
  __name: "VsgIconArrowDashedRotateLeft",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-dashed-rotate-left", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, s0));
  }
});
class r0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M3.25 12a8.75 8.75 0 0 1 15-6.123V4a.75.75 0 0 1 1.5 0v4.75H15a.75.75 0 0 1 0-1.5h2.477A7.25 7.25 0 0 0 4.75 12a.75.75 0 0 1-1.5 0Zm1.54 3.549a.75.75 0 0 1 1.031.246c.216.35.461.682.732.99a.75.75 0 0 1-1.126.99 8.779 8.779 0 0 1-.883-1.194.75.75 0 0 1 .245-1.032Zm14.06.651a.75.75 0 0 1 .15 1.051 8.8 8.8 0 0 1-.892 1.014.75.75 0 0 1-1.047-1.074c.267-.26.515-.542.74-.84a.75.75 0 0 1 1.05-.15Zm-8.943 3.56a.75.75 0 0 1 .865-.613 7.306 7.306 0 0 0 2.345.018.75.75 0 1 1 .23 1.482 8.82 8.82 0 0 1-2.827-.022.75.75 0 0 1-.613-.865Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-dashed-rotate-right", r0);
const n0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], bi = /* @__PURE__ */ t({
  __name: "VsgIconArrowDashedRotateRight",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-dashed-rotate-right", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, n0));
  }
});
class o0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m12 15-5-5h10l-5 5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-drop-down", o0);
const t0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], zi = /* @__PURE__ */ t({
  __name: "VsgIconArrowDropDown",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-drop-down", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, t0));
  }
});
class c0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m9 12 5-5v10l-5-5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-drop-left", c0);
const u0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], $i = /* @__PURE__ */ t({
  __name: "VsgIconArrowDropLeft",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-drop-left", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, u0));
  }
});
class i0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m15 12-5-5v10l5-5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-drop-right", i0);
const m0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Zi = /* @__PURE__ */ t({
  __name: "VsgIconArrowDropRight",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-drop-right", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, m0));
  }
});
class d0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m12 9-5 5h10l-5-5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-drop-up", d0);
const g0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Vi = /* @__PURE__ */ t({
  __name: "VsgIconArrowDropUp",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-drop-up", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, g0));
  }
});
class h0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.53 4.47a.75.75 0 1 0-1.06 1.06l5.72 5.72H5a.75.75 0 0 0 0 1.5h12.19l-5.72 5.72a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06l-7-7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-forward", h0);
const p0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Bi = /* @__PURE__ */ t({
  __name: "VsgIconArrowForward",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-forward", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, p0));
  }
});
class v0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 4.5a.75.75 0 0 1 .75.75h-1.5A.75.75 0 0 1 12 4.5Zm5.245 12.445c-.043-1.218-.344-2.183-.793-2.989-.48-.86-1.112-1.503-1.686-2.047-.09-.087-.18-.17-.265-.251l-.001-.001c-1.055-.993-1.75-1.647-1.75-2.907v-3.5h-1.5v3.5c0 1.26-.695 1.914-1.75 2.907a85.34 85.34 0 0 0-.266.252c-.574.544-1.206 1.188-1.686 2.047-.45.806-.75 1.771-.793 2.989L5.53 15.72a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.213 1.212c.043-.954.279-1.667.601-2.245.364-.652.857-1.167 1.408-1.69.097-.092.196-.184.298-.278.488-.454 1.02-.947 1.436-1.557.417.61.948 1.103 1.436 1.556l.298.279c.55.523 1.044 1.038 1.408 1.69.322.578.558 1.29.601 2.245L14.53 15.72a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.225 1.225Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-split", v0);
const x0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ii = /* @__PURE__ */ t({
  __name: "VsgIconArrowSplit",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-split", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, x0));
  }
});
class y0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.47 9.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12 11.06l-3.47 3.47a.75.75 0 0 1-1.06-1.06l4-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrow-up", y0);
const _0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ji = /* @__PURE__ */ t({
  __name: "VsgIconArrowUp",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrow-up", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _0));
  }
});
class w0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.498 3.499H8.49a.75.75 0 1 1 0 1.5H6.058l3.908 3.908a.75.75 0 0 1-1.06 1.06L4.998 6.06v2.432a.75.75 0 1 1-1.5 0V3.499Zm11.261.75a.75.75 0 0 1 .75-.75h4.993V8.49a.75.75 0 0 1-1.5 0V6.059l-3.908 3.908a.75.75 0 1 1-1.06-1.06l3.908-3.908h-2.433a.75.75 0 0 1-.75-.75Zm-4.793 9.845a.75.75 0 0 1 0 1.06l-3.908 3.909h2.433a.75.75 0 0 1 0 1.5H3.498V15.57a.75.75 0 0 1 1.5 0v2.431l3.908-3.908a.75.75 0 0 1 1.06 0Zm4.068 0a.75.75 0 0 1 1.06 0l3.908 3.908v-2.431a.75.75 0 0 1 1.5 0v4.992H15.51a.75.75 0 0 1 0-1.5h2.433l-3.909-3.908a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-arrows-maximize", w0);
const f0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Mi = /* @__PURE__ */ t({
  __name: "VsgIconArrowsMaximize",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-arrows-maximize", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, f0));
  }
});
class b0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.75 5A.25.25 0 0 1 5 4.75h14a.25.25 0 0 1 .25.25v9.19l-2.72-2.72-.53-.53-.53.53-1.97 1.97-3.97-3.97L9 8.94l-.53.53-3.72 3.72V5Zm-1.5 9.69V5c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0 1 19 20.75H5A1.75 1.75 0 0 1 3.25 19v-4.31Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-assets-filled", b0);
const z0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Hi = /* @__PURE__ */ t({
  __name: "VsgIconAssetsFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-assets-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, z0));
  }
});
class $0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.75 5A.25.25 0 0 1 5 4.75h14a.25.25 0 0 1 .25.25v9.19l-2.72-2.72-.53-.53-.53.53-1.97 1.97-3.97-3.97L9 8.94l-.53.53-3.72 3.72V5Zm0 10.31L9 11.06l3.44 3.44-4.75 4.75H5a.25.25 0 0 1-.25-.25v-3.69Zm5.06 3.94L16 13.06l3.25 3.25V19a.25.25 0 0 1-.25.25H9.81ZM8 20.75H5A1.75 1.75 0 0 1 3.25 19V5c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0 1 19 20.75H8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-assets", $0);
const Z0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ki = /* @__PURE__ */ t({
  __name: "VsgIconAssets",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-assets", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Z0));
  }
});
class V0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.45 4.498H20a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h5.55a2.5 2.5 0 0 1 4.9 0Zm-9.7 15v-13.5h6.5V4.75a.75.75 0 0 1 1.5 0v1.247h6.5v13.5h-1.06V18.28c0-.638-.223-1.157-.599-1.557-.354-.378-.811-.615-1.233-.781-.378-.15-.788-.265-1.143-.365l-.12-.034c-.403-.114-.715-.21-.949-.323a.35.35 0 0 1-.133-.122 4.423 4.423 0 0 0 1.156-2.808l.001-.015v-.031c0-.311 0-1.193-.368-2.015a2.846 2.846 0 0 0-.977-1.202c-.483-.333-1.09-.517-1.825-.517-.736 0-1.344.186-1.826.521a2.86 2.86 0 0 0-.976 1.206c-.368.824-.368 1.706-.368 2.008v.035l.001.02a4.47 4.47 0 0 0 1.158 2.77.556.556 0 0 1-.075.122.158.158 0 0 1-.025.025c-.24.116-.558.212-.966.326l-.116.032c-.36.1-.774.216-1.156.366-.424.166-.883.403-1.24.78-.376.4-.601.92-.601 1.56v1.215H4.75Zm11.94-.007v.006H7.31v-1.216c0-.255.078-.407.193-.53.137-.144.36-.28.696-.413.306-.12.644-.215 1.017-.319l.111-.03c.392-.11.84-.239 1.22-.423h.002c.42-.206.666-.576.8-.861.134-.288.211-.61.211-.874v-.335l-.25-.223a2.97 2.97 0 0 1-.98-2.033c0-.3.012-.886.237-1.39.11-.246.259-.445.461-.585.198-.138.498-.254.972-.254.476 0 .776.116.974.252.202.14.35.337.46.58.225.504.236 1.094.236 1.403a2.921 2.921 0 0 1-.962 2.038l-.227.205-.02.305a1.85 1.85 0 0 0 1.01 1.766l.008.004c.376.185.82.314 1.209.424l.115.032c.368.104.701.198 1.003.317.334.132.556.269.691.413.115.122.193.274.193.531v1.21Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-assign", V0);
const B0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ci = /* @__PURE__ */ t({
  __name: "VsgIconAssign",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-assign", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, B0));
  }
});
class I0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M16.034 4.693c-.527-.03-1.116.147-1.68.71L6.93 12.827c-.917.917-1.227 1.904-1.174 2.807.054.92.491 1.814 1.174 2.497.682.682 1.576 1.12 2.497 1.173.902.054 1.89-.256 2.806-1.173l6.01-6.01a.75.75 0 1 1 1.061 1.06l-6.01 6.01c-1.205 1.205-2.604 1.69-3.955 1.61-1.333-.078-2.561-.701-3.47-1.61-.908-.908-1.532-2.136-1.61-3.469-.08-1.351.406-2.75 1.61-3.955l7.425-7.425c.85-.85 1.852-1.204 2.828-1.146.957.056 1.832.503 2.475 1.146.643.643 1.09 1.518 1.147 2.475.057.976-.296 1.977-1.147 2.828l-7.425 7.425c-.497.497-1.1.718-1.7.682a2.302 2.302 0 0 1-1.481-.682 2.302 2.302 0 0 1-.683-1.48c-.035-.6.185-1.204.683-1.702L14 7.878a.75.75 0 1 1 1.06 1.06l-6.01 6.01c-.21.21-.254.402-.245.553.01.17.093.356.245.508a.805.805 0 0 0 .508.246c.152.009.343-.036.553-.246l7.424-7.424c.564-.564.741-1.153.71-1.68-.032-.545-.292-1.085-.71-1.502-.417-.417-.957-.678-1.502-.71Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-attach", I0);
const j0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Li = /* @__PURE__ */ t({
  __name: "VsgIconAttach",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-attach", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, j0));
  }
});
class M0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M17.834 6.166A8.25 8.25 0 1 0 6.166 17.834 8.25 8.25 0 0 0 17.834 6.166ZM5.106 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788Zm6.275 5.038a2.5 2.5 0 0 0-3.535 3.535l1.944 1.945a.75.75 0 0 1-1.06 1.06L6.785 14.74a4 4 0 1 1 5.657-5.657l1.944 1.945a.75.75 0 0 1-1.06 1.06l-1.945-1.944Zm4.773.177a2.5 2.5 0 1 1-3.535 3.535l-1.945-1.944a.75.75 0 1 0-1.06 1.06l1.944 1.945a4 4 0 1 0 5.657-5.657L15.27 7.315a.75.75 0 0 0-1.06 1.061l1.944 1.945Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-authy", M0);
const H0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ai = /* @__PURE__ */ t({
  __name: "VsgIconAuthy",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-authy", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, H0));
  }
});
class k0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.024 3.25C7.18 3.25 3.25 7.166 3.25 12A8.741 8.741 0 0 0 12 20.75c4.37 0 7.634-3.28 8.711-6.513a.75.75 0 0 0-1.423-.474C18.366 16.53 15.582 19.25 12 19.25A7.241 7.241 0 0 1 4.75 12c0-4.002 3.254-7.25 7.274-7.25a7.272 7.272 0 0 1 5.895 3H16.5a.75.75 0 0 0 0 1.5h3.75V5.5a.75.75 0 0 0-1.5 0v.88a8.766 8.766 0 0 0-6.726-3.13Zm.726 3.938V8.1c.292.08.574.212.822.4.48.366.803.93.803 1.642v.75h-1.5v-.75a.518.518 0 0 0-.212-.448c-.15-.115-.388-.195-.663-.195s-.512.08-.663.195a.518.518 0 0 0-.212.448c0 .425.126.6.256.716.183.163.45.274.886.44l.046.018c.374.142.893.34 1.303.703.479.426.759 1.024.759 1.837 0 .712-.323 1.276-.803 1.641a2.4 2.4 0 0 1-.822.401v.914h-1.5v-.914a2.414 2.414 0 0 1-.822-.4 2.015 2.015 0 0 1-.803-1.642v-.75h1.5v.75c0 .217.083.35.212.448.15.115.388.195.663.195s.512-.08.663-.195a.518.518 0 0 0 .212-.448c0-.425-.126-.6-.256-.716-.183-.163-.45-.274-.886-.44l-.046-.018c-.374-.142-.893-.339-1.303-.703-.479-.426-.759-1.024-.759-1.837 0-.712.323-1.276.803-1.641a2.4 2.4 0 0 1 .822-.401v-.914h1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-automatic-payment", k0);
const C0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ei = /* @__PURE__ */ t({
  __name: "VsgIconAutomaticPayment",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-automatic-payment", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, C0));
  }
});
class L0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.5 12a6.5 6.5 0 0 1 6.732-6.496c-.037.489-.128.766-.214.931-.1.192-.224.292-.446.438a.77.77 0 0 1-.221.088 1.25 1.25 0 0 1-.292.039.75.75 0 0 0-1.309.5c0 .533.41.791.62.88.227.094.475.12.68.12.41 0 .935-.105 1.344-.372.286-.188.672-.46.953-.997.193-.37.317-.825.371-1.401A6.5 6.5 0 1 1 5.5 12ZM12 4a8.002 8.002 0 0 0-7.335 4.803 3.251 3.251 0 0 0 0 6.394 8.002 8.002 0 0 0 14.67 0 3.251 3.251 0 0 0 0-6.394A8.002 8.002 0 0 0 12 4Zm7.89 6.672a8.056 8.056 0 0 1 0 2.655 1.746 1.746 0 0 0 0-2.655ZM3.5 12c0-.53.236-1.007.61-1.328a8.055 8.055 0 0 0 0 2.655A1.746 1.746 0 0 1 3.5 12Zm4-.5a2 2 0 1 1 4 0 .75.75 0 0 1-1.5 0 .5.5 0 0 0-1 0 .75.75 0 0 1-1.5 0Zm7-2a2 2 0 0 0-2 2 .75.75 0 0 0 1.5 0 .5.5 0 0 1 1 0 .75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Zm-4.75 4a.75.75 0 0 1 .75.751c.004.016.046.186.343.396.283.2.694.353 1.157.353a2.03 2.03 0 0 0 1.157-.353c.297-.21.339-.38.343-.396v-.001a.75.75 0 0 1 1.5 0c0 .694-.476 1.267-.975 1.62A3.531 3.531 0 0 1 12 16.5a3.53 3.53 0 0 1-2.025-.63c-.5-.353-.975-.926-.975-1.62a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-baby", L0);
const A0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Si = /* @__PURE__ */ t({
  __name: "VsgIconBaby",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-baby", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, A0));
  }
});
class E0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M16.495 6.413a4.5 4.5 0 0 0-8.995.212v.75H4.286a.75.75 0 0 0-.746.676l-1.123 11.35a2.252 2.252 0 0 0 2.241 2.474h14.688a2.248 2.248 0 0 0 2.237-2.47L20.46 8.051a.75.75 0 0 0-.746-.676H16.5v-.75l-.005-.212ZM15 8.875v1.75l.007.102a.75.75 0 0 0 1.493-.102v-1.75h2.535l1.056 10.678a.748.748 0 0 1-.745.822H4.658l-.1-.007a.753.753 0 0 1-.649-.82L4.965 8.876H7.5v1.75l.007.102A.75.75 0 0 0 9 10.625v-1.75h6Zm0-1.5v-.75a3 3 0 0 0-5.995-.176L9 6.625v.75h6Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bag", E0);
const S0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ji = /* @__PURE__ */ t({
  __name: "VsgIconBag",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bag", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, S0));
  }
});
class J0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.75 3a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 .75.75v18a.75.75 0 0 1-1.166.624l-2.614-1.743-3.098 1.77a.75.75 0 0 1-.744 0l-3.098-1.77-2.614 1.743A.75.75 0 0 1 4.75 21V3Zm8 3.5v-.75h-1.5v1.085a2.85 2.85 0 0 0-1.08.497c-.55.42-.92 1.063-.92 1.882 0 .956.327 1.644.877 2.132.479.426 1.091.66 1.556.836l.05.019c.53.202.89.349 1.144.574.2.178.373.443.373 1.01a.81.81 0 0 1-.33.69c-.22.168-.552.275-.92.275s-.7-.107-.92-.275a.81.81 0 0 1-.33-.69v-.75h-1.5v.75c0 .82.37 1.464.92 1.883a2.85 2.85 0 0 0 1.08.497v1.085h1.5v-1.085a2.85 2.85 0 0 0 1.08-.497c.55-.42.92-1.063.92-1.882 0-.956-.327-1.643-.877-2.132-.479-.426-1.091-.659-1.556-.836l-.05-.019c-.53-.202-.89-.349-1.144-.574-.2-.178-.373-.443-.373-1.01a.81.81 0 0 1 .33-.69c.22-.168.551-.275.92-.275.368 0 .7.107.92.275.2.152.33.365.33.69v.75h1.5v-.75c0-.82-.37-1.464-.92-1.883a2.837 2.837 0 0 0-1.08-.497V6.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bill-filled", J0);
const T0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ti = /* @__PURE__ */ t({
  __name: "VsgIconBillFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bill-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, T0));
  }
});
class q0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.5 2.25a.75.75 0 0 0-.75.75v18a.75.75 0 0 0 1.166.624l2.614-1.743 3.098 1.77a.75.75 0 0 0 .744 0l3.098-1.77 2.614 1.743A.75.75 0 0 0 19.25 21V3a.75.75 0 0 0-.75-.75h-13Zm.75 17.349V3.75h11.5v15.849l-1.834-1.223a.75.75 0 0 0-.788-.027L12 20.136 8.872 18.35a.75.75 0 0 0-.788.027L6.25 19.599ZM12.75 6.5v-.75h-1.5v1.085a2.85 2.85 0 0 0-1.08.497c-.55.42-.92 1.063-.92 1.882 0 .956.327 1.644.877 2.132.479.426 1.091.66 1.556.836l.05.019c.53.202.89.349 1.144.574.2.178.373.443.373 1.01a.81.81 0 0 1-.33.69c-.22.168-.552.275-.92.275s-.7-.107-.92-.275a.81.81 0 0 1-.33-.69v-.75h-1.5v.75c0 .82.37 1.464.92 1.883a2.85 2.85 0 0 0 1.08.497v1.085h1.5v-1.085a2.85 2.85 0 0 0 1.08-.497c.55-.42.92-1.063.92-1.882 0-.956-.327-1.643-.877-2.132-.479-.426-1.091-.659-1.556-.836l-.05-.019c-.53-.202-.89-.349-1.144-.574-.2-.178-.373-.443-.373-1.01a.81.81 0 0 1 .33-.69c.22-.168.551-.275.92-.275.368 0 .7.107.92.275.2.152.33.365.33.69v.75h1.5v-.75c0-.82-.37-1.464-.92-1.883a2.837 2.837 0 0 0-1.08-.497V6.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bill", q0);
const R0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], qi = /* @__PURE__ */ t({
  __name: "VsgIconBill",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bill", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, R0));
  }
});
class D0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 2.5A.75.75 0 0 1 4 1.75h13a.75.75 0 0 1 .75.75v2.25H20a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.166.624l-2.614-1.743-3.098 1.77a.75.75 0 0 1-.744 0l-3.098-1.77-2.614 1.743A.75.75 0 0 1 6.25 21.5v-3.599l-1.834 1.223A.75.75 0 0 1 3.25 18.5v-16Zm3 13.599V5.5A.75.75 0 0 1 7 4.75h9.25v-1.5H4.75v13.849l1.5-1Zm1.5-9.849v13.849l1.834-1.223a.75.75 0 0 1 .788-.027l3.128 1.787 3.128-1.787a.75.75 0 0 1 .788.027l1.834 1.223V6.25H7.75Zm6.5 1v1.085c.385.09.758.252 1.08.497.55.42.92 1.064.92 1.882v.75h-1.5v-.75a.81.81 0 0 0-.33-.689c-.22-.168-.552-.275-.92-.275-.369 0-.7.107-.92.275a.81.81 0 0 0-.33.69c0 .567.173.832.373 1.01.254.226.615.373 1.144.574l.05.02c.465.176 1.077.409 1.556.835.55.489.877 1.176.877 2.132 0 .819-.37 1.463-.92 1.882a2.838 2.838 0 0 1-1.08.497v1.085h-1.5v-1.085a2.838 2.838 0 0 1-1.08-.497 2.307 2.307 0 0 1-.92-1.882v-.75h1.5v.75c0 .324.13.537.33.689.22.168.552.275.92.275s.7-.107.92-.275a.81.81 0 0 0 .33-.69c0-.567-.173-.832-.373-1.01-.254-.225-.615-.372-1.144-.574l-.05-.019c-.465-.177-1.077-.41-1.556-.836-.55-.488-.877-1.176-.877-2.132 0-.819.37-1.463.92-1.882a2.837 2.837 0 0 1 1.08-.497V7.25h1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bills", D0);
const F0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ri = /* @__PURE__ */ t({
  __name: "VsgIconBills",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bills", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, F0));
  }
});
class P0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 2s-1.5 1.333-1.5 2.667C10.5 5.409 11.171 6 12 6c.826 0 1.5-.591 1.5-1.333C13.5 3.333 12 2 12 2Zm.75 7.25V7h-1.5v2.25H6A1.75 1.75 0 0 0 4.25 11v9.75h15.5v-5.203a.773.773 0 0 0 0-.094V11A1.75 1.75 0 0 0 18 9.25h-5.25Zm5.5 5.912V11a.25.25 0 0 0-.25-.25H6a.25.25 0 0 0-.25.25v4.114c.335.3.764.459 1.134.396.36-.06.951-.389 1.404-1.747a.75.75 0 0 1 1.423 0c.772 2.316 3.805 2.316 4.577 0a.75.75 0 0 1 1.423 0c.452 1.357 1.041 1.685 1.412 1.747.354.06.77-.077 1.126-.348Zm-12.5 1.68v2.408h12.5v-2.397a2.71 2.71 0 0 1-1.374.137c-.756-.126-1.414-.58-1.931-1.36-1.529 1.827-4.363 1.827-5.891 0-.516.779-1.171 1.233-1.92 1.36a2.635 2.635 0 0 1-1.385-.148Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-birthday", P0);
const W0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Di = /* @__PURE__ */ t({
  __name: "VsgIconBirthday",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-birthday", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, W0));
  }
});
class O0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9 6.5h6V5H9v1.5Zm7.5 0V4.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75V6.5H3.75a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75H16.5Zm-6.75 5.453L4.5 10.7v7.8h15v-7.793L14.25 12v1.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-1.297Zm0-1.542L4.5 9.158V8h15v1.162l-5.25 1.293v-.205a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v.16Zm1.5 2.089V11h1.5v1.5h-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-briefcase", O0);
const U0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Fi = /* @__PURE__ */ t({
  __name: "VsgIconBriefcase",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-briefcase", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, U0));
  }
});
class N0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 4.75a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75v-13a.75.75 0 0 0-.75-.75H4Zm15.25 4v-2.5H4.75v2.5h14.5Zm-14.5 1.5h14.5v7.5H4.75v-7.5ZM6 8h2V7H6v1Zm5 0H9V7h2v1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-browser", N0);
const K0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Pi = /* @__PURE__ */ t({
  __name: "VsgIconBrowser",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-browser", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, K0));
  }
});
class G0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m4.18 9.092.067.088.776 1.183a1.25 1.25 0 0 0 1.586.441l.117-.064.147-.093c.29.611.73 1.192 1.254 1.678.807.75 1.891 1.354 3.123 1.528v8.018l-.137-.003c-1.135-.03-1.857-.24-3.425-1.612-.334-.292-.642-.684-.923-1.132a6.586 6.586 0 0 1-.334-.601 1.243 1.243 0 0 0-.62.65l-.041.119-.427 1.421a.75.75 0 0 1-1.46-.332l.024-.099.426-1.421a2.748 2.748 0 0 1 1.598-1.757 7.386 7.386 0 0 1-.155-2.198c-.279.036-.54.165-.738.37l-1.505 1.549a.75.75 0 0 1-1.076-1.045l1.505-1.55a2.75 2.75 0 0 1 1.973-.834h.084c.08-.33.178-.657.291-.98a2.745 2.745 0 0 1-2.43-1.072l-.112-.159-.775-1.183a.75.75 0 0 1 1.187-.91Zm16.611-.128a.75.75 0 0 1 .216 1.038l-.775 1.183a2.75 2.75 0 0 1-2.565 1.23c.11.324.206.651.284.98l.114.001a2.75 2.75 0 0 1 1.827.695l.146.14 1.505 1.549a.75.75 0 0 1-.993 1.119l-.083-.074-1.505-1.55a1.25 1.25 0 0 0-.753-.37l-.024-.002a7.627 7.627 0 0 1-.151 2.187 2.745 2.745 0 0 1 1.633 1.771l.426 1.421a.75.75 0 0 1-1.436.431l-.427-1.421a1.249 1.249 0 0 0-.683-.78c-.098.213-.21.422-.334.627-.28.463-.582.854-.9 1.117-1.477 1.22-2.302 1.532-3.562 1.6l-.001-8.011c1.208-.185 2.271-.781 3.067-1.52a5.623 5.623 0 0 0 1.266-1.704l.191.119a1.25 1.25 0 0 0 1.703-.377l.776-1.183a.75.75 0 0 1 1.038-.216Zm-5.522-.182c.392.02.554.085.61.126l.017.015.018.036.016.071a.89.89 0 0 1 .008.124c0 .546-.377 1.361-1.142 2.072-.745.691-1.748 1.178-2.824 1.178-1.076 0-2.08-.487-2.824-1.178-.765-.71-1.142-1.526-1.142-2.072 0-.13.02-.19.03-.213a.07.07 0 0 1 .028-.033l.062-.034.023-.009a1.83 1.83 0 0 1 .526-.083c.25-.013.54-.005.875.012l.613.036c.542.035 1.16.074 1.809.074.52 0 1.018-.025 1.475-.053l.946-.057a8.87 8.87 0 0 1 .876-.012Zm1.817-6.472a1 1 0 1 1-.565 1.825l-.152.03c-.415.08-.622.12-.988.274l-.032.029-.031.038a2.151 2.151 0 0 0-.202.365l-.247.543c-.057.12-.119.245-.188.372a2.955 2.955 0 0 1 .28 1.491c-.253 0-.52.011-.792.027l-.471.029c-.55.034-1.126.07-1.726.07-.45 0-.887-.02-1.31-.045l-.479-.03a22.15 22.15 0 0 0-1.145-.052 2.957 2.957 0 0 1 .282-1.492 7.91 7.91 0 0 1-.269-.544l-.167-.37-.09-.183a1.393 1.393 0 0 0-.111-.18.281.281 0 0 0-.064-.068 3.378 3.378 0 0 0-.629-.202l-.51-.102a1 1 0 1 1 .175-1.496l.166.033c.474.09.86.165 1.381.384.593.25.875.824 1.04 1.178l.152.332A2.946 2.946 0 0 1 12 4.093c.592 0 1.144.174 1.607.472l.15-.331c.167-.354.448-.928 1.041-1.178a5.522 5.522 0 0 1 1.15-.34l.397-.076a.996.996 0 0 1 .741-.33Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bug-filled", G0);
const Y0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Wi = /* @__PURE__ */ t({
  __name: "VsgIconBugFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bug-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Y0));
  }
});
class Q0 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M17.086 2.31a1 1 0 1 1-.465 1.885l-.1-.06-.152.03c-.415.08-.622.12-.988.274a.168.168 0 0 0-.032.029l-.031.038a2.151 2.151 0 0 0-.202.365l-.165.365a3.464 3.464 0 0 1 .51 2.053c.44.029.928.117 1.322.4.481.346.683.873.683 1.465 0 .49-.132.994-.36 1.48l.168.106a1.25 1.25 0 0 0 1.703-.377l.776-1.183a.75.75 0 0 1 1.254.822l-.775 1.183a2.75 2.75 0 0 1-2.565 1.23c.11.324.206.652.284.98l.114.001a2.75 2.75 0 0 1 1.827.695l.146.14 1.505 1.549a.75.75 0 0 1-.993 1.119l-.083-.074-1.505-1.55a1.25 1.25 0 0 0-.753-.37l-.024-.002a7.63 7.63 0 0 1-.151 2.187 2.74 2.74 0 0 1 1.578 1.607l.055.164.426 1.421a.75.75 0 0 1-1.4.527l-.036-.096-.427-1.421a1.249 1.249 0 0 0-.683-.78c-.098.213-.21.422-.334.627-.28.463-.582.854-.9 1.117-1.671 1.38-2.506 1.598-4.083 1.615h-.98c-1.216-.018-1.932-.188-3.563-1.615-.333-.292-.64-.684-.922-1.132a6.574 6.574 0 0 1-.334-.601 1.243 1.243 0 0 0-.62.65l-.041.119-.427 1.421a.75.75 0 0 1-1.46-.332l.024-.099.426-1.421a2.748 2.748 0 0 1 1.599-1.758 7.368 7.368 0 0 1-.156-2.196 1.241 1.241 0 0 0-.632.27l-.106.098-1.505 1.55a.75.75 0 0 1-1.147-.96l.071-.085 1.505-1.55a2.75 2.75 0 0 1 1.77-.827l.203-.007h.084c.08-.33.178-.656.291-.98a2.746 2.746 0 0 1-2.542-1.231l-.775-1.183a.75.75 0 0 1 1.254-.822l.776 1.183a1.25 1.25 0 0 0 1.703.377l.17-.106-.006-.01c-.225-.482-.356-.983-.356-1.47 0-.592.202-1.119.683-1.465.394-.283.883-.371 1.322-.4a3.453 3.453 0 0 1 .51-2.052l-.165-.366-.09-.184a1.393 1.393 0 0 0-.111-.18.281.281 0 0 0-.064-.068 3.378 3.378 0 0 0-.629-.202l-.51-.102a1 1 0 1 1 .176-1.495l.165.032c.474.09.86.165 1.381.384.528.223.809.701.98 1.053A3.43 3.43 0 0 1 12 3.593c.667 0 1.29.188 1.818.514.172-.35.453-.829.98-1.05a5.525 5.525 0 0 1 1.15-.34l.396-.077a.997.997 0 0 1 .742-.33Zm-9.078 9.874-.07.16c-.11.264-.207.53-.292.796l-.077.256-.11.425-.054.246-.04.217.02-.115c-.161.861-.172 1.706-.009 2.497l.065.276c.048.184.106.364.174.54l.035.09.113.255.062.126.065.125.147.25.106.163.122.174c.148.2.286.353.41.462.918.803 1.373 1.042 1.691 1.14.238.074.463.096.881.103l.002-6.521c-1.22-.18-2.293-.78-3.094-1.524l-.147-.141Zm7.973.01-.136.13c-.802.745-1.875 1.345-3.095 1.525l.002 6.504c.381-.025.65-.075.904-.164.398-.138.883-.414 1.701-1.09a2.02 2.02 0 0 0 .307-.339l.111-.156c.05-.073.101-.153.155-.242l.188-.339.12-.252.082-.2.029-.072a5.57 5.57 0 0 0 .094-.275l.078-.275.055-.24a6.339 6.339 0 0 0 .096-1.88l-.04-.345-.042-.268-.04-.217.023.118a9.335 9.335 0 0 0-.592-1.924Zm-1.56-3.4-.612.036c-.542.035-1.16.074-1.809.074-.52 0-1.019-.025-1.475-.053l-.947-.057a8.87 8.87 0 0 0-.875-.012c-.392.02-.554.085-.61.126a.07.07 0 0 0-.028.033l-.015.047a.74.74 0 0 0-.016.166c0 .103.014.216.04.335l.029.11.046.146.062.16.09.191.04.075c.098.18.219.363.364.546.136.173.293.344.47.509.634.588 1.455 1.028 2.348 1.146l.177.02c.1.008.2.012.3.012l.277-.01.198-.021.11-.017c.851-.138 1.632-.566 2.24-1.13a4.55 4.55 0 0 0 .452-.486l.093-.12.16-.231.117-.199.077-.147.068-.147.062-.16.05-.163.034-.142a1.54 1.54 0 0 0 .028-.277c0-.13-.02-.19-.03-.213a.069.069 0 0 0-.028-.033c-.057-.04-.219-.107-.611-.126a8.87 8.87 0 0 0-.875.012ZM12 5.094a1.96 1.96 0 0 0-1.276.469l-.112.103-.104.111-.098.124-.09.135-.07.124a1.964 1.964 0 0 0-.2 1.158l.224.015c.55.034 1.125.07 1.726.07.45 0 .887-.02 1.309-.045l.641-.04a1.97 1.97 0 0 0-.173-1.104l-.096-.178-.06-.092-.091-.121a1.961 1.961 0 0 0-1.53-.73Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bug", Q0);
const X0 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Oi = /* @__PURE__ */ t({
  __name: "VsgIconBug",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bug", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, X0));
  }
});
class lr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 7h10.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm0 1.5a.5.5 0 0 0-.5.5v10.5a.5.5 0 0 0 .5.5h10.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H5Z"/>   <path d="M14.535 11.464a.75.75 0 0 1 0 1.061l-4.95 4.95-.014.015-.01.01a.75.75 0 0 1-1.061 0L6 15a.75.75 0 0 1 1.06-1.06l1.97 1.97 4.445-4.446a.75.75 0 0 1 1.06 0ZM8.75 3H19.5a2 2 0 0 1 2 2v10.75a.75.75 0 0 1-1.5 0V5a.5.5 0 0 0-.5-.5H8.75a.75.75 0 0 1 0-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bulk-select", lr);
const er = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ui = /* @__PURE__ */ t({
  __name: "VsgIconBulkSelect",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bulk-select", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, er));
  }
});
class ar extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.5 8.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM9 6.25a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5H9ZM8.25 12a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM4.5 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8.25 17a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM4.5 18.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-bulleted-list", ar);
const sr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ni = /* @__PURE__ */ t({
  __name: "VsgIconBulletedList",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-bulleted-list", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, sr));
  }
});
class rr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.25 3.875a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 .75.75v15.25H20a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h1.25V3.875Zm1.5 15.25h1.5v-4h7.5v4h1.5v-14.5H6.75v14.5Zm7.5 0v-2.5h-4.5v2.5h4.5ZM9 10.875h2v-2H9v2Zm6 0h-2v-2h2v2Zm-6-3h2v-2H9v2Zm6 0h-2v-2h2v2Zm-6 6h2v-2H9v2Zm6 0h-2v-2h2v2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-business", rr);
const nr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ki = /* @__PURE__ */ t({
  __name: "VsgIconBusiness",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-business", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, nr));
  }
});
class or extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.375 4h11.25a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5H6.375a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5Zm-2 .5a2 2 0 0 1 2-2h11.25a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6.375a2 2 0 0 1-2-2v-15ZM15.5 13.75a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Zm-8-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm4.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-4.5 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm4.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-4.5 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm4.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.5-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM8.5 8V7h7v1h-7ZM7 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 7 9V6Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-calculator", or);
const tr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Gi = /* @__PURE__ */ t({
  __name: "VsgIconCalculator",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-calculator", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, tr));
  }
});
class cr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8 4.25h-.464l-.207.415-.793 1.585H4A1.75 1.75 0 0 0 2.25 8v9c0 .966.784 1.75 1.75 1.75h16A1.75 1.75 0 0 0 21.75 17V8A1.75 1.75 0 0 0 20 6.25h-2.537l-.792-1.585-.207-.415H8Zm-.33 3.085.794-1.585h7.072l.793 1.585.207.415H20a.25.25 0 0 1 .25.25v9a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V8A.25.25 0 0 1 4 7.75h3.464l.207-.415ZM9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-camera", cr);
const ur = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Yi = /* @__PURE__ */ t({
  __name: "VsgIconCamera",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-camera", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, ur));
  }
});
class ir extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.593 4.327a.75.75 0 0 1 .656-.003l9.327 4.495a.75.75 0 0 1 .001 1.35l-.327.159v4.922a.75.75 0 0 1-1.5 0v-4.195l-1.5.728v4.967c0 .611-.326 1.101-.72 1.457-.393.355-.913.637-1.478.855-1.133.44-2.602.688-4.052.688-1.45 0-2.92-.248-4.052-.688-.565-.218-1.086-.5-1.478-.855-.394-.356-.72-.846-.72-1.457V11.8l-3.33-1.626a.75.75 0 0 1 0-1.347l9.173-4.5Zm.694 10.348 4.463-2.165v4.24c0 .04-.017.156-.226.345-.208.188-.547.388-1.014.569-.93.36-2.21.586-3.51.586-1.3 0-2.58-.226-3.51-.586-.467-.181-.806-.38-1.014-.57-.208-.188-.226-.304-.226-.344v-4.216l4.38 2.14a.75.75 0 0 0 .657 0Zm-.36-8.841L4.455 9.499l7.505 3.667 7.566-3.67-7.6-3.662Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-cap", ir);
const mr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Qi = /* @__PURE__ */ t({
  __name: "VsgIconCap",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-cap", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, mr));
  }
});
class dr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M12.75 13.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0v-.5ZM9.4 14a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0V14Zm6.7 0a.75.75 0 0 0-1.5 0v.5a.75.75 0 0 0 1.5 0V14Z"/>   <path fill-rule="evenodd" d="M12.75 2.75a.75.75 0 0 0-1.5 0v1.322A1.75 1.75 0 0 0 10 5.75v1.329a6.25 6.25 0 0 0-4.099 4.555c-.088.04-.171.08-.25.124a2.138 2.138 0 0 0-.58.442c-.17.19-.321.461-.321.8 0 .29.11.528.25.713v2.663c-.43.103-.81.218-1.12.348-.25.104-.499.235-.697.406-.194.167-.433.457-.433.87 0 .355.179.622.347.79.048.049.1.094.153.135V22h1.5v-3.96l-.048-.023a10.06 10.06 0 0 1 1.418-.34c1.483-.26 3.563-.427 5.88-.427 2.317 0 4.397.166 5.88.428.594.105 1.07.221 1.418.339l-.048.024V22h1.5v-3.075c.053-.041.105-.086.153-.134.168-.17.347-.436.347-.791 0-.413-.24-.703-.433-.87a2.603 2.603 0 0 0-.696-.406A7.413 7.413 0 0 0 19 16.376v-2.663c.14-.185.25-.422.25-.713 0-.339-.152-.61-.32-.8a2.138 2.138 0 0 0-.582-.442 3.599 3.599 0 0 0-.249-.124A6.25 6.25 0 0 0 14 7.08V5.75a1.75 1.75 0 0 0-1.25-1.678V2.75Zm-.25 3v1h-1v-1a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25Zm-.5 5c-1.644 0-3.168.137-4.363.373a4.75 4.75 0 0 1 8.726 0c-1.195-.236-2.719-.373-4.363-.373Zm-5.5 2.305-.035-.029c.246-.118.616-.242 1.107-.356 1.107-.255 2.673-.42 4.428-.42s3.321.165 4.427.42c.492.114.861.238 1.108.356l-.035.029v3.043c-1.512-.22-3.428-.348-5.5-.348s-3.987.129-5.5.348v-3.043Z"/>   <path d="M11.25 19a.75.75 0 0 0-1.5 0v3h1.5v-3Zm3 0a.75.75 0 0 0-1.5 0v3h1.5v-3Zm-6 .25a.75.75 0 0 0-1.5 0V22h1.5v-2.75Zm9 0a.75.75 0 0 0-1.5 0V22h1.5v-2.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-capital", dr);
const gr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Xi = /* @__PURE__ */ t({
  __name: "VsgIconCapital",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-capital", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, gr));
  }
});
class hr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.446 5a.25.25 0 0 0-.234.163L4.605 9.5h14.79l-1.607-4.337A.25.25 0 0 0 17.554 5H6.446Zm13.504 6H4.05l-.05.134V17h16v-5.866L19.95 11ZM2.5 17.75v1.75a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h13v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8.634l-.047-.127-2.258-6.097A1.75 1.75 0 0 0 17.554 3.5H6.446a1.75 1.75 0 0 0-1.641 1.142L2.547 10.74l-.047.127v6.884Zm5.75-4.125a1.625 1.625 0 1 1-3.25 0 1.625 1.625 0 0 1 3.25 0Zm9.125 1.625a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-car", hr);
const pr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], l3 = /* @__PURE__ */ t({
  __name: "VsgIconCar",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-car", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, pr));
  }
});
class vr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 8.5A.75.75 0 0 1 4 7.75h16a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75v-7Zm1.5.75v5.5h14.5v-5.5H4.75Zm1.5 2.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM17 10.75a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H17Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-card-condensed", vr);
const xr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], e3 = /* @__PURE__ */ t({
  __name: "VsgIconCardCondensed",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-card-condensed", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, xr));
  }
});
class yr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 4A.75.75 0 0 1 4 3.25h16a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V4Zm1.5.75v14.5h14.5V4.75H4.75ZM6.25 7A.75.75 0 0 1 7 6.25h7a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 7ZM17 6.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H17Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-card-expanded", yr);
const _r = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], a3 = /* @__PURE__ */ t({
  __name: "VsgIconCardExpanded",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-card-expanded", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _r));
  }
});
class wr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 6.5A.75.75 0 0 1 4 5.75h16a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75v-11Zm1.5.75v9.5h14.5v-9.5H4.75Zm1.5 2.25A.75.75 0 0 1 7 8.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM17 8.75a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H17Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-card-normal", wr);
const fr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], s3 = /* @__PURE__ */ t({
  __name: "VsgIconCardNormal",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-card-normal", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, fr));
  }
});
class br extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.5 4.25a.75.75 0 0 0-.75.75v8c0 .414.336.75.75.75h2.25V16c0 .414.336.75.75.75h2.25V19c0 .414.336.75.75.75h11a.75.75 0 0 0 .75-.75v-8a.75.75 0 0 0-.75-.75h-2.25V8a.75.75 0 0 0-.75-.75h-2.25V5a.75.75 0 0 0-.75-.75h-11Zm13.25 6v-1.5h-9.5v6.5h1.5V11a.75.75 0 0 1 .75-.75h7.25ZM5.75 8v4.25h-1.5v-6.5h9.5v1.5H6.5a.75.75 0 0 0-.75.75Zm4.5 10.25v-6.5h9.5v6.5h-9.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-cards", br);
const zr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], r3 = /* @__PURE__ */ t({
  __name: "VsgIconCards",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-cards", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, zr));
  }
});
class $r extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M1.5 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H5.25A.75.75 0 0 1 4.5 18v-2.25H2.25A.75.75 0 0 1 1.5 15V6Zm3 8.25V9a.75.75 0 0 1 .75-.75H18v-1.5H3v7.5h1.5Zm1.5 3v-7.5h15v7.5H6Zm1.5-5.5h12v1h-12v-1Zm6 2.5H13v1h6.5v-1h-6Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-check-range", $r);
const Zr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], n3 = /* @__PURE__ */ t({
  __name: "VsgIconCheckRange",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-check-range", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Zr));
  }
});
class Vr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 7.5A.75.75 0 0 1 3 6.75h18a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-9Zm1.5.75v7.5h16.5v-7.5H3.75ZM5 10h14v1H5v-1Zm6 3h-.5v1H19v-1h-8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-check", Vr);
const Br = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], o3 = /* @__PURE__ */ t({
  __name: "VsgIconCheck",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-check", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Br));
  }
});
class Ir extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19.959 7.53a.75.75 0 0 0-1.06-1.06l-9.47 9.47-3.47-3.47a.75.75 0 0 0-1.06 1.06l4 4a.751.751 0 0 0 1.06 0"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-checkmark", Ir);
const jr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], t3 = /* @__PURE__ */ t({
  __name: "VsgIconCheckmark",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-checkmark", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, jr));
  }
});
class Mr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.53 5.47a.75.75 0 0 1 0 1.06L9.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-chevron-back", Mr);
const Hr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], c3 = /* @__PURE__ */ t({
  __name: "VsgIconChevronBack",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-chevron-back", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Hr));
  }
});
class kr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.47 9.47a.75.75 0 0 1 1.06 0L12 12.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-chevron-down", kr);
const Cr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], u3 = /* @__PURE__ */ t({
  __name: "VsgIconChevronDown",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-chevron-down", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Cr));
  }
});
class Lr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9.47 5.47a.75.75 0 0 0 0 1.06L14.94 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-chevron-forward", Lr);
const Ar = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], i3 = /* @__PURE__ */ t({
  __name: "VsgIconChevronForward",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-chevron-forward", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ar));
  }
});
class Er extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.53 7.47a.75.75 0 0 1 0 1.06L11.06 12l3.47 3.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-chevron-left", Er);
const Sr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], m3 = /* @__PURE__ */ t({
  __name: "VsgIconChevronLeft",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-chevron-left", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Sr));
  }
});
class Jr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9.47 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L12.94 12 9.47 8.53a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-chevron-right", Jr);
const Tr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], d3 = /* @__PURE__ */ t({
  __name: "VsgIconChevronRight",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-chevron-right", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Tr));
  }
});
class qr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.47 9.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12 11.06l-3.47 3.47a.75.75 0 0 1-1.06-1.06l4-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-chevron-up", qr);
const Rr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], g3 = /* @__PURE__ */ t({
  __name: "VsgIconChevronUp",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-chevron-up", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Rr));
  }
});
class Dr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 7.25a.75.75 0 0 0-.75.75v8c0 .414.336.75.75.75h4.75v-1.5h-4v-6.5h4v-1.5H4Zm8.75.75v-.75h-1.5v9.5h1.5V8Zm2.5 0a.75.75 0 0 1 .75-.75h4.75v1.5h-4v2.5h3v1.5h-3v4h-1.5V8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-cif", Dr);
const Fr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], h3 = /* @__PURE__ */ t({
  __name: "VsgIconCif",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-cif", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Fr));
  }
});
class Pr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 14.614 5.25H17.5V6.5h-11v10.75h-.864A8.216 8.216 0 0 1 3.75 12Zm3.505 6.75A8.212 8.212 0 0 0 12 20.25a8.212 8.212 0 0 0 4.745-1.5h-9.49ZM8 17.25h1.25v-3h5.5v3H16V8H8v9.25Zm5.25 0v-1.5h-2.5v1.5h2.5ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM11 9H9.5v1.455H11V9Zm-1.5 2.5H11V13H9.5v-1.5Zm5-2.5H13v1.455h1.5V9ZM13 11.5h1.5V13H13v-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-business", Pr);
const Wr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], p3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleBusiness",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-business", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Wr));
  }
});
class Or extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.755-3.005a.75.75 0 0 1 0 1.06l-4.95 4.95-.015.015-.01.01a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.97 1.97 4.444-4.445a.75.75 0 0 1 1.061 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-checkmark-filled", Or);
const Ur = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], v3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleCheckmarkFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-checkmark-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ur));
  }
});
class Nr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.755-3.005a.75.75 0 0 1 0 1.06l-4.95 4.95a1.096 1.096 0 0 1-.025.025.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.97 1.97 4.444-4.445a.75.75 0 0 1 1.061 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-checkmark", Nr);
const Kr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], x3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleCheckmark",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-checkmark", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Kr));
  }
});
class Gr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6.22-3.53a.75.75 0 0 1 1.06 0L12 10.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L13.06 12l2.47 2.47a.75.75 0 0 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-close-filled", Gr);
const Yr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], y3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleCloseFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-close-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Yr));
  }
});
class Qr extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6.22-3.53a.75.75 0 0 1 1.06 0L12 10.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L13.06 12l2.47 2.47a.75.75 0 0 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-close", Qr);
const Xr = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], _3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleClose",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-close", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Xr));
  }
});
class l1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm10.5-5v-.75h-1.5v1.085a2.85 2.85 0 0 0-1.08.497c-.55.42-.92 1.064-.92 1.882 0 .956.327 1.644.877 2.132.479.426 1.091.66 1.556.836l.05.019c.53.202.89.349 1.144.574.2.178.373.443.373 1.01a.81.81 0 0 1-.33.69c-.22.168-.552.275-.92.275s-.7-.107-.92-.275a.81.81 0 0 1-.33-.69v-.75h-1.5v.75c0 .82.37 1.464.92 1.883a2.85 2.85 0 0 0 1.08.497v1.085h1.5v-1.085a2.85 2.85 0 0 0 1.08-.497c.55-.42.92-1.063.92-1.882 0-.956-.327-1.643-.877-2.132-.479-.426-1.091-.659-1.556-.836l-.05-.019c-.53-.201-.89-.348-1.144-.574-.2-.178-.373-.443-.373-1.01a.81.81 0 0 1 .33-.69c.22-.168.551-.275.92-.275.368 0 .7.107.92.275.2.152.33.365.33.69v.75h1.5v-.75c0-.82-.37-1.464-.92-1.883a2.836 2.836 0 0 0-1.08-.497V7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-dollar-filled", l1);
const e1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], w3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleDollarFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-dollar-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, e1));
  }
});
class a1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 7v-.75h-1.5v1.085a2.85 2.85 0 0 0-1.08.497c-.55.42-.92 1.064-.92 1.882 0 .956.327 1.644.877 2.132.479.426 1.091.66 1.556.836l.05.019c.53.202.89.349 1.144.574.2.178.373.443.373 1.01a.81.81 0 0 1-.33.69c-.22.168-.552.275-.92.275s-.7-.107-.92-.275a.81.81 0 0 1-.33-.69v-.75h-1.5v.75c0 .82.37 1.464.92 1.883a2.85 2.85 0 0 0 1.08.497v1.085h1.5v-1.085a2.85 2.85 0 0 0 1.08-.497c.55-.42.92-1.063.92-1.882 0-.956-.327-1.643-.877-2.132-.479-.426-1.091-.659-1.556-.836l-.05-.019c-.53-.201-.89-.348-1.144-.574-.2-.178-.373-.443-.373-1.01a.81.81 0 0 1 .33-.69c.22-.168.551-.275.92-.275.368 0 .7.107.92.275.2.152.33.365.33.69v.75h1.5v-.75c0-.82-.37-1.464-.92-1.883a2.837 2.837 0 0 0-1.08-.497V7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-dollar", a1);
const s1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], f3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleDollar",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-dollar", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, s1));
  }
});
class r1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-empty", r1);
const n1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], b3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleEmpty",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-empty", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, n1));
  }
});
class o1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-filled", o1);
const t1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], z3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, t1));
  }
});
class c1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-3.6 7c-.8 0-1.565.328-2.13.799-.555.462-1.02 1.155-1.02 1.951s.465 1.489 1.02 1.951c.565.471 1.33.799 2.13.799.805 0 1.548-.333 2.197-.739.479-.3.952-.667 1.403-1.037.451.37.924.738 1.402 1.037.65.406 1.393.739 2.198.739.8 0 1.565-.328 2.13-.799.555-.462 1.02-1.155 1.02-1.951s-.465-1.489-1.02-1.951c-.565-.471-1.33-.799-2.13-.799-.805 0-1.548.333-2.198.739-.478.3-.95.667-1.402 1.037-.451-.37-.924-.738-1.403-1.037-.65-.406-1.392-.739-2.197-.739Zm1.402 2.011c.332.208.668.46 1.017.739-.349.28-.685.531-1.017.739-.55.344-1.007.511-1.402.511-.4 0-.835-.172-1.17-.451-.345-.288-.48-.595-.48-.799 0-.204.135-.511.48-.799.335-.279.77-.451 1.17-.451.395 0 .852.167 1.402.511Zm4.395 1.478c-.332-.208-.668-.46-1.016-.739.348-.28.684-.531 1.016-.739.55-.344 1.008-.511 1.403-.511.4 0 .835.172 1.17.451.345.288.48.595.48.799 0 .204-.135.511-.48.799-.335.279-.77.451-1.17.451-.395 0-.852-.167-1.403-.511Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-infinity", c1);
const u1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], $3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleInfinity",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-infinity", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, u1));
  }
});
class i1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-4 9a.75.75 0 1 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-minus", i1);
const m1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Z3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleMinus",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-minus", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, m1));
  }
});
class d1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM10 7.5a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7A.75.75 0 0 1 10 7.5Zm4.75.75a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0v-7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-pause", d1);
const g1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], V3 = /* @__PURE__ */ t({
  __name: "VsgIconCirclePause",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-pause", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, g1));
  }
});
class h1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.759 10.46a.75.75 0 0 0 0-1.208l-6.515-4.799a.75.75 0 0 0-1.195.604v9.598a.75.75 0 0 0 1.195.604l6.515-4.799Zm-6.21 2.711v-6.63l4.5 3.315-4.5 3.315Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-play", h1);
const p1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], B3 = /* @__PURE__ */ t({
  __name: "VsgIconCirclePlay",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-play", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, p1));
  }
});
class v1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 7.75a.75.75 0 0 1 .75.75v2.75h2.75a.75.75 0 1 1 0 1.5h-2.75v2.75a.75.75 0 0 1-1.5 0v-2.75H8.5a.75.75 0 0 1 0-1.5h2.75V8.5a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-plus-filled", v1);
const x1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], I3 = /* @__PURE__ */ t({
  __name: "VsgIconCirclePlusFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-plus-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, x1));
  }
});
class y1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm5.5 0a.75.75 0 0 1 .75-.75h2.75V8.5a.75.75 0 0 1 1.5 0v2.75h2.75a.75.75 0 1 1 0 1.5h-2.75v2.75a.75.75 0 0 1-1.5 0v-2.75H8.5a.75.75 0 0 1-.75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-plus", y1);
const _1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], j3 = /* @__PURE__ */ t({
  __name: "VsgIconCirclePlus",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-plus", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _1));
  }
});
class w1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-radio-selected", w1);
const f1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], M3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleRadioSelected",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-radio-selected", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, f1));
  }
});
class b1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.78-4.03a.75.75 0 0 0-1.06 0l-3.5 3.5a.75.75 0 0 0 0 1.06l3.5 3.5a.75.75 0 1 0 1.06-1.06L13.06 12l2.97-2.97a.75.75 0 0 0 0-1.06Zm-5.56 0a.75.75 0 1 1 1.06 1.06L8.56 12l2.97 2.97a.75.75 0 0 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 0-1.06l3.5-3.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-rewind", b1);
const z1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], H3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleRewind",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-rewind", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, z1));
  }
});
class $1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm9.97-4.03a.75.75 0 0 1 1.06 0l3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5a.75.75 0 0 1-1.06-1.06L15.19 12l-2.97-2.97a.75.75 0 0 1 0-1.06Zm-3.44 0a.75.75 0 0 0-1.06 1.06L10.69 12l-2.97 2.97a.75.75 0 0 0 1.06 1.06l3.5-3.5a.75.75 0 0 0 0-1.06l-3.5-3.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-skip", $1);
const Z1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], k3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleSkip",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-skip", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Z1));
  }
});
class V1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm.679 4.289a.75.75 0 0 0-1.358 0l-1.263 2.69-3.165.458a.75.75 0 0 0-.388 1.305l2.368 2.082-.47 2.95a.75.75 0 0 0 1.104.775L12 15.415l2.493 1.384a.75.75 0 0 0 1.105-.774l-.47-2.951 2.367-2.082a.75.75 0 0 0-.388-1.305l-3.165-.458-1.263-2.69Zm-1.435 3.694L12 8.623l.756 1.61a.75.75 0 0 0 .572.423l1.956.283-1.458 1.281a.75.75 0 0 0-.245.681l.293 1.838-1.51-.838a.75.75 0 0 0-.728 0l-1.51.838.293-1.838a.75.75 0 0 0-.245-.681l-1.458-1.281 1.956-.283a.75.75 0 0 0 .572-.423Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-star", V1);
const B1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], C3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleStar",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-star", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, B1));
  }
});
class I1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-3.5 5.5a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75h-7Zm.75 7v-5.5h5.5v5.5h-5.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-stop", I1);
const j1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], L3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleStop",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-stop", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, j1));
  }
});
class M1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 14.992 4.756 2.353 2.353 0 0 0-.631-1.46c-.38-.409-.874-.667-1.336-.85-.424-.168-.882-.294-1.28-.404l-.108-.03c-.447-.124-.796-.227-1.058-.352a.44.44 0 0 1-.203-.21 4.833 4.833 0 0 0 1.293-3.084l.001-.016v-.033c0-.341 0-1.304-.399-2.2a3.08 3.08 0 0 0-1.05-1.302c-.518-.36-1.173-.561-1.971-.561s-1.453.201-1.971.561a3.08 3.08 0 0 0-1.05 1.301c-.4.897-.4 1.86-.399 2.201v.051a4.85 4.85 0 0 0 1.247 3.03.843.843 0 0 1-.225.295c-.253.118-.582.22-.994.338l-.146.041c-.388.11-.829.235-1.237.397-.46.182-.952.437-1.333.84-.358.38-.588.862-.634 1.447A8.212 8.212 0 0 1 3.75 12Zm3 6.364A8.216 8.216 0 0 0 12 20.25a8.216 8.216 0 0 0 5.25-1.886v-1.39c0-.312-.096-.504-.237-.656-.162-.173-.419-.33-.79-.477-.345-.137-.727-.242-1.142-.357l-.095-.026c-.426-.118-.908-.255-1.311-.449l-.007-.003a1.94 1.94 0 0 1-1.076-1.89l.023-.297.22-.2a3.33 3.33 0 0 0 1.085-2.302c0-.34-.011-1.012-.269-1.59a1.583 1.583 0 0 0-.535-.68c-.233-.161-.58-.293-1.116-.293-.537 0-.883.132-1.116.293-.237.165-.41.398-.535.68-.257.577-.269 1.249-.269 1.589a3.35 3.35 0 0 0 1.078 2.296l.267.246-.027.362a2.351 2.351 0 0 1-.955 1.719l-.05.037-.056.027c-.405.205-.889.348-1.317.47l-.148.042c-.397.113-.762.217-1.095.348-.373.148-.632.304-.793.476-.14.149-.234.335-.234.635v1.39ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-user", M1);
const H1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], A3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleUser",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-user", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, H1));
  }
});
class k1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 6.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75Zm0 10.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-circle-warning", k1);
const C1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], E3 = /* @__PURE__ */ t({
  __name: "VsgIconCircleWarning",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-circle-warning", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, C1));
  }
});
class L1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 8a.75.75 0 0 0-1.5 0v4c0 .25.125.485.334.624l3 2a.75.75 0 0 0 .832-1.248L12.75 11.6V8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-clock", L1);
const A1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], S3 = /* @__PURE__ */ t({
  __name: "VsgIconClock",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-clock", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, A1));
  }
});
class E1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.53 5.47a.75.75 0 0 0-1.06 1.06L10.94 12l-5.47 5.47a.75.75 0 0 0 1.06 1.06L12 13.06l5.47 5.47a.75.75 0 0 0 1.06-1.06L13.06 12l5.47-5.47a.75.75 0 0 0-1.06-1.06L12 10.94 6.53 5.47Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-close", E1);
const S1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], J3 = /* @__PURE__ */ t({
  __name: "VsgIconClose",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-close", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, S1));
  }
});
class J1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8.03 8.53a.75.75 0 0 0-1.06-1.06l-4 4a.75.75 0 0 0 0 1.06l4 4a.75.75 0 0 0 1.06-1.06L4.56 12l3.47-3.47Zm9-1.06a.75.75 0 1 0-1.06 1.06L19.44 12l-3.47 3.47a.75.75 0 0 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06l-4-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-code", J1);
const T1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], T3 = /* @__PURE__ */ t({
  __name: "VsgIconCode",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-code", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, T1));
  }
});
class q1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M15 3.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5ZM8.25 9a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0Zm7.25-3.75v1.075c.204.06.407.152.586.273.333.226.664.61.664 1.152v.5h-1v-.5c0-.092-.053-.207-.225-.324A1.038 1.038 0 0 0 15 7.25c-.189 0-.402.04-.55.129-.119.07-.2.166-.2.371 0 .101.122.528.9.773 1.048.33 1.6.99 1.6 1.727 0 .612-.296 1.023-.696 1.252-.18.102-.372.164-.554.2v1.048h-1v-1.055a1.907 1.907 0 0 1-.554-.213 1.375 1.375 0 0 1-.696-1.232v-.5h1v.5c0 .202.08.299.203.37.151.09.366.13.547.13.204 0 .415-.035.558-.117a.356.356 0 0 0 .135-.126.49.49 0 0 0 .057-.257c0-.152-.106-.523-.9-.773-1.063-.334-1.6-1.065-1.6-1.727 0-.598.303-1.002.69-1.231a1.89 1.89 0 0 1 .56-.215V5.25h1ZM2.25 15a6.753 6.753 0 0 1 5.065-6.538 7.818 7.818 0 0 0 .047 1.549A5.252 5.252 0 0 0 9 20.25a5.252 5.252 0 0 0 4.99-3.613 7.78 7.78 0 0 0 1.548.047A6.75 6.75 0 0 1 2.25 15Zm5.69-2.481c.053-.032.107-.06.162-.085.152.303.322.595.51.873a.796.796 0 0 0-.163.072c-.118.07-.199.166-.199.371 0 .101.122.528.9.773 1.048.33 1.6.99 1.6 1.727 0 .612-.296 1.023-.696 1.252-.18.102-.372.164-.554.2v1.048h-1v-1.055a1.907 1.907 0 0 1-.554-.212 1.375 1.375 0 0 1-.696-1.233v-.5h1v.5c0 .202.08.299.203.37.151.09.366.13.547.13.204 0 .415-.035.558-.117a.356.356 0 0 0 .135-.126.49.49 0 0 0 .057-.257c0-.152-.106-.523-.9-.773-1.063-.334-1.6-1.065-1.6-1.727 0-.598.303-1.002.69-1.231Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-coins", q1);
const R1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], q3 = /* @__PURE__ */ t({
  __name: "VsgIconCoins",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-coins", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, R1));
  }
});
class D1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8.53 4.47a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0-1.06-1.06L12 7.94 8.53 4.47Zm8 14-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06L12 16.06l3.47 3.47a.75.75 0 0 0 1.06-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-collapse", D1);
const F1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], R3 = /* @__PURE__ */ t({
  __name: "VsgIconCollapse",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-collapse", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, F1));
  }
});
class P1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75v16.5a8.25 8.25 0 0 0 0-16.5Zm0-1.5c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-contrast", P1);
const W1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], D3 = /* @__PURE__ */ t({
  __name: "VsgIconContrast",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-contrast", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, W1));
  }
});
class O1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 5c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75v10A1.75 1.75 0 0 1 20 16.75H8.263L3.47 20.586l-1.219.975V5ZM4 4.75a.25.25 0 0 0-.25.25v13.44l3.781-3.026.206-.164H20a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25H4ZM7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8ZM8 11.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-conversation", O1);
const U1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], F3 = /* @__PURE__ */ t({
  __name: "VsgIconConversation",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-conversation", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, U1));
  }
});
class N1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.5 4.25a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75V7h2.75a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-10a.75.75 0 0 1-.75-.75V17H5.25a.75.75 0 0 1-.75-.75v-12ZM8 15.5V7.75A.75.75 0 0 1 8.75 7h5.75V5H6v10.5h2ZM9.5 19V8.5H18V19H9.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-copy", N1);
const K1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], P3 = /* @__PURE__ */ t({
  __name: "VsgIconCopy",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-copy", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, K1));
  }
});
class G1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.875 7.25a.25.25 0 0 0-.25.25v1.75h16.5V7.5a.25.25 0 0 0-.25-.25h-16Zm-.25 9.25v-4.25h16.5v4.25a.25.25 0 0 1-.25.25h-16a.25.25 0 0 1-.25-.25Zm-1.5-9c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 0 1-1.75 1.75h-16a1.75 1.75 0 0 1-1.75-1.75v-9Zm3.5 6.75h-.5v1h8v-1h-7.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-credit-card", G1);
const Y1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], W3 = /* @__PURE__ */ t({
  __name: "VsgIconCreditCard",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-credit-card", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Y1));
  }
});
class Q1 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3 3.75h8v16.5H3V3.75Zm1.5 1.5v13.5h5V5.25h-5Zm8.5-1.5h8v8.5h-8v-8.5Zm1.5 1.5v5.5h5v-5.5h-5Zm-.75 8.5H13v6.5h8v-6.5h-7.25Zm.75 5v-3.5h5v3.5h-5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-dashboard", Q1);
const X1 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], O3 = /* @__PURE__ */ t({
  __name: "VsgIconDashboard",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-dashboard", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, X1));
  }
});
class ln extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.75 4a.75.75 0 0 0-1.5 0v2.25H4a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-2.25V4a.75.75 0 0 0-1.5 0v2.25h-8.5V4ZM17 7.75H4.75v2.5h14.5v-2.5H17ZM4.75 19.25v-7.5h14.5v7.5H4.75Zm8-5.75a.75.75 0 0 0-1.5 0v1.25H10a.75.75 0 0 0 0 1.5h1.25v1.25a.75.75 0 0 0 1.5 0v-1.25H14a.75.75 0 0 0 0-1.5h-1.25V13.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-date-add", ln);
const en = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], U3 = /* @__PURE__ */ t({
  __name: "VsgIconDateAdd",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-date-add", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, en));
  }
});
class an extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.75 4a.75.75 0 0 0-1.5 0v2.25H4a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-2.25V4a.75.75 0 0 0-1.5 0v2.25h-8.5V4ZM17 7.75H4.75v2.5h14.5v-2.5H17ZM4.75 19.25v-7.5h14.5v7.5H4.75ZM6 17h9v-3H6v3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-date-block", an);
const sn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], N3 = /* @__PURE__ */ t({
  __name: "VsgIconDateBlock",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-date-block", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, sn));
  }
});
class rn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.75 4a.75.75 0 0 0-1.5 0v2.25H4a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-2.25V4a.75.75 0 0 0-1.5 0v2.25h-8.5V4ZM17 7.75H4.75v2.5h14.5v-2.5H17ZM4.75 19.25v-7.5h14.5v7.5H4.75ZM9 17H6v-3h3v3Zm2 0h3v-3h-3v3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-date-range", rn);
const nn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], K3 = /* @__PURE__ */ t({
  __name: "VsgIconDateRange",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-date-range", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, nn));
  }
});
class on extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.75 4a.75.75 0 0 0-1.5 0v2.25H4a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-2.25V4a.75.75 0 0 0-1.5 0v2.25h-8.5V4ZM17 7.75H4.75v2.5h14.5v-2.5H17ZM4.75 19.25v-7.5h14.5v7.5H4.75Zm6.28-5.78a.75.75 0 1 0-1.06 1.06l.97.97-.97.97a.75.75 0 0 0 1.06 1.06l.97-.97.97.97a.75.75 0 0 0 1.06-1.06l-.97-.97.97-.97a.75.75 0 0 0-1.06-1.06l-.97.97-.97-.97Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-date-remove", on);
const tn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], G3 = /* @__PURE__ */ t({
  __name: "VsgIconDateRemove",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-date-remove", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, tn));
  }
});
class cn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.75 4a.75.75 0 0 0-1.5 0v2.25H4a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-2.25V4a.75.75 0 0 0-1.5 0v2.25h-8.5V4ZM17 7.75H4.75v2.5h14.5v-2.5H17ZM4.75 19.25v-7.5h14.5v7.5H4.75ZM6 17h3v-3H6v3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-date", cn);
const un = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Y3 = /* @__PURE__ */ t({
  __name: "VsgIconDate",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-date", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, un));
  }
});
class mn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9 3.25a.75.75 0 0 0-.75.75v2.25H5a.75.75 0 0 0 0 1.5h.75V19c0 1.032.897 1.75 1.85 1.75h8.8c.953 0 1.85-.718 1.85-1.75V7.75H19a.75.75 0 0 0 0-1.5h-3.25V4a.75.75 0 0 0-.75-.75H9Zm5.25 3v-1.5h-4.5v1.5h4.5ZM9 7.75H7.25V19c0 .044.018.099.077.152.06.054.154.098.273.098h8.8a.405.405 0 0 0 .273-.098c.059-.053.077-.108.077-.152V7.75H9ZM10.75 10a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0v-7ZM14 9.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-delete", mn);
const dn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Q3 = /* @__PURE__ */ t({
  __name: "VsgIconDelete",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-delete", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, dn));
  }
});
class gn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9 3.25a.75.75 0 0 0-.007 1.5H9l.058.005a2.317 2.317 0 0 1 1.026.37C10.6 5.467 11.25 6.218 11.25 8v6.19l-2.72-2.72a.75.75 0 1 0-1.06 1.06l4 4 .53.53.53-.53 4-4a.75.75 0 0 0-1.06-1.06l-2.72 2.72V8c0-2.218-.85-3.468-1.834-4.124A3.817 3.817 0 0 0 9.2 3.261a2.652 2.652 0 0 0-.175-.01H9V4v-.75Zm-6 11a.75.75 0 0 1 .75.75v3.045c0 .403.117.736.268.949.152.215.292.256.367.256h15.23c.075 0 .215-.041.367-.256.151-.213.268-.546.268-.95V15a.75.75 0 0 1 1.5 0v3.045c0 .676-.193 1.321-.544 1.816-.348.493-.9.89-1.59.89H4.384c-.69 0-1.242-.397-1.59-.89-.35-.495-.544-1.14-.544-1.816V15a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-deposit", gn);
const hn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], X3 = /* @__PURE__ */ t({
  __name: "VsgIconDeposit",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-deposit", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, hn));
  }
});
class pn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 4.5A.75.75 0 0 1 4 3.75h16a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-4.96l.671 2.013a.75.75 0 0 1-.711.987H9a.75.75 0 0 1-.712-.987l.671-2.013H4a.75.75 0 0 1-.75-.75v-12Zm1.5 9.75v1.5h14.5v-1.5H4.75Zm14.5-1.5H4.75v-7.5h14.5v7.5Zm-8.71 4.5h2.92l.5 1.5h-3.92l.5-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-desktop", pn);
const vn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], l4 = /* @__PURE__ */ t({
  __name: "VsgIconDesktop",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-desktop", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, vn));
  }
});
class xn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 4.75a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h1.25V4.75H4Zm2-1.5H4A1.75 1.75 0 0 0 2.25 5v10c0 .966.784 1.75 1.75 1.75h8v-1.5H6.75V4.75h9.5V6h1.5V4.75H19a.25.25 0 0 1 .25.25v1h1.5V5A1.75 1.75 0 0 0 19 3.25H6ZM13.25 8a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-7a.75.75 0 0 1-.75-.75V8Zm7 .75v7.5h-5.5v-7.5h5.5Zm0 9h-5.5v1.5h5.5v-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-devices", xn);
const yn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], e4 = /* @__PURE__ */ t({
  __name: "VsgIconDevices",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-devices", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, yn));
  }
});
class _n extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M15.968 4.405c-.505.505-.843 1.196-.843 1.97v3.865l.52 1.386h1.23V3.788c-.312.13-.627.337-.907.617Zm-2.295 6.234.702 1.872v7.364a2 2 0 1 0 4 0v-17a.75.75 0 0 0-.75-.75c-.987 0-1.982.484-2.718 1.22-.745.745-1.282 1.804-1.282 3.03v4h.75-.75c0 .09.016.18.048.264Zm2.202 9.236v-6.75h1v6.75a.5.5 0 1 1-1 0ZM7.625 8.898a.5.5 0 0 1-.5-.5V5.375a.75.75 0 0 0-1.5 0v4.5c0 1.04.49 1.967 1.25 2.562v7.688c0 .967.784 1.75 1.75 1.75h.5a1.75 1.75 0 0 0 1.75-1.75v-7.688a3.244 3.244 0 0 0 1.25-2.562v-4.5a.75.75 0 0 0-1.5 0v3.023a.5.5 0 0 1-1 0V5.375a.75.75 0 0 0-1.5 0v3.023a.5.5 0 0 1-.5.5Zm0 1.5c.473 0 .908-.164 1.25-.439a1.991 1.991 0 0 0 1.685.392 1.75 1.75 0 0 1-3.37 0c.14.03.286.047.435.047Zm1.75 2.727h-1v7c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-dining", _n);
const wn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], a4 = /* @__PURE__ */ t({
  __name: "VsgIconDining",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-dining", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, wn));
  }
});
class fn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.47 2.47a.75.75 0 0 1 1.06 0l9 9a.75.75 0 0 1 0 1.06l-9 9a.75.75 0 0 1-1.06 0l-9-9a.75.75 0 0 1 0-1.06l9-9ZM4.06 12 12 19.94 19.94 12 12 4.06 4.06 12Zm5.19-1a.75.75 0 0 1 .75-.75h4.19l-1.22-1.22a.75.75 0 0 1 1.06-1.06l2.5 2.5.53.53-.53.53-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22h-3.44V16a.75.75 0 0 1-1.5 0v-5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-directions", fn);
const bn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], s4 = /* @__PURE__ */ t({
  __name: "VsgIconDirections",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-directions", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, bn));
  }
});
class zn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.5 3.25A1.75 1.75 0 0 0 4.75 5v14c0 .967.784 1.75 1.75 1.75h11A1.75 1.75 0 0 0 19.25 19V5a1.75 1.75 0 0 0-1.75-1.75h-11ZM6.25 5a.25.25 0 0 1 .25-.25h11a.25.25 0 0 1 .25.25v14a.25.25 0 0 1-.25.25h-11a.25.25 0 0 1-.25-.25V5ZM9 7.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9ZM8.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 15.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-document", zn);
const $n = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], r4 = /* @__PURE__ */ t({
  __name: "VsgIconDocument",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-document", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, $n));
  }
});
class Zn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3 6.25a.75.75 0 0 0-.75.75v10c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75H3Zm.75 3.23v5.041a1.504 1.504 0 0 1 1.729 1.729h13.042a1.504 1.504 0 0 1 1.729-1.729V9.48a1.504 1.504 0 0 1-1.729-1.729H5.479A1.504 1.504 0 0 1 3.75 9.48Zm6.5 2.52a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM12 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-dollar-bill", Zn);
const Vn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], n4 = /* @__PURE__ */ t({
  __name: "VsgIconDollarBill",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-dollar-bill", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Vn));
  }
});
class Bn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13 4v1.51a3.935 3.935 0 0 1 1.531.695C15.29 6.783 15.8 7.67 15.8 8.8v1h-2v-1c0-.47-.19-.782-.481-1.004-.32-.243-.794-.396-1.32-.396-.524 0-.999.152-1.318.396-.291.221-.481.534-.481 1.004 0 .808.247 1.193.54 1.453.362.322.877.531 1.616.813l.068.025c.652.249 1.501.572 2.165 1.162.758.674 1.211 1.622 1.211 2.947 0 1.13-.51 2.018-1.269 2.596A3.934 3.934 0 0 1 13 18.49V20h-2v-1.51a3.935 3.935 0 0 1-1.531-.695C8.71 17.218 8.2 16.33 8.2 15.2v-1h2v1c0 .47.19.783.481 1.005.32.243.794.395 1.319.395.525 0 1-.152 1.319-.395.291-.222.481-.535.481-1.005 0-.808-.247-1.193-.54-1.452-.362-.323-.877-.531-1.616-.813l-.068-.026c-.652-.248-1.501-.571-2.165-1.161C8.653 11.074 8.2 10.125 8.2 8.8c0-1.13.51-2.017 1.269-2.595A3.934 3.934 0 0 1 11 5.509V4h2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-dollar", Bn);
const In = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], o4 = /* @__PURE__ */ t({
  __name: "VsgIconDollar",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-dollar", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, In));
  }
});
class jn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3 6.25a.75.75 0 0 0-.75.75v10c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75H3Zm.75 8.271V9.48a1.504 1.504 0 0 0 1.729-1.73h13.042a1.504 1.504 0 0 0 1.729 1.73v5.042a1.504 1.504 0 0 0-1.729 1.729H5.479a1.504 1.504 0 0 0-1.729-1.729Zm11.85-3.764C15.6 12.715 12 15 12 15s-3.6-2.285-3.6-4.243c0-2.285 3.6-2.285 3.6-.326 0-1.959 3.6-1.959 3.6.326Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-donate", jn);
const Mn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], t4 = /* @__PURE__ */ t({
  __name: "VsgIconDonate",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-donate", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Mn));
  }
});
class Hn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 4.25a.75.75 0 0 1 .75.75v9.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4-.53.53-.53-.53-4-4a.75.75 0 0 1 1.06-1.06l2.72 2.72V5a.75.75 0 0 1 .75-.75Zm-9 10a.75.75 0 0 1 .75.75v3.045c0 .403.117.736.268.949.152.215.292.256.367.256h15.23c.075 0 .215-.041.367-.256.151-.213.268-.546.268-.95V15a.75.75 0 0 1 1.5 0v3.045c0 .676-.193 1.321-.544 1.816-.348.493-.9.89-1.59.89H4.384c-.69 0-1.242-.397-1.59-.89-.35-.495-.544-1.14-.544-1.816V15a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-download", Hn);
const kn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], c4 = /* @__PURE__ */ t({
  __name: "VsgIconDownload",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-download", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, kn));
  }
});
class Cn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M20.485 2.603a.75.75 0 0 1-.588.883l-4.542.908-.43 1.61h2.825a.75.75 0 0 1 .748.807l-1 12.997a.75.75 0 0 1-.262.513l-.486-.57c.486.57.485.571.485.571l-.001.001-.003.002-.005.005-.012.01a.952.952 0 0 1-.101.072 2.242 2.242 0 0 1-.23.128 4.725 4.725 0 0 1-.864.31c-.783.209-2.04.4-4.019.4-1.983 0-3.351-.192-4.241-.393a7.99 7.99 0 0 1-.993-.286 3.949 3.949 0 0 1-.333-.14l-.025-.013-.009-.005-.004-.002-.001-.001s-.002 0 .356-.66l-.358.66a.75.75 0 0 1-.39-.602l-1-12.997a.75.75 0 0 1 .748-.808h7.623l.652-2.446a.75.75 0 0 1 .578-.542l5-1a.75.75 0 0 1 .882.588Zm-7.512 4.9H6.56l.137 1.785c.3-.054.674-.1 1.096-.138C8.817 9.057 10.216 9 11.75 9c.28 0 .554.002.822.006l.4-1.503Zm-6.126 3.735.615 7.986c.154.05.362.11.628.17.767.173 2.024.356 3.91.356 1.89 0 3.009-.183 3.633-.35a4.18 4.18 0 0 0 .401-.126l.619-8.037c-.271.044-.591.081-.946.114-.626.056-1.39.1-2.24.125l-1.992 7.467a.75.75 0 0 1-1.45-.386l1.882-7.057h-.157c-1.534 0-2.933-.056-3.957-.15a14.38 14.38 0 0 1-.946-.112Zm9.956-1.95.137-1.785h-2.415l-.412 1.545a33.8 33.8 0 0 1 1.594.102c.422.038.796.084 1.096.138Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-drink", Cn);
const Ln = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], u4 = /* @__PURE__ */ t({
  __name: "VsgIconDrink",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-drink", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ln));
  }
});
class An extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M16.78 3.22a.75.75 0 0 0-1.06 0l-1.97 1.97-.53.53-8 8-.53.53-.47.47a.75.75 0 0 0-.205.383l-1 5a.75.75 0 0 0 .882.883l5-1a.75.75 0 0 0 .383-.206l.47-.47.53-.53 8-8 .53-.53 1.97-1.97a.75.75 0 0 0 0-1.06l-4-4Zm.97 5.97 1.44-1.44-2.94-2.94-1.44 1.44 2.94 2.94Zm-4-1.88-6.94 6.94 2.94 2.94 6.94-6.94-2.94-2.94ZM8.69 18.25l-2.94-2.94-.31.31-.734 3.674 3.674-.735.31-.309Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-edit", An);
const En = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], i4 = /* @__PURE__ */ t({
  __name: "VsgIconEdit",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-edit", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, En));
  }
});
class Sn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm2-4a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-ellipsis-vertical", Sn);
const Jn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], m4 = /* @__PURE__ */ t({
  __name: "VsgIconEllipsisVertical",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-ellipsis-vertical", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Jn));
  }
});
class Tn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.53 3.47a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06L12 5.06l3.47 3.47a.75.75 0 1 0 1.06-1.06l-4-4Zm-4 12a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L12 18.94l-3.47-3.47Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-expand", Tn);
const qn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], d4 = /* @__PURE__ */ t({
  __name: "VsgIconExpand",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-expand", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, qn));
  }
});
class Rn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.53 4.47 12 3.94l-.53.53-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72V16a.75.75 0 0 0 1.5 0V6.81l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4ZM3.25 20a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-export", Rn);
const Dn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], g4 = /* @__PURE__ */ t({
  __name: "VsgIconExport",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-export", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Dn));
  }
});
class Fn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.159 4.159A2.25 2.25 0 0 1 5.75 3.5h2a.75.75 0 0 0 0-1.5h-2A3.75 3.75 0 0 0 2 5.75v2a.75.75 0 0 0 1.5 0v-2c0-.597.237-1.169.659-1.591Zm4.048 3.634A1 1 0 0 0 6.5 8.5v.75a1 1 0 0 0 2 0V8.5a1 1 0 0 0-.293-.707Zm9 0A1 1 0 0 0 15.5 8.5v.75a1 1 0 0 0 2 0V8.5a1 1 0 0 0-.293-.707Zm-8.891 7.69a.75.75 0 0 1 1.06-.027 3.82 3.82 0 0 0 5.258 0 .75.75 0 1 1 1.032 1.088 5.32 5.32 0 0 1-7.322 0 .75.75 0 0 1-.028-1.06ZM2.75 15.5a.75.75 0 0 1 .75.75v2a2.25 2.25 0 0 0 2.25 2.25h2a.75.75 0 0 1 0 1.5h-2A3.75 3.75 0 0 1 2 18.25v-2a.75.75 0 0 1 .75-.75Zm19.25.75a.75.75 0 0 0-1.5 0v2a2.25 2.25 0 0 1-2.25 2.25h-2a.75.75 0 0 0 0 1.5h2A3.75 3.75 0 0 0 22 18.25v-2Zm-6.5-13.5a.75.75 0 0 1 .75-.75h1.86a3.75 3.75 0 0 1 3.75 3.75v1.86a.75.75 0 0 1-1.5 0V5.75a2.25 2.25 0 0 0-2.25-2.25h-1.86a.75.75 0 0 1-.75-.75ZM13.25 8.5a.75.75 0 0 0-1.5 0v3.25c0 .261-.052.486-.124.617a.23.23 0 0 1-.065.082c-.002.002-.015.011-.061.011a.75.75 0 0 0 0 1.5c.701 0 1.177-.396 1.437-.865.24-.431.313-.936.313-1.345V8.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-face-id", Fn);
const Pn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], h4 = /* @__PURE__ */ t({
  __name: "VsgIconFaceId",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-face-id", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Pn));
  }
});
class Wn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <g fill-rule="evenodd">     <path d="M12 6.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5ZM5.25 12a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0Z"/>     <path d="M10.667 10.5a.834.834 0 1 1-1.668 0 .834.834 0 0 1 1.668 0Zm4.333 0a.834.834 0 1 1-1.667 0 .834.834 0 0 1 1.667 0Zm-6.083 2.21a.75.75 0 0 1 1.04.207c1.037 1.555 3.05 1.555 4.086 0a.75.75 0 1 1 1.248.832c-1.63 2.446-4.952 2.446-6.582 0a.75.75 0 0 1 .208-1.04ZM2.75 16.75a.75.75 0 0 1 .75.75v2.75c0 .138.112.25.25.25H6.5a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25V17.5a.75.75 0 0 1 .75-.75Zm18.5 0a.75.75 0 0 0-.75.75v2.75a.25.25 0 0 1-.25.25H17.5a.75.75 0 0 0 0 1.5h2.75A1.75 1.75 0 0 0 22 20.25V17.5a.75.75 0 0 0-.75-.75Zm-1-13.25a.25.25 0 0 1 .25.25V6.5a.75.75 0 0 0 1.5 0V3.75A1.75 1.75 0 0 0 20.25 2H17.5a.75.75 0 0 0 0 1.5h2.75Zm-16.5 0a.25.25 0 0 0-.25.25V6.5a.75.75 0 0 1-1.5 0V3.75C2 2.784 2.784 2 3.75 2H6.5a.75.75 0 0 1 0 1.5H3.75Z"/>   </g> </svg> 
    `;
  }
}
customElements.define("jha-icon-face-viewfinder", Wn);
const On = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], p4 = /* @__PURE__ */ t({
  __name: "VsgIconFaceViewfinder",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-face-viewfinder", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, On));
  }
});
class Un extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.584 3.376a.75.75 0 0 1 .832 0l7.5 5A.75.75 0 0 1 19.5 9.75h-2.25v5.5h1.25a.75.75 0 0 1 0 1.5h-13a.75.75 0 1 1 0-1.5h1.25v-5.5H4.5a.75.75 0 0 1-.416-1.374l7.5-5ZM15.75 9.75v5.5h-1.5v-5.5h1.5Zm-3 0v5.5h-1.5v-5.5h1.5Zm-3 0v5.5h-1.5v-5.5h1.5Zm6.75-1.5h.523L12 4.902 6.977 8.25H16.5Zm-12 9.5a.75.75 0 0 0 0 1.5h15a.75.75 0 1 0 0-1.5h-15Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-fi", Un);
const Nn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], v4 = /* @__PURE__ */ t({
  __name: "VsgIconFi",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-fi", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Nn));
  }
});
class Kn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.006 2H9.728l.623 1.116a2.68 2.68 0 0 1-.069 2.73c-.944.436-1.865.852-2.758 1.254-1.404.634-2.738 1.236-3.978 1.832-.897.415-1.548 1.048-1.543 1.93.004.79.555 1.432 1.085 1.864.565.461 1.293.84 2.009 1.087.703.241 1.485.386 2.148.29.235-.035.462-.075.694-.115.34-.06.69-.12 1.094-.17.645-.08 1.223-.097 1.665.002.415.094.617.264.717.521.123.32.16.948-.221 2.105l-.54 1.639 1.566-.724c1.07-.494 2.196-.875 3.362-1.252l.475-.153c1.007-.324 2.042-.656 3.048-1.06l.044-.017.041-.023a1.81 1.81 0 0 0 .837-1.008l.004-.013.004-.012a1.75 1.75 0 0 0-.137-1.326c-1.227-2.33-2.622-4.534-4.031-6.723l-.002-.003c-.767-1.18-1.541-2.107-2.33-2.746-.79-.64-1.637-1.025-2.53-1.025Zm1.178 2.672a4.177 4.177 0 0 0-.028-.794c.14.087.284.19.435.312.621.504 1.296 1.291 2.015 2.398 1.41 2.19 2.773 4.344 3.966 6.611l.005.009a.25.25 0 0 1 .023.177.31.31 0 0 1-.11.142c-.935.372-1.896.68-2.885.998l-.485.157c-.711.23-1.435.47-2.153.743.073-.62.026-1.162-.154-1.625-.335-.867-1.054-1.277-1.784-1.443-.704-.159-1.494-.113-2.18-.028-.413.05-.87.13-1.255.195-.22.038-.417.072-.567.094-.327.048-.848-.02-1.442-.224-.581-.2-1.145-.5-1.549-.83-.439-.358-.533-.616-.533-.71v-.001c0-.008-.01-.245.677-.562l.01-.005a182.917 182.917 0 0 1 3.921-1.805c.954-.43 1.948-.878 2.99-1.36l.177-.082.114-.158a4.18 4.18 0 0 0 .792-2.209Zm7.942 12.996-.18-.45-7.083 2.583.166.464 7.097-2.597Zm-.428-1.956c.3-.104.63-.086.917.051.292.138.52.382.636.683l.368.915.033.08.013.087c.015.099.02.2.012.3.008.105.004.211-.014.316l-.016.1-.043.092a1.23 1.23 0 0 1-.307.41l-.01.009a1.34 1.34 0 0 1-.387.227l-.009.003-7.57 2.77-.043.016-.045.01a1.15 1.15 0 0 1-.36.027 1.2 1.2 0 0 1-.366-.026l-.1-.023-.09-.048a1.66 1.66 0 0 1-.292-.2l-.046-.04-.04-.047a1.34 1.34 0 0 1-.226-.386l-.003-.007-.003-.007-.332-.928a1.21 1.21 0 0 1 .015-.965l.002-.003a1.229 1.229 0 0 1 .741-.658l7.553-2.754.012-.004Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-fido", Kn);
const Gn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], x4 = /* @__PURE__ */ t({
  __name: "VsgIconFido",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-fido", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Gn));
  }
});
class Yn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.25 4A.75.75 0 0 1 6 3.25h4.25V11c0 .415.336.75.75.75h7.75V20a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V4Zm13.06 6.25-6.56-6.56v6.56h6.56Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-file-filled", Yn);
const Qn = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], y4 = /* @__PURE__ */ t({
  __name: "VsgIconFileFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-file-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Qn));
  }
});
class Xn extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6 3.25a.75.75 0 0 0-.75.75v16c0 .415.336.75.75.75h12a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.22-.53l-7-7a.75.75 0 0 0-.53-.22H6Zm.75 16V4.75h3.5V11c0 .415.336.75.75.75h6.25v7.5H6.75Zm9.439-9L11.75 5.811v4.44h4.439Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-file", Xn);
const l5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], _4 = /* @__PURE__ */ t({
  __name: "VsgIconFile",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-file", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, l5));
  }
});
class e5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-1.42.75H2.75a.75.75 0 1 1 0-1.5h1.83a3.501 3.501 0 0 1 6.84 0h9.83a.75.75 0 0 1 0 1.5h-9.83a3.501 3.501 0 0 1-6.84 0Zm16.67 10h-1.83a3.501 3.501 0 0 1-6.84 0H2.75a.75.75 0 1 1 0-1.5h9.83a3.501 3.501 0 0 1 6.84 0h1.83a.75.75 0 0 1 0 1.5ZM16 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-filter", e5);
const a5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], w4 = /* @__PURE__ */ t({
  __name: "VsgIconFilter",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-filter", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, a5));
  }
});
class s5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.998 3.501c-2.381 0-4.312.7-5.377 1.356a.75.75 0 0 1-.787-1.277c1.305-.804 3.509-1.579 6.164-1.579 2.67 0 4.71.78 6.109 1.564a.75.75 0 1 1-.733 1.308c-1.22-.684-3.011-1.372-5.376-1.372Zm-.745 2.43c-2.998.286-5.695 1.897-6.974 3.887a.75.75 0 0 1-1.262-.81C4.58 6.573 7.724 4.76 11.11 4.437c3.43-.325 7.163.873 9.846 4.531a.75.75 0 1 1-1.21.887c-2.34-3.192-5.538-4.205-8.494-3.924ZM9.67 8.607c3.82-1.507 8.563 1.228 9.143 5.413.126.91-.145 1.422-.462 1.73-.35.343-.838.513-1.205.557a1.885 1.885 0 0 1-1.176-.28c-.35-.224-.651-.604-.696-1.273-.072-1.068-.497-1.899-1.155-2.45-.646-.54-1.456-.762-2.227-.737-1.495.049-3.156 1.091-3.156 3.014 0 1.413.216 2.805 1.004 4.086.79 1.282 2.099 2.365 4.122 3.268a.75.75 0 0 0 .612-1.37c-1.838-.82-2.87-1.732-3.456-2.684-.588-.954-.782-2.035-.782-3.3 0-.861.74-1.483 1.705-1.515.46-.014.894.12 1.215.389.31.26.574.693.621 1.4.079 1.163.65 1.965 1.384 2.435.7.45 1.525.584 2.166.506.598-.072 1.426-.34 2.072-.972.68-.664 1.086-1.661.9-3.01-.713-5.14-6.45-8.468-11.18-6.603-2.286.902-4.007 2.426-4.887 4.428-.88 2.003-.878 4.393.105 6.947a.75.75 0 1 0 1.4-.538c-.87-2.258-.824-4.23-.132-5.806C6.3 10.664 7.683 9.39 9.67 8.606Zm2.284 5.401a.75.75 0 0 1 .76.74c.04 2.692 2.468 4.333 5.093 3.82a.75.75 0 1 1 .287 1.472c-3.361.657-6.824-1.468-6.88-5.27a.75.75 0 0 1 .74-.762Zm.004-3.358c.887-.019 2.012.315 2.906 1.016.873.686 1.506 1.704 1.506 3.092a.75.75 0 1 0 1.5 0c0-1.908-.895-3.341-2.08-4.272-1.165-.914-2.628-1.362-3.863-1.336-2.367.049-5.325 1.553-5.723 4.978-.38 3.269 1.62 6.224 3.02 7.568a.75.75 0 0 0 1.039-1.082c-1.237-1.188-2.871-3.709-2.569-6.313.284-2.447 2.385-3.612 4.264-3.651Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-fingerprint", s5);
const r5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], f4 = /* @__PURE__ */ t({
  __name: "VsgIconFingerprint",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-fingerprint", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, r5));
  }
});
class n5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.75 3a.75.75 0 0 0-1.5 0v18a.75.75 0 1 0 1.5 0v-6.882a5.323 5.323 0 0 1 1.576-.71c1.144-.304 2.787-.326 4.726.96 2.348 1.556 4.703 1.553 6.443 1.168a9.948 9.948 0 0 0 2.093-.717 8.526 8.526 0 0 0 .805-.437l.014-.009.004-.003h.002v-.001L20 13.743l.414.625a.75.75 0 0 0 .336-.625V5.257a.75.75 0 0 0-1.202-.598l-.002.002-.023.016a5.795 5.795 0 0 1-.522.319 6.669 6.669 0 0 1-1.518.595c-1.236.312-2.854.314-4.497-.931-2.107-1.597-4.495-1.575-6.275-1.197-.77.163-1.443.396-1.961.607V3Zm0 2.711v6.685a6.9 6.9 0 0 1 1.191-.439c1.522-.403 3.613-.382 5.94 1.161 1.92 1.272 3.83 1.276 5.29.954a8.45 8.45 0 0 0 2.079-.761V6.548c-.39.18-.863.362-1.4.497-1.564.395-3.68.394-5.77-1.19-1.626-1.232-3.505-1.254-5.058-.925a10.161 10.161 0 0 0-2.272.781Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-flag", n5);
const o5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], b4 = /* @__PURE__ */ t({
  __name: "VsgIconFlag",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-flag", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, o5));
  }
});
class t5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.582 2.287A.75.75 0 0 1 12.1 3v7.35h3.75a.75.75 0 0 1 .607 1.191l-7.2 9.9a.75.75 0 0 1-1.357-.44v-7.35H4.15a.75.75 0 0 1-.607-1.192l7.2-9.9a.75.75 0 0 1 .839-.272Zm-5.96 9.863H8.65a.75.75 0 0 1 .75.75v5.794l4.977-6.844H11.35a.75.75 0 0 1-.75-.75V5.307L5.623 12.15Zm11.228 1.1c.3 0 .571.179.69.455l3 7a.75.75 0 0 1-1.38.59l-.662-1.545h-3.296l-.663 1.546a.75.75 0 0 1-1.378-.591l3-7a.75.75 0 0 1 .689-.455Zm-1.005 5h2.01l-1.005-2.346-1.005 2.346Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-flash-auto", t5);
const c5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], z4 = /* @__PURE__ */ t({
  __name: "VsgIconFlashAuto",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-flash-auto", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, c5));
  }
});
class u5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.082 2.287A.75.75 0 0 1 13.6 3v7.35h3.75a.75.75 0 0 1 .606 1.191l-2.105 2.896 4.184 4.184-.707.707L4.672 4.672l.708-.707 3.38 3.382 3.482-4.788a.75.75 0 0 1 .839-.272ZM9.835 8.421l2.265 2.265v-5.38L9.835 8.422Zm3.43 3.43 1.512 1.512 1.1-1.513h-2.613Zm.321 3.15 1.074 1.074-3.903 5.366a.75.75 0 0 1-1.357-.44v-7.35H5.65a.75.75 0 0 1-.607-1.192L7.57 8.985l1.074 1.074-1.521 2.091h3.027a.75.75 0 0 1 .75.75v5.794L13.586 15Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-flash-off", u5);
const i5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], $4 = /* @__PURE__ */ t({
  __name: "VsgIconFlashOff",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-flash-off", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, i5));
  }
});
class m5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.582 2.287A.75.75 0 0 1 14.1 3v7.35h3.75a.75.75 0 0 1 .607 1.191l-7.2 9.9a.75.75 0 0 1-1.357-.44v-7.35H6.15a.75.75 0 0 1-.607-1.192l7.2-9.9a.75.75 0 0 1 .839-.272Zm-5.96 9.863h3.028a.75.75 0 0 1 .75.75v5.794l4.977-6.844H13.35a.75.75 0 0 1-.75-.75V5.307L7.623 12.15Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-flash", m5);
const d5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Z4 = /* @__PURE__ */ t({
  __name: "VsgIconFlash",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-flash", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, d5));
  }
});
class g5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.752a3.88 3.88 0 0 0-.733.084c-.332.066-.615.435-.523.939l.52 2.86a.746.746 0 0 0 .214.402 4.039 4.039 0 0 1 1.044 0 .746.746 0 0 0 .214-.401l.52-2.861c.092-.504-.191-.873-.523-.94A3.863 3.863 0 0 0 12 3.753ZM9.566 8.83a.746.746 0 0 0-.133-.434l-1.655-2.39c-.292-.422-.753-.483-1.034-.295a3.862 3.862 0 0 0-.578.46 3.85 3.85 0 0 0-.458.577c-.188.281-.128.742.293 1.034l2.391 1.655a.746.746 0 0 0 .435.132c.213-.277.461-.526.739-.739Zm-3.88.558-.538-.373c-.947-.656-1.424-1.998-.688-3.1.18-.27.398-.558.646-.805a5.23 5.23 0 0 1 .805-.646c1.102-.736 2.445-.26 3.1.687l.375.542-.118-.649c-.206-1.133.406-2.419 1.706-2.678A5.34 5.34 0 0 1 12 2.252c.35 0 .707.05 1.026.113 1.3.259 1.912 1.545 1.706 2.678l-.117.645.373-.539c.655-.947 1.997-1.423 3.1-.687.27.18.557.398.805.645.248.248.465.535.646.805.736 1.103.26 2.445-.688 3.1l-.538.374.644-.118c1.133-.206 2.42.406 2.678 1.706.064.32.113.676.113 1.026s-.049.707-.113 1.026c-.259 1.3-1.545 1.912-2.678 1.706l-.645-.117.54.373c.946.655 1.423 1.998.687 3.1-.18.27-.398.558-.646.805a5.335 5.335 0 0 1-.805.646c-1.103.736-2.445.26-3.1-.688l-.373-.538.117.644c.206 1.134-.406 2.42-1.706 2.679a5.346 5.346 0 0 1-1.026.113c-.35 0-.707-.05-1.026-.113-1.3-.26-1.912-1.545-1.706-2.679l.117-.644-.373.539c-.655.947-1.997 1.423-3.1.687a5.337 5.337 0 0 1-.805-.646 5.34 5.34 0 0 1-.646-.805c-.736-1.102-.26-2.445.688-3.1l.535-.37-.641.116c-1.133.206-2.42-.406-2.678-1.706a5.34 5.34 0 0 1-.113-1.026c0-.35.049-.707.113-1.026.259-1.3 1.545-1.912 2.678-1.706l.644.117Zm8.88 6.22a.746.746 0 0 1-.133-.431 4.02 4.02 0 0 0 .742-.743c.15 0 .3.043.432.133l2.39 1.655c.422.292.482.753.294 1.034a3.863 3.863 0 0 1-.459.578c-.154.154-.355.31-.577.459-.282.188-.742.127-1.034-.294l-1.655-2.391Zm-5.741-1.174c.214.28.463.529.742.743.001.15-.043.3-.133.43l-1.655 2.392c-.292.421-.752.482-1.034.293a3.864 3.864 0 0 1-.577-.458 3.862 3.862 0 0 1-.46-.578c-.187-.281-.127-.742.295-1.034l2.39-1.655a.746.746 0 0 1 .432-.133Zm6.782-4.999a.746.746 0 0 1-.435.133 4.021 4.021 0 0 0-.739-.739.746.746 0 0 1 .133-.434l1.655-2.391c.292-.421.752-.482 1.034-.294.222.148.423.304.577.459.155.154.311.355.46.577.187.282.127.743-.295 1.034l-2.39 1.655Zm-7.572 2.044a4.037 4.037 0 0 0 0 1.048.746.746 0 0 1-.4.212l-2.86.52c-.505.092-.873-.191-.94-.523a3.864 3.864 0 0 1-.083-.733c0-.218.031-.47.084-.733.066-.332.434-.615.938-.523l2.861.52a.746.746 0 0 1 .4.212Zm8.33 1.258a.746.746 0 0 1-.4-.212 4.039 4.039 0 0 0 0-1.047.746.746 0 0 1 .4-.213l2.86-.52c.505-.092.873.191.94.524.052.261.083.514.083.732 0 .219-.031.471-.084.733-.066.332-.434.615-.939.524l-2.86-.52Zm-4.89 3.23a4.049 4.049 0 0 0 1.05 0 .746.746 0 0 1 .21.399l.521 2.86c.092.505-.191.873-.523.94a3.86 3.86 0 0 1-.733.084 3.86 3.86 0 0 1-.733-.084c-.332-.066-.615-.435-.523-.94l.52-2.86a.746.746 0 0 1 .21-.398ZM12 10.004a1.999 1.999 0 1 0 0 3.998 1.999 1.999 0 0 0 0-3.998Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-flower", g5);
const h5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], V4 = /* @__PURE__ */ t({
  __name: "VsgIconFlower",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-flower", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, h5));
  }
});
class p5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8.75 4.75 10.5 7h8.75a1 1 0 0 1 1 1v10.25a1 1 0 0 1-1 1H4.75a1 1 0 0 1-1-1V5.75a1 1 0 0 1 1-1h4Zm2.484.75-1.3-1.67a1.5 1.5 0 0 0-1.184-.58h-4a2.5 2.5 0 0 0-2.5 2.5v12.5a2.5 2.5 0 0 0 2.5 2.5h14.5a2.5 2.5 0 0 0 2.5-2.5V8a2.5 2.5 0 0 0-2.5-2.5h-8.016Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-folder", p5);
const v5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], B4 = /* @__PURE__ */ t({
  __name: "VsgIconFolder",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-folder", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, v5));
  }
});
class x5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.53 7.53c1.727-1.726 4.566-2.471 7.19-2.749l.25.25 4 4 .249.249c-.277 2.624-1.023 5.464-2.75 7.19-1.726 1.726-4.565 2.472-7.19 2.75l-.249-.25-4-4-.249-.25c.277-2.623 1.023-5.463 2.75-7.19Zm-2.88 9.181 2.64 2.64a28.744 28.744 0 0 1-2.595-.046 28.753 28.753 0 0 1-.045-2.594Zm14.7-9.422a28.744 28.744 0 0 0-.045-2.593 28.755 28.755 0 0 0-2.594-.045l2.639 2.638Zm1.395-3.371L20 4l.745-.082a.75.75 0 0 0-.662-.663L20 4l.082-.745h-.002l-.007-.001-.022-.002a10.27 10.27 0 0 0-.388-.035 29.42 29.42 0 0 0-4.73.036c-2.783.253-6.266 1.02-8.463 3.217-2.198 2.197-2.964 5.68-3.217 8.462a29.422 29.422 0 0 0-.036 4.731 17.292 17.292 0 0 0 .034.388l.003.023v.008L4 20l-.745.083a.75.75 0 0 0 .662.663L4 20l-.082.746h.009l.022.003.082.008a26.446 26.446 0 0 0 1.412.086c.928.033 2.21.033 3.625-.096 2.782-.253 6.265-1.02 8.462-3.216 2.198-2.198 2.964-5.68 3.217-8.463a29.414 29.414 0 0 0 .036-4.73 16.51 16.51 0 0 0-.034-.389l-.002-.022-.001-.006v-.003Zm-10.16 5.607a.75.75 0 0 0-1.06 1.061L10.94 12l-.939.94-.414-.415a.75.75 0 0 0-1.06 1.061l1.767 1.768a.75.75 0 0 0 1.06-1.06L11.062 14l.939-.939 1.414 1.414a.75.75 0 0 0 1.06-1.06L13.062 12l.939-.939.293.293a.75.75 0 0 0 1.06-1.06l-1.767-1.769a.75.75 0 1 0-1.06 1.061l.413.414-.939.94-1.414-1.415Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-football", x5);
const y5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], I4 = /* @__PURE__ */ t({
  __name: "VsgIconFootball",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-football", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, y5));
  }
});
class _5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 3.25A1.75 1.75 0 0 0 3.25 5v14c0 .967.784 1.75 1.75 1.75h11A1.75 1.75 0 0 0 17.75 19v-3.582l-1.5 1.5V19a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25V5A.25.25 0 0 1 5 4.75h11a.25.25 0 0 1 .25.25v.877l.967-.968c.145-.144.304-.265.474-.362A1.75 1.75 0 0 0 16 3.25H5ZM6.25 8A.75.75 0 0 1 7 7.25h6a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8ZM7 11.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H7Zm11.278-5.28a.75.75 0 0 1 1.06 0l2.34 2.339a.75.75 0 0 1 0 1.06l-6.724 6.724a.75.75 0 0 1-.384.205l-2.923.585a.75.75 0 0 1-.882-.883l.584-2.923a.75.75 0 0 1 .205-.383l6.724-6.724Zm-5.502 7.624-.32 1.597 1.598-.32 6.032-6.032-1.278-1.278-6.032 6.033ZM7 15.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-form", _5);
const w5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], j4 = /* @__PURE__ */ t({
  __name: "VsgIconForm",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-form", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, w5));
  }
});
class f5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.366-9.75 9.75 0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75c0-5.384-4.365-9.75-9.75-9.75ZM8.75 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm7.75-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-8.916 7.124a.75.75 0 0 0 1.04-.208c1.703-2.554 5.049-2.554 6.752 0a.75.75 0 1 0 1.248-.832c-2.297-3.445-6.951-3.445-9.248 0a.75.75 0 0 0 .208 1.04Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-frown", f5);
const b5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], M4 = /* @__PURE__ */ t({
  __name: "VsgIconFrown",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-frown", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, b5));
  }
});
class z5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.25 6.928a8.213 8.213 0 0 0-4.53 1.877l.86.86-1.06 1.06-.86-.86a8.213 8.213 0 0 0-1.876 4.53H5v1.5H3a.75.75 0 0 1-.75-.75c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75a.75.75 0 0 1-.75.75h-2v-1.5h1.216a8.213 8.213 0 0 0-1.876-4.53l-.86.86-1.06-1.06.86-.86a8.213 8.213 0 0 0-4.53-1.877v1.217h-1.5V6.928Zm3.016 2.84-.75-.01-.668-.342a.75.75 0 0 1 1.418.353Zm-.75-.01-.668-.342-.002.004-.006.011-.023.045-.087.171a305.087 305.087 0 0 0-1.275 2.537c-.355.716-.718 1.46-1.006 2.077-.272.582-.518 1.133-.592 1.407-.289 1.078.355 2.263 1.48 2.565 1.127.301 2.277-.403 2.566-1.481.085-.32.14-.945.181-1.6.044-.692.079-1.522.106-2.317a182.214 182.214 0 0 0 .071-2.81l.004-.189V9.77l-.75-.011Zm-.836 3.334a94.631 94.631 0 0 0-.872 1.805c-.298.635-.47 1.043-.502 1.16a.615.615 0 0 0 .42.727.615.615 0 0 0 .728-.42c.038-.144.088-.601.133-1.307a75.77 75.77 0 0 0 .093-1.965Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-gauge", z5);
const $5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], H4 = /* @__PURE__ */ t({
  __name: "VsgIconGauge",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-gauge", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, $5));
  }
});
class Z5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9.72 4.07a8.271 8.271 0 0 0-5.07 4.18h3.864c.156-1.06.378-2.026.653-2.85.161-.484.345-.933.552-1.33ZM12 3.75c-.086 0-.287.052-.579.422-.284.361-.574.93-.83 1.702a15.11 15.11 0 0 0-.56 2.376h3.938a15.11 15.11 0 0 0-.56-2.376c-.256-.771-.546-1.34-.83-1.702-.292-.37-.493-.422-.579-.422Zm3.486 4.5a16.946 16.946 0 0 0-.653-2.85 9.182 9.182 0 0 0-.552-1.33 8.271 8.271 0 0 1 5.07 4.18h-3.865Zm-1.333 1.5H9.847A25.577 25.577 0 0 0 9.75 12c0 .781.034 1.536.097 2.25h4.306c.063-.714.097-1.469.097-2.25 0-.78-.034-1.535-.097-2.25Zm1.505 4.5a27.271 27.271 0 0 0 0-4.5h4.281c.203.716.311 1.47.311 2.25s-.108 1.535-.31 2.25h-4.282Zm-1.69 1.5h-3.937c.142.895.333 1.698.56 2.377.256.77.546 1.34.83 1.702.292.37.493.421.579.421.086 0 .287-.051.579-.421.284-.362.574-.931.83-1.702a15.11 15.11 0 0 0 .56-2.377Zm.313 4.18c.207-.397.39-.845.552-1.329a16.9 16.9 0 0 0 .653-2.85h3.864a8.27 8.27 0 0 1-5.07 4.18ZM12 21.75A9.75 9.75 0 0 0 21.75 12c0-5.384-4.365-9.75-9.75-9.75S2.25 6.616 2.25 12A9.75 9.75 0 0 0 12 21.75Zm-2.28-1.82a9.183 9.183 0 0 1-.553-1.329 16.945 16.945 0 0 1-.653-2.85H4.65a8.27 8.27 0 0 0 5.07 4.18Zm-1.378-5.68A27.18 27.18 0 0 1 8.25 12c0-.773.032-1.527.092-2.25H4.06A8.256 8.256 0 0 0 3.75 12c0 .78.108 1.535.31 2.25h4.282Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-globe", Z5);
const V5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], k4 = /* @__PURE__ */ t({
  __name: "VsgIconGlobe",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-globe", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, V5));
  }
});
class B5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-grabber", B5);
const I5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], C4 = /* @__PURE__ */ t({
  __name: "VsgIconGrabber",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-grabber", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, I5));
  }
});
class j5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.905 5.845a.75.75 0 1 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l2.47-2.469 6.44 6.44h-4.19a.75.75 0 0 0 0 1.5h6.75v-6.75a.75.75 0 0 0-1.5 0v4.189l-6.97-6.97a.75.75 0 0 0-1.06 0l-2.47 2.47-5.47-5.47Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-graph-down", j5);
const M5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], L4 = /* @__PURE__ */ t({
  __name: "VsgIconGraphDown",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-graph-down", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, M5));
  }
});
class H5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.625 5.625a.75.75 0 0 0 0 1.5h4.19l-6.44 6.44-2.47-2.47a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 1 0 1.06 1.06l5.47-5.469 2.47 2.47a.75.75 0 0 0 1.06 0l6.97-6.97v4.19a.75.75 0 0 0 1.5 0v-6.75h-6.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-graph-up", H5);
const k5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], A4 = /* @__PURE__ */ t({
  __name: "VsgIconGraphUp",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-graph-up", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, k5));
  }
});
class C5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.625 5.625a.75.75 0 0 0 0 1.5h4.19l-6.44 6.44-2.47-2.47a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 1 0 1.06 1.06l5.47-5.47 2.47 2.47a.75.75 0 0 0 1.06 0l6.97-6.97v4.19a.75.75 0 0 0 1.5 0v-6.75h-6.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-graph", C5);
const L5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], E4 = /* @__PURE__ */ t({
  __name: "VsgIconGraph",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-graph", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, L5));
  }
});
class A5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.5 8.5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm5 0h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm4 0h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm-9 5h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm4 0h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm6 0h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm-11 5h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm6 0h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm4 0h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-grid-view", A5);
const E5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], S4 = /* @__PURE__ */ t({
  __name: "VsgIconGridView",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-grid-view", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, E5));
  }
});
class S5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m15.852 2.843-.749-.043-.05-.748.847-.056-.048.847Zm-3.758 4.614a2.19 2.19 0 0 0 2.472-.73c.623-.664.924-1.69 1.08-2.422a11.139 11.139 0 0 0 .204-1.425l.001-.025v-.011l-.748-.044-.05-.748h-.01l-.025.003a7.662 7.662 0 0 0-.394.039c-.255.03-.606.079-.988.156-.38.078-.806.186-1.206.34-.378.144-.787.349-1.104.648a2.41 2.41 0 0 0-.754 1.111c-.47-.665-1.049-1.293-1.757-1.78a.75.75 0 1 0-.85 1.237c1.132.777 1.907 2.101 2.404 3.312.12.29.22.57.305.824a8.093 8.093 0 0 0-.84-.402c-.395-.158-.848-.29-1.304-.29-1.48 0-2.704.632-3.534 1.765-.81 1.107-1.206 2.635-1.206 4.405 0 1.757.37 3.84 1.242 5.514C5.91 20.617 7.37 22 9.54 22c.863 0 1.525-.38 1.971-.687.112-.077.216-.153.304-.217l.002-.002c.08-.059.142-.105.198-.144l.206.143.01.008c.092.064.198.14.314.216.46.303 1.136.673 2.005.673 2.158 0 3.595-1.397 4.45-3.078.853-1.674 1.21-3.753 1.21-5.492 0-1.759-.39-3.286-1.192-4.394C18.196 7.89 16.98 7.25 15.5 7.25c-.45 0-.901.133-1.293.29-.4.16-.791.368-1.134.563-.173.099-.337.196-.486.285l-.027.015-.162.096c-.018-.073-.04-.154-.063-.241a14.37 14.37 0 0 0-.241-.8Zm2.148-3.794a9.667 9.667 0 0 0-.307.057 6.276 6.276 0 0 0-.968.27c-.307.117-.51.24-.62.347l-.026.025-.028.023a.91.91 0 0 0-.087 1.337l.034.037.03.04a.69.69 0 0 0 1.116 0l.033-.044.038-.04c.322-.328.567-.996.721-1.722.024-.113.045-.224.064-.33ZM6.207 9.901c-.563.768-.917 1.95-.917 3.52 0 1.583.34 3.414 1.073 4.82.728 1.397 1.768 2.26 3.177 2.26.407 0 .76-.176 1.122-.424.09-.061.175-.124.263-.19l.014-.01c.081-.06.17-.125.256-.183.09-.061.2-.13.319-.186a1.18 1.18 0 0 1 .496-.118c.205 0 .376.062.491.114.12.054.23.121.32.181.086.056.175.12.258.178l.018.013c.091.064.18.127.273.188.375.247.75.426 1.18.426 1.382 0 2.4-.858 3.114-2.259.718-1.409 1.046-3.24 1.046-4.81 0-1.562-.35-2.745-.908-3.516C17.264 9.16 16.5 8.75 15.5 8.75c-.175 0-.42.056-.734.182-.307.123-.63.293-.951.475-.16.09-.314.182-.463.27l-.03.019c-.137.08-.272.16-.395.23-.13.074-.265.148-.392.204a1.32 1.32 0 0 1-.525.13c-.227 0-.43-.087-.526-.131a4.643 4.643 0 0 1-.389-.205 19.384 19.384 0 0 1-.38-.225l-.04-.024a30.96 30.96 0 0 0-.456-.27 7.713 7.713 0 0 0-.943-.473c-.312-.125-.562-.182-.746-.182-1.009 0-1.78.409-2.323 1.15Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-groceries", S5);
const J5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], J4 = /* @__PURE__ */ t({
  __name: "VsgIconGroceries",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-groceries", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, J5));
  }
});
class T5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.366 9.75 9.75c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.75.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM10.5 6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM7 15.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-group", T5);
const q5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], T4 = /* @__PURE__ */ t({
  __name: "VsgIconGroup",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-group", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, q5));
  }
});
class R5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M17.72 8.518c.072.247.13.458.174.614.13.013.256.027.378.041.805.092 1.49.205 1.986.339.242.066.484.147.68.257.098.055.22.136.328.256.11.124.234.328.234.6a.902.902 0 0 1-.235.6c-.106.12-.23.202-.327.257-.196.11-.438.191-.68.257-.291.078-.647.15-1.054.214-.037.38-.104.863-.226 1.354a10.792 10.792 0 0 1-.505 1.483 13.267 13.267 0 0 1-.276.617l-.019.038-.005.011-.001.003-.001.002-.381-.19.38.19a.75.75 0 0 1-.567.407 9.764 9.764 0 0 1-1.105 2.258c-1.088 1.624-2.668 2.75-4.498 2.75s-3.41-1.126-4.498-2.75a9.767 9.767 0 0 1-1.105-2.258.75.75 0 0 1-.568-.408l.381-.19-.381.19v-.002l-.003-.003-.005-.01-.018-.039a13.453 13.453 0 0 1-.276-.619 10.796 10.796 0 0 1-.505-1.48 9.389 9.389 0 0 1-.225-1.354 10.315 10.315 0 0 1-1.055-.214 3.062 3.062 0 0 1-.68-.257 1.249 1.249 0 0 1-.327-.256.903.903 0 0 1-.235-.6.9.9 0 0 1 .235-.601c.106-.12.23-.201.327-.256.196-.11.438-.191.68-.257.497-.134 1.18-.247 1.986-.339.122-.014.249-.028.378-.04a45.716 45.716 0 0 1 .81-2.63c.254-.728.55-1.488.857-2.076a4.18 4.18 0 0 1 .517-.797c.162-.186.487-.505.96-.505.639 0 1.091.233 1.417.4.037.02.072.038.106.054A2.43 2.43 0 0 0 12 3.875c.594 0 .914-.139 1.227-.296.034-.016.07-.035.106-.054.326-.167.778-.4 1.417-.4.473 0 .798.319.96.505.193.222.366.506.517.797.307.588.603 1.348.856 2.077.256.735.479 1.468.637 2.014Zm-7.47 7.607c-.407 0-1.369-.064-2.196-.126.2.472.435.905.694 1.293.912 1.361 2.082 2.083 3.252 2.083s2.34-.721 3.252-2.083a7.84 7.84 0 0 0 .694-1.293c-.827.062-1.789.126-2.196.126-.628 0-1.055-.321-1.296-.503l-.029-.022c-.265-.198-.33-.225-.425-.225-.095 0-.16.027-.425.225l-.03.022c-.24.182-.667.503-1.295.503Zm-6.462-5.043.003-.002-.003.002Zm16.424 0-.003-.002.003.002Zm0-.913-.003.002.001-.001a.04.04 0 0 0 .002-.001Zm-16.42.002a.026.026 0 0 1-.004-.002l.003.002Zm11.88 2.454-.25.001c-1.013.02-2.597.934-2.142 1.643 1.026 1.603 4.239-.703 3.775-1.332-.151-.205-.72-.303-1.382-.312Zm-8.727.312c.171-.23.87-.325 1.634-.31 1.012.019 2.595.933 2.14 1.642-1.025 1.602-4.237-.702-3.774-1.332Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-hacker", R5);
const D5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], q4 = /* @__PURE__ */ t({
  __name: "VsgIconHacker",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-hacker", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, D5));
  }
});
class F5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.097 4.183c.507-.167 1.12-.29 1.768-.19.614.095 1.32.42 1.85.675l.3.145c.162.079.305.15.44.211.103.047.186.083.25.107a.857.857 0 0 0 .08.027h.001c.075.011.264-.009.52-.076a4.417 4.417 0 0 0 .37-.115l.02-.007.002-.001a.75.75 0 0 1 .955.394l2.282 5.124a.75.75 0 0 1-.137.818l-1.211 1.294a2.195 2.195 0 0 1-.167 2.921 2.193 2.193 0 0 1-1.382.638 2.12 2.12 0 0 1-2.358 1.97 2.122 2.122 0 0 1-2.379 1.58 2 2 0 0 1-3.319.802l-1.689-1.688a2.126 2.126 0 0 1-3.332-1.571 2.117 2.117 0 0 1-1.329-.615 2.116 2.116 0 0 1-.61-1.278 1.992 1.992 0 0 1-1.246-.579l-.177-.176a2 2 0 0 1 0-2.829l.174-.173c.064-.064.131-.123.202-.177l-.88-1.583a.75.75 0 0 1 .126-.897l4.622-4.596a.75.75 0 0 1 .82-.16l.003.002.01.004.043.018a18.76 18.76 0 0 0 .697.271c.442.163.88.303 1.107.335.1.014.254.018.494.018h.087c.206 0 .45.001.7.014.188.01.396.027.612.061l.164-.071a9.79 9.79 0 0 0 .249-.11c.045-.02.095-.044.147-.069.297-.14.695-.328 1.12-.468Zm-2.722 13.589 1.669 1.669a.5.5 0 0 0 .707-.707L11.318 17.3a.75.75 0 0 1 1.06-1.061l.56.56.002.002 1.238 1.238a.625.625 0 0 0 .885-.883l-.001-.001-2.033-2.033a.75.75 0 0 1 1.06-1.06l2.387 2.386a.625.625 0 1 0 .884-.884l-2.917-2.917a.75.75 0 0 1 1.06-1.06l2.863 2.862a.703.703 0 0 0 .993 0 .694.694 0 0 0 .053-.928c-.997-1.24-2.539-3.133-2.978-3.572-.276-.276-.741-.577-1.185-.825a12.06 12.06 0 0 0-.545-.286l-.026-.013-.01.001c-.14.021-.33.051-.527.089-.2.038-.397.08-.559.126a1.962 1.962 0 0 0-.215.07c-.105.076-.283.252-.563.552l-.18.195c-.222.24-.476.515-.74.778-.321.322-.732.453-1.095.49a2.872 2.872 0 0 1-1.07-.104 2.846 2.846 0 0 1-.924-.447c-.246-.186-.558-.506-.613-.966-.06-.505.07-1.013.261-1.481.194-.475.48-.98.804-1.499.071-.113.146-.22.224-.32a2.716 2.716 0 0 1-.154-.016c-.412-.057-.998-.258-1.42-.413-.124-.046-.241-.09-.346-.131L3.68 9.598l.794 1.428c.412.06.809.248 1.126.565l.177.177c.255.255.427.562.515.886a2.12 2.12 0 0 1 2.255 1.598 2.125 2.125 0 0 1 1.827 3.52ZM14.688 7.31a.746.746 0 0 1 .418.059h.002l.005.003.014.006.053.025.188.09c.156.078.373.189.613.323.464.26 1.083.643 1.514 1.073.365.366 1.29 1.48 2.14 2.523l.727-.779-1.81-4.066c-.275.064-.66.128-1.008.072-.238-.038-.51-.158-.716-.252-.148-.068-.32-.152-.493-.236-.09-.044-.181-.089-.27-.131-.562-.27-1.071-.49-1.43-.545-.324-.05-.682.005-1.07.133-.33.108-.633.25-.932.392a38.72 38.72 0 0 1-.172.08c-.11.052-.22.1-.328.148-.628.279-1.197.53-1.614 1.197-.31.496-.542.915-.687 1.27-.123.302-.164.514-.165.658l.032.026c.093.07.245.148.432.201.185.053.364.07.502.056.141-.015.186-.055.19-.06.241-.24.468-.485.687-.722l.197-.212c.256-.275.543-.577.797-.757.207-.147.483-.234.673-.287.22-.062.465-.114.686-.156a15.574 15.574 0 0 1 .767-.124l.052-.007.006-.001Zm-9.97 6.225a.5.5 0 0 0 0-.707l-.178-.176a.5.5 0 0 0-.707 0l-.173.173a.5.5 0 0 0 0 .707l.177.177a.5.5 0 0 0 .707 0l.173-.174Zm.975 1.146a.625.625 0 1 0 .884.884l.352-.352a.625.625 0 0 0-.884-.884l-.352.352Zm3.532 1.24a.625.625 0 0 0-.884 0l-.704.705a.625.625 0 0 0 .884.883l.704-.704a.625.625 0 0 0 0-.883Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-handshake", F5);
const P5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], R4 = /* @__PURE__ */ t({
  __name: "VsgIconHandshake",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-handshake", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, P5));
  }
});
class W5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m11.895 4.5-.04.196-.735 3.68h3.21l.775-3.876h2.04l-.04.196-.735 3.68h2.355l-.4 2H15.97l-.65 3.25h2.355l-.4 2H14.92l-.775 3.874h-2.04l.04-.196.735-3.679H9.67L8.895 19.5h-2.04l.04-.196.735-3.679H5.275l.4-2H8.03l.65-3.25H6.325l.4-2H9.08L9.855 4.5h2.04Zm-1.825 9.125.65-3.25h3.21l-.65 3.25h-3.21Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-hash", W5);
const O5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], D4 = /* @__PURE__ */ t({
  __name: "VsgIconHash",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-hash", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, O5));
  }
});
class U5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.737 3.248a5.323 5.323 0 0 0-5.323 5.323c0 4.742 2.354 8.036 4.666 10.12a17.99 17.99 0 0 0 3.17 2.274 15.717 15.717 0 0 0 1.355.68l.084.036.024.01.007.003h.002l.001.001.277-.697-.276.697a.75.75 0 0 0 .552 0L12 20.998l.277.697.003-.001.007-.003.024-.01.084-.035a15.32 15.32 0 0 0 1.354-.681 17.99 17.99 0 0 0 3.171-2.275c2.312-2.083 4.666-5.378 4.666-10.119a5.323 5.323 0 0 0-5.323-5.323A5.305 5.305 0 0 0 12 5.39a5.306 5.306 0 0 0-4.263-2.142Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-heart-filled", U5);
const N5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], F4 = /* @__PURE__ */ t({
  __name: "VsgIconHeartFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-heart-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, N5));
  }
});
class K5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.414 8.571a5.323 5.323 0 0 1 5.323-5.323c1.748 0 3.294.843 4.263 2.142a5.305 5.305 0 0 1 4.263-2.142 5.323 5.323 0 0 1 5.323 5.323c0 4.742-2.354 8.036-4.666 10.12a17.99 17.99 0 0 1-3.17 2.274 15.719 15.719 0 0 1-1.355.68 6.25 6.25 0 0 1-.084.036l-.024.01-.007.003h-.002l-.001.001-.277-.697-.277.697-.003-.001-.007-.003-.024-.01a7.605 7.605 0 0 1-.386-.171c-.257-.12-.62-.3-1.052-.545a17.99 17.99 0 0 1-3.17-2.275c-2.313-2.083-4.667-5.378-4.667-10.119ZM12 20.998l-.276.697a.75.75 0 0 0 .552 0L12 20.998Zm0-.818.062-.029c.226-.106.554-.269.95-.492a16.49 16.49 0 0 0 2.904-2.083c2.106-1.898 4.17-4.817 4.17-9.005A3.82 3.82 0 0 0 12.7 7.196a.75.75 0 0 1-1.4 0 3.82 3.82 0 0 0-7.386 1.375c0 4.188 2.064 7.107 4.17 9.005a16.506 16.506 0 0 0 2.904 2.083 14.133 14.133 0 0 0 1.012.52Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-heart", K5);
const G5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], P4 = /* @__PURE__ */ t({
  __name: "VsgIconHeart",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-heart", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, G5));
  }
});
class Y5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.737 3.25a5.323 5.323 0 0 0-5.323 5.324c0 1.34.188 2.565.51 3.68A.75.75 0 0 0 3 13.75h.461c.902 2.093 2.268 3.725 3.619 4.942a17.985 17.985 0 0 0 3.17 2.275 15.727 15.727 0 0 0 1.355.681l.084.035.024.01.007.003.002.001h.001L12 21l-.276.698a.75.75 0 0 0 .552 0L12 21c.276.698.276.698.277.697h.003l.007-.004.024-.01.084-.035a15.32 15.32 0 0 0 1.354-.681 17.986 17.986 0 0 0 3.171-2.274c1.351-1.218 2.717-2.85 3.619-4.943h.961a.75.75 0 0 0 0-1.5h-.424c.322-1.113.51-2.337.51-3.676a5.323 5.323 0 0 0-5.323-5.324A5.306 5.306 0 0 0 12 5.392 5.306 5.306 0 0 0 7.737 3.25Zm11.768 9c.364-1.098.58-2.32.58-3.676A3.82 3.82 0 0 0 12.7 7.199a.75.75 0 0 1-1.399 0 3.82 3.82 0 0 0-7.386 1.375c0 1.355.217 2.578.58 3.676H6.98l1.318-3.513a.75.75 0 0 1 1.4-.01l2.202 5.605 2.462-3.977a.75.75 0 0 1 1.262-.02l1.277 1.915h2.604Zm-14.39 1.5c.788 1.576 1.873 2.84 2.97 3.828 1.053.95 2.11 1.636 2.903 2.083.396.223.724.386.95.492l.062.029.062-.029c.226-.106.554-.269.95-.492a16.48 16.48 0 0 0 2.904-2.083c1.096-.988 2.18-2.252 2.969-3.828H16.5a.75.75 0 0 1-.624-.334l-.853-1.279-2.635 4.258a.75.75 0 0 1-1.336-.12l-2.036-5.182-.814 2.17a.75.75 0 0 1-.702.487H5.115Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-heartbeat", Y5);
const Q5 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], W4 = /* @__PURE__ */ t({
  __name: "VsgIconHeartbeat",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-heartbeat", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Q5));
  }
});
class X5 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.366 9.75 9.75c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.51-3.84c-.296.247-.51.618-.51 1.174a.75.75 0 0 1-1.5 0c0-1 .411-1.795 1.052-2.327.624-.518 1.427-.757 2.198-.757.753 0 1.545.21 2.168.674A2.644 2.644 0 0 1 15.25 9.1c0 1.39-.844 2.281-1.495 2.874-.138.125-.258.23-.367.324a6.707 6.707 0 0 0-.454.42c-.15.157-.18.23-.184.243v1.04a.75.75 0 0 1-1.5 0v-1.05c0-.569.337-.993.598-1.267.177-.186.413-.393.628-.58v-.001c.096-.084.188-.165.27-.239.598-.545 1.004-1.053 1.004-1.764 0-.446-.187-.755-.48-.974-.315-.235-.773-.376-1.27-.376-.479 0-.926.15-1.24.41ZM12 17.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-help", X5);
const lo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], O4 = /* @__PURE__ */ t({
  __name: "VsgIconHelp",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-help", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, lo));
  }
});
class eo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m4.672 4.672.708-.707 2.956 2.957c1.06-.42 2.261-.672 3.664-.672 4.354 0 6.76 2.427 9.066 4.753l.464.467a.75.75 0 0 1 0 1.06l-.464.467c-1.094 1.104-2.21 2.23-3.546 3.109l2.515 2.515-.707.707L4.672 4.672ZM6.48 7.895c-1.336.879-2.452 2.005-3.546 3.108l-.464.467a.75.75 0 0 0 0 1.06l.464.467C5.24 15.324 7.646 17.75 12 17.75c1.403 0 2.604-.252 3.664-.671l-1.176-1.176A8.57 8.57 0 0 1 12 16.25c-3.65 0-5.635-1.933-7.941-4.25 1.166-1.171 2.25-2.244 3.507-3.02L6.48 7.896Zm2.812 2.812a3 3 0 0 0 4 4l-4-4Zm.22-2.61 1.195 1.196a3 3 0 0 1 4 4l1.727 1.727c1.258-.775 2.341-1.848 3.507-3.02-2.306-2.317-4.29-4.25-7.941-4.25a8.57 8.57 0 0 0-2.488.348Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-hide", eo);
const ao = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], U4 = /* @__PURE__ */ t({
  __name: "VsgIconHide",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-hide", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, ao));
  }
});
class so extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.748 8.25a7.275 7.275 0 0 1 6.228-3.5c4.02 0 7.274 3.25 7.274 7.25A7.241 7.241 0 0 1 12 19.25c-3.582 0-6.366-2.72-7.288-5.487a.75.75 0 0 0-1.423.475C4.366 17.47 7.63 20.75 12 20.75A8.741 8.741 0 0 0 20.75 12c0-4.834-3.93-8.75-8.774-8.75A8.772 8.772 0 0 0 4.75 7.035V5a.75.75 0 1 0-1.5 0v4.75H8a.75.75 0 1 0 0-1.5H5.748Zm6.252-1a.75.75 0 0 1 .75.75v3.6l2.666 1.777a.75.75 0 1 1-.832 1.248l-3-2-.334-.222V8a.75.75 0 0 1 .75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-history", so);
const ro = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], N4 = /* @__PURE__ */ t({
  __name: "VsgIconHistory",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-history", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, ro));
  }
});
class no extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.506 4.436a.75.75 0 0 1 .988 0l3.256 2.849V6h2v3h-.04l2.784 2.436a.75.75 0 1 1-.988 1.129l-.756-.662v7.347H20a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h1.25v-7.347l-.756.662a.75.75 0 1 1-.988-1.13l8-7ZM6.75 19.25h2.5V13a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v6.25h2.5v-8.66L12 5.998 6.75 10.59v8.66Zm6.5 0v-5.5h-2.5v5.5h2.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-home", no);
const oo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], K4 = /* @__PURE__ */ t({
  __name: "VsgIconHome",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-home", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, oo));
  }
});
class to extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19.111 18.5H4.89c-1.35 0-2.389-1.11-2.389-2.409V7.91C2.5 6.611 3.538 5.5 4.889 5.5H19.11c1.35 0 2.389 1.111 2.389 2.41v8.181c0 1.299-1.038 2.41-2.389 2.41ZM4.89 17h14.22a.9.9 0 0 0 .889-.909V7.91a.9.9 0 0 0-.888-.91H4.89a.9.9 0 0 0-.89.91v8.181a.9.9 0 0 0 .889.91ZM14 9.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm-.5 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm-2.84-3.05c.028-.765-.265-1.394-.757-1.817-.473-.407-1.082-.588-1.658-.588-.577.001-1.186.183-1.66.587-.492.42-.794 1.044-.775 1.808v.016c.023.492.085.982.184 1.465a3.901 3.901 0 0 0-.261.12c-.445.223-1.233.74-1.233 1.7v.51a.75.75 0 0 0 1.5 0v-.51c0-.03.032-.172.407-.36a2.825 2.825 0 0 1 .627-.223l.006-.002a.75.75 0 0 0 .57-.943 7.86 7.86 0 0 1-.3-1.817c-.007-.315.106-.501.249-.622.161-.138.409-.228.687-.229.279 0 .522.09.678.224.137.118.248.302.237.62a8.1 8.1 0 0 1-.302 1.826.75.75 0 0 0 .578.943l.007.001.037.008a2.917 2.917 0 0 1 .603.213c.385.188.416.332.416.361v.51a.75.75 0 0 0 1.5 0v-.51c0-.97-.804-1.487-1.254-1.708a3.992 3.992 0 0 0-.27-.12c.098-.479.16-.966.183-1.455v-.008Zm-1.223 2.708h.001Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-id-card", to);
const co = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], G4 = /* @__PURE__ */ t({
  __name: "VsgIconIdCard",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-id-card", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, co));
  }
});
class uo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 4.25a.75.75 0 0 1 .75.75v9.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4-.53.531-.53-.53-4-4a.75.75 0 1 1 1.06-1.061l2.72 2.72V5a.75.75 0 0 1 .75-.75ZM3.25 20a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-import", uo);
const io = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Y4 = /* @__PURE__ */ t({
  __name: "VsgIconImport",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-import", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, io));
  }
});
class mo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.7 5.25h-.408l-.222.343-3.7 5.728-.12.186V16.5A2.756 2.756 0 0 0 5 19.25h14a2.756 2.756 0 0 0 2.75-2.75v-4.993l-.12-.186-3.7-5.728-.222-.343H6.7Zm13.099 6-2.907-4.5H7.108l-2.907 4.5H9a.75.75 0 0 1 .75.75A2.259 2.259 0 0 0 12 14.25 2.259 2.259 0 0 0 14.25 12a.75.75 0 0 1 .75-.75h4.799ZM3.75 12.75h4.576c.35 1.708 1.867 3 3.674 3a3.762 3.762 0 0 0 3.674-3h4.576v3.75c0 .686-.564 1.25-1.25 1.25H5c-.686 0-1.25-.564-1.25-1.25v-3.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-inbox", mo);
const go = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Q4 = /* @__PURE__ */ t({
  __name: "VsgIconInbox",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-inbox", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, go));
  }
});
class ho extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.384 4.365-9.75 9.75-9.75s9.75 4.366 9.75 9.75c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 10.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Zm0-1.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-information", ho);
const po = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], X4 = /* @__PURE__ */ t({
  __name: "VsgIconInformation",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-information", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, po));
  }
});
class vo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.25 5c0-.966.784-1.75 1.75-1.75h12c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0 1 18 20.75H6A1.75 1.75 0 0 1 4.25 19V5ZM6 4.75a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h12a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25H6ZM7.25 8A.75.75 0 0 1 8 7.25h3a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8ZM8 10.25a.75.75 0 0 0-.75.75v6c0 .415.336.75.75.75h8a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75H8Zm4.25 1.5h-3.5v1.5h3.5v-1.5Zm1.5 1.5v-1.5h1.5v1.5h-1.5Zm-1.5 1.5h-3.5v1.5h3.5v-1.5Zm1.5 1.5v-1.5h1.5v1.5h-1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-invoice", vo);
const xo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], l6 = /* @__PURE__ */ t({
  __name: "VsgIconInvoice",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-invoice", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, xo));
  }
});
class yo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.75 6a.75.75 0 0 0-1.5 0v9.19l-2.72-2.72a.75.75 0 0 0-1.06 1.06l4 4 .53.531.53-.53 4-4a.75.75 0 1 0-1.06-1.061l-2.72 2.72V6Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-large-arrow-down", yo);
const _o = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], e6 = /* @__PURE__ */ t({
  __name: "VsgIconLargeArrowDown",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-large-arrow-down", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _o));
  }
});
class wo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.53 8.53a.75.75 0 0 0-1.06-1.06l-4 4-.53.53.53.53 4 4a.75.75 0 1 0 1.06-1.06l-2.72-2.72H18a.75.75 0 0 0 0-1.5H8.81l2.72-2.72Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-large-arrow-left", wo);
const fo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], a6 = /* @__PURE__ */ t({
  __name: "VsgIconLargeArrowLeft",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-large-arrow-left", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, fo));
  }
});
class bo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.47 8.53a.75.75 0 0 1 1.06-1.06l4 4 .53.53-.53.53-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H6a.75.75 0 0 1 0-1.5h9.19l-2.72-2.72Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-large-arrow-right", bo);
const zo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], s6 = /* @__PURE__ */ t({
  __name: "VsgIconLargeArrowRight",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-large-arrow-right", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, zo));
  }
});
class $o extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.53 6.47 12 5.94l-.53.53-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.719v9.19a.75.75 0 0 0 1.5 0V8.81l2.72 2.72a.75.75 0 1 0 1.06-1.061l-4-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-large-arrow-up", $o);
const Zo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], r6 = /* @__PURE__ */ t({
  __name: "VsgIconLargeArrowUp",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-large-arrow-up", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Zo));
  }
});
class Vo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M21.033 10A9.263 9.263 0 0 0 14 2.968 1 1 0 0 0 13 2h-2a1 1 0 0 0-1 .967 9.263 9.263 0 0 0-7.033 7.034A1 1 0 0 0 2 11v2a1 1 0 0 0 .967.999A9.263 9.263 0 0 0 10 21.034 1 1 0 0 0 11 22h2a1 1 0 0 0 1-.966A9.263 9.263 0 0 0 21.032 14 1 1 0 0 0 22 13v-2a1 1 0 0 0-.967-1ZM10.861 4.334a7.812 7.812 0 0 1 2.278 0l-.61 2.444a5.31 5.31 0 0 0-1.058 0l-.61-2.444Zm-1.455.362a7.772 7.772 0 0 0-4.711 4.711l2.443.61a5.268 5.268 0 0 1 2.877-2.877l-.61-2.444Zm-5.073 6.167a7.814 7.814 0 0 0 0 2.277l2.443-.61a5.313 5.313 0 0 1 0-1.058l-2.443-.61Zm.362 3.733a7.772 7.772 0 0 0 4.71 4.71l.61-2.443a5.267 5.267 0 0 1-2.877-2.877l-2.443.61Zm6.166 5.072a7.815 7.815 0 0 0 2.278 0l-.61-2.443a5.292 5.292 0 0 1-1.058 0l-.61 2.443Zm3.733-.362a7.772 7.772 0 0 0 4.711-4.71l-2.443-.61a5.267 5.267 0 0 1-2.877 2.877l.61 2.443Zm5.073-6.166a7.801 7.801 0 0 0 0-2.277l-2.443.609a5.292 5.292 0 0 1 0 1.059l2.443.609Zm-.362-3.733a7.772 7.772 0 0 0-4.71-4.71l-.61 2.443a5.267 5.267 0 0 1 2.877 2.876l2.443-.609ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-life-preserver", Vo);
const Bo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], n6 = /* @__PURE__ */ t({
  __name: "VsgIconLifePreserver",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-life-preserver", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Bo));
  }
});
class Io extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 3.75A5.25 5.25 0 0 0 6.75 9c0 2.333 1.504 4.588 3.5 5.293.3.106.5.39.5.707v1.24h2.5V15c0-.318.201-.6.5-.707 1.996-.705 3.5-2.96 3.5-5.293 0-2.9-2.35-5.25-5.25-5.25ZM5.25 9a6.75 6.75 0 1 1 13.5 0c0 2.707-1.608 5.398-4 6.504v1.487a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75v-1.487c-2.391-1.105-4-3.796-4-6.504Zm4 10a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM11 20.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-lightbulb", Io);
const jo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], o6 = /* @__PURE__ */ t({
  __name: "VsgIconLightbulb",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-lightbulb", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, jo));
  }
});
class Mo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M19.85 4.149c-.87-.87-2.319-.865-3.199.014l-2.744 2.74a2.311 2.311 0 0 0-.654 1.723l-1.249 1.248a3.8 3.8 0 0 1 .83-4.02l.01-.008 2.747-2.744c1.456-1.455 3.854-1.48 5.32-.014 1.465 1.465 1.443 3.862-.014 5.318l-.934.935-1.811 1.812a3.762 3.762 0 0 1-4.024.84l1.247-1.246a2.252 2.252 0 0 0 1.716-.655l1.81-1.81.935-.936c.88-.88.885-2.327.014-3.197Zm-9.973 7.853a3.795 3.795 0 0 0-4.036.85l-2.748 2.744-.008.008c-1.43 1.474-1.466 3.826.008 5.299a3.76 3.76 0 0 0 5.309 0l1.81-1.812.935-.935a3.79 3.79 0 0 0 .851-4.033l-1.25 1.251c.03.62-.191 1.252-.661 1.722h-.001l-.934.935-1.81 1.81a2.26 2.26 0 0 1-3.189 0c-.871-.87-.872-2.28.004-3.188l2.744-2.74a2.28 2.28 0 0 1 1.725-.66l1.25-1.251Zm.373-7.752a.75.75 0 1 0-1.5 0v1.5a.75.75 0 1 0 1.5 0v-1.5Zm-4.97-.03a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06l-1.5-1.5Zm14.47 9.53h-1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5Zm-1.03 6.03a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 1 0-1.06 1.06l1.5 1.5Zm-4.22.72a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-.75.75ZM5.75 10.25h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 1 1 0 1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-link-broken", Mo);
const Ho = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], t6 = /* @__PURE__ */ t({
  __name: "VsgIconLinkBroken",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-link-broken", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ho));
  }
});
class ko extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M15.359 5.46a2.259 2.259 0 0 1 3.182 0 2.259 2.259 0 0 1 0 3.182l-4.243 4.242a2.259 2.259 0 0 1-3.182 0 .75.75 0 0 0-1.06 1.06 3.759 3.759 0 0 0 5.303 0L19.6 9.703a3.759 3.759 0 0 0 0-5.303 3.76 3.76 0 0 0-5.303 0l-2.12 2.12a.75.75 0 1 0 1.06 1.06l2.122-2.12Zm-5.657 5.656a2.259 2.259 0 0 1 3.182 0 .75.75 0 0 0 1.06-1.06 3.759 3.759 0 0 0-5.303 0L4.4 14.298a3.759 3.759 0 0 0 0 5.304 3.759 3.759 0 0 0 5.303 0l2.121-2.122a.75.75 0 0 0-1.06-1.06L8.64 18.54a2.259 2.259 0 0 1-3.182 0 2.259 2.259 0 0 1 0-3.182l4.243-4.243Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-link", ko);
const Co = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], c6 = /* @__PURE__ */ t({
  __name: "VsgIconLink",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-link", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Co));
  }
});
class Lo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.772 6.821c0 .065-.065.065-.065.065h-.065c-.066 0-.066-.065-.13-.13 0 0-.066-.065-.066-.13s0-.065.065-.065l.13.065c.066.065.131.13.131.195Zm-1.238-.651c0-.326-.13-.521-.325-.521 0 0 0 .065-.066.065v.13h.196c0 .13.065.195.065.326h.13Zm2.345-.326c.13 0 .196.13.261.326h.13c-.065-.065-.065-.13-.065-.196 0-.065 0-.13-.065-.195s-.13-.13-.195-.13c0 0-.066.065-.13.065 0 .065.065.065.065.13Zm-2.02 1.042c-.064 0-.064 0-.064-.065s0-.13.065-.195c.13 0 .195-.065.195-.065.066 0 .066.065.066.065 0 .065-.066.13-.196.26h-.065Zm-.716-.065c-.26-.13-.325-.326-.325-.651 0-.196 0-.326.13-.456a.358.358 0 0 1 .326-.196c.13 0 .195.065.325.196.066.195.13.39.13.586v.13h.066v-.065c.065 0 .065-.13.065-.39 0-.196 0-.392-.13-.587-.13-.196-.26-.326-.521-.326a.49.49 0 0 0-.457.326c-.13.26-.13.456-.13.782 0 .26.065.52.391.781 0-.065.065-.065.13-.13Zm8.34 9.446c.064 0 .064 0 .064-.065 0-.13-.065-.326-.26-.52-.196-.196-.521-.327-.912-.392h-.261c-.065 0-.195 0-.26-.065.195-.651.26-1.173.26-1.629 0-.651-.13-1.107-.39-1.563-.262-.391-.522-.586-.848-.652-.065.066-.065.066-.065.13.326.131.651.392.847.783.195.455.26.846.26 1.367 0 .391-.065.913-.325 1.63-.26.13-.521.325-.717.716 0 .065 0 .065.065.065 0 0 .065-.065.13-.195l.326-.326c.196-.13.326-.196.522-.196.325 0 .651.066.846.13a.917.917 0 0 1 .456.261c.066.13.13.196.196.26 0 .196.065.261.065.261Zm-6.125-9.706c-.065-.066-.065-.196-.065-.326 0-.26 0-.391.13-.586.13-.13.261-.196.391-.196.196 0 .326.13.456.26.066.196.13.326.13.522 0 .326-.13.521-.39.586 0 0 .065.065.13.065.13 0 .195.065.326.13.065-.39.13-.65.13-.977 0-.39-.065-.651-.195-.847a.837.837 0 0 0-.652-.26c-.195 0-.39.065-.586.195-.13.196-.196.326-.196.522 0 .325.066.586.196.846.065 0 .13.066.195.066Zm.782 1.107c-.847.586-1.563.847-2.085.847-.456 0-.912-.195-1.368-.521.065.13.13.26.196.326l.39.39c.261.261.587.391.913.391.456 0 .977-.26 1.694-.716l.586-.391c.13-.13.26-.26.26-.456 0-.065 0-.13-.065-.13 0-.196-.325-.391-.977-.587-.586-.26-1.042-.39-1.368-.39-.196 0-.521.13-.977.39-.391.26-.652.521-.652.782 0 0 .065.065.13.195.392.326.782.522 1.173.522.521 0 1.173-.261 2.085-.913v.13c.065.066.065.131.065.131Zm1.564 13.485c.26.522.716.782 1.237.782.13 0 .261 0 .391-.065.13 0 .26-.065.326-.13.065-.065.13-.065.195-.13.13-.066.13-.066.196-.13l1.107-.978c.26-.195.521-.39.847-.586l.652-.326c.195-.065.325-.13.456-.26.065-.131.13-.196.13-.392 0-.195-.13-.325-.26-.456-.13-.13-.261-.195-.391-.195-.13-.065-.261-.13-.456-.326-.13-.195-.261-.39-.326-.716l-.065-.391c-.066-.196-.066-.326-.13-.391h-.066c-.065 0-.195.065-.26.195l-.391.391c-.065.13-.26.26-.391.391-.196.13-.391.195-.521.195-.522 0-.782-.13-.978-.456-.13-.195-.195-.456-.26-.716-.13-.13-.196-.196-.326-.196-.325 0-.456.326-.456 1.043v2.019c0 .065-.065.196-.065.391-.065.196-.065.456-.065.717l-.13.716Zm-9.707-.39c.651.065 1.368.26 2.15.586.781.326 1.303.456 1.498.456.456 0 .847-.196 1.173-.587.065-.13.065-.26.065-.456 0-.65-.391-1.433-1.173-2.41l-.456-.586c-.065-.13-.195-.326-.326-.586-.13-.261-.26-.457-.39-.587a1.22 1.22 0 0 0-.391-.456c-.196-.13-.391-.26-.587-.326-.26.066-.456.13-.586.261-.13.13-.13.26-.13.39 0 .131-.066.261-.13.261-.066.066-.196.066-.326.13h-.391c-.326 0-.587.066-.717.131a.837.837 0 0 0-.26.651c0 .13 0 .261.065.522.065.26.065.456.065.586 0 .26-.065.521-.26.847-.196.26-.261.521-.261.651.13.26.586.456 1.368.521Zm2.215-6.06c0-.455.13-.976.39-1.563.261-.586.457-.977.717-1.237 0-.066-.065-.066-.13-.066l-.065-.13c-.196.196-.456.652-.717 1.368-.26.587-.456 1.173-.456 1.564 0 .325.065.586.196.782.13.195.52.52 1.042.977l.717.456c.781.651 1.172 1.107 1.172 1.368 0 .13-.065.26-.26.456-.13.13-.326.26-.456.26v.066l.195.39c.26.391.912.587 1.694.587 1.498 0 2.606-.587 3.453-1.824 0-.326 0-.521-.066-.652v-.26c0-.456.066-.782.196-.978.13-.195.26-.325.456-.325.13 0 .26.065.39.13.066-.521.066-.977.066-1.368 0-.586 0-1.108-.13-1.564a3.432 3.432 0 0 0-.326-.977l-.391-.586c-.13-.196-.195-.391-.326-.586-.065-.261-.13-.457-.13-.782-.195-.326-.326-.652-.521-.977-.13-.326-.26-.652-.391-.912l-.586.456c-.652.456-1.173.651-1.694.651-.391 0-.717-.065-.912-.326l-.391-.325c0 .195-.065.456-.196.716l-.39.782c-.196.456-.261.717-.326.912 0 .13-.065.26-.065.26l-.521.978c-.522.977-.847 1.954-.847 2.67 0 .131 0 .327.065.457-.326-.196-.456-.456-.456-.847Zm4.82 6.32c-.846 0-1.563.13-2.019.326-.326.39-.717.586-1.238.586-.325 0-.847-.13-1.563-.39-.717-.261-1.303-.457-1.89-.522-.065 0-.195-.065-.39-.065-.196 0-.391-.065-.522-.065-.13 0-.325-.065-.456-.13-.195-.066-.325-.13-.39-.196a.494.494 0 0 1-.13-.26c0-.13 0-.196.064-.326a.899.899 0 0 1 .196-.26c.065-.066.065-.131.13-.196s.065-.13.065-.196c0-.065.065-.13.065-.195v-.196c0-.065 0-.26-.065-.651-.065-.326-.065-.586-.065-.651 0-.326.065-.522.196-.717.13-.196.26-.26.456-.26h.781c.065 0 .13-.066.326-.131.065-.13.065-.195.13-.26.066-.066.066-.13.066-.196 0-.065 0-.065.065-.13a.14.14 0 0 1 .13-.13c-.065-.066-.065-.13-.065-.261v-.196c0-.26.13-.586.326-1.042l.26-.39.456-.913c.13-.26.26-.651.391-1.173.13-.456.39-.912.782-1.433l.52-.586c.327-.391.587-.717.718-.977.13-.26.195-.587.195-.847 0-.13-.065-.521-.13-1.173-.065-.651-.13-1.368-.13-1.954 0-.456.065-.782.13-1.108.065-.325.26-.651.456-.912.195-.26.456-.521.847-.651.39-.13.847-.196 1.433-.196.195 0 .39 0 .586.065.196 0 .456.066.782.196.26.13.521.26.717.456.13.13.39.456.586.782.13.39.26.781.326 1.368.065.325.065.651.13 1.107 0 .391.065.652.065.847.065.196.065.456.13.782.066.26.13.521.26.717.131.26.261.52.457.781.195.326.456.652.717 1.043.586.651 1.042 1.433 1.368 2.15.325.65.52 1.563.52 2.475 0 .456-.064.912-.195 1.368.13 0 .196.065.261.13.065.066.13.326.195.587l.066.52c.065.131.13.262.325.392.13.13.26.195.456.326.13.065.326.13.456.26s.196.26.196.391a.74.74 0 0 1-.196.521c-.13.13-.26.196-.456.26l-.781.392c-.326.195-.652.456-.978.716l-.651.586c-.26.261-.521.457-.717.587-.195.13-.456.195-.716.195l-.456-.065c-.521-.13-.847-.39-1.043-.847-1.172 0-2.02-.065-2.54-.065Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-linux", Lo);
const Ao = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], u6 = /* @__PURE__ */ t({
  __name: "VsgIconLinux",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-linux", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ao));
  }
});
class Eo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M17.487 5.32a.75.75 0 0 0-.997.363l-4.17 8.942a.75.75 0 0 0-.061.43l.467 3.059a.75.75 0 0 0 1.131.527l2.643-1.607a.749.749 0 0 0 .29-.324l4.17-8.942a.75.75 0 0 0-.363-.997l-3.11-1.45Zm-3.711 9.734 3.756-8.057 1.751.816-3.757 8.057-1.487.905-.263-1.721ZM10 6h4.963l-.933 2H10a1 1 0 1 1 0-2Zm0 5h2.632l-.933 2H10a1 1 0 1 1 0-2Zm0 5h1.139l.305 2H10a1 1 0 1 1 0-2ZM5 8.5h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm1 5H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm-1 5h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-list-edit", Eo);
const So = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], i6 = /* @__PURE__ */ t({
  __name: "VsgIconListEdit",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-list-edit", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, So));
  }
});
class Jo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 8.5h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1ZM10 6a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2h-9Zm0 5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-9Zm-1 6a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1Zm-3-3.5H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm-1 5h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-list-view", Jo);
const To = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], m6 = /* @__PURE__ */ t({
  __name: "VsgIconListView",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-list-view", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, To));
  }
});
class qo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.323 3.323a.749.749 0 0 0 .147.208l16 16a.748.748 0 0 0 .207.146.75.75 0 0 1-1.207.854l-2.93-2.93a46.869 46.869 0 0 1-2.9 3.805l-.055.065-.015.017-.004.004-.001.002L12 21l-.565.494-.001-.002-.004-.004-.015-.017-.055-.065a42.936 42.936 0 0 1-.932-1.136 45.87 45.87 0 0 1-2.202-3.016c-.8-1.2-1.612-2.56-2.225-3.918C5.393 11.989 4.95 10.58 4.95 9.3c0-.683.105-1.352.3-1.989l-2.78-2.78a.75.75 0 0 1 .853-1.208Zm3.41 1.35 1.063 1.063C8.816 4.539 10.326 3.75 12 3.75c3.049 0 5.55 2.615 5.55 5.55 0 .97-.345 2.149-.918 3.418-.186.412-.393.827-.615 1.24l1.105 1.104a22.22 22.22 0 0 0 .877-1.726c.608-1.347 1.051-2.755 1.051-4.036 0-3.743-3.152-7.05-7.05-7.05-2.096 0-3.976.957-5.267 2.423Zm7.223 7.222A3.247 3.247 0 0 0 15.25 9.3 3.253 3.253 0 0 0 12 6.05c-1.06 0-2.001.509-2.595 1.295l1.08 1.08A1.752 1.752 0 0 1 12 7.55a1.75 1.75 0 0 1 .875 3.265l1.08 1.08ZM12 21l-.564.494.564.645.564-.645L12 21ZM6.45 9.3c0-.248.018-.494.053-.737l7.957 7.958A44.97 44.97 0 0 1 12 19.832a45.404 45.404 0 0 1-2.526-3.41c-.774-1.162-1.538-2.447-2.106-3.704-.573-1.27-.918-2.449-.918-3.418Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-location-off", qo);
const Ro = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], d6 = /* @__PURE__ */ t({
  __name: "VsgIconLocationOff",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-location-off", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ro));
  }
});
class Do extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 2.25c-3.898 0-7.05 3.307-7.05 7.05 0 1.281.443 2.69 1.05 4.036.614 1.358 1.425 2.717 2.226 3.918a46.234 46.234 0 0 0 3.134 4.152l.055.065.015.017.004.004v.002h.001L12 21l-.565.494.565.645.564-.645L12 21l.565.494.001-.002.004-.004.015-.017.055-.065a42.61 42.61 0 0 0 .932-1.136c.6-.756 1.4-1.813 2.202-3.016.8-1.2 1.612-2.56 2.225-3.918.608-1.347 1.051-2.755 1.051-4.036 0-3.743-3.152-7.05-7.05-7.05Zm.396 17.09c-.145.183-.278.348-.396.492a44.762 44.762 0 0 1-2.526-3.41c-.775-1.162-1.538-2.447-2.106-3.704-.573-1.27-.918-2.449-.918-3.418 0-2.935 2.501-5.55 5.55-5.55s5.55 2.615 5.55 5.55c0 .97-.345 2.149-.918 3.418-.568 1.257-1.332 2.542-2.106 3.704a44.759 44.759 0 0 1-2.13 2.917ZM10.25 9.3c0-.964.786-1.75 1.75-1.75s1.75.786 1.75 1.75c0 .965-.786 1.75-1.75 1.75s-1.75-.785-1.75-1.75ZM12 6.05A3.253 3.253 0 0 0 8.75 9.3 3.253 3.253 0 0 0 12 12.55a3.253 3.253 0 0 0 3.25-3.25A3.253 3.253 0 0 0 12 6.05Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-location", Do);
const Fo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], g6 = /* @__PURE__ */ t({
  __name: "VsgIconLocation",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-location", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Fo));
  }
});
class Po extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 4.25c-1.912 0-3.25 1.68-3.25 3.25v2.25h6.5V7.5c0-1.568-1.35-3.25-3.25-3.25ZM7.25 7.5v2.25H5a.75.75 0 0 0-.75.75v10c0 .415.336.75.75.75h14a.75.75 0 0 0 .75-.75v-10a.75.75 0 0 0-.75-.75h-2.25V7.5c0-2.289-1.917-4.75-4.75-4.75-2.848 0-4.75 2.463-4.75 4.75Zm11 3.75H5.75v8.5h12.5v-8.5ZM13 16.233a2 2 0 1 0-2 0V18.5h2v-2.267Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-lock", Po);
const Wo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], h6 = /* @__PURE__ */ t({
  __name: "VsgIconLock",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-lock", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Wo));
  }
});
class Oo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9.334 4.75a.583.583 0 0 0-.584.584V7a.75.75 0 0 1-1.5 0V5.334c0-1.15.933-2.084 2.084-2.084h8.332c1.151 0 2.084.933 2.084 2.084v13.333c0 1.15-.933 2.083-2.084 2.083H9.334a2.083 2.083 0 0 1-2.084-2.083V17a.75.75 0 0 1 1.5 0v1.667c0 .322.261.583.584.583h8.332a.583.583 0 0 0 .584-.583V5.334a.583.583 0 0 0-.584-.584H9.334Zm1.136 2.72a.75.75 0 0 1 1.06 0l4 4 .53.53-.53.53-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H3a.75.75 0 0 1 0-1.5h10.19l-2.72-2.72a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-login", Oo);
const Uo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], p6 = /* @__PURE__ */ t({
  __name: "VsgIconLogin",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-login", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Uo));
  }
});
class No extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.334 4.75a.583.583 0 0 0-.584.584V7a.75.75 0 0 1-1.5 0V5.334c0-1.15.933-2.084 2.084-2.084h6.332c1.151 0 2.084.933 2.084 2.084v13.333c0 1.15-.933 2.083-2.084 2.083h-6.332a2.083 2.083 0 0 1-2.084-2.083V17a.75.75 0 0 1 1.5 0v1.667c0 .322.261.583.584.583h6.332a.583.583 0 0 0 .584-.583V5.334a.583.583 0 0 0-.584-.584h-6.332ZM8.53 7.47a.75.75 0 0 1 0 1.06l-2.72 2.72H16a.75.75 0 0 1 0 1.5H5.81l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4-.53-.53.53-.53 4-4a.75.75 0 0 1 1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-logout", No);
const Ko = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], v6 = /* @__PURE__ */ t({
  __name: "VsgIconLogout",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-logout", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ko));
  }
});
class Go extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3 5.25a.75.75 0 0 0-.75.75v12c0 .415.336.75.75.75h18a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H3Zm17.25 2.31v-.81H3.75v.809L12 12.142l8.25-4.583ZM3.75 9.275v7.975h16.5V9.275l-7.886 4.38a.75.75 0 0 1-.728 0L3.75 9.276Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-mail", Go);
const Yo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], x6 = /* @__PURE__ */ t({
  __name: "VsgIconMail",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-mail", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Yo));
  }
});
class Qo extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 2.25a.75.75 0 0 1 .75.75v1.286a7.752 7.752 0 0 1 6.964 6.964H21a.75.75 0 0 1 0 1.5h-1.286a7.752 7.752 0 0 1-6.964 6.965V21a.75.75 0 0 1-1.5 0v-1.285a7.752 7.752 0 0 1-6.964-6.965H3a.75.75 0 0 1 0-1.5h1.286a7.752 7.752 0 0 1 6.964-6.964V3a.75.75 0 0 1 .75-.75Zm.75 15.956V18a.75.75 0 0 0-1.5 0v.206a6.253 6.253 0 0 1-5.455-5.456H6a.75.75 0 0 0 0-1.5h-.205a6.253 6.253 0 0 1 5.455-5.455V6a.75.75 0 0 0 1.5 0v-.205a6.253 6.253 0 0 1 5.456 5.455H18a.75.75 0 0 0 0 1.5h.206a6.253 6.253 0 0 1-5.456 5.456ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-marketing", Qo);
const Xo = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], y6 = /* @__PURE__ */ t({
  __name: "VsgIconMarketing",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-marketing", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Xo));
  }
});
class lt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.049 4.815h-.75.75v4.023c.434.06.89.098 1.357.098 1.162 0 2.419-.234 3.405-.478a21.015 21.015 0 0 0 1.612-.47l.02-.006.005-.002a.75.75 0 0 1 1.003.706h-.75.75v6.251c0 1.66-.9 2.93-2.072 3.757-1.16.818-2.637 1.243-3.973 1.243-2.433 0-4.923-1.689-5.38-4.177a7.07 7.07 0 0 1-2.023.305c-2.692 0-5.454-2.068-5.454-5V4.816h.75-.75a.75.75 0 0 1 1.06-.684l.001.001.015.007.064.027a12.52 12.52 0 0 0 1.233.428c.823.238 1.925.47 3.081.47 1.163 0 2.42-.234 3.405-.478a21.049 21.049 0 0 0 1.613-.469l.02-.007.005-.002a.75.75 0 0 1 1.003.707Zm0 5.732v-.197c.434.054.89.086 1.357.086 1.337 0 2.728-.265 3.765-.522.287-.07.55-.142.78-.207v5.229c0 1.056-.556 1.91-1.436 2.53-.891.629-2.062.97-3.11.97-1.996 0-3.813-1.476-3.946-3.287.178-.101.351-.21.518-.328.728-.513 1.35-1.197 1.718-2.04a.75.75 0 1 0 .333-1.283c.014-.14.02-.286.02-.433v-.518Zm-10-4.652v5.17c0 1.907 1.88 3.5 3.954 3.5 1.048 0 2.219-.342 3.11-.97.88-.62 1.436-1.474 1.436-2.53v-5.23c-.23.066-.493.137-.78.208-1.037.256-2.428.522-3.766.522-1.344 0-2.594-.268-3.498-.53a14.609 14.609 0 0 1-.456-.14ZM14.462 16.63a.75.75 0 0 0 .75-.75c0-.076.058-.263.268-.455.197-.18.46-.295.732-.295.272 0 .535.115.732.295.21.192.268.38.268.455a.75.75 0 0 0 1.5 0c0-.615-.334-1.177-.758-1.563a2.602 2.602 0 0 0-1.742-.687c-.694 0-1.307.29-1.743.687-.423.386-.757.948-.757 1.563 0 .414.336.75.75.75Zm3.978-4.728a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-11.786-.78a.75.75 0 0 0-1.5 0c0 .614.334 1.177.757 1.563a2.602 2.602 0 0 0 1.743.686c.694 0 1.306-.289 1.743-.687.423-.385.757-.948.757-1.563a.75.75 0 0 0-1.5 0c0 .076-.058.263-.268.455-.197.18-.46.295-.732.295a1.1 1.1 0 0 1-.732-.295c-.21-.192-.268-.379-.268-.455Zm.069-2.339a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.98 1.142a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-masks", lt);
const et = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], _6 = /* @__PURE__ */ t({
  __name: "VsgIconMasks",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-masks", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, et));
  }
});
class at extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.366-9.75 9.75A9.75 9.75 0 0 0 12 21.75V21v.75h.043c.024 0 .06 0 .105-.002a13.802 13.802 0 0 0 1.583-.13c.463-.066.98-.168 1.46-.328.466-.156.97-.39 1.34-.76a.75.75 0 1 0-1.061-1.06c-.13.13-.377.271-.754.397a7.03 7.03 0 0 1-1.197.266 12.29 12.29 0 0 1-1.493.117H12A8.25 8.25 0 1 1 20.25 12c0 1.093-.325 1.852-.757 2.356a2.709 2.709 0 0 1-1.616.905c-.601.1-1.163-.009-1.548-.244-.363-.222-.579-.554-.579-1.017V8a.75.75 0 0 0-1.5 0v.375c-.729-.696-1.679-1.125-2.75-1.125-2.438 0-4.25 2.224-4.25 4.75s1.812 4.75 4.25 4.75c1.235 0 2.31-.57 3.07-1.463.23.421.57.762.976 1.01.74.452 1.678.593 2.577.443a4.208 4.208 0 0 0 2.509-1.408c.693-.808 1.118-1.925 1.118-3.332 0-5.384-4.365-9.75-9.75-9.75ZM14.25 12c0-1.892-1.322-3.25-2.75-3.25S8.75 10.108 8.75 12s1.322 3.25 2.75 3.25 2.75-1.358 2.75-3.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-mention", at);
const st = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], w6 = /* @__PURE__ */ t({
  __name: "VsgIconMention",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-mention", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, st));
  }
});
class rt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-menu", rt);
const nt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], f6 = /* @__PURE__ */ t({
  __name: "VsgIconMenu",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-menu", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, nt));
  }
});
class ot extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.336 11.01a.75.75 0 0 0 1.046.176l.041-.03c.588-.418 1.31-.933 1.867-1.714.588-.825.96-1.894.96-3.382V5.001a.75.75 0 0 0-1.5 0V6.06c0 1.216-.297 1.971-.681 2.511-.403.565-.936.95-1.558 1.394a.75.75 0 0 0-.175 1.046Zm-.586 5.68 1.22-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.22 1.22v-3.13c0-.684-.21-1.106-.516-1.456-.287-.325-.646-.582-1.102-.908l-.323-.232c-.579-.42-1.238-.943-1.738-1.729-.51-.799-.821-1.813-.821-3.175v-.919a.75.75 0 1 1 1.5 0v.919c0 1.119.251 1.844.586 2.37.343.537.809.924 1.355 1.32.084.062.173.125.264.19.462.328.993.706 1.405 1.174.537.61.89 1.38.89 2.446v3.13Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-merge", ot);
const tt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], b6 = /* @__PURE__ */ t({
  __name: "VsgIconMerge",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-merge", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, tt));
  }
});
class ct extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 3.25A1.75 1.75 0 0 0 2.25 5v16.56l1.219-.974 4.794-3.836H20A1.75 1.75 0 0 0 21.75 15V5A1.75 1.75 0 0 0 20 3.25H4ZM3.75 5A.25.25 0 0 1 4 4.75h16a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25H7.737l-.206.165L3.75 18.44V5ZM8 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-message", ct);
const ut = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], z6 = /* @__PURE__ */ t({
  __name: "VsgIconMessage",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-message", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, ut));
  }
});
class it extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m20.678 20.678.707-.707-3.952-3.952c.802-1.182 1.317-2.813 1.317-5.019v-1a.75.75 0 0 0-1.5 0v1c0 1.777-.37 3.036-.903 3.932l-.9-.9c.351-.595.553-1.29.553-2.032V6a4 4 0 0 0-8 0v.586L4.414 3l-.707.707 16.97 16.97ZM14.5 6v6c0 .322-.061.63-.172.914L9.5 8.086V6a2.5 2.5 0 0 1 5 0Z"/>   <path d="M9.5 10.914 8 9.414V12a4 4 0 0 0 6.032 3.446l-1.118-1.118A2.5 2.5 0 0 1 9.5 12v-1.086Z"/>   <path d="M14.975 16.389c-1.008.674-2.161.861-2.975.861-.898 0-2.21-.228-3.281-1.086C7.679 15.333 6.75 13.817 6.75 11v-1a.75.75 0 0 0-1.5 0v1c0 3.183 1.071 5.167 2.532 6.336 1.133.906 2.43 1.265 3.468 1.374v1.79h-2.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-2.5v-1.79c.987-.104 2.209-.433 3.3-1.245l-1.075-1.076Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-mic-off", it);
const mt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], $6 = /* @__PURE__ */ t({
  __name: "VsgIconMicOff",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-mic-off", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, mt));
  }
});
class dt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8 6a4 4 0 1 1 8 0v6a4 4 0 0 1-8 0V6Zm6.5 0v6a2.5 2.5 0 0 1-5 0V6a2.5 2.5 0 0 1 5 0Z"/>   <path d="M6.75 10a.75.75 0 0 0-1.5 0v1c0 3.183 1.071 5.167 2.532 6.336 1.133.906 2.43 1.265 3.468 1.374v1.79h-2.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-2.5v-1.79c1.038-.11 2.335-.468 3.468-1.374 1.46-1.169 2.532-3.153 2.532-6.336v-1a.75.75 0 0 0-1.5 0v1c0 2.817-.929 4.333-1.969 5.164-1.072.858-2.383 1.086-3.281 1.086-.898 0-2.21-.228-3.281-1.086C7.679 15.333 6.75 13.817 6.75 11v-1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-mic", dt);
const gt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Z6 = /* @__PURE__ */ t({
  __name: "VsgIconMic",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-mic", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, gt));
  }
});
class ht extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-minus", ht);
const pt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], V6 = /* @__PURE__ */ t({
  __name: "VsgIconMinus",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-minus", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, pt));
  }
});
class vt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.75 4.5A.25.25 0 0 1 8 4.25h8a.25.25 0 0 1 .25.25v12.293a.75.75 0 0 0-.25-.043H8a.75.75 0 0 0-.25.043V4.5Zm0 13.708V19.5c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-1.292a.75.75 0 0 1-.25.042H8a.75.75 0 0 1-.25-.042ZM8 2.75A1.75 1.75 0 0 0 6.25 4.5v15c0 .967.784 1.75 1.75 1.75h8a1.75 1.75 0 0 0 1.75-1.75v-15A1.75 1.75 0 0 0 16 2.75H8Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-mobile", vt);
const xt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], B6 = /* @__PURE__ */ t({
  __name: "VsgIconMobile",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-mobile", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, xt));
  }
});
class yt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.409 4.429a2.481 2.481 0 0 1-1.09.49c-.38.075-.75.09-1.093.069L10.901 6h2.18l1.404-2.282A2.308 2.308 0 0 0 13.5 3.5c-.189 0-.256.04-.286.06-.054.036-.108.093-.241.264l-.023.029c-.116.15-.292.377-.541.576Zm-4.533-.263L9.158 6.09a2 2 0 0 0-.713 3.427C6.407 11.706 5 14.096 5 17.5c0 .992.211 1.802.584 2.45a3.74 3.74 0 0 0 1.421 1.403c1.05.595 2.212.647 2.745.647h4.5c.643 0 1.82-.045 2.848-.648C18.199 20.707 19 19.506 19 17.5c0-1.859-.295-3.344-1-4.743-.563-1.118-1.372-2.147-2.434-3.25a2 2 0 0 0-.77-3.431l1.343-2.183a.75.75 0 0 0-.105-.92L15.5 3.5c.534-.527.533-.527.533-.528l-.001-.001-.003-.002-.005-.005-.014-.014a2.731 2.731 0 0 0-.181-.156A3.806 3.806 0 0 0 13.5 2c-.44 0-.806.105-1.116.31a2.546 2.546 0 0 0-.584.58l-.01.012c-.135.175-.213.272-.316.354a.99.99 0 0 1-.448.191c-.53.106-1.069.026-1.499-.098a4.157 4.157 0 0 1-.664-.256l-.004-.002a.75.75 0 0 0-.982 1.075ZM9.75 7.5h4.5a.5.5 0 0 1 0 1h-4.5a.5.5 0 0 1 0-1Zm4.194 2.5H10.06c-2.192 2.212-3.56 4.357-3.56 7.5 0 .776.164 1.319.385 1.704.22.384.522.652.86.844.7.397 1.538.452 2.005.452h4.501c.606 0 1.43-.056 2.089-.442.586-.344 1.16-1.017 1.16-2.558 0-1.686-.264-2.927-.84-4.068-.552-1.097-1.415-2.149-2.716-3.432ZM12.5 12v-.5h-1v1.054a1.89 1.89 0 0 0-.56.215c-.387.229-.69.633-.69 1.231 0 .662.537 1.393 1.6 1.727.794.25.9.622.9.773a.49.49 0 0 1-.057.258.356.356 0 0 1-.135.126c-.143.081-.354.116-.558.116-.18 0-.396-.04-.547-.129-.122-.072-.203-.168-.203-.37V16h-1v.5c0 .601.31 1.005.696 1.232.178.105.37.172.554.213v.804h1v-.796c.182-.037.374-.099.554-.201.4-.229.696-.64.696-1.252 0-.737-.552-1.397-1.6-1.726-.778-.245-.9-.672-.9-.774 0-.205.081-.3.2-.37.148-.089.361-.13.55-.13.135 0 .35.059.525.177.172.116.225.23.225.323v.5h1V14c0-.541-.331-.926-.664-1.151a2.095 2.095 0 0 0-.586-.273V12Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-moneybag", yt);
const _t = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], I6 = /* @__PURE__ */ t({
  __name: "VsgIconMoneybag",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-moneybag", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _t));
  }
});
class wt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m12 2.14.368.207 8 4.5.382.215V7.5c0 6.425-2.064 10.016-4.246 11.994a9.607 9.607 0 0 1-2.984 1.855c-.41.158-.756.255-1.004.314a5.345 5.345 0 0 1-.382.076l-.026.004h-.009l-.003.001h-.002L12 21c-.093.745-.094.744-.094.744H11.9l-.009-.001-.026-.004a5.345 5.345 0 0 1-.382-.076 7.826 7.826 0 0 1-1.004-.314 9.608 9.608 0 0 1-2.984-1.855C5.314 17.516 3.25 13.925 3.25 7.5v-.438l.382-.215 8-4.5L12 2.14ZM12 21l.093.745-.093.011-.093-.011L12 21Zm0-.76a6.332 6.332 0 0 0 .98-.291 8.108 8.108 0 0 0 2.516-1.567c1.774-1.607 3.66-4.654 3.75-10.445L12 3.861 4.753 7.937c.09 5.79 1.977 8.838 3.75 10.445a8.107 8.107 0 0 0 2.517 1.567 6.332 6.332 0 0 0 .98.291Zm-.096.017ZM12 18.7V12H6.72C7.89 17.17 11 18.43 12 18.7Zm5.28-6.7H12V5.58l5.71 3.22a18.64 18.64 0 0 1-.43 3.2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-monitor", wt);
const ft = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], j6 = /* @__PURE__ */ t({
  __name: "VsgIconMonitor",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-monitor", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, ft));
  }
});
class bt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.506 2.936a.75.75 0 0 1 .988 0l3.256 2.849V4.5h2v3h-.04l2.784 2.436a.75.75 0 1 1-.988 1.129l-.756-.662v7.347H20a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h1.25v-7.347l-.756.662a.75.75 0 1 1-.988-1.13l8-7ZM17.25 9.09v8.66H6.75V9.09L12 4.497l5.25 4.594Zm-4.75-.34v-.5h-1v.754a1.954 1.954 0 0 0-.765.348 1.59 1.59 0 0 0-.635 1.297c0 .663.226 1.137.605 1.474.332.295.757.457 1.083.58l.034.014c.37.14.627.245.808.406.146.13.27.322.27.726a.591.591 0 0 1-.24.503c-.16.121-.398.197-.66.197s-.5-.076-.66-.197a.591.591 0 0 1-.24-.502v-.5h-1v.5c0 .564.255 1.008.635 1.297.227.173.492.287.765.348v.754h1v-.754c.273-.061.538-.175.765-.348a1.59 1.59 0 0 0 .635-1.297c0-.663-.226-1.137-.605-1.474-.332-.295-.757-.457-1.083-.581l-.034-.013c-.37-.14-.627-.245-.808-.406-.146-.13-.27-.322-.27-.727 0-.235.095-.391.24-.502.16-.121.398-.198.66-.198s.5.077.66.198c.145.111.24.267.24.502v.5h1v-.5a1.59 1.59 0 0 0-.635-1.297 1.967 1.967 0 0 0-.765-.348V8.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-mortgage", bt);
const zt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], M6 = /* @__PURE__ */ t({
  __name: "VsgIconMortgage",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-mortgage", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, zt));
  }
});
class $t extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m12 1.94.53.53 3 3a.75.75 0 0 1-1.06 1.06l-1.72-1.719v6.44h6.44l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3 .53.53-.53.53-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-6.44v6.439l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3-.53.531-.53-.53-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.719v-6.44H4.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3-.53-.53.53-.53 3-3a.75.75 0 0 1 1.06 1.06l-1.72 1.72h6.44V4.811l-1.72 1.72a.75.75 0 0 1-1.06-1.06l3-3L12 1.94Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-move", $t);
const Zt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], H6 = /* @__PURE__ */ t({
  __name: "VsgIconMove",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-move", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Zt));
  }
});
class Vt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.544 6.855 3.97 4.28a.75.75 0 0 1 1.06-1.06l15.247 15.247a.75.75 0 0 0 .18.032.734.734 0 0 1-.044.103l.617.618a.75.75 0 0 1-1.06 1.06L18.69 19H4.25a.75.75 0 0 1-.53-1.28l1.78-1.78v-5.69a6.17 6.17 0 0 1 1.044-3.395ZM17.189 17.5H6.061l.72-.72.219-.219V10.25c0-.796.22-1.597.632-2.307l9.557 9.557ZM17 13.184v.006l1.5 1.5v-4.44c0-2.722-1.925-5.42-5-6.09V3.5a1.5 1.5 0 0 0-3 0v.66a6.428 6.428 0 0 0-1.829.7l1.113 1.114c.646-.3 1.39-.474 2.216-.474 3.064 0 5 2.393 5 4.75v2.934ZM12 22a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-notifications-off", Vt);
const Bt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], k6 = /* @__PURE__ */ t({
  __name: "VsgIconNotificationsOff",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-notifications-off", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Bt));
  }
});
class It extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 2a1.5 1.5 0 0 0-1.5 1.5v.66c-3.075.67-5 3.368-5 6.09v5.69l-1.78 1.78A.75.75 0 0 0 4.25 19h15.5a.75.75 0 0 0 .53-1.28l-1.78-1.78v-5.69c0-2.722-1.925-5.42-5-6.09V3.5A1.5 1.5 0 0 0 12 2Zm-5 8.25C7 7.893 8.936 5.5 12 5.5s5 2.393 5 4.75v6.311l.22.22.72.72H6.06l.72-.72.22-.22V10.25ZM12 22a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-notifications", It);
const jt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], C6 = /* @__PURE__ */ t({
  __name: "VsgIconNotifications",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-notifications", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, jt));
  }
});
class Mt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.763 7.414a.75.75 0 0 1 .837.261l4.65 6.2v-6.5h1.5v8.75a.75.75 0 0 1-1.35.45l-4.65-6.2v6.5h-1.5v-8.75a.75.75 0 0 1 .513-.711ZM16.25 8.875v8h1.5v-8h3v-1.5h-7.5v1.5h3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-nt", Mt);
const Ht = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], L6 = /* @__PURE__ */ t({
  __name: "VsgIconNt",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-nt", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ht));
  }
});
class kt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-paginate", kt);
const Ct = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], A6 = /* @__PURE__ */ t({
  __name: "VsgIconPaginate",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-paginate", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ct));
  }
});
class Lt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM16 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-password", Lt);
const At = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], E6 = /* @__PURE__ */ t({
  __name: "VsgIconPassword",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-password", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, At));
  }
});
class Et extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M10.25 2c-.74 0-1.387.402-1.732 1H7.25a.75.75 0 0 0-.707.5H5.75A1.75 1.75 0 0 0 4 5.25v11c0 .966.784 1.75 1.75 1.75H9v3.25c0 .414.336.75.75.75h10a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75H16.5V5.25a1.75 1.75 0 0 0-1.75-1.75h-.793a.75.75 0 0 0-.707-.5h-1.268c-.345-.598-.991-1-1.732-1ZM15 8.5V5.25a.25.25 0 0 0-.25-.25H14v1.75a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75V5h-.75a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25H9V9.25a.75.75 0 0 1 .75-.75H15ZM9.76 3.9a.5.5 0 0 1 .98 0c.07.349.378.6.735.6H12.5V6H8V4.5h1.025a.75.75 0 0 0 .735-.6Zm.74 16.6V10H19v10.5h-8.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-paste", Et);
const St = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], S6 = /* @__PURE__ */ t({
  __name: "VsgIconPaste",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-paste", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, St));
  }
});
class Jt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.5 3.25a.75.75 0 0 0-.75.75v13c0 .415.336.75.75.75h2.25V20c0 .415.336.75.75.75h14a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-2.25V4a.75.75 0 0 0-.75-.75h-14ZM5.75 7v9.25h-1.5V4.75h12.5v1.5H6.5a.75.75 0 0 0-.75.75Zm1.5.75v11.5h.5v-.657c0-.605.216-1.097.575-1.474.338-.354.77-.574 1.162-.727.35-.137.727-.242 1.05-.332l.115-.032c.334-.093.588-.17.778-.255a.58.58 0 0 0 .112-.138 4.14 4.14 0 0 1-1.011-2.54l-.001-.017v-.047c0-.286-.002-1.096.329-1.856a2.68 2.68 0 0 1 .915-1.147c.457-.32 1.033-.495 1.726-.495.693 0 1.27.175 1.728.493.454.315.743.734.925 1.142.348.776.347 1.602.347 1.88v.038l-.001.023a4.13 4.13 0 0 1-1.085 2.545.25.25 0 0 0 .082.063l.012.006c.205.103.484.191.857.298l.122.035c.322.091.695.198 1.04.334.39.155.82.376 1.155.732.356.377.568.869.568 1.47v.659h.5V7.75H7.25Zm10.5 11.5v-.657c0-.218-.065-.342-.16-.443-.116-.123-.311-.245-.615-.365a9.713 9.713 0 0 0-.898-.286l-.125-.036c-.354-.101-.765-.223-1.114-.398a1.75 1.75 0 0 1-.974-1.747l.03-.293.22-.195A2.63 2.63 0 0 0 15 13.039c0-.276-.013-.805-.216-1.259a1.217 1.217 0 0 0-.41-.521c-.174-.12-.442-.226-.874-.226s-.696.105-.866.224a1.185 1.185 0 0 0-.4.516c-.2.458-.204.99-.204 1.273a2.64 2.64 0 0 0 .848 1.815l.26.24-.02.352a2.08 2.08 0 0 1-.844 1.564l-.051.038-.058.029c-.344.172-.757.29-1.109.389l-.114.032a9.68 9.68 0 0 0-.91.284c-.305.12-.503.24-.62.364-.097.102-.162.225-.162.44v.657h8.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-payees", Jt);
const Tt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], J6 = /* @__PURE__ */ t({
  __name: "VsgIconPayees",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-payees", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Tt));
  }
});
class qt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.368 2.347 12 2.14l-.368.207-8 4.5-.382.215V7.5c0 6.424 2.064 10.015 4.246 11.993a9.607 9.607 0 0 0 2.984 1.855c.41.158.756.255 1.004.314a5.458 5.458 0 0 0 .382.076l.026.004.009.001h.005L12 21l-.093.745.093.011.093-.011L12 21l.094.745h.002l.003-.001.009-.001.026-.004a4.15 4.15 0 0 0 .382-.076 7.826 7.826 0 0 0 1.004-.314 9.607 9.607 0 0 0 2.984-1.855c2.182-1.978 4.246-5.569 4.246-11.993v-.44l-.382-.214-8-4.5Zm-.197 17.856c-.07.017-.127.029-.171.037a6.315 6.315 0 0 1-.98-.291 8.107 8.107 0 0 1-2.516-1.567c-1.774-1.607-3.66-4.654-3.75-10.445L12 3.861l7.247 4.076c-.09 5.79-1.977 8.838-3.75 10.445a8.108 8.108 0 0 1-2.517 1.567c-.34.131-.62.21-.809.254Zm-.267.054ZM12.75 7v-.75h-1.5v1.085c-.385.09-.758.251-1.08.496a2.31 2.31 0 0 0-.92 1.883c0 .956.327 1.643.877 2.132.479.426 1.091.659 1.556.835l.05.02c.53.201.89.348 1.144.573.2.178.373.443.373 1.011a.81.81 0 0 1-.33.69c-.22.167-.552.274-.92.274s-.7-.107-.92-.275a.81.81 0 0 1-.33-.689v-.75h-1.5v.75c0 .82.37 1.463.92 1.883.322.245.695.407 1.08.496v1.085h1.5v-1.085c.385-.09.758-.251 1.08-.496.55-.42.92-1.064.92-1.883 0-.955-.327-1.643-.877-2.132-.479-.426-1.091-.659-1.556-.835l-.05-.02c-.53-.201-.89-.348-1.144-.573-.2-.178-.373-.443-.373-1.011a.81.81 0 0 1 .33-.69c.22-.167.551-.274.92-.274.368 0 .7.107.92.275.2.152.33.365.33.689v.75h1.5v-.75c0-.819-.37-1.463-.92-1.882a2.837 2.837 0 0 0-1.08-.497V7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-payroll-protection", qt);
const Rt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], T6 = /* @__PURE__ */ t({
  __name: "VsgIconPayrollProtection",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-payroll-protection", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Rt));
  }
});
class Dt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8.442 6.11c-.736 0-1.343.187-1.826.522a2.86 2.86 0 0 0-.976 1.21c-.367.826-.367 1.713-.367 2.026v.016c0 .412.105.964.324 1.512.17.427.423.885.785 1.286a.415.415 0 0 1-.094.16l-.001.002c-.23.114-.539.21-.941.324l-.128.037c-.352.1-.758.214-1.133.362-.422.167-.88.404-1.234.78-.376.4-.601.92-.601 1.558v1.235a.75.75 0 0 0 1.5 0v-1.235c0-.255.078-.407.193-.529.136-.145.36-.281.693-.414.3-.118.63-.212.993-.315l.127-.036c.388-.11.833-.24 1.207-.428.43-.215.661-.597.783-.876.127-.29.185-.577.21-.747l.063-.415-.321-.271c-.315-.265-.55-.639-.708-1.034-.16-.399-.217-.763-.217-.956 0-.306.007-.914.238-1.434.11-.246.259-.446.46-.586.198-.137.497-.253.97-.253.475 0 .774.116.971.253.202.14.351.34.46.586.231.52.238 1.128.238 1.434 0 .193-.057.56-.218.963-.16.398-.398.773-.715 1.035l-.287.237.015.372c.01.252.049.574.202.89.163.335.432.611.813.802.375.188.82.318 1.208.428l.127.036c.363.103.693.197.992.315.335.133.558.27.694.414.115.122.193.274.193.53v1.234a.75.75 0 0 0 1.5 0v-1.235c0-.639-.225-1.158-.6-1.557a2.406 2.406 0 0 0-.098-.098 3.46 3.46 0 0 0 .143-.067c.43-.215.661-.597.784-.876.127-.29.184-.576.21-.745l.064-.417-.323-.271c-.315-.265-.55-.639-.708-1.034-.16-.399-.216-.763-.216-.956 0-.306.007-.914.237-1.434.11-.246.259-.446.46-.586.198-.137.497-.253.971-.253s.773.116.97.253c.203.14.352.34.461.586.231.52.238 1.128.238 1.434 0 .193-.057.56-.219.963-.16.398-.398.773-.715 1.035l-.287.237.016.372c.01.252.048.574.201.89.164.335.432.611.813.802.375.188.82.318 1.208.428l.127.036c.364.103.693.197.993.315.334.133.557.27.693.414.115.122.193.274.193.53v1.234a.75.75 0 0 0 1.5 0v-1.235c0-.639-.224-1.158-.6-1.557-.356-.377-.813-.614-1.234-.78a11.91 11.91 0 0 0-1.134-.364l-.128-.036c-.406-.115-.717-.212-.947-.327-.09-.045-.118-.084-.132-.11a4.26 4.26 0 0 0 .825-1.326c.222-.552.327-1.109.327-1.52v-.017c0-.313 0-1.2-.367-2.027a2.86 2.86 0 0 0-.976-1.209c-.483-.335-1.09-.521-1.826-.521-.735 0-1.343.186-1.826.521a2.86 2.86 0 0 0-.975 1.21c-.368.826-.367 1.713-.367 2.026v.016c0 .412.104.964.323 1.513a4.3 4.3 0 0 0 .785 1.285l-.01.023a.415.415 0 0 1-.084.138v.001c-.265.131-.599.226-1.024.347-.12.034-.246.07-.38.11a37.276 37.276 0 0 0-.334-.097l-.128-.036c-.406-.115-.717-.212-.947-.327-.09-.045-.118-.084-.132-.11a4.28 4.28 0 0 0 .825-1.326c.221-.552.326-1.109.326-1.52v-.017c0-.313 0-1.2-.367-2.027a2.86 2.86 0 0 0-.975-1.209c-.483-.335-1.09-.521-1.826-.521Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-people", Dt);
const Ft = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], q6 = /* @__PURE__ */ t({
  __name: "VsgIconPeople",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-people", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ft));
  }
});
class Pt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5.312 2.47a.75.75 0 0 1 1.06 0l4.737 4.737a.75.75 0 0 1 0 1.06L8.937 10.44a.198.198 0 0 0 0 .28l4.345 4.344a.198.198 0 0 0 .279 0l2.172-2.173a.75.75 0 0 1 1.06 0l4.737 4.737a.75.75 0 0 1 0 1.06l-2.842 2.843a.75.75 0 0 1-.53.22c-3.6 0-7.57-2.285-10.596-5.312C4.535 13.412 2.25 9.442 2.25 5.843a.75.75 0 0 1 .22-.53L5.312 2.47ZM3.757 6.147c.125 2.967 2.067 6.433 4.866 9.231 2.798 2.798 6.264 4.74 9.23 4.866l2.086-2.085-3.676-3.677-1.642 1.642a1.698 1.698 0 0 1-2.4 0L7.877 11.78a1.698 1.698 0 0 1 0-2.4l1.641-1.642L5.842 4.06 3.757 6.147Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-phone", Pt);
const Wt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], R6 = /* @__PURE__ */ t({
  __name: "VsgIconPhone",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-phone", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Wt));
  }
});
class Ot extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.875 2.25a.75.75 0 0 0-.75.75v7a.75.75 0 0 0 .75.75h7a.75.75 0 0 0 .75-.75 7.75 7.75 0 0 0-7.75-7.75Zm.75 7V3.797A6.25 6.25 0 0 1 20.08 9.25h-5.455ZM7.097 6.973a7.25 7.25 0 0 1 3.278-1.183v7.212a.75.75 0 0 0 .75.75h7.211a7.25 7.25 0 1 1-11.239-6.78Zm4.028-2.721a8.75 8.75 0 1 0 8.75 8.75.75.75 0 0 0-.75-.75h-7.25V5a.75.75 0 0 0-.75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-pie-chart", Ot);
const Ut = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], D6 = /* @__PURE__ */ t({
  __name: "VsgIconPieChart",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-pie-chart", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Ut));
  }
});
class Nt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13 3.469a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2.5 1a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM7.245 7.032c-.497-.277-.776-.228-.888-.163-.113.065-.295.284-.302.859-.007.549.16 1.27.538 2.027a.75.75 0 0 1-.099.82c-.304.36-.561.76-.761 1.192a.75.75 0 0 1-.444.396L3.5 12.76v1.665l1.469.49a.75.75 0 0 1 .484.504c.2.701.544 1.343.998 1.892a.75.75 0 0 1-.048 1.008l-.842.842 1.06 1.06 1.185-1.184a.75.75 0 0 1 .8-.17 5.237 5.237 0 0 0 1.894.352H14a5.23 5.23 0 0 0 2.08-.428.75.75 0 0 1 .827.159l1.272 1.271.88-.88-.989-.99a.75.75 0 0 1-.044-1.012A5.25 5.25 0 0 0 14 8.719h-3.5a5.28 5.28 0 0 0-1.008.097.75.75 0 0 1-.767-.32c-.466-.699-1.004-1.198-1.48-1.464Zm2.445.235c-.51-.666-1.103-1.204-1.715-1.545-.706-.394-1.595-.599-2.368-.153-.777.45-1.042 1.327-1.052 2.14-.009.707.166 1.497.495 2.277a6.75 6.75 0 0 0-.532.853l-2.005.668A.75.75 0 0 0 2 12.22v2.746c0 .323.207.61.513.712l1.62.54c.189.534.443 1.036.752 1.499l-.915.915a.75.75 0 0 0 0 1.06l2.121 2.122a.75.75 0 0 0 1.06 0l1.385-1.384a6.75 6.75 0 0 0 1.964.29H14a6.74 6.74 0 0 0 2.191-.364l1.457 1.457a.75.75 0 0 0 1.061 0l1.942-1.941a.75.75 0 0 0 0-1.061l-1.06-1.06a6.719 6.719 0 0 0 1.154-3.531h.505a.75.75 0 0 0 0-1.5h-.616A6.752 6.752 0 0 0 14 7.219h-3.5c-.274 0-.544.016-.81.048Zm.81 3.452a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Zm-2.5 2.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-piggy-bank", Nt);
const Kt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], F6 = /* @__PURE__ */ t({
  __name: "VsgIconPiggyBank",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-piggy-bank", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Kt));
  }
});
class Gt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M10.53 2.392a1.5 1.5 0 0 0-2.226.23 2.24 2.24 0 0 0-.107 2.461l-5.86 15.624a.75.75 0 0 0 1.004.95l15.615-6.831c.71.409 1.6.415 2.327-.014a1.5 1.5 0 0 0 .247-2.4l-11-10.02Zm7.15 11.355L9.357 6.26l-.651 1.737a2 2 0 1 1-1.214 3.238l-3.127 8.336 2.408-1.053a2 2 0 1 1 3.263-1.427l7.644-3.345ZM9.625 4.484A.74.74 0 0 1 9.52 3.5l.544.495L19.949 13l.57.52a.81.81 0 0 1-.953-.095L9.625 4.484Zm3.415 6.487a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-pizza", Gt);
const Yt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], P6 = /* @__PURE__ */ t({
  __name: "VsgIconPizza",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-pizza", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Yt));
  }
});
class Qt extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M20.25 12a8.25 8.25 0 1 0-13.797 6.107c.29.264.866.785 1.878 1.176.798.308 1.555.25 2.08-.023.501-.261.839-.736.839-1.438v-1.384c-1.937-.324-3.594-1.893-3.503-4.133V9.75a.75.75 0 0 1 .75-.75H9.75V6.75a.75.75 0 0 1 1.5 0V9h1.5V6.75a.75.75 0 0 1 1.5 0V9h1.247a.75.75 0 0 1 .75.75v2.555c.088 2.17-1.543 3.794-3.497 4.13v1.387c0 1.276-.662 2.256-1.646 2.768-.96.5-2.172.533-3.314.092a7.189 7.189 0 0 1-2.346-1.465 9.786 9.786 0 0 1-1.938-2.426 9.709 9.709 0 0 1-1.256-4.79c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75c0 4.567-3.14 8.4-7.378 9.459a.75.75 0 1 1-.364-1.455A8.254 8.254 0 0 0 20.25 12Zm-11.003.32V10.5h5.5v1.854c.066 1.462-1.187 2.647-2.75 2.647-1.559 0-2.819-1.13-2.751-2.647v-.034Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-plug", Qt);
const Xt = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], W6 = /* @__PURE__ */ t({
  __name: "VsgIconPlug",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-plug", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Xt));
  }
});
class l2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.75 5a.75.75 0 0 0-1.5 0v6.25H5a.75.75 0 0 0 0 1.5h6.25V19a.75.75 0 0 0 1.5 0v-6.25H19a.75.75 0 0 0 0-1.5h-6.25V5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-plus", l2);
const e2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], O6 = /* @__PURE__ */ t({
  __name: "VsgIconPlus",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-plus", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, e2));
  }
});
class a2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.658 3.922a.75.75 0 0 0 0 1.5h3.846l-6.548 6.548a.75.75 0 1 0 1.06 1.06l6.548-6.547v3.846a.75.75 0 0 0 1.5 0V3.922h-6.406ZM3.236 7a.75.75 0 0 1 .75-.75h6a.75.75 0 1 1 0 1.5h-5.25v11.5h11.5V15a.75.75 0 1 1 1.5 0v5a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75V7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-popout", a2);
const s2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], U6 = /* @__PURE__ */ t({
  __name: "VsgIconPopout",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-popout", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, s2));
  }
});
class r2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 2.25a.75.75 0 0 0-.75.75v3.25H3a.75.75 0 0 0-.75.75v10c0 .415.336.75.75.75h3.25v4h11.5v-4H21a.75.75 0 0 0 .75-.75V7a.75.75 0 0 0-.75-.75h-1.25V3a.75.75 0 0 0-.75-.75H5Zm1.25 10.5v3.5h-2.5v-8.5h16.5v8.5h-2.5v-3.5H18a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5h.25Zm1.5 0v7.5h8.5v-7.5h-8.5Zm10.5-6.5v-2.5H5.75v2.5h12.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-print", r2);
const n2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], N6 = /* @__PURE__ */ t({
  __name: "VsgIconPrint",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-print", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, n2));
  }
});
class o2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9 4.75a.25.25 0 0 0-.25.25v10.524a7.261 7.261 0 0 0-1.5-1.006V5c0-.967.784-1.75 1.75-1.75h8c.966 0 1.75.783 1.75 1.75v15A1.75 1.75 0 0 1 17 21.75h-5.883c.083-.236.129-.49.129-.753 0-.253-.013-.502-.038-.747H17a.25.25 0 0 0 .25-.25v-1.25h-6.36a7.213 7.213 0 0 0-.687-1.5h7.047V5a.25.25 0 0 0-.25-.25H9ZM3.246 18.999a.75.75 0 0 1 .75-.75 2.75 2.75 0 0 1 2.75 2.75.75.75 0 1 1-1.5 0c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1-.75-.75Zm.75-3.75a.75.75 0 0 0 0 1.5 4.25 4.25 0 0 1 4.25 4.25.75.75 0 1 0 1.5 0 5.75 5.75 0 0 0-5.75-5.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-push", o2);
const t2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], K6 = /* @__PURE__ */ t({
  __name: "VsgIconPush",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-push", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, t2));
  }
});
class c2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M10.5 8c0-.643.213-.976.431-1.163.245-.209.618-.337 1.067-.336.466 0 .857.127 1.107.321.216.168.395.434.395.929 0 .133-.055.334-.234.614a5.23 5.23 0 0 1-.721.853c-.19.188-.345.332-.502.476-.111.103-.222.205-.345.323a4.179 4.179 0 0 0-.373.398 1.728 1.728 0 0 0-.187.283 1.21 1.21 0 0 0-.138.553v.028c.009.292.009.837.007 1.325l-.005.624-.001.191v.053l-.001.013v.004l1 .012 1 .01v-.073l.002-.194.005-.631c.001-.353.002-.757-.002-1.078l.079-.077c.06-.058.148-.14.25-.234.19-.175.425-.394.62-.589.334-.33.706-.737.998-1.195.29-.455.548-1.032.548-1.69 0-1.09-.446-1.947-1.168-2.508-.687-.534-1.546-.741-2.33-.742-.802-.002-1.678.224-2.371.817-.72.616-1.13 1.534-1.13 2.683v.75h2V8Zm2.386 3.664.002-.002-.002.002Zm.614 5.338a1.5 1.5 0 1 0-2.999.001 1.5 1.5 0 0 0 2.999-.001Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-question-mark", c2);
const u2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], G6 = /* @__PURE__ */ t({
  __name: "VsgIconQuestionMark",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-question-mark", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, u2));
  }
});
class i2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.75 2.938a.75.75 0 0 0-.75.75v4.1L2.649 9.65a.752.752 0 0 0-.399.663v10c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75v-10a.747.747 0 0 0-.399-.663L18 7.788v-4.1a.75.75 0 0 0-.75-.75H6.75ZM18 9.504v1.618l1.456-.809L18 9.504Zm-1.5 2.451V4.438h-9v7.517l4.5 2.5 4.5-2.5ZM6 11.122V9.504l-1.456.81L6 11.121Zm14.25.466-7.886 4.38a.75.75 0 0 1-.728 0l-7.886-4.38v7.975h16.5v-7.975Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-read-message", i2);
const m2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Y6 = /* @__PURE__ */ t({
  __name: "VsgIconReadMessage",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-read-message", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, m2));
  }
});
class d2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6 2.25a.75.75 0 0 0-.75.75v18a.75.75 0 0 0 1.166.625L9 19.902l2.584 1.723a.75.75 0 0 0 .832 0L15 19.902l2.584 1.723A.75.75 0 0 0 18.75 21V3a.75.75 0 0 0-.75-.75H6Zm.75 17.35V3.75h10.5V19.6l-1.834-1.223a.75.75 0 0 0-.832 0L12 20.099l-2.584-1.722a.75.75 0 0 0-.832 0L6.75 19.599ZM8.5 6.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7ZM7.75 11a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 3.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-receipt", d2);
const g2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Q6 = /* @__PURE__ */ t({
  __name: "VsgIconReceipt",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-receipt", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, g2));
  }
});
class h2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.024 3.25C7.18 3.25 3.25 7.167 3.25 12A8.741 8.741 0 0 0 12 20.75c4.37 0 7.634-3.28 8.711-6.512a.75.75 0 0 0-1.423-.475c-.922 2.767-3.706 5.488-7.288 5.488A7.241 7.241 0 0 1 4.75 12c0-4.002 3.254-7.25 7.274-7.25a7.275 7.275 0 0 1 6.228 3.5H16a.75.75 0 0 0 0 1.5h4.75V5a.75.75 0 0 0-1.5 0v2.034a8.772 8.772 0 0 0-7.226-3.784Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-refresh", h2);
const p2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], X6 = /* @__PURE__ */ t({
  __name: "VsgIconRefresh",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-refresh", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, p2));
  }
});
class v2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6.377 5.95c.396-.445.962-.7 1.557-.7H20c.966 0 1.75.784 1.75 1.75v10A1.75 1.75 0 0 1 20 18.75H7.934a2.083 2.083 0 0 1-1.557-.699l-.017-.02-.016-.02-3.587-4.648a2.084 2.084 0 0 1 0-2.724l3.587-4.65.016-.02.017-.02ZM9.47 8.47a.75.75 0 0 1 1.06 0L13 10.94l2.47-2.47a.75.75 0 0 1 1.06 1.06L14.06 12l2.47 2.47a.75.75 0 0 1-1.06 1.06L13 13.062l-2.47 2.47a.75.75 0 1 1-1.06-1.06L11.94 12 9.47 9.53a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-remove-tag-filled", v2);
const x2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], lm = /* @__PURE__ */ t({
  __name: "VsgIconRemoveTagFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-remove-tag-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, x2));
  }
});
class y2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.512 6.931 3.93 11.573l-.016.02-.017.02a.584.584 0 0 0 0 .775l.017.02.016.02 3.582 4.642c.11.115.263.18.422.18H20a.25.25 0 0 0 .25-.25V7a.25.25 0 0 0-.25-.25H7.934a.583.583 0 0 0-.422.181ZM6.377 5.95c.396-.445.962-.7 1.557-.7H20c.966 0 1.75.784 1.75 1.75v10A1.75 1.75 0 0 1 20 18.75H7.934a2.084 2.084 0 0 1-1.557-.698l-.017-.02-.016-.02-3.587-4.65a2.084 2.084 0 0 1 0-2.723l3.587-4.65.016-.02.017-.02ZM9.47 8.47a.75.75 0 0 1 1.06 0L13 10.94l2.47-2.47a.75.75 0 0 1 1.06 1.06L14.06 12l2.47 2.47a.75.75 0 1 1-1.06 1.06L13 13.062l-2.47 2.47a.75.75 0 0 1-1.06-1.06L11.94 12 9.47 9.53a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-remove-tag", y2);
const _2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], em = /* @__PURE__ */ t({
  __name: "VsgIconRemoveTag",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-remove-tag", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _2));
  }
});
class w2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 4A.75.75 0 0 1 4 3.25h13a.75.75 0 0 1 .75.75v4.208A5.504 5.504 0 0 0 16.25 8V4.75H4.75v14.5h11.5V19c.52 0 1.023-.073 1.5-.207V20a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V4Zm13 6.25a3.25 3.25 0 1 0 3.093 4.25h1.552a4.752 4.752 0 0 1-9.395-1 4.75 4.75 0 0 1 8.125-3.342v-.157a.625.625 0 0 1 1.25 0v2.625H18.25a.625.625 0 1 1 0-1.25h.46a3.243 3.243 0 0 0-2.46-1.125ZM7 7.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H7ZM6.25 12a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM7 15.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 1 0 0-1.5H7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-renew", w2);
const f2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], am = /* @__PURE__ */ t({
  __name: "VsgIconRenew",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-renew", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, f2));
  }
});
class b2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.5 4.496a1 1 0 0 0-1 1v13.5h-2v-4.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v4.5H3.25a.75.75 0 0 0 0 1.5h13.157a.95.95 0 0 0 .093.004h1a.964.964 0 0 0 .093-.004h3.157a.75.75 0 0 0 0-1.5H18.5v-9.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v9.5h-2v-13.5a1 1 0 0 0-1-1h-1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-reports", b2);
const z2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], sm = /* @__PURE__ */ t({
  __name: "VsgIconReports",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-reports", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, z2));
  }
});
class $2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19.5 14.5a7.503 7.503 0 0 0-5.024-7.081l1.853-2.256.302-.367-.202-.429-.912-1.936-.203-.43H8.685l-.203.43-.91 1.936-.202.43.3.366 1.854 2.256A7.5 7.5 0 1 0 19.5 14.5ZM9.13 4.578l2.03 2.47a7.581 7.581 0 0 1 1.68 0l2.03-2.47-.507-1.076H9.637L9.13 4.577ZM12 8.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-3.25 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM12 9.75a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-ring", $2);
const Z2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], rm = /* @__PURE__ */ t({
  __name: "VsgIconRing",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-ring", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Z2));
  }
});
class V2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 4A.75.75 0 0 1 4 3.25h13a.75.75 0 0 1 .53.22l3 3c.141.14.22.332.22.53v13a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V4Zm1.5.75h2.5V9c0 .415.336.75.75.75h8a.75.75 0 0 0 .75-.75V4.812l2.5 2.5v11.94H4.75V4.75Zm10.5 3.5v-3.5h-6.5v3.5h6.5Zm-8.25 4a.75.75 0 0 0-.75.75v4c0 .415.336.75.75.75h10a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75H7Zm.75 4v-2.5h8.5v2.5h-8.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-save", V2);
const B2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], nm = /* @__PURE__ */ t({
  __name: "VsgIconSave",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-save", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, B2));
  }
});
class I2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M6 2.25a.75.75 0 0 0-.75.75v18a.75.75 0 0 0 1.28.53L12 16.062l5.47 5.47a.75.75 0 0 0 1.28-.53V3a.75.75 0 0 0-.75-.75H6Zm.75 5v-3.5h10.5v3.5H6.75Zm0 1.5v10.44l4.72-4.72a.75.75 0 0 1 1.06 0l4.72 4.72V8.75H6.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-saved-reply", I2);
const j2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], om = /* @__PURE__ */ t({
  __name: "VsgIconSavedReply",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-saved-reply", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, j2));
  }
});
class M2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 4a.75.75 0 0 1 .75-.75h14.5A.75.75 0 0 1 20 4v1.55l.003.004 1.85 2.5.147.2v1.277l-.003.031c-.09 1.117-.902 2.098-1.997 2.365v6.822h.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 1 1 0-1.5H4v-6.822c-1.095-.267-1.907-1.248-1.998-2.365L2 9.533V8.237l.164-.205L4 5.737V4.001Zm1.5 1.25h13v-.5h-13v.5Zm.958 1.5H5.11L3.5 8.765v.704c.06.576.555 1.033 1.1 1.033s1.04-.457 1.1-1.033V8.33l.074-.154.684-1.425ZM5.5 11.836c.362-.138.685-.357.95-.632.469.486 1.12.798 1.85.798s1.381-.312 1.85-.797c.469.485 1.12.796 1.85.796s1.381-.31 1.85-.796c.469.485 1.12.796 1.85.796s1.381-.31 1.85-.796c.265.274.588.493.95.63v6.916h-1v-3.534l-.007-.144-.001-.017-.002-.017c-.126-1.36-1.384-2.287-2.74-2.287-1.356 0-2.614.926-2.74 2.287l-.002.017v.017l-.007.144-.001.017v3.518H5.5v-6.916Zm3.91-3.453.26-1.631H8.122L7.2 8.67v.797c.06.576.555 1.033 1.1 1.033s1.04-.457 1.1-1.033V8.441l.01-.059ZM12 10.501c-.545 0-1.04-.457-1.1-1.033V8.56l.29-1.81h1.62l.29 1.81v.908c-.06.576-.555 1.033-1.1 1.033Zm3.7 0c.545 0 1.04-.457 1.1-1.033v-.797l-.922-1.92H14.33l.26 1.631.01.059v1.027c.06.576.555 1.033 1.1 1.033Zm3.7 0c-.545 0-1.04-.457-1.1-1.033V8.33l-.074-.154-.684-1.425h1.48L20.5 8.748v.72c-.06.576-.555 1.033-1.1 1.033Zm-5.9 4.767.005-.106c.05-.434.51-.912 1.245-.912.735 0 1.196.478 1.245.912l.005.106V18.5h-2.5v-3.232Zm-7-.768c0-.966.784-1.75 1.75-1.75h1c.966 0 1.75.784 1.75 1.75v1a1.75 1.75 0 0 1-1.75 1.75h-1A1.75 1.75 0 0 1 6.5 15.5v-1Zm1.75-.25a.25.25 0 0 0-.25.25v1c0 .139.112.25.25.25h1a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-1Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-sba", M2);
const H2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], tm = /* @__PURE__ */ t({
  __name: "VsgIconSba",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-sba", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, H2));
  }
});
class k2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9.404 9.045a3 3 0 1 0-1.855 1.293l1.606 1.043 1.836-1.193-1.64-1.065.053-.078Zm-1.7-2.892A1.5 1.5 0 1 1 6.072 8.67a1.5 1.5 0 0 1 1.634-2.517Zm1.7 8.801a3 3 0 1 1-1.908-1.303l9.887-6.42 2.313-.246c.523-.056.766.63.325.916L9.33 14.845c.026.036.05.072.075.11Zm-1.7 2.892a1.5 1.5 0 1 0-1.633-2.516 1.5 1.5 0 0 0 1.634 2.516Z"/>   <path d="m17.383 16.724-4.556-2.958 1.836-1.193 5.359 3.48c.44.286.197.972-.325.916l-2.314-.245Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-scissors", k2);
const C2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], cm = /* @__PURE__ */ t({
  __name: "VsgIconScissors",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-scissors", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, C2));
  }
});
class L2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.625 10.376a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Zm5.75-7.25a7.25 7.25 0 1 0 4.569 12.88l4.65 4.65a.75.75 0 1 0 1.061-1.06l-4.65-4.652a7.25 7.25 0 0 0-5.63-11.819Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-search", L2);
const A2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], um = /* @__PURE__ */ t({
  __name: "VsgIconSearch",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-search", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, A2));
  }
});
class E2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m3.33 2.33 17.99 9c.26.121.43.382.43.67 0 .286-.17.547-.43.67l-17.99 9a.73.73 0 0 1-.85-.13.76.76 0 0 1-.17-.84l3.216-7.231L18.25 12 5.527 10.533 2.31 3.299a.75.75 0 0 1 1.02-.97Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-send-filled", E2);
const S2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], im = /* @__PURE__ */ t({
  __name: "VsgIconSendFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-send-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, S2));
  }
});
class J2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m4.534 4.609 14.773 7.39-14.773 7.39 2.723-6.12 10.993-1.268-10.992-1.269L4.534 4.61Zm1.646 7.39-3.87 8.7a.76.76 0 0 0 .17.84.73.73 0 0 0 .85.13l17.99-9a.744.744 0 0 0 .43-.67.744.744 0 0 0-.43-.67l-17.99-9a.75.75 0 0 0-1.02.97L6.18 12Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-send", J2);
const T2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], mm = /* @__PURE__ */ t({
  __name: "VsgIconSend",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-send", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, T2));
  }
});
class q2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.26 2.09h-.001a8.975 8.975 0 0 0-2.518 0l-.357.044a.75.75 0 0 0-.646.617l-.47 2.727A7.064 7.064 0 0 0 7.495 6.55L4.93 5.643a.75.75 0 0 0-.86.27l-.213.299A9.955 9.955 0 0 0 2.65 8.477v.001l-.128.342a.75.75 0 0 0 .251.864l2.185 1.64a6.453 6.453 0 0 0 0 1.358l-2.185 1.64a.75.75 0 0 0-.251.863l.128.342v.002c.305.806.71 1.569 1.205 2.263l.214.299a.75.75 0 0 0 .86.27l2.565-.907c.531.44 1.127.803 1.773 1.073l.47 2.727a.75.75 0 0 0 .646.616l.357.045a9.96 9.96 0 0 0 1.259.087 9.96 9.96 0 0 0 1.259-.087l.357-.045a.75.75 0 0 0 .646-.616l.47-2.727a7.067 7.067 0 0 0 1.773-1.073l2.565.908a.75.75 0 0 0 .86-.271l.213-.299a9.96 9.96 0 0 0 1.206-2.264l.128-.343a.75.75 0 0 0-.251-.863l-2.185-1.64a6.452 6.452 0 0 0 0-1.357l2.185-1.641a.75.75 0 0 0 .251-.864l-.128-.342a9.958 9.958 0 0 0-1.205-2.264v-.001l-.214-.298a.75.75 0 0 0-.86-.271l-2.565.907a7.065 7.065 0 0 0-1.773-1.072l-.47-2.727a.75.75 0 0 0-.646-.617l-.357-.044Zm-2.586 4.063.448-2.598a7.179 7.179 0 0 1 1.756 0l.448 2.598a.75.75 0 0 0 .494.581 5.57 5.57 0 0 1 2.005 1.216.75.75 0 0 0 .765.162l2.445-.866c.332.49.614 1.019.838 1.576l-2.084 1.566a.75.75 0 0 0-.29.72c.049.303.08.599.08.894 0 .295-.031.59-.08.894a.75.75 0 0 0 .29.72l2.084 1.565a8.462 8.462 0 0 1-.838 1.577l-2.445-.866a.75.75 0 0 0-.765.162c-.57.537-1.25.955-2.005 1.215a.75.75 0 0 0-.494.582l-.448 2.598c-.328.036-.61.052-.878.052s-.55-.016-.878-.052l-.448-2.598a.75.75 0 0 0-.495-.582 5.567 5.567 0 0 1-2.004-1.215.75.75 0 0 0-.765-.162l-2.445.866a8.457 8.457 0 0 1-.839-1.577l2.085-1.565a.75.75 0 0 0 .29-.72 5.533 5.533 0 0 1-.08-.894c0-.296.03-.591.08-.894a.75.75 0 0 0-.29-.72L4.126 8.822a8.459 8.459 0 0 1 .839-1.576l2.445.866a.75.75 0 0 0 .765-.162 5.566 5.566 0 0 1 2.004-1.216.75.75 0 0 0 .495-.581ZM10.25 12a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM12 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-settings", q2);
const R2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], dm = /* @__PURE__ */ t({
  __name: "VsgIconSettings",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-settings", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, R2));
  }
});
class D2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.75 6a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM17 2.25a3.75 3.75 0 0 0-3.572 4.897L9.165 9.989a3.75 3.75 0 1 0 0 4.023l4.263 2.842a3.75 3.75 0 1 0 .738-1.31L9.708 12.57a3.778 3.778 0 0 0 0-1.14l4.46-2.973A3.75 3.75 0 1 0 17 2.25Zm0 13.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM3.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-share", D2);
const F2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], gm = /* @__PURE__ */ t({
  __name: "VsgIconShare",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-share", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, F2));
  }
});
class P2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.487 4.574a.25.25 0 0 1 .177-.073h1.399a2.975 2.975 0 0 0 5.924 0h1.349a.25.25 0 0 1 .177.073l3.68 3.681-1.414 1.414L17.28 8.17A.75.75 0 0 0 16 8.7v10.8H8V8.7a.75.75 0 0 0-1.28-.53l-1.5 1.5-1.414-1.415 3.681-3.681Zm5.987-.073h-2.898a1.475 1.475 0 0 0 2.898 0ZM7.664 3a1.75 1.75 0 0 0-1.237.512L2.215 7.725a.75.75 0 0 0 0 1.06L4.69 11.26a.75.75 0 0 0 1.061 0l.749-.749v9.74c0 .414.336.75.75.75h9.5a.75.75 0 0 0 .75-.75v-9.74l.75.75a.75.75 0 0 0 1.06 0l2.475-2.476a.75.75 0 0 0 0-1.06l-4.212-4.212a1.75 1.75 0 0 0-1.237-.512H7.664Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-shirt", P2);
const W2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], hm = /* @__PURE__ */ t({
  __name: "VsgIconShirt",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-shirt", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, W2));
  }
});
class O2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 6.25c-4.354 0-6.76 2.428-9.066 4.754l-.464.466a.75.75 0 0 0 0 1.061l.464.467C5.24 15.324 7.646 17.751 12 17.751c4.354 0 6.76-2.427 9.066-4.753l.464-.467a.75.75 0 0 0 0-1.06l-.464-.467C18.76 8.678 16.354 6.25 12 6.25Zm0 10c-3.65 0-5.635-1.932-7.941-4.25C6.365 9.685 8.349 7.75 12 7.75c3.65 0 5.635 1.934 7.941 4.25-2.306 2.318-4.29 4.25-7.941 4.25ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-show", O2);
const U2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], pm = /* @__PURE__ */ t({
  __name: "VsgIconShow",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-show", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, U2));
  }
});
class N2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5.001 8.25 8.25 0 0 1-16.5 0ZM12 2.25c-5.385 0-9.75 4.366-9.75 9.75 0 5.386 4.365 9.75 9.75 9.75s9.75-4.364 9.75-9.75c0-5.384-4.365-9.75-9.75-9.75ZM8.75 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm7.75-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-7.876 3.835a.75.75 0 0 0-1.248.832c2.297 3.445 6.951 3.445 9.248 0a.75.75 0 1 0-1.248-.832c-1.703 2.555-5.049 2.555-6.752 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-smile", N2);
const K2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], vm = /* @__PURE__ */ t({
  __name: "VsgIconSmile",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-smile", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, K2));
  }
});
class G2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 3.25A1.75 1.75 0 0 0 2.25 5v16.561l1.219-.974 4.794-3.836H20A1.75 1.75 0 0 0 21.75 15V5A1.75 1.75 0 0 0 20 3.25H4ZM3.75 5A.25.25 0 0 1 4 4.75h16a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25H7.737l-.206.165L3.75 18.44V5Zm2.997 7.375c-1.158 0-1.888-.546-1.907-1.429h1.11c.029.334.362.546.845.546.434 0 .733-.21.733-.51 0-.255-.2-.391-.724-.496l-.603-.12c-.838-.16-1.27-.616-1.27-1.337 0-.895.718-1.482 1.822-1.482 1.073 0 1.816.581 1.835 1.428H7.512c-.025-.323-.333-.549-.743-.549s-.679.194-.679.499c0 .25.203.396.686.492l.59.114c.905.174 1.31.584 1.31 1.31 0 .956-.73 1.534-1.929 1.534Zm7.69-4.704v4.58H13.36V9.36h-.058l-1.018 2.548h-.72L10.541 9.36h-.057v2.89H9.409V7.672h1.374l1.111 2.809h.06l1.108-2.809h1.374Zm2.636 4.704c-1.158 0-1.888-.546-1.907-1.429h1.11c.029.334.362.546.845.546.434 0 .733-.21.733-.51 0-.255-.2-.391-.724-.496l-.603-.12c-.838-.16-1.27-.616-1.27-1.337 0-.895.718-1.482 1.822-1.482 1.073 0 1.816.581 1.835 1.428h-1.076c-.026-.323-.333-.549-.743-.549s-.679.194-.679.499c0 .25.203.396.686.492l.59.114c.904.174 1.31.584 1.31 1.31 0 .956-.73 1.534-1.929 1.534Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-sms", G2);
const Y2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], xm = /* @__PURE__ */ t({
  __name: "VsgIconSms",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-sms", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Y2));
  }
});
class Q2 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8.53 3.72 8 3.19l-.53.53-4 4a.75.75 0 0 0 1.06 1.061l2.72-2.72v9.19a.75.75 0 0 0 1.5 0V6.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4Zm8.22 5.03a.75.75 0 0 0-1.5 0v9.19l-2.72-2.72a.75.75 0 1 0-1.06 1.061l4 4 .53.53.53-.53 4-4a.75.75 0 1 0-1.06-1.06l-2.72 2.72V8.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-sort", Q2);
const X2 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ym = /* @__PURE__ */ t({
  __name: "VsgIconSort",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-sort", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, X2));
  }
});
class l7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7 3.25a.75.75 0 0 0-.658.39L5.033 6.033 2.64 7.342a.75.75 0 0 0 0 1.316l2.393 1.309 1.309 2.393a.75.75 0 0 0 1.316 0l1.309-2.393 2.393-1.309a.75.75 0 0 0 0-1.316L8.967 6.033 7.658 3.64A.75.75 0 0 0 7 3.25Zm0 2.313.756 1.383a.75.75 0 0 0 .298.298L9.437 8l-1.383.756a.75.75 0 0 0-.298.298L7 10.437l-.756-1.383a.75.75 0 0 0-.298-.298L4.563 8l1.383-.756a.75.75 0 0 0 .298-.298L7 5.563Zm7.838-1.029a.913.913 0 0 1 .65-.284c.334 0 .555.19.648.284.108.11.182.23.232.325.094.18.169.399.197.597.273 1.562.591 2.97 1.27 3.884.662.893 1.744 1.409 2.873 1.779.199.053.403.167.558.287.276.212.484.523.484.881 0 .365-.215.673-.5.881a1.89 1.89 0 0 1-.524.282c-1.137.362-2.222.83-2.892 1.734-.674.909-.997 2.363-1.27 3.902a1.731 1.731 0 0 1-.21.6c-.054.094-.134.21-.247.314a.921.921 0 0 1-.62.25.91.91 0 0 1-.631-.265 1.302 1.302 0 0 1-.234-.314 1.953 1.953 0 0 1-.208-.564c-.247-1.334-.395-2.8-1.216-3.93-.661-.907-1.759-1.347-2.928-1.72a1.579 1.579 0 0 1-.566-.302c-.262-.214-.454-.52-.454-.867 0-.482.347-.773.47-.868.154-.12.335-.232.523-.293 1.154-.376 2.299-.894 2.958-1.786.823-1.114.968-2.567 1.21-3.889.028-.197.102-.414.196-.593a1.4 1.4 0 0 1 .231-.325Zm.658 3.13c-.222.905-.53 1.812-1.089 2.569-.764 1.033-1.903 1.646-2.934 2.048 1.018.374 2.159.944 2.938 2.014.557.766.857 1.687 1.082 2.597.248-.942.595-1.873 1.136-2.602.774-1.043 1.877-1.625 2.884-2.007-1.023-.405-2.118-1.018-2.883-2.05-.541-.728-.887-1.638-1.134-2.57Z"/>   <path d="M8.965 14.68a.5.5 0 0 0-.93 0l-.587 1.487a.5.5 0 0 1-.281.281l-1.488.587a.5.5 0 0 0 0 .93l1.488.587a.5.5 0 0 1 .281.281l.587 1.488a.5.5 0 0 0 .93 0l.587-1.488a.5.5 0 0 1 .281-.281l1.488-.587a.5.5 0 0 0 0-.93l-1.488-.587a.5.5 0 0 1-.281-.281l-.587-1.488Z"/>   <path d="M9.552 16.167a.5.5 0 0 0 .281.281l1.488.587a.5.5 0 0 1 0 .93l-1.488.587a.5.5 0 0 0-.281.281l-.587 1.488a.5.5 0 0 1-.93 0l-.587-1.488a.5.5 0 0 0-.281-.281l-1.488-.587a.5.5 0 0 1 0-.93l1.488-.587a.5.5 0 0 0 .281-.281l.587-1.488a.5.5 0 0 1 .93 0l.587 1.488Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-sparkles", l7);
const e7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], _m = /* @__PURE__ */ t({
  __name: "VsgIconSparkles",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-sparkles", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, e7));
  }
});
class a7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm11.005 5.996a.75.75 0 0 1 0 1.06l-4.95 4.95-.015.016-.01.01a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.062l1.97 1.97 4.444-4.444a.75.75 0 0 1 1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-square-checkmark-filled", a7);
const s7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], wm = /* @__PURE__ */ t({
  __name: "VsgIconSquareCheckmarkFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-square-checkmark-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, s7));
  }
});
class r7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm0 1.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5Zm11.268 4.483a.75.75 0 0 1 0 1.06l-4.95 4.95a.534.534 0 0 1-.025.026.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.061l1.97 1.97 4.444-4.445a.75.75 0 0 1 1.06 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-square-checkmark", r7);
const n7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], fm = /* @__PURE__ */ t({
  __name: "VsgIconSquareCheckmark",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-square-checkmark", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, n7));
  }
});
class o7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm2.75 8.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-square-dash-filled", o7);
const t7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], bm = /* @__PURE__ */ t({
  __name: "VsgIconSquareDashFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-square-dash-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, t7));
  }
});
class c7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM4.5 5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V5Zm3.25 6.25a.75.75 0 1 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-square-dash", c7);
const u7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], zm = /* @__PURE__ */ t({
  __name: "VsgIconSquareDash",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-square-dash", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, u7));
  }
});
class i7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm0 1.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-square-empty", i7);
const m7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], $m = /* @__PURE__ */ t({
  __name: "VsgIconSquareEmpty",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-square-empty", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, m7));
  }
});
class d7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12 4.25a.75.75 0 0 1 .68.433l1.98 4.242 4.948.718a.75.75 0 0 1 .389 1.304l-3.71 3.278.74 4.658a.75.75 0 0 1-1.107.773L12 17.468l-3.92 2.188a.75.75 0 0 1-1.106-.773l.739-4.658-3.71-3.278a.75.75 0 0 1 .39-1.304l4.947-.718 1.98-4.242a.75.75 0 0 1 .68-.432Zm0 2.523-1.472 3.154a.75.75 0 0 1-.572.425l-3.746.543 2.805 2.479a.75.75 0 0 1 .244.68l-.562 3.54 2.938-1.64a.75.75 0 0 1 .73 0l2.938 1.64-.562-3.54a.75.75 0 0 1 .244-.68l2.806-2.479-3.747-.543a.75.75 0 0 1-.572-.425L12 6.773Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-star-empty", d7);
const g7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Zm = /* @__PURE__ */ t({
  __name: "VsgIconStarEmpty",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-star-empty", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, g7));
  }
});
class h7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M20.22,10.17a.75.75,0,0,0-.61-.53l-4.95-.72-2-4.24a.78.78,0,0,0-1.36,0l-2,4.24-4.95.72A.75.75,0,0,0,4,10.95l3.71,3.28L7,18.88a.75.75,0,0,0,1.11.77L12,17.47l3.92,2.19A.75.75,0,0,0,17,18.88l-.74-4.66L20,10.95A.75.75,0,0,0,20.22,10.17Z"/> </svg>
    `;
  }
}
customElements.define("jha-icon-star-fill", h7);
const p7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Vm = /* @__PURE__ */ t({
  __name: "VsgIconStarFill",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-star-fill", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, p7));
  }
});
class v7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.68 4.684a.75.75 0 0 0-1.36 0L9.34 8.925l-4.948.718a.75.75 0 0 0-.389 1.304l3.71 3.278-.74 4.659a.75.75 0 0 0 1.107.772L12 17.468l3.92 2.188a.75.75 0 0 0 1.106-.772l-.739-4.659 3.71-3.277a.75.75 0 0 0-.39-1.305l-4.947-.718-1.98-4.241Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-star-filled", v7);
const x7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Bm = /* @__PURE__ */ t({
  __name: "VsgIconStarFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-star-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, x7));
  }
});
class y7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 2.376A1.75 1.75 0 0 0 2 4.126v14.59l1.227-1.011 4.042-3.329h8.981a1.75 1.75 0 0 0 1.75-1.75v-8.5a1.75 1.75 0 0 0-1.75-1.75H3.75Zm-.25 1.75a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25v8.5a.25.25 0 0 1-.25.25H6.73l-.207.171-3.023 2.49V4.126Zm4.5 12.5v-.75h1.5v.75c0 .138.112.25.25.25h7.504l.202.154 3.044 2.328V8.126a.25.25 0 0 0-.25-.25h-.75v-1.5h.75c.966 0 1.75.783 1.75 1.75v14.268l-1.206-.922-4.048-3.096H9.75A1.75 1.75 0 0 1 8 16.626Zm-.75-8.25a.75.75 0 0 1 .75-.75h1.25v-1.25a.75.75 0 1 1 1.5 0v1.25H12a.75.75 0 0 1 0 1.5h-1.25v1.25a.75.75 0 0 1-1.5 0v-1.25H8a.75.75 0 0 1-.75-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-start-conversation", y7);
const _7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Im = /* @__PURE__ */ t({
  __name: "VsgIconStartConversation",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-start-conversation", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _7));
  }
});
class w7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 7.001a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 .75.75v2.316a5.997 5.997 0 0 0-1.5-.88v-.686H4.75v7.5h6.38c.113.53.294 1.032.536 1.5H4a.75.75 0 0 1-.75-.75v-9Zm3.25 2.5h6.531a6.028 6.028 0 0 0-.905 1H6v-1h.5Zm2 2.5h2.841a5.95 5.95 0 0 0-.258 1H8v-1h.5Zm5.25 2a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM17 9.251a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Zm-1.643 3.107a.555.555 0 0 1 .786 0l.857.857.857-.857a.555.555 0 1 1 .786.786l-.857.857.857.857a.556.556 0 0 1-.786.786L17 14.787l-.857.857a.556.556 0 0 1-.786-.786l.857-.857-.857-.857a.556.556 0 0 1 0-.786Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-stop-payment", w7);
const f7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], jm = /* @__PURE__ */ t({
  __name: "VsgIconStopPayment",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-stop-payment", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, f7));
  }
});
class b7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2 4.126c0-.967.784-1.75 1.75-1.75h12.5c.966 0 1.75.783 1.75 1.75v8.5a1.75 1.75 0 0 1-1.75 1.75H7.27l-4.043 3.329L2 18.715V4.126Zm6 11.75h8.25a3.25 3.25 0 0 0 3.25-3.25v-6.25h.75c.966 0 1.75.783 1.75 1.75v14.268l-1.206-.922-4.048-3.096H9.75A1.75 1.75 0 0 1 8 16.626v-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-support-filled", b7);
const z7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Mm = /* @__PURE__ */ t({
  __name: "VsgIconSupportFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-support-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, z7));
  }
});
class $7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.75 2.376A1.75 1.75 0 0 0 2 4.126v14.59l1.227-1.011 4.042-3.329h8.981a1.75 1.75 0 0 0 1.75-1.75v-8.5a1.75 1.75 0 0 0-1.75-1.75H3.75Zm-.25 1.75a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25v8.5a.25.25 0 0 1-.25.25H6.73l-.207.171-3.023 2.49V4.126Zm4.5 12.5v-.75h1.5v.75c0 .138.112.25.25.25h7.504l.202.154 3.044 2.328V8.126a.25.25 0 0 0-.25-.25h-.75v-1.5h.75c.966 0 1.75.783 1.75 1.75v14.268l-1.206-.922-4.048-3.096H9.75A1.75 1.75 0 0 1 8 16.626Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-support", $7);
const Z7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Hm = /* @__PURE__ */ t({
  __name: "VsgIconSupport",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-support", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Z7));
  }
});
class V7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m7 3.94.53.53 4 4a.75.75 0 0 1-1.06 1.061l-2.72-2.72v8.19c0 1.781.65 2.532 1.166 2.876A2.314 2.314 0 0 0 10 18.25h.007a.75.75 0 0 1-.007 1.5V19l-.001.75h-.024a2.782 2.782 0 0 1-.175-.011 3.815 3.815 0 0 1-1.716-.615C7.1 18.468 6.25 17.218 6.25 15V6.81L3.53 9.53a.75.75 0 0 1-1.06-1.06l4-4L7 3.94Zm7 .311a.75.75 0 0 0-.007 1.5H14l.058.004a2.317 2.317 0 0 1 1.026.37c.516.344 1.166 1.094 1.166 2.876v8.19l-2.72-2.72a.75.75 0 1 0-1.06 1.06l4 4 .53.53.53-.53 4-4a.75.75 0 0 0-1.06-1.06l-2.72 2.72V9c0-2.219-.85-3.468-1.834-4.124a3.817 3.817 0 0 0-1.716-.615 2.658 2.658 0 0 0-.175-.01l-.015-.001h-.009L14 5v-.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-switch", V7);
const B7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], km = /* @__PURE__ */ t({
  __name: "VsgIconSwitch",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-switch", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, B7));
  }
});
class I7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 6.751a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h1.25v-10.5H4Zm2.75 0v10.5h10.5v-10.5H6.75ZM18 5.251H4a1.75 1.75 0 0 0-1.75 1.75v10c0 .966.784 1.75 1.75 1.75h16a1.75 1.75 0 0 0 1.75-1.75v-10A1.75 1.75 0 0 0 20 5.251h-2Zm.75 1.5v10.5H20a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25h-1.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-tablet", I7);
const j7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Cm = /* @__PURE__ */ t({
  __name: "VsgIconTablet",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-tablet", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, j7));
  }
});
class M7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M7.934 5.251c-.595 0-1.161.255-1.557.7l-.017.019-.016.02-3.587 4.649a2.084 2.084 0 0 0 0 2.724l3.587 4.649.016.02.017.02c.396.444.962.699 1.557.699H20a1.75 1.75 0 0 0 1.75-1.75v-10A1.75 1.75 0 0 0 20 5.251H7.934Zm-.184 6.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-tag-filled", M7);
const H7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Lm = /* @__PURE__ */ t({
  __name: "VsgIconTagFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-tag-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, H7));
  }
});
class k7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m3.93 11.574 3.582-4.642a.583.583 0 0 1 .422-.181H20a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25H7.934a.583.583 0 0 1-.422-.18L3.93 12.427l-.016-.02-.017-.02a.584.584 0 0 1 0-.774l.017-.02.016-.02ZM7.934 5.25c-.595 0-1.161.255-1.557.7l-.017.019-.016.02-3.587 4.649a2.084 2.084 0 0 0 0 2.724l3.587 4.649.016.02.017.02c.396.444.962.699 1.557.699H20A1.75 1.75 0 0 0 21.75 17V7A1.75 1.75 0 0 0 20 5.251H7.934ZM7.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM9 9.251a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-tag", k7);
const C7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Am = /* @__PURE__ */ t({
  __name: "VsgIconTag",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-tag", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, C7));
  }
});
class L7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.375 4.001a.75.75 0 0 1 .75-.75h13.75a.75.75 0 0 1 .75.75v3.79l.82-.82a.75.75 0 0 1 1.06 1.06l-2.125 2.125a.75.75 0 0 1-1.06 0l-2.125-2.125a.75.75 0 1 1 1.06-1.06l.87.87V4.75H5.875V10a.75.75 0 0 1-1.5 0V4Zm14.5 9.283a.75.75 0 0 1 .75.75v5.967a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75v-4.214l-.82.82a.75.75 0 0 1-1.06-1.061L4.62 13.42a.75.75 0 0 1 1.06 0l2.125 2.125a.75.75 0 1 1-1.06 1.06l-.87-.87v3.515h12.25v-5.217a.75.75 0 0 1 .75-.75Zm-8.45.967a.75.75 0 0 0 0 1.5h3.15a.75.75 0 0 0 0-1.5h-3.15Zm-.75-2.55a.75.75 0 0 1 .75-.75h3.15a.75.75 0 0 1 0 1.5h-3.15a.75.75 0 0 1-.75-.75Zm.75-3.95a.75.75 0 0 0 0 1.5h3.15a.75.75 0 0 0 0-1.5h-3.15Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-template", L7);
const A7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Em = /* @__PURE__ */ t({
  __name: "VsgIconTemplate",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-template", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, A7));
  }
});
class E7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.25 5.626H9v-1.5h12v1.5h-5.25v14.25h-1.5V5.626Zm-6.5 6H11v-1.5H3v1.5h3.25v8.25h1.5v-8.25Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-text", E7);
const S7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Sm = /* @__PURE__ */ t({
  __name: "VsgIconText",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-text", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, S7));
  }
});
class J7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.503 18.786a4.752 4.752 0 0 1 5.608-6.691l.754-.754 1.06 1.06-1.089 1.09a.75.75 0 0 1-.823.16 3.251 3.251 0 0 0-4.495 3.39l2.165-2.164a.75.75 0 0 1 1.06 0l1.769 1.767a.75.75 0 0 1 0 1.061L6.346 19.87a3.251 3.251 0 0 0 3.39-4.495.75.75 0 0 1 .161-.823l1.09-1.09 1.06 1.061-.754.754a4.752 4.752 0 0 1-6.692 5.609.75.75 0 0 1-.191-1.2l2.51-2.511-.706-.707-2.511 2.51a.75.75 0 0 1-1.2-.192Zm9.898-8.86-1.06-1.06.753-.753a4.752 4.752 0 0 1 6.691-5.609.75.75 0 0 1 .192 1.2l-2.51 2.51.707.708 2.51-2.511a.75.75 0 0 1 1.2.192 4.752 4.752 0 0 1-5.608 6.691l-.754.754-1.06-1.06 1.089-1.09a.75.75 0 0 1 .823-.16 3.251 3.251 0 0 0 4.495-3.39l-2.165 2.165a.75.75 0 0 1-1.06 0l-1.768-1.768a.75.75 0 0 1 0-1.06l2.165-2.166a3.251 3.251 0 0 0-3.39 4.495.75.75 0 0 1-.16.823l-1.09 1.09Zm.546 5.85a.75.75 0 0 0 0 1.061l4.95 4.95a.75.75 0 0 0 1.06 0l2.83-2.828a.75.75 0 0 0 0-1.06l-4.95-4.95a.75.75 0 0 0-1.061 0l-.884.883-7.687-7.687-.12-.119a1.75 1.75 0 0 0-.41-1.825l-.708-.708a1.75 1.75 0 1 0-2.474 2.475l.707.707a1.75 1.75 0 0 0 1.825.412l.12.119 7.686 7.687-.883.884Zm5.48 4.42-3.888-3.889 1.767-1.768 3.89 3.89-1.768 1.767ZM4.554 4.554a.25.25 0 0 0 0 .354l.707.707a.25.25 0 1 0 .354-.354l-.707-.707a.25.25 0 0 0-.354 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-tools", J7);
const T7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Jm = /* @__PURE__ */ t({
  __name: "VsgIconTools",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-tools", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, T7));
  }
});
class q7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M11.585 3.307a.75.75 0 0 1-.653.835c-2.377.29-4.456 1.892-5.675 4.035a.75.75 0 0 1-1.304-.741C5.36 4.963 7.814 3.012 10.75 2.653a.75.75 0 0 1 .835.654Zm1.45 3.731c-.633-.122-1.36-.112-2.188.112-1.663.45-2.667 1.294-3.229 2.237-.569.957-.721 2.08-.56 3.134.122.804.209 1.503.232 2.15a.75.75 0 0 1-1.499.054c-.02-.559-.096-1.19-.216-1.977-.205-1.34-.02-2.826.754-4.128.783-1.314 2.13-2.378 4.127-2.918 1.037-.28 1.995-.305 2.864-.136a.75.75 0 1 1-.284 1.472Zm2.207.12a.75.75 0 0 1 1.06-.042 7.97 7.97 0 0 1 1.82 2.545c.48 1.07.76 2.562.834 4.142.074 1.592-.06 3.336-.452 4.932a.75.75 0 1 1-1.457-.358c.354-1.437.479-3.036.41-4.504-.068-1.48-.33-2.765-.703-3.599a6.473 6.473 0 0 0-1.47-2.057.75.75 0 0 1-.042-1.06ZM11.784 9.98c-.417.065-.851.173-1.197.386-.35.215-.63.545-.675 1.178a.75.75 0 0 1-1.496-.108C8.5 10.279 9.079 9.534 9.8 9.09c.677-.417 1.451-.553 1.958-.62a.75.75 0 0 1 .22.004c.919-.064 1.704.18 2.32.648.645.492 1.05 1.19 1.26 1.912.378 1.302.556 2.996.463 5.011-.096 2.072-.766 4.079-1.01 4.702a.75.75 0 1 1-1.396-.548c.213-.544.822-2.38.908-4.223.088-1.9-.085-3.421-.405-4.524-.14-.482-.392-.879-.73-1.136-.326-.249-.784-.408-1.433-.334a.752.752 0 0 1-.17 0Zm.055 1.31a.75.75 0 0 1 .91.546c.29 1.16.396 3.205.21 4.73-.027.225-.06.447-.098.666a.75.75 0 1 1-1.477-.258c.034-.194.063-.39.087-.588.167-1.376.061-3.234-.177-4.186a.75.75 0 0 1 .545-.91Zm-.127 7.545a.75.75 0 0 1 .445.963c-.135.367-.283.732-.44 1.1a.75.75 0 1 1-1.379-.593c.15-.347.287-.687.411-1.025a.75.75 0 0 1 .963-.445Zm-2.358-5.283a.75.75 0 0 1 .784.715c.036.778.017 1.665-.125 2.515-.235 1.401-.868 2.642-1.172 3.238l-.097.191a.75.75 0 1 1-1.345-.663l.11-.22c.31-.613.831-1.64 1.024-2.793.12-.714.14-1.489.106-2.199a.75.75 0 0 1 .715-.784ZM6.942 17.29a.75.75 0 1 0-1.427-.462 8.78 8.78 0 0 1-.396.99.75.75 0 0 0 1.36.634c.187-.404.342-.786.463-1.162Zm-2.554-6.964a.75.75 0 1 0-1.454-.368c-.423 1.67-.403 3.456.22 5.13a.75.75 0 0 0 1.406-.522c-.503-1.353-.53-2.825-.172-4.24Zm9.402-7.54a.75.75 0 1 0-.314 1.466c3.104.665 6.422 3.777 6.648 8.893a.75.75 0 0 0 1.498-.067c-.255-5.774-4.037-9.48-7.832-10.293Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-touch-id", q7);
const R7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Tm = /* @__PURE__ */ t({
  __name: "VsgIconTouchId",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-touch-id", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, R7));
  }
});
class D7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19.5 8.501a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM15 6.251a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h11Zm.75 5.75a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 .75-.75Zm3.75 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-3.75 3.5a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 .75-.75Zm3.75 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-transactions", D7);
const F7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], qm = /* @__PURE__ */ t({
  __name: "VsgIconTransactions",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-transactions", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, F7));
  }
});
class P7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m19.53 7.531.53-.53-.53-.53-4-4a.75.75 0 0 0-1.28.53v3.25H9c-2.218 0-3.468.85-4.124 1.834a3.817 3.817 0 0 0-.615 1.716 2.655 2.655 0 0 0-.01.175v.015l-.001.006V10l.75.001h-.75a.75.75 0 0 0 1.5.007v-.007l.004-.058a2.317 2.317 0 0 1 .37-1.026C6.468 8.401 7.218 7.751 9 7.751h5.25v3.25a.75.75 0 0 0 1.28.53l4-4Zm-.53 5.72a.75.75 0 0 1 .75.75H19l.75.001v.024a1.9 1.9 0 0 1-.011.175 3.815 3.815 0 0 1-.615 1.716c-.656.984-1.906 1.834-4.124 1.834H9.75v3.25a.75.75 0 0 1-1.28.53l-4-4-.53-.53.53-.53 4-4a.75.75 0 0 1 1.28.53v3.25H15c1.782 0 2.532-.65 2.876-1.166a2.319 2.319 0 0 0 .374-1.084v-.007a.75.75 0 0 1 .75-.743Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-transfer-filled", P7);
const W7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Rm = /* @__PURE__ */ t({
  __name: "VsgIconTransferFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-transfer-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, W7));
  }
});
class O7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m20.06 7.001-.53.53-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H9c-1.782 0-2.532.65-2.876 1.166a2.317 2.317 0 0 0-.374 1.084v.007a.75.75 0 0 1-1.5-.007H5L4.25 10v-.024a1.91 1.91 0 0 1 .011-.175 3.817 3.817 0 0 1 .615-1.716C5.532 7.1 6.782 6.25 9 6.25h8.19l-2.72-2.72a.75.75 0 0 1 1.06-1.06l4 4 .53.53Zm-.31 7a.75.75 0 0 0-1.5-.007v.007l-.004.058a2.32 2.32 0 0 1-.37 1.026c-.344.516-1.095 1.166-2.876 1.166H6.81l2.72-2.72a.75.75 0 0 0-1.06-1.06l-4 4-.53.53.53.53 4 4a.75.75 0 1 0 1.06-1.06l-2.72-2.72H15c2.218 0 3.468-.85 4.124-1.834a3.815 3.815 0 0 0 .624-1.849 1.9 1.9 0 0 0 .002-.042v-.024l-.75-.001h.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-transfer", O7);
const U7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Dm = /* @__PURE__ */ t({
  __name: "VsgIconTransfer",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-transfer", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, U7));
  }
});
class N7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M14.794 3.81a.746.746 0 0 0-.29-.059h-.012a.746.746 0 0 0-.388.113l-4.67 2.802-4.655-1.861A.75.75 0 0 0 3.75 5.5v12a.75.75 0 0 0 .471.696l4.985 1.994a.747.747 0 0 0 .294.06h.01a.747.747 0 0 0 .386-.113l4.67-2.803 4.655 1.862a.75.75 0 0 0 1.029-.696v-12a.75.75 0 0 0-.471-.696L14.794 3.81ZM13.75 5.827l-3.5 2.1v10.25l3.5-2.1V5.826Zm1.5 10.167V5.61l3.5 1.4v10.384l-3.5-1.4Zm-10-9.384 3.5 1.4v10.384l-3.5-1.4V6.61Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-tutorial", N7);
const K7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Fm = /* @__PURE__ */ t({
  __name: "VsgIconTutorial",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-tutorial", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, K7));
  }
});
class G7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.75 2.876a.75.75 0 0 0-1.5 0v.77A8.86 8.86 0 0 0 3 12.35a.754.754 0 0 0 .55.749.751.751 0 0 0 .854-.356 2.69 2.69 0 0 1 .73-.787c.313-.223.616-.33.866-.33s.553.107.866.33c.305.218.566.51.73.788a.752.752 0 0 0 1.135.207c.765-.63 1.621-1.087 2.519-1.255v7.18c0 .59-.181.959-.383 1.174a1.01 1.01 0 0 1-1.484 0C9.181 19.835 9 19.465 9 18.877a.75.75 0 0 0-1.5 0c0 .91.288 1.666.789 2.2a2.51 2.51 0 0 0 3.672 0c.501-.534.789-1.29.789-2.2v-7.18c.898.168 1.754.625 2.519 1.255a.747.747 0 0 0 1.05-.086.747.747 0 0 0 .085-.121 2.69 2.69 0 0 1 .73-.787c.314-.224.618-.331.866-.331s.552.107.866.331c.306.218.566.51.73.786a.753.753 0 0 0 .854.356.752.752 0 0 0 .55-.748 8.859 8.859 0 0 0-8.25-8.705v-.77ZM9.23 5.61l-.076.03a7.36 7.36 0 0 0-4.359 4.778A2.775 2.775 0 0 1 6 10.126c.604 0 1.163.228 1.62.529.165-1.258.498-2.59.967-3.74.187-.459.402-.901.644-1.305Zm9.67 3.96c.119.278.22.56.305.85A2.771 2.771 0 0 0 18 10.125c-.604 0-1.163.229-1.62.53-.165-1.258-.497-2.591-.967-3.741a9.578 9.578 0 0 0-.644-1.305l.077.03a7.36 7.36 0 0 1 4.053 3.93Zm-4.876-2.088c.427 1.044.728 2.271.875 3.415-.871-.47-1.85-.771-2.899-.771-1.05 0-2.028.302-2.899.771.147-1.144.448-2.37.875-3.415.31-.759.668-1.378 1.045-1.794.376-.415.703-.56.974-.562h.01c.271.002.598.147.974.562.377.416.736 1.035 1.045 1.794Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-umbrella", G7);
const Y7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Pm = /* @__PURE__ */ t({
  __name: "VsgIconUmbrella",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-umbrella", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Y7));
  }
});
class Q7 extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <g fill-rule="evenodd">     <path d="M8.363 7.608A.75.75 0 0 1 8.75 7.5h6.5a.75.75 0 0 1 .387.108l1.25.752a.75.75 0 0 1 .363.643v8.338C17.25 20.01 14.797 22 12 22s-5.25-1.99-5.25-4.659V9.003a.75.75 0 0 1 .363-.643l1.25-.752ZM8.958 9l-.708.427v7.914C8.25 18.99 9.826 20.5 12 20.5s3.75-1.51 3.75-3.159V9.427L15.042 9H8.958Z"/>     <path d="M12 16.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM9.75 17a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM8 2.75A.75.75 0 0 1 8.75 2h6.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-.75.75h-6.5A.75.75 0 0 1 8 8.25v-5.5Zm1.5.75v4h5v-4h-5Z"/>     <path d="M13.985 6h-1.5V4.5h1.5V6Zm-2.482 0h-1.5V4.5h1.5V6Z"/>   </g> </svg> 
    `;
  }
}
customElements.define("jha-icon-usb-drive", Q7);
const X7 = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Wm = /* @__PURE__ */ t({
  __name: "VsgIconUsbDrive",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-usb-drive", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, X7));
  }
});
class lc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path d="M12 5.75c-.797 0-1.452.202-1.97.561-.513.357-.84.832-1.049 1.301-.398.897-.398 1.86-.397 2.205v.017c0 .442.112 1.041.35 1.638.19.477.475.988.884 1.43a1.24 1.24 0 0 1-.03.072.685.685 0 0 1-.087.153c-.022.027-.036.036-.036.036-.261.13-.61.238-1.058.365l-.14.04c-.39.11-.833.236-1.243.398-.46.182-.952.438-1.333.841-.4.427-.641.98-.641 1.665v.202a.75.75 0 0 0 1.5 0v-.202c0-.301.093-.487.234-.636.161-.172.419-.328.792-.475.334-.133.701-.237 1.101-.35l.141-.04c.428-.122.911-.264 1.317-.466.452-.226.696-.629.828-.929a3.29 3.29 0 0 0 .226-.802l.064-.417-.323-.271c-.359-.302-.625-.726-.803-1.17-.178-.448-.243-.858-.243-1.082 0-.338.007-1.024.268-1.613.082-.184.184-.347.311-.484a1.38 1.38 0 0 1 .223-.194c.233-.161.578-.293 1.114-.293.536 0 .882.132 1.114.293.237.165.41.397.534.678.262.59.269 1.275.269 1.613 0 .223-.066.638-.247 1.09-.18.447-.449.872-.81 1.172l-.287.237.015.371c.011.273.052.616.215.95.172.354.455.647.862.85.406.203.89.345 1.317.467l.14.04c.4.113.768.217 1.102.35.373.147.63.303.792.474.14.15.234.336.234.637v.202a.75.75 0 0 0 1.5 0v-.202c0-.685-.24-1.238-.641-1.665-.38-.404-.873-.66-1.333-.841-.41-.162-.853-.288-1.242-.398l-.141-.04c-.447-.127-.797-.235-1.058-.365-.123-.062-.162-.12-.184-.165a.416.416 0 0 1-.017-.043c.432-.451.73-.98.928-1.473.241-.601.355-1.206.355-1.648v-.017c0-.344 0-1.308-.398-2.205a3.077 3.077 0 0 0-1.05-1.3c-.517-.36-1.171-.562-1.969-.562Z"/>   <path fill-rule="evenodd" d="M2.75 16.75a.75.75 0 0 1 .75.75v2.75c0 .138.112.25.25.25H6.5a.75.75 0 0 1 0 1.5H3.75A1.75 1.75 0 0 1 2 20.25V17.5a.75.75 0 0 1 .75-.75Zm18.5 0a.75.75 0 0 0-.75.75v2.75a.25.25 0 0 1-.25.25H17.5a.75.75 0 0 0 0 1.5h2.75A1.75 1.75 0 0 0 22 20.25V17.5a.75.75 0 0 0-.75-.75Zm-1-13.25a.25.25 0 0 1 .25.25V6.5a.75.75 0 0 0 1.5 0V3.75A1.75 1.75 0 0 0 20.25 2H17.5a.75.75 0 0 0 0 1.5h2.75Zm-16.5 0a.25.25 0 0 0-.25.25V6.5a.75.75 0 0 1-1.5 0V3.75C2 2.784 2.784 2 3.75 2H6.5a.75.75 0 0 1 0 1.5H3.75Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-user-viewfinder", lc);
const ec = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Om = /* @__PURE__ */ t({
  __name: "VsgIconUserViewfinder",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-user-viewfinder", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, ec));
  }
});
class ac extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M9.26 3.526c.705-.49 1.61-.775 2.74-.775 1.13 0 2.035.285 2.74.775.7.486 1.154 1.14 1.445 1.795.565 1.272.565 2.651.565 3.162v.018c0 .61-.158 1.468-.505 2.333-.305.76-.774 1.57-1.458 2.233.023.136.056.25.103.345.07.145.19.29.446.418.427.214.985.384 1.65.574l.213.06c.585.166 1.231.349 1.827.584.669.265 1.348.623 1.864 1.171.537.57.86 1.309.86 2.24v2.042a.75.75 0 0 1-1.5 0v-2.042c0-.548-.177-.919-.452-1.212-.297-.315-.742-.574-1.324-.804-.52-.206-1.09-.367-1.686-.536l-.212-.06c-.647-.185-1.339-.389-1.911-.675-.54-.27-.903-.65-1.124-1.104-.211-.434-.269-.888-.285-1.276l-.015-.372.287-.237c.604-.5 1.04-1.197 1.325-1.908.286-.714.397-1.384.397-1.774 0-.504-.007-1.607-.435-2.57-.209-.47-.506-.879-.93-1.173-.42-.292-1.016-.507-1.885-.507-.87 0-1.465.215-1.885.507-.424.294-.721.704-.93 1.173-.428.963-.435 2.066-.435 2.57 0 .39.11 1.054.393 1.763.281.705.712 1.399 1.31 1.902l.323.272-.064.416c-.04.259-.126.685-.312 1.11-.18.414-.5.926-1.065 1.208-.572.286-1.264.49-1.91.675l-.213.06c-.596.169-1.166.33-1.686.536-.581.23-1.027.489-1.324.804-.275.293-.452.664-.452 1.212v2.042a.75.75 0 0 1-1.5 0v-2.042c0-.931.323-1.67.86-2.24.516-.548 1.195-.906 1.864-1.17.596-.236 1.242-.42 1.827-.585l.212-.06c.666-.19 1.224-.36 1.652-.574.112-.056.243-.198.361-.467a2.58 2.58 0 0 0 .124-.36c-.653-.654-1.105-1.442-1.4-2.183-.343-.858-.5-1.71-.5-2.319v-.018c0-.51 0-1.89.565-3.162.291-.656.744-1.309 1.445-1.795Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-user", ac);
const sc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Um = /* @__PURE__ */ t({
  __name: "VsgIconUser",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-user", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, sc));
  }
});
class rc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M3.25 4.001a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 .75.75v3H22v3h-1.25v4H22v3h-1.25v3a.75.75 0 0 1-.75.75h-1v1.25h-3v-1.25H8v1.25H5v-1.25H4a.75.75 0 0 1-.75-.75v-16Zm1.5.75v14.5h14.5v-14.5H4.75Zm9.25 5.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm-3.25 1.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm-2-2.5a.75.75 0 1 0-1.5 0v5a.75.75 0 0 0 1.5 0v-5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-vault", rc);
const nc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Nm = /* @__PURE__ */ t({
  __name: "VsgIconVault",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-vault", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, nc));
  }
});
class oc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m3.575 2.661-.707.707 5.664 5.664 8.417 8.417 2.183 2.183.707-.707L17 16.085v-.7l1.643 1.517c1.282 1.182 3.357.273 3.357-1.47V8.568c0-1.744-2.075-2.652-3.357-1.47L17 8.615V7a2 2 0 0 0-2-2H5.914L3.575 2.661ZM7.415 6.5l2.5 2.5h3.335a.75.75 0 0 1 0 1.5h-1.836l4.086 4.086V7a.5.5 0 0 0-.5-.5H7.414Zm9.746 6.992a.5.5 0 0 1-.161-.368v-2.248a.5.5 0 0 1 .16-.368l2.5-2.307a.5.5 0 0 1 .84.367v6.864a.5.5 0 0 1-.84.367l-2.5-2.307Z"/>   <path d="M2 7a2 2 0 0 1 1.237-1.85L4.586 6.5H4a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .394-.192l1.062 1.063A1.994 1.994 0 0 1 15 19H4a2 2 0 0 1-2-2V7Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-video-off", oc);
const tc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Km = /* @__PURE__ */ t({
  __name: "VsgIconVideoOff",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-video-off", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, tc));
  }
});
class cc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M15 6.5H4a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5ZM17 17v-1.615l1.643 1.517c1.282 1.182 3.357.273 3.357-1.47V8.568c0-1.744-2.075-2.652-3.357-1.47L17 8.615V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2Zm.16-3.508a.5.5 0 0 1-.16-.368v-2.248a.5.5 0 0 1 .16-.368l2.5-2.307a.5.5 0 0 1 .84.367v6.864a.5.5 0 0 1-.84.367l-2.5-2.307ZM13.25 10.5a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h4.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-video", cc);
const uc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Gm = /* @__PURE__ */ t({
  __name: "VsgIconVideo",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-video", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, uc));
  }
});
class ic extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M8 12.001a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-view-more", ic);
const mc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Ym = /* @__PURE__ */ t({
  __name: "VsgIconViewMore",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-view-more", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, mc));
  }
});
class dc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M2.25 5.501c0-.967.784-1.75 1.75-1.75h15c.966 0 1.75.783 1.75 1.75v2.75h-6.5a2 2 0 0 0-2 2v3.5a2 2 0 0 0 2 2h6.5v2.75a1.75 1.75 0 0 1-1.75 1.75H4a1.75 1.75 0 0 1-1.75-1.75v-13Zm12 4.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h7.5v-4.5h-7.5Zm1.75 3.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-wallet-filled", dc);
const gc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Qm = /* @__PURE__ */ t({
  __name: "VsgIconWalletFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-wallet-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, gc));
  }
});
class hc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4 3.751a1.75 1.75 0 0 0-1.75 1.75v13c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-2.75H21a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75h-.25v-2.75A1.75 1.75 0 0 0 19 3.751H4Zm10.25 12h5v2.75a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25v-13a.25.25 0 0 1 .25-.25h15a.25.25 0 0 1 .25.25v2.75h-5a2 2 0 0 0-2 2v3.5a2 2 0 0 0 2 2Zm0-6a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h6v-4.5h-6Zm1.75 3.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-wallet", hc);
const pc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], Xm = /* @__PURE__ */ t({
  __name: "VsgIconWallet",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-wallet", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, pc));
  }
});
class vc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="m21.02 8.734-.829-.829.526-1.035c1.017-2.004-1.124-4.145-3.128-3.128l-1.036.525-.829-.829c-1.58-1.581-4.298-.238-3.936 2.007l.185 1.146-1.03.523c-1.585.804-1.611 2.796-.506 3.8L4.023 17.33c-.866.866-1.019 2.31-.11 3.217.907.908 2.35.756 3.217-.11l6.414-6.415c1.005 1.105 2.996 1.08 3.8-.506l.523-1.03 1.146.186c2.245.361 3.589-2.356 2.007-3.937Zm-8.093 3.782-.136-.848-.849-.137-6.858 6.858c-.386.386-.333.875-.111 1.096.222.223.71.276 1.096-.11l6.858-6.859Zm5.34-7.436c.71-.36 1.473.4 1.112 1.111l-.747 1.473a.826.826 0 0 0 .154.957l1.174 1.174c.566.566.08 1.522-.708 1.395l-1.636-.264a.82.82 0 0 0-.861.438l-.748 1.472c-.36.71-1.422.54-1.549-.25l-.263-1.635a.83.83 0 0 0-.688-.687L11.873 10c-.789-.127-.96-1.188-.25-1.549l1.473-.747a.82.82 0 0 0 .437-.862l-.263-1.635c-.127-.79.829-1.274 1.395-.708l1.173 1.173c.253.254.64.316.958.155l1.472-.747Z"/>   <path d="M18.272 14.818a.5.5 0 0 0-.93 0l-.594 1.507a.5.5 0 0 1-.282.281l-1.506.594a.5.5 0 0 0 0 .93l1.506.595a.5.5 0 0 1 .282.281l.594 1.507a.5.5 0 0 0 .93 0l.594-1.507a.5.5 0 0 1 .282-.281l1.506-.595a.5.5 0 0 0 0-.93l-1.506-.594a.5.5 0 0 1-.282-.282l-.594-1.506Z"/>   <path fill-rule="evenodd" d="M18.866 16.325a.5.5 0 0 0 .282.281l1.506.594a.5.5 0 0 1 0 .93l-1.506.595a.5.5 0 0 0-.282.281l-.594 1.507a.5.5 0 0 1-.93 0l-.594-1.507a.5.5 0 0 0-.282-.281l-1.506-.595a.5.5 0 0 1 0-.93l1.506-.594a.5.5 0 0 0 .282-.282l.594-1.506a.5.5 0 0 1 .93 0l.594 1.507ZM7.415 5.49a.5.5 0 0 0 .282.282l1.128.445a.5.5 0 0 1 0 .93l-1.128.446a.5.5 0 0 0-.282.281L6.97 9.003a.5.5 0 0 1-.93 0l-.446-1.129a.5.5 0 0 0-.281-.281l-1.13-.446a.5.5 0 0 1 0-.93l1.13-.445a.5.5 0 0 0 .281-.282l.445-1.128a.5.5 0 0 1 .93 0l.446 1.128Zm-2.441 5.654c.042.036.09.065.143.086l.59.233a.5.5 0 0 1 0 .93l-.59.233a.5.5 0 0 0-.282.282l-.233.591a.5.5 0 0 1-.93 0l-.233-.59a.5.5 0 0 0-.282-.283l-.59-.232a.5.5 0 0 1 0-.93l.59-.234a.502.502 0 0 0 .282-.282l.233-.59a.5.5 0 0 1 .93 0l.233.59a.5.5 0 0 0 .14.196Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-wand-magic-sparkles", vc);
const xc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ld = /* @__PURE__ */ t({
  __name: "VsgIconWandMagicSparkles",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-wand-magic-sparkles", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, xc));
  }
});
class yc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M13.876 4.281c-.845-1.373-2.906-1.374-3.752 0L2.56 16.567c-.903 1.466.257 3.184 1.876 3.184h15.13c1.618 0 2.78-1.718 1.876-3.184L13.876 4.281Zm-1.126 3.72a.75.75 0 0 0-1.5 0v4a.75.75 0 1 0 1.5 0v-4Zm-1.75 7.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-warning-filled", yc);
const _c = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ed = /* @__PURE__ */ t({
  __name: "VsgIconWarningFilled",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-warning-filled", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, _c));
  }
});
class wc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.598 5.067c-.26-.422-.937-.422-1.197 0L7.61 11.226l-3.773 6.127c-.211.343.006.897.599.897h15.13c.593 0 .81-.554.6-.897l-3.774-6.128L12.6 5.067Zm1.278-.786c-.845-1.374-2.906-1.374-3.752 0l-3.792 6.158-3.773 6.128c-.903 1.465.257 3.183 1.876 3.183h15.13c1.619 0 2.78-1.718 1.876-3.183l-3.773-6.128-3.792-6.158ZM12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75Zm0 7.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-warning", wc);
const fc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], ad = /* @__PURE__ */ t({
  __name: "VsgIconWarning",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-warning", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, fc));
  }
});
class bc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M22 11.501v-9.5l-10.854 1.6v8l10.854-.1Zm-20-6.6 8.14-1.2v7.9H2v-6.7Zm0 14.3v-6.7h8.14v7.9L2 19.201Zm20 2.8-10.854-1.5v-8H22v9.5Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-windows", bc);
const zc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], sd = /* @__PURE__ */ t({
  __name: "VsgIconWindows",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-windows", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, zc));
  }
});
class $c extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.728 2.82a.75.75 0 1 0-1.456.363l2 8a.75.75 0 0 0 1.424.097L8 8.02l1.304 3.26a.75.75 0 0 0 1.423-.097l2-8a.75.75 0 1 0-1.455-.364L9.835 8.57 8.696 5.722a.75.75 0 0 0-1.392 0L6.165 8.57 4.728 2.82Zm8.742 9.65a.75.75 0 0 1 1.06 0l4 4 .53.531-.53.53-4 4a.75.75 0 0 1-1.06-1.06l2.72-2.72H9.5c-1.344 0-2.346-.31-3.081-.798A3.692 3.692 0 0 1 5.04 15.29a.75.75 0 1 1 1.383-.581c.137.327.381.698.825.993.444.294 1.143.548 2.252.548h6.69l-2.72-2.72a.75.75 0 0 1 0-1.06Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-wires", $c);
const Zc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], rd = /* @__PURE__ */ t({
  __name: "VsgIconWires",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-wires", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Zc));
  }
});
class Vc extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M19 4.001 3 7.891l9.37 2.74L15.11 20 19 4Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-xperience", Vc);
const Bc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], nd = /* @__PURE__ */ t({
  __name: "VsgIconXperience",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-xperience", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, Bc));
  }
});
class Ic extends u {
  static get styles() {
    return [m];
  }
  render() {
    return i`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M12.887 20.001H11.27c-.151 0-.275-.144-.275-.322v-1.843H8.38c-.209 0-.379-.2-.379-.445v-1.489c0-.099.029-.196.08-.274l4.633-6.922H8.587c-.21 0-.38-.2-.38-.444V6.61c0-.246.17-.445.38-.445h2.407V4.323c0-.178.123-.322.275-.322h1.617c.151 0 .274.144.274.322v1.843h2.46c.21 0 .38.2.38.445v1.424a.497.497 0 0 1-.08.274l-4.662 6.987h4.363c.209 0 .379.199.379.444v1.65c0 .246-.17.445-.38.445h-2.458v1.844c0 .178-.123.322-.275.322Z"/> </svg> 
    `;
  }
}
customElements.define("jha-icon-zelle", Ic);
const jc = ["x-small", "small", "large", "x-large", "primary", "success", "danger", "base", "light", "muted", "neutral"], od = /* @__PURE__ */ t({
  __name: "VsgIconZelle",
  props: {
    size: {},
    color: {}
  },
  setup(e) {
    const l = e;
    return (a, s) => (n(), o("jha-icon-zelle", {
      "x-small": l.size === "x-small" ? "" : null,
      small: l.size === "small" ? "" : null,
      large: l.size === "large" ? "" : null,
      "x-large": l.size === "x-large" ? "" : null,
      primary: l.color === "primary" ? "" : null,
      success: l.color === "success" ? "" : null,
      danger: l.color === "danger" ? "" : null,
      base: l.color === "base" ? "" : null,
      light: l.color === "light" ? "" : null,
      muted: l.color === "muted" ? "" : null,
      neutral: l.color === "neutral" ? "" : null
    }, null, 8, jc));
  }
});
export {
  fu as $,
  Qc as A,
  Xc as B,
  lu as C,
  eu as D,
  I as E,
  au as F,
  su as G,
  ru as H,
  nu as I,
  ou as J,
  tu as K,
  cu as L,
  uu as M,
  iu as N,
  mu as O,
  du as P,
  gu as Q,
  hu as R,
  pu as S,
  vu as T,
  xu as U,
  Ac as V,
  yu as W,
  _u as X,
  ea as Y,
  wu as Z,
  tl as _,
  Is as a,
  ji as a$,
  bu as a0,
  zu as a1,
  $u as a2,
  Zu as a3,
  Vu as a4,
  Bu as a5,
  Iu as a6,
  ju as a7,
  Mu as a8,
  Hu as a9,
  si as aA,
  ni as aB,
  oi as aC,
  Lc as aD,
  ti as aE,
  ci as aF,
  ui as aG,
  Y as aH,
  ii as aI,
  mi as aJ,
  di as aK,
  gi as aL,
  hi as aM,
  pi as aN,
  vi as aO,
  xi as aP,
  yi as aQ,
  _i as aR,
  wi as aS,
  fi as aT,
  bi as aU,
  zi as aV,
  $i as aW,
  Zi as aX,
  Vi as aY,
  Bi as aZ,
  Ii as a_,
  ku as aa,
  Cu as ab,
  Lu as ac,
  Au as ad,
  Eu as ae,
  Su as af,
  Ju as ag,
  Tu as ah,
  qu as ai,
  Ru as aj,
  Du as ak,
  Ma as al,
  Fu as am,
  Pu as an,
  Wu as ao,
  Ou as ap,
  Uu as aq,
  Nu as ar,
  Ku as as,
  Gu as at,
  Yu as au,
  Qu as av,
  Xu as aw,
  li as ax,
  ei as ay,
  ai as az,
  Hc as b,
  T3 as b$,
  Mi as b0,
  Hi as b1,
  ki as b2,
  Ci as b3,
  Li as b4,
  Ai as b5,
  Ei as b6,
  Si as b7,
  Ji as b8,
  Ti as b9,
  d3 as bA,
  g3 as bB,
  h3 as bC,
  p3 as bD,
  v3 as bE,
  x3 as bF,
  y3 as bG,
  _3 as bH,
  w3 as bI,
  f3 as bJ,
  b3 as bK,
  z3 as bL,
  $3 as bM,
  Z3 as bN,
  V3 as bO,
  B3 as bP,
  I3 as bQ,
  j3 as bR,
  M3 as bS,
  H3 as bT,
  k3 as bU,
  C3 as bV,
  L3 as bW,
  A3 as bX,
  E3 as bY,
  S3 as bZ,
  J3 as b_,
  qi as ba,
  Ri as bb,
  Di as bc,
  Fi as bd,
  Pi as be,
  Wi as bf,
  Oi as bg,
  Ui as bh,
  Ni as bi,
  Ki as bj,
  Gi as bk,
  Yi as bl,
  Qi as bm,
  Xi as bn,
  l3 as bo,
  e3 as bp,
  a3 as bq,
  s3 as br,
  r3 as bs,
  n3 as bt,
  o3 as bu,
  t3 as bv,
  c3 as bw,
  u3 as bx,
  i3 as by,
  m3 as bz,
  kc as c,
  K4 as c$,
  q3 as c0,
  R3 as c1,
  D3 as c2,
  F3 as c3,
  P3 as c4,
  W3 as c5,
  O3 as c6,
  U3 as c7,
  N3 as c8,
  K3 as c9,
  b4 as cA,
  z4 as cB,
  $4 as cC,
  Z4 as cD,
  V4 as cE,
  B4 as cF,
  I4 as cG,
  j4 as cH,
  M4 as cI,
  H4 as cJ,
  k4 as cK,
  C4 as cL,
  L4 as cM,
  A4 as cN,
  E4 as cO,
  S4 as cP,
  J4 as cQ,
  T4 as cR,
  q4 as cS,
  R4 as cT,
  D4 as cU,
  F4 as cV,
  P4 as cW,
  W4 as cX,
  O4 as cY,
  U4 as cZ,
  N4 as c_,
  G3 as ca,
  Y3 as cb,
  Q3 as cc,
  X3 as cd,
  l4 as ce,
  e4 as cf,
  a4 as cg,
  s4 as ch,
  r4 as ci,
  n4 as cj,
  o4 as ck,
  t4 as cl,
  c4 as cm,
  u4 as cn,
  i4 as co,
  m4 as cp,
  d4 as cq,
  g4 as cr,
  h4 as cs,
  p4 as ct,
  v4 as cu,
  x4 as cv,
  y4 as cw,
  _4 as cx,
  w4 as cy,
  f4 as cz,
  Cc as d,
  rm as d$,
  G4 as d0,
  Y4 as d1,
  Q4 as d2,
  X4 as d3,
  l6 as d4,
  e6 as d5,
  a6 as d6,
  s6 as d7,
  r6 as d8,
  n6 as d9,
  H6 as dA,
  k6 as dB,
  C6 as dC,
  L6 as dD,
  A6 as dE,
  E6 as dF,
  S6 as dG,
  J6 as dH,
  T6 as dI,
  q6 as dJ,
  R6 as dK,
  D6 as dL,
  F6 as dM,
  P6 as dN,
  W6 as dO,
  O6 as dP,
  U6 as dQ,
  N6 as dR,
  K6 as dS,
  G6 as dT,
  Y6 as dU,
  Q6 as dV,
  X6 as dW,
  lm as dX,
  em as dY,
  am as dZ,
  sm as d_,
  o6 as da,
  t6 as db,
  c6 as dc,
  u6 as dd,
  i6 as de,
  m6 as df,
  d6 as dg,
  g6 as dh,
  h6 as di,
  p6 as dj,
  v6 as dk,
  x6 as dl,
  y6 as dm,
  _6 as dn,
  w6 as dp,
  f6 as dq,
  b6 as dr,
  z6 as ds,
  $6 as dt,
  Z6 as du,
  V6 as dv,
  B6 as dw,
  I6 as dx,
  j6 as dy,
  M6 as dz,
  Ec as e,
  nm as e0,
  om as e1,
  tm as e2,
  cm as e3,
  um as e4,
  im as e5,
  mm as e6,
  dm as e7,
  gm as e8,
  hm as e9,
  Rm as eA,
  Dm as eB,
  Fm as eC,
  Pm as eD,
  ws as eE,
  Wm as eF,
  Om as eG,
  Um as eH,
  Nm as eI,
  Km as eJ,
  Gm as eK,
  Ym as eL,
  Qm as eM,
  Xm as eN,
  ld as eO,
  ed as eP,
  ad as eQ,
  sd as eR,
  rd as eS,
  nd as eT,
  od as eU,
  pm as ea,
  vm as eb,
  xm as ec,
  ym as ed,
  _m as ee,
  wm as ef,
  fm as eg,
  bm as eh,
  zm as ei,
  $m as ej,
  Zm as ek,
  Vm as el,
  Bm as em,
  Im as en,
  jm as eo,
  Mm as ep,
  Hm as eq,
  km as er,
  Cm as es,
  Lm as et,
  Am as eu,
  Em as ev,
  Sm as ew,
  Jm as ex,
  Tm as ey,
  qm as ez,
  Wl as f,
  Sc as g,
  Jc as h,
  nl as i,
  Tc as j,
  qc as k,
  Rc as l,
  Dc as m,
  Fc as n,
  Pc as o,
  Wc as p,
  Oc as q,
  u as r,
  Gl as s,
  Uc as t,
  fl as u,
  Nc as v,
  Kc as w,
  i as x,
  Gc as y,
  Yc as z
};
